
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}
var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("gWF6I", function(module, exports) {

$parcel$export(module.exports, "RelayEnvironmentProvider", () => $8122506f239babd4$export$43b1f3e917d65526);
$parcel$export(module.exports, "useRelayEnvironmentProvider", () => $8122506f239babd4$export$e237a628f59c9f4e);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $6hqbZ = parcelRequire("6hqbZ");

var $lan9D = parcelRequire("lan9D");

var $3tMMZ = parcelRequire("3tMMZ");
const $8122506f239babd4$var$environment = new (0, $lan9D.Environment)((0, $3tMMZ.getDefaultRelayEnvironmentConfig)({}));
const $8122506f239babd4$export$43b1f3e917d65526 = ({ children: children })=>{
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $6hqbZ.RelayEnvironmentProvider), {
        environment: $8122506f239babd4$var$environment,
        children: children
    });
};
function $8122506f239babd4$export$e237a628f59c9f4e() {
    const environment = (0, $6hqbZ.useRelayEnvironment)();
    return (0, $gwFzn.useMemo)(()=>({
            getEnvironment () {
                return environment;
            }
        }), [
        environment
    ]);
}

});
parcelRegister("6hqbZ", function(module, exports) {
/**
 * Relay v0.0.0-main-5980a913
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 
module.exports = (parcelRequire("eblQb"));

});
parcelRegister("eblQb", function(module, exports) {
'use strict';

var $ddePm = parcelRequire("ddePm");

var $gUSPY = parcelRequire("gUSPY");

var $7nf8e = parcelRequire("7nf8e");

var $8nBV4 = parcelRequire("8nBV4");

var $fuHNx = parcelRequire("fuHNx");

var $6ZmAE = parcelRequire("6ZmAE");

var $b8i1g = parcelRequire("b8i1g");

var $itR7S = parcelRequire("itR7S");

var $kgUNJ = parcelRequire("kgUNJ");
var $a53308e1fb0c9187$var$loadQuery = $kgUNJ.loadQuery;

var $fWBut = parcelRequire("fWBut");

var $2AmqJ = parcelRequire("2AmqJ");

var $76WCZ = parcelRequire("76WCZ");

var $aSHZo = parcelRequire("aSHZo");

var $6sNrX = parcelRequire("6sNrX");

var $ktUWe = parcelRequire("ktUWe");

var $dWvxD = parcelRequire("dWvxD");

var $ctS2H = parcelRequire("ctS2H");

var $8mdVS = parcelRequire("8mdVS");

var $h4xdD = parcelRequire("h4xdD");

var $1Q1T2 = parcelRequire("1Q1T2");

var $cdYu4 = parcelRequire("cdYu4");

var $fXECE = parcelRequire("fXECE");

var $hdLtK = parcelRequire("hdLtK");

var $lan9D = parcelRequire("lan9D");
module.exports = {
    ConnectionHandler: $lan9D.ConnectionHandler,
    QueryRenderer: $fuHNx,
    LocalQueryRenderer: $7nf8e,
    MutationTypes: $lan9D.MutationTypes,
    RangeOperations: $lan9D.RangeOperations,
    ReactRelayContext: $ddePm,
    applyOptimisticMutation: $lan9D.applyOptimisticMutation,
    commitLocalUpdate: $lan9D.commitLocalUpdate,
    commitMutation: $lan9D.commitMutation,
    createFragmentContainer: $gUSPY.createContainer,
    createPaginationContainer: $8nBV4.createContainer,
    createRefetchContainer: $6ZmAE.createContainer,
    fetchQuery_DEPRECATED: $lan9D.fetchQuery_DEPRECATED,
    graphql: $lan9D.graphql,
    readInlineData: $lan9D.readInlineData,
    requestSubscription: $lan9D.requestSubscription,
    EntryPointContainer: $b8i1g,
    RelayEnvironmentProvider: $2AmqJ,
    ProfilerContext: $fWBut,
    fetchQuery: $lan9D.fetchQuery,
    loadQuery: $a53308e1fb0c9187$var$loadQuery,
    loadEntryPoint: $itR7S,
    useClientQuery: $76WCZ,
    useFragment: $6sNrX,
    useLazyLoadQuery: $ktUWe,
    useEntryPointLoader: $aSHZo,
    useQueryLoader: $h4xdD,
    useMutation: $dWvxD,
    usePaginationFragment: $ctS2H,
    usePreloadedQuery: $8mdVS,
    useRefetchableFragment: $1Q1T2,
    useRelayEnvironment: $cdYu4,
    useSubscribeToInvalidationState: $fXECE,
    useSubscription: $hdLtK
};

});
parcelRegister("ddePm", function(module, exports) {
'use strict';

var $gwFzn = parcelRequire("gwFzn");

var $lan9D = parcelRequire("lan9D");
var $99e7fda616ad868f$var$createRelayContext = $lan9D.__internal.createRelayContext;
module.exports = $99e7fda616ad868f$var$createRelayContext($gwFzn);

});
parcelRegister("lan9D", function(module, exports) {
/**
 * Relay v0.0.0-main-5980a913
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 
module.exports = (parcelRequire("1xysS"));

});
parcelRegister("1xysS", function(module, exports) {
'use strict';

var $jnVed = parcelRequire("jnVed");

var $lhnaB = parcelRequire("lhnaB");

var $emDuK = parcelRequire("emDuK");

var $4LekS = parcelRequire("4LekS");

var $d1Rdu = parcelRequire("d1Rdu");

var $424Ih = parcelRequire("424Ih");

var $cEfBU = parcelRequire("cEfBU");

var $jgdIQ = parcelRequire("jgdIQ");

var $eegbk = parcelRequire("eegbk");

var $8IVD8 = parcelRequire("8IVD8");

var $fDXrH = parcelRequire("fDXrH");

var $4cNkK = parcelRequire("4cNkK");

var $bvrmS = parcelRequire("bvrmS");

var $fexah = parcelRequire("fexah");

var $8AEJo = parcelRequire("8AEJo");

var $cfzqz = parcelRequire("cfzqz");

var $70q7x = parcelRequire("70q7x");
var $11f39b7a14e2efe1$var$generateClientID = $70q7x.generateClientID, $11f39b7a14e2efe1$var$generateUniqueClientID = $70q7x.generateUniqueClientID, $11f39b7a14e2efe1$var$isClientID = $70q7x.isClientID;

var $hmKan = parcelRequire("hmKan");

var $9XnRn = parcelRequire("9XnRn");

var $gXI8O = parcelRequire("gXI8O");
var $11f39b7a14e2efe1$var$isSuspenseSentinel = $gXI8O.isSuspenseSentinel, $11f39b7a14e2efe1$var$suspenseSentinel = $gXI8O.suspenseSentinel;

var $j6CXw = parcelRequire("j6CXw");

var $4gr1T = parcelRequire("4gr1T");

var $bjfzJ = parcelRequire("bjfzJ");

var $kpcDM = parcelRequire("kpcDM");

var $4Ai67 = parcelRequire("4Ai67");

var $ilblc = parcelRequire("ilblc");

var $c4ZG3 = parcelRequire("c4ZG3");

var $3o9ph = parcelRequire("3o9ph");

var $gJ2QW = parcelRequire("gJ2QW");

var $3s9KA = parcelRequire("3s9KA");

var $fWVgk = parcelRequire("fWVgk");

var $a6k4O = parcelRequire("a6k4O");

var $b7drZ = parcelRequire("b7drZ");

var $2Ww7b = parcelRequire("2Ww7b");

var $Olnt2 = parcelRequire("Olnt2");

var $8oDak = parcelRequire("8oDak");

var $8YAvI = parcelRequire("8YAvI");

var $inxuq = parcelRequire("inxuq");

var $8duCX = parcelRequire("8duCX");

var $8wd6q = parcelRequire("8wd6q");

var $HZplc = parcelRequire("HZplc");

var $6FEiH = parcelRequire("6FEiH");

var $5oZCd = parcelRequire("5oZCd");

var $9ESC3 = parcelRequire("9ESC3");

var $lSrhQ = parcelRequire("lSrhQ");

var $fPxW5 = parcelRequire("fPxW5");

var $8N9I0 = parcelRequire("8N9I0");

var $bwVmU = parcelRequire("bwVmU");

var $hrF5e = parcelRequire("hrF5e");

var $9lZfN = parcelRequire("9lZfN");

var $f1aE8 = parcelRequire("f1aE8");

var $3JkID = parcelRequire("3JkID");

var $9DZlA = parcelRequire("9DZlA");

var $8xKQX = parcelRequire("8xKQX");

var $gxoN7 = parcelRequire("gxoN7");

var $ahEdt = parcelRequire("ahEdt");

var $7c6mq = parcelRequire("7c6mq");
var $11f39b7a14e2efe1$var$mapStr, $11f39b7a14e2efe1$var$setStr, $11f39b7a14e2efe1$var$promiseStr, $11f39b7a14e2efe1$var$objStr;
module.exports = {
    Environment: $4Ai67,
    Network: $eegbk,
    Observable: $8IVD8,
    QueryResponseCache: $fDXrH,
    RecordSource: $fWVgk,
    Record: $c4ZG3,
    ReplaySubject: $gxoN7,
    Store: $gJ2QW,
    areEqualSelectors: $3o9ph.areEqualSelectors,
    createFragmentSpecResolver: $hmKan,
    createNormalizationSelector: $3o9ph.createNormalizationSelector,
    createOperationDescriptor: $ilblc.createOperationDescriptor,
    createReaderSelector: $3o9ph.createReaderSelector,
    createRequestDescriptor: $ilblc.createRequestDescriptor,
    getArgumentValues: $a6k4O.getArgumentValues,
    getDataIDsFromFragment: $3o9ph.getDataIDsFromFragment,
    getDataIDsFromObject: $3o9ph.getDataIDsFromObject,
    getNode: $8AEJo.getNode,
    getFragment: $8AEJo.getFragment,
    getInlineDataFragment: $8AEJo.getInlineDataFragment,
    getModuleComponentKey: $a6k4O.getModuleComponentKey,
    getModuleOperationKey: $a6k4O.getModuleOperationKey,
    getPaginationFragment: $8AEJo.getPaginationFragment,
    getPluralSelector: $3o9ph.getPluralSelector,
    getRefetchableFragment: $8AEJo.getRefetchableFragment,
    getRequest: $8AEJo.getRequest,
    getRequestIdentifier: $9ESC3,
    getSelector: $3o9ph.getSelector,
    getSelectorsFromObject: $3o9ph.getSelectorsFromObject,
    getSingularSelector: $3o9ph.getSingularSelector,
    getStorageKey: $a6k4O.getStorageKey,
    getVariablesFromFragment: $3o9ph.getVariablesFromFragment,
    getVariablesFromObject: $3o9ph.getVariablesFromObject,
    getVariablesFromPluralFragment: $3o9ph.getVariablesFromPluralFragment,
    getVariablesFromSingularFragment: $3o9ph.getVariablesFromSingularFragment,
    handlePotentialSnapshotErrors: $fPxW5,
    graphql: $8AEJo.graphql,
    isFragment: $8AEJo.isFragment,
    isInlineDataFragment: $8AEJo.isInlineDataFragment,
    isSuspenseSentinel: $11f39b7a14e2efe1$var$isSuspenseSentinel,
    suspenseSentinel: $11f39b7a14e2efe1$var$suspenseSentinel,
    isRequest: $8AEJo.isRequest,
    readInlineData: $bjfzJ,
    MutationTypes: $jgdIQ.MutationTypes,
    RangeOperations: $jgdIQ.RangeOperations,
    DefaultHandlerProvider: $4LekS,
    ConnectionHandler: $jnVed,
    MutationHandlers: $emDuK,
    VIEWER_ID: $2Ww7b.VIEWER_ID,
    VIEWER_TYPE: $2Ww7b.VIEWER_TYPE,
    applyOptimisticMutation: $d1Rdu,
    commitLocalUpdate: $424Ih,
    commitMutation: $cEfBU,
    fetchQuery: $4cNkK,
    fetchQuery_DEPRECATED: $bvrmS,
    isRelayModernEnvironment: $j6CXw,
    requestSubscription: $Olnt2,
    ConnectionInterface: $lhnaB,
    PreloadableQueryRegistry: $cfzqz,
    RelayProfiler: $8xKQX,
    createPayloadFor3DField: $8oDak,
    RelayConcreteNode: $9lZfN,
    RelayError: $3JkID,
    RelayFeatureFlags: $9DZlA,
    DEFAULT_HANDLE_KEY: $f1aE8.DEFAULT_HANDLE_KEY,
    FRAGMENTS_KEY: $a6k4O.FRAGMENTS_KEY,
    FRAGMENT_OWNER_KEY: $a6k4O.FRAGMENT_OWNER_KEY,
    ID_KEY: $a6k4O.ID_KEY,
    REF_KEY: $a6k4O.REF_KEY,
    REFS_KEY: $a6k4O.REFS_KEY,
    ROOT_ID: $a6k4O.ROOT_ID,
    ROOT_TYPE: $a6k4O.ROOT_TYPE,
    TYPENAME_KEY: $a6k4O.TYPENAME_KEY,
    deepFreeze: $8YAvI,
    generateClientID: $11f39b7a14e2efe1$var$generateClientID,
    generateUniqueClientID: $11f39b7a14e2efe1$var$generateUniqueClientID,
    getRelayHandleKey: $5oZCd,
    isClientID: $11f39b7a14e2efe1$var$isClientID,
    isPromise: $8N9I0,
    isScalarAndEqual: $bwVmU,
    recycleNodesInto: $hrF5e,
    stableCopy: $ahEdt,
    getFragmentIdentifier: $inxuq,
    getRefetchMetadata: $6FEiH,
    getPaginationMetadata: $8duCX,
    getPaginationVariables: $8wd6q,
    getPendingOperationsForFragment: $HZplc,
    getValueAtPath: $lSrhQ,
    __internal: {
        ResolverFragments: $b7drZ,
        OperationTracker: $3s9KA,
        createRelayContext: $9XnRn,
        getOperationVariables: $kpcDM.getOperationVariables,
        getLocalVariables: $kpcDM.getLocalVariables,
        fetchQuery: $fexah.fetchQuery,
        fetchQueryDeduped: $fexah.fetchQueryDeduped,
        getPromiseForActiveRequest: $fexah.getPromiseForActiveRequest,
        getObservableForActiveRequest: $fexah.getObservableForActiveRequest,
        normalizeResponse: $4gr1T,
        withProvidedVariables: $7c6mq
    }
};

});
parcelRegister("jnVed", function(module, exports) {
'use strict';

var $70q7x = parcelRequire("70q7x");
var $e1cc8ea87636e302$var$generateClientID = $70q7x.generateClientID;

var $a6k4O = parcelRequire("a6k4O");
var $e1cc8ea87636e302$var$getStableStorageKey = $a6k4O.getStableStorageKey;

var $5oZCd = parcelRequire("5oZCd");

var $lhnaB = parcelRequire("lhnaB");

var $bQThX = parcelRequire("bQThX");
parcelRequire("hzw7m");
var $e1cc8ea87636e302$var$CONNECTION = 'connection';
var $e1cc8ea87636e302$var$NEXT_EDGE_INDEX = '__connection_next_edge_index';
function $e1cc8ea87636e302$var$update(store, payload) {
    var record = store.get(payload.dataID);
    if (!record) return;
    var _ConnectionInterface$ = $lhnaB.get(), EDGES = _ConnectionInterface$.EDGES, END_CURSOR = _ConnectionInterface$.END_CURSOR, HAS_NEXT_PAGE = _ConnectionInterface$.HAS_NEXT_PAGE, HAS_PREV_PAGE = _ConnectionInterface$.HAS_PREV_PAGE, PAGE_INFO = _ConnectionInterface$.PAGE_INFO, PAGE_INFO_TYPE = _ConnectionInterface$.PAGE_INFO_TYPE, START_CURSOR = _ConnectionInterface$.START_CURSOR;
    var serverConnection = record.getLinkedRecord(payload.fieldKey);
    var serverPageInfo = serverConnection && serverConnection.getLinkedRecord(PAGE_INFO);
    if (!serverConnection) {
        record.setValue(null, payload.handleKey);
        return;
    }
    var clientConnectionID = $e1cc8ea87636e302$var$generateClientID(record.getDataID(), payload.handleKey);
    var clientConnectionField = record.getLinkedRecord(payload.handleKey);
    var clientConnection = clientConnectionField !== null && clientConnectionField !== void 0 ? clientConnectionField : store.get(clientConnectionID);
    var clientPageInfo = clientConnection && clientConnection.getLinkedRecord(PAGE_INFO);
    if (!clientConnection) {
        var connection = store.create(clientConnectionID, serverConnection.getType());
        connection.setValue(0, $e1cc8ea87636e302$var$NEXT_EDGE_INDEX);
        connection.copyFieldsFrom(serverConnection);
        var serverEdges = serverConnection.getLinkedRecords(EDGES);
        if (serverEdges) {
            serverEdges = serverEdges.map(function(edge) {
                return $e1cc8ea87636e302$var$buildConnectionEdge(store, connection, edge);
            });
            connection.setLinkedRecords(serverEdges, EDGES);
        }
        record.setLinkedRecord(connection, payload.handleKey);
        clientPageInfo = store.create($e1cc8ea87636e302$var$generateClientID(connection.getDataID(), PAGE_INFO), PAGE_INFO_TYPE);
        clientPageInfo.setValue(false, HAS_NEXT_PAGE);
        clientPageInfo.setValue(false, HAS_PREV_PAGE);
        clientPageInfo.setValue(null, END_CURSOR);
        clientPageInfo.setValue(null, START_CURSOR);
        if (serverPageInfo) clientPageInfo.copyFieldsFrom(serverPageInfo);
        connection.setLinkedRecord(clientPageInfo, PAGE_INFO);
    } else {
        if (clientConnectionField == null) record.setLinkedRecord(clientConnection, payload.handleKey);
        var _connection = clientConnection;
        var _serverEdges = serverConnection.getLinkedRecords(EDGES);
        if (_serverEdges) _serverEdges = _serverEdges.map(function(edge) {
            return $e1cc8ea87636e302$var$buildConnectionEdge(store, _connection, edge);
        });
        var prevEdges = _connection.getLinkedRecords(EDGES);
        var prevPageInfo = _connection.getLinkedRecord(PAGE_INFO);
        _connection.copyFieldsFrom(serverConnection);
        if (prevEdges) _connection.setLinkedRecords(prevEdges, EDGES);
        if (prevPageInfo) _connection.setLinkedRecord(prevPageInfo, PAGE_INFO);
        var nextEdges = [];
        var args = payload.args;
        if (prevEdges && _serverEdges) {
            if (args.after != null) {
                var _clientPageInfo;
                var clientEndCursor = (_clientPageInfo = clientPageInfo) === null || _clientPageInfo === void 0 ? void 0 : _clientPageInfo.getValue(END_CURSOR);
                var serverEndCursor = serverPageInfo === null || serverPageInfo === void 0 ? void 0 : serverPageInfo.getValue(END_CURSOR);
                var isAddingEdgesAfterCurrentPage = clientPageInfo && args.after === clientEndCursor;
                var isFillingOutCurrentPage = clientPageInfo && clientEndCursor === serverEndCursor;
                if (isAddingEdgesAfterCurrentPage || isFillingOutCurrentPage) {
                    var nodeIDs = new Set();
                    $e1cc8ea87636e302$var$mergeEdges(prevEdges, nextEdges, nodeIDs);
                    $e1cc8ea87636e302$var$mergeEdges(_serverEdges, nextEdges, nodeIDs);
                } else return;
            } else if (args.before != null) {
                if (clientPageInfo && args.before === clientPageInfo.getValue(START_CURSOR)) {
                    var _nodeIDs = new Set();
                    $e1cc8ea87636e302$var$mergeEdges(_serverEdges, nextEdges, _nodeIDs);
                    $e1cc8ea87636e302$var$mergeEdges(prevEdges, nextEdges, _nodeIDs);
                } else return;
            } else nextEdges = _serverEdges;
        } else if (_serverEdges) nextEdges = _serverEdges;
        else nextEdges = prevEdges;
        if (nextEdges != null && nextEdges !== prevEdges) _connection.setLinkedRecords(nextEdges, EDGES);
        if (clientPageInfo && serverPageInfo) {
            if (args.after == null && args.before == null) clientPageInfo.copyFieldsFrom(serverPageInfo);
            else if (args.before != null || args.after == null && args.last) {
                clientPageInfo.setValue(!!serverPageInfo.getValue(HAS_PREV_PAGE), HAS_PREV_PAGE);
                var startCursor = serverPageInfo.getValue(START_CURSOR);
                if (typeof startCursor === 'string') clientPageInfo.setValue(startCursor, START_CURSOR);
            } else if (args.after != null || args.before == null && args.first) {
                clientPageInfo.setValue(!!serverPageInfo.getValue(HAS_NEXT_PAGE), HAS_NEXT_PAGE);
                var endCursor = serverPageInfo.getValue(END_CURSOR);
                if (typeof endCursor === 'string') clientPageInfo.setValue(endCursor, END_CURSOR);
            }
        }
    }
}
function $e1cc8ea87636e302$var$getConnection(record, key, filters) {
    var handleKey = $5oZCd($e1cc8ea87636e302$var$CONNECTION, key, null);
    return record.getLinkedRecord(handleKey, filters);
}
function $e1cc8ea87636e302$var$getConnectionID(recordID, key, filters) {
    var handleKey = $5oZCd($e1cc8ea87636e302$var$CONNECTION, key, null);
    var storageKey = $e1cc8ea87636e302$var$getStableStorageKey(handleKey, filters);
    return $e1cc8ea87636e302$var$generateClientID(recordID, storageKey);
}
function $e1cc8ea87636e302$var$insertEdgeAfter(record, newEdge, cursor) {
    var _ConnectionInterface$2 = $lhnaB.get(), CURSOR = _ConnectionInterface$2.CURSOR, EDGES = _ConnectionInterface$2.EDGES;
    var edges = record.getLinkedRecords(EDGES);
    if (!edges) {
        record.setLinkedRecords([
            newEdge
        ], EDGES);
        return;
    }
    var nextEdges;
    if (cursor == null) nextEdges = edges.concat(newEdge);
    else {
        nextEdges = [];
        var foundCursor = false;
        for(var ii = 0; ii < edges.length; ii++){
            var edge = edges[ii];
            nextEdges.push(edge);
            if (edge == null) continue;
            var edgeCursor = edge.getValue(CURSOR);
            if (cursor === edgeCursor) {
                nextEdges.push(newEdge);
                foundCursor = true;
            }
        }
        if (!foundCursor) nextEdges.push(newEdge);
    }
    record.setLinkedRecords(nextEdges, EDGES);
}
function $e1cc8ea87636e302$var$createEdge(store, record, node, edgeType) {
    var _ConnectionInterface$3 = $lhnaB.get(), NODE = _ConnectionInterface$3.NODE;
    var edgeID = $e1cc8ea87636e302$var$generateClientID(record.getDataID(), node.getDataID());
    var edge = store.get(edgeID);
    if (!edge) edge = store.create(edgeID, edgeType);
    edge.setLinkedRecord(node, NODE);
    if (edge.getValue('cursor') == null) edge.setValue(null, 'cursor');
    return edge;
}
function $e1cc8ea87636e302$var$insertEdgeBefore(record, newEdge, cursor) {
    var _ConnectionInterface$4 = $lhnaB.get(), CURSOR = _ConnectionInterface$4.CURSOR, EDGES = _ConnectionInterface$4.EDGES;
    var edges = record.getLinkedRecords(EDGES);
    if (!edges) {
        record.setLinkedRecords([
            newEdge
        ], EDGES);
        return;
    }
    var nextEdges;
    if (cursor == null) nextEdges = [
        newEdge
    ].concat(edges);
    else {
        nextEdges = [];
        var foundCursor = false;
        for(var ii = 0; ii < edges.length; ii++){
            var edge = edges[ii];
            if (edge != null) {
                var edgeCursor = edge.getValue(CURSOR);
                if (cursor === edgeCursor) {
                    nextEdges.push(newEdge);
                    foundCursor = true;
                }
            }
            nextEdges.push(edge);
        }
        if (!foundCursor) nextEdges.unshift(newEdge);
    }
    record.setLinkedRecords(nextEdges, EDGES);
}
function $e1cc8ea87636e302$var$deleteNode(record, nodeID) {
    var _ConnectionInterface$5 = $lhnaB.get(), EDGES = _ConnectionInterface$5.EDGES, NODE = _ConnectionInterface$5.NODE;
    var edges = record.getLinkedRecords(EDGES);
    if (!edges) return;
    var nextEdges;
    for(var ii = 0; ii < edges.length; ii++){
        var edge = edges[ii];
        var node = edge && edge.getLinkedRecord(NODE);
        if (node != null && node.getDataID() === nodeID) {
            if (nextEdges === undefined) nextEdges = edges.slice(0, ii);
        } else if (nextEdges !== undefined) nextEdges.push(edge);
    }
    if (nextEdges !== undefined) record.setLinkedRecords(nextEdges, EDGES);
}
function $e1cc8ea87636e302$var$buildConnectionEdge(store, connection, edge) {
    if (edge == null) return edge;
    var _ConnectionInterface$6 = $lhnaB.get(), EDGES = _ConnectionInterface$6.EDGES;
    var edgeIndex = connection.getValue($e1cc8ea87636e302$var$NEXT_EDGE_INDEX);
    !(typeof edgeIndex === 'number') && $bQThX(false);
    var edgeID = $e1cc8ea87636e302$var$generateClientID(connection.getDataID(), EDGES, edgeIndex);
    var connectionEdge = store.create(edgeID, edge.getType());
    connectionEdge.copyFieldsFrom(edge);
    if (connectionEdge.getValue('cursor') == null) connectionEdge.setValue(null, 'cursor');
    connection.setValue(edgeIndex + 1, $e1cc8ea87636e302$var$NEXT_EDGE_INDEX);
    return connectionEdge;
}
function $e1cc8ea87636e302$var$mergeEdges(sourceEdges, targetEdges, nodeIDs) {
    var _ConnectionInterface$7 = $lhnaB.get(), NODE = _ConnectionInterface$7.NODE;
    for(var ii = 0; ii < sourceEdges.length; ii++){
        var edge = sourceEdges[ii];
        if (!edge) continue;
        var node = edge.getLinkedRecord(NODE);
        var nodeID = node && node.getDataID();
        if (nodeID) {
            if (nodeIDs.has(nodeID)) continue;
            nodeIDs.add(nodeID);
        }
        targetEdges.push(edge);
    }
}
module.exports = {
    buildConnectionEdge: $e1cc8ea87636e302$var$buildConnectionEdge,
    createEdge: $e1cc8ea87636e302$var$createEdge,
    deleteNode: $e1cc8ea87636e302$var$deleteNode,
    getConnection: $e1cc8ea87636e302$var$getConnection,
    getConnectionID: $e1cc8ea87636e302$var$getConnectionID,
    insertEdgeAfter: $e1cc8ea87636e302$var$insertEdgeAfter,
    insertEdgeBefore: $e1cc8ea87636e302$var$insertEdgeBefore,
    update: $e1cc8ea87636e302$var$update
};

});
parcelRegister("70q7x", function(module, exports) {
'use strict';

var $9DZlA = parcelRequire("9DZlA");

var $lnxjc = parcelRequire("lnxjc");
var $519ccb7b74d6e9c4$var$intern = $lnxjc.intern;
var $519ccb7b74d6e9c4$var$PREFIX = 'client:';
function $519ccb7b74d6e9c4$var$generateClientID(id, storageKey, index) {
    var internedId = $9DZlA.STRING_INTERN_LEVEL <= 0 ? id : $519ccb7b74d6e9c4$var$intern(id, $9DZlA.MAX_DATA_ID_LENGTH);
    var key = internedId + ':' + storageKey;
    if (index != null) key += ':' + index;
    if (key.indexOf($519ccb7b74d6e9c4$var$PREFIX) !== 0) key = $519ccb7b74d6e9c4$var$PREFIX + key;
    return key;
}
function $519ccb7b74d6e9c4$var$isClientID(id) {
    return id.indexOf($519ccb7b74d6e9c4$var$PREFIX) === 0;
}
var $519ccb7b74d6e9c4$var$localID = 0;
function $519ccb7b74d6e9c4$var$generateUniqueClientID() {
    return "".concat($519ccb7b74d6e9c4$var$PREFIX, "local:").concat($519ccb7b74d6e9c4$var$localID++);
}
function $519ccb7b74d6e9c4$var$generateClientObjectClientID(typename, localId, index) {
    var key = "".concat($519ccb7b74d6e9c4$var$PREFIX).concat(typename, ":").concat(localId);
    if (index != null) key += ':' + index;
    return key;
}
module.exports = {
    generateClientID: $519ccb7b74d6e9c4$var$generateClientID,
    generateClientObjectClientID: $519ccb7b74d6e9c4$var$generateClientObjectClientID,
    generateUniqueClientID: $519ccb7b74d6e9c4$var$generateUniqueClientID,
    isClientID: $519ccb7b74d6e9c4$var$isClientID
};

});
parcelRegister("9DZlA", function(module, exports) {
'use strict';
var $705757d316af4187$var$RelayFeatureFlags = {
    ENABLE_VARIABLE_CONNECTION_KEY: false,
    ENABLE_RELAY_RESOLVERS: false,
    ENABLE_GETFRAGMENTIDENTIFIER_OPTIMIZATION: false,
    ENABLE_FRIENDLY_QUERY_NAME_GQL_URL: false,
    ENABLE_LOAD_QUERY_REQUEST_DEDUPING: true,
    ENABLE_DO_NOT_WRAP_LIVE_QUERY: false,
    ENABLE_NOTIFY_SUBSCRIPTION: false,
    BATCH_ASYNC_MODULE_UPDATES_FN: null,
    ENABLE_CONTAINERS_SUBSCRIBE_ON_COMMIT: false,
    MAX_DATA_ID_LENGTH: null,
    STRING_INTERN_LEVEL: 0,
    LOG_MISSING_RECORDS_IN_PROD: false,
    ENABLE_LOOSE_SUBSCRIPTION_ATTRIBUTION: false,
    ENABLE_OPERATION_TRACKER_OPTIMISTIC_UPDATES: false,
    ENABLE_RELAY_OPERATION_TRACKER_SUSPENSE: false,
    ENABLE_FIELD_ERROR_HANDLING: false,
    ENABLE_FIELD_ERROR_HANDLING_THROW_BY_DEFAULT: false,
    ENABLE_FIELD_ERROR_HANDLING_CATCH_DIRECTIVE: false,
    PROCESS_OPTIMISTIC_UPDATE_BEFORE_SUBSCRIPTION: false,
    MARK_RESOLVER_VALUES_AS_CLEAN_AFTER_FRAGMENT_REREAD: false
};
module.exports = $705757d316af4187$var$RelayFeatureFlags;

});

parcelRegister("lnxjc", function(module, exports) {
'use strict';
var $f905955fd3b1eb8d$var$internTable = new Map();
var $f905955fd3b1eb8d$var$nextIndex = 1;
var $f905955fd3b1eb8d$var$digits = $f905955fd3b1eb8d$var$initDigitTable();
var $f905955fd3b1eb8d$var$INTERN_PREFIX = '\t';
var $f905955fd3b1eb8d$var$ESCAPE_PREFIX = '\v';
function $f905955fd3b1eb8d$var$initDigitTable() {
    var digits = new Set();
    for(var i = 0; i < 10; ++i)digits.add(i.toString());
    return digits;
}
function $f905955fd3b1eb8d$var$escape(str) {
    if (str[0] === $f905955fd3b1eb8d$var$INTERN_PREFIX && $f905955fd3b1eb8d$var$digits.has(str[1]) || str[0] === $f905955fd3b1eb8d$var$ESCAPE_PREFIX) return $f905955fd3b1eb8d$var$ESCAPE_PREFIX + str;
    return str;
}
function $f905955fd3b1eb8d$var$intern(str, limit) {
    if (limit == null || str.length < limit) return $f905955fd3b1eb8d$var$escape(str);
    var internedString = $f905955fd3b1eb8d$var$internTable.get(str);
    if (internedString != null) return internedString;
    internedString = $f905955fd3b1eb8d$var$INTERN_PREFIX + $f905955fd3b1eb8d$var$nextIndex++;
    $f905955fd3b1eb8d$var$internTable.set(str, internedString);
    return internedString;
}
module.exports = {
    intern: $f905955fd3b1eb8d$var$intern
};

});


parcelRegister("a6k4O", function(module, exports) {
'use strict';

var $7dvyf = parcelRequire("7dvyf");
var $75aa09bad22f5af8$var$_interopRequireDefault = $7dvyf.default;

var $75aa09bad22f5af8$var$_toConsumableArray2 = $75aa09bad22f5af8$var$_interopRequireDefault((parcelRequire("gvI75")));

var $5oZCd = parcelRequire("5oZCd");

var $9lZfN = parcelRequire("9lZfN");

var $ahEdt = parcelRequire("ahEdt");

var $bQThX = parcelRequire("bQThX");
var $75aa09bad22f5af8$var$VARIABLE = $9lZfN.VARIABLE, $75aa09bad22f5af8$var$LITERAL = $9lZfN.LITERAL, $75aa09bad22f5af8$var$OBJECT_VALUE = $9lZfN.OBJECT_VALUE, $75aa09bad22f5af8$var$LIST_VALUE = $9lZfN.LIST_VALUE;
var $75aa09bad22f5af8$var$ERRORS_KEY = '__errors';
var $75aa09bad22f5af8$var$MODULE_COMPONENT_KEY_PREFIX = '__module_component_';
var $75aa09bad22f5af8$var$MODULE_OPERATION_KEY_PREFIX = '__module_operation_';
function $75aa09bad22f5af8$var$getArgumentValue(arg, variables) {
    if (arg.kind === $75aa09bad22f5af8$var$VARIABLE) return $75aa09bad22f5af8$var$getStableVariableValue(arg.variableName, variables);
    else if (arg.kind === $75aa09bad22f5af8$var$LITERAL) return arg.value;
    else if (arg.kind === $75aa09bad22f5af8$var$OBJECT_VALUE) {
        var value = {};
        arg.fields.forEach(function(field) {
            value[field.name] = $75aa09bad22f5af8$var$getArgumentValue(field, variables);
        });
        return value;
    } else if (arg.kind === $75aa09bad22f5af8$var$LIST_VALUE) {
        var _value = [];
        arg.items.forEach(function(item) {
            item != null && _value.push($75aa09bad22f5af8$var$getArgumentValue(item, variables));
        });
        return _value;
    }
}
function $75aa09bad22f5af8$var$getArgumentValues(args, variables, isWithinUnmatchedTypeRefinement) {
    var values = {};
    if (isWithinUnmatchedTypeRefinement) values[$75aa09bad22f5af8$var$RelayStoreUtils.FRAGMENT_POINTER_IS_WITHIN_UNMATCHED_TYPE_REFINEMENT] = true;
    if (args) args.forEach(function(arg) {
        values[arg.name] = $75aa09bad22f5af8$var$getArgumentValue(arg, variables);
    });
    return values;
}
function $75aa09bad22f5af8$var$getHandleStorageKey(handleField, variables) {
    var dynamicKey = handleField.dynamicKey, handle = handleField.handle, key = handleField.key, name = handleField.name, args = handleField.args, filters = handleField.filters;
    var handleName = $5oZCd(handle, key, name);
    var filterArgs = null;
    if (args && filters && args.length !== 0 && filters.length !== 0) filterArgs = args.filter(function(arg) {
        return filters.indexOf(arg.name) > -1;
    });
    if (dynamicKey) filterArgs = filterArgs != null ? [
        dynamicKey
    ].concat((0, $75aa09bad22f5af8$var$_toConsumableArray2["default"])(filterArgs)) : [
        dynamicKey
    ];
    if (filterArgs === null) return handleName;
    else return $75aa09bad22f5af8$var$formatStorageKey(handleName, $75aa09bad22f5af8$var$getArgumentValues(filterArgs, variables));
}
function $75aa09bad22f5af8$var$getStorageKey(field, variables) {
    if (field.storageKey) return field.storageKey;
    var args = $75aa09bad22f5af8$var$getArguments(field);
    var name = field.name;
    return args && args.length !== 0 ? $75aa09bad22f5af8$var$formatStorageKey(name, $75aa09bad22f5af8$var$getArgumentValues(args, variables)) : name;
}
function $75aa09bad22f5af8$var$getArguments(field) {
    if (field.kind === 'RelayResolver' || field.kind === 'RelayLiveResolver') {
        var _field$fragment2;
        if (field.args == null) {
            var _field$fragment;
            return (_field$fragment = field.fragment) === null || _field$fragment === void 0 ? void 0 : _field$fragment.args;
        }
        if (((_field$fragment2 = field.fragment) === null || _field$fragment2 === void 0 ? void 0 : _field$fragment2.args) == null) return field.args;
        return field.args.concat(field.fragment.args);
    }
    var args = typeof field.args === 'undefined' ? undefined : field.args;
    return args;
}
function $75aa09bad22f5af8$var$getStableStorageKey(name, args) {
    return $75aa09bad22f5af8$var$formatStorageKey(name, $ahEdt(args));
}
function $75aa09bad22f5af8$var$formatStorageKey(name, argValues) {
    if (!argValues) return name;
    var values = [];
    for(var argName in argValues)if (argValues.hasOwnProperty(argName)) {
        var value = argValues[argName];
        if (value != null) {
            var _JSON$stringify;
            values.push(argName + ':' + ((_JSON$stringify = JSON.stringify(value)) !== null && _JSON$stringify !== void 0 ? _JSON$stringify : 'undefined'));
        }
    }
    return values.length === 0 ? name : name + "(".concat(values.join(','), ")");
}
function $75aa09bad22f5af8$var$getStableVariableValue(name, variables) {
    !variables.hasOwnProperty(name) && $bQThX(false);
    return $ahEdt(variables[name]);
}
function $75aa09bad22f5af8$var$getModuleComponentKey(documentName) {
    return "".concat($75aa09bad22f5af8$var$MODULE_COMPONENT_KEY_PREFIX).concat(documentName);
}
function $75aa09bad22f5af8$var$getModuleOperationKey(documentName) {
    return "".concat($75aa09bad22f5af8$var$MODULE_OPERATION_KEY_PREFIX).concat(documentName);
}
var $75aa09bad22f5af8$var$RelayStoreUtils = {
    ACTOR_IDENTIFIER_KEY: '__actorIdentifier',
    CLIENT_EDGE_TRAVERSAL_PATH: '__clientEdgeTraversalPath',
    FRAGMENTS_KEY: '__fragments',
    FRAGMENT_OWNER_KEY: '__fragmentOwner',
    FRAGMENT_POINTER_IS_WITHIN_UNMATCHED_TYPE_REFINEMENT: '$isWithinUnmatchedTypeRefinement',
    FRAGMENT_PROP_NAME_KEY: '__fragmentPropName',
    MODULE_COMPONENT_KEY: '__module_component',
    ERRORS_KEY: $75aa09bad22f5af8$var$ERRORS_KEY,
    ID_KEY: '__id',
    REF_KEY: '__ref',
    REFS_KEY: '__refs',
    ROOT_ID: 'client:root',
    ROOT_TYPE: '__Root',
    TYPENAME_KEY: '__typename',
    INVALIDATED_AT_KEY: '__invalidated_at',
    RELAY_RESOLVER_VALUE_KEY: '__resolverValue',
    RELAY_RESOLVER_INVALIDATION_KEY: '__resolverValueMayBeInvalid',
    RELAY_RESOLVER_SNAPSHOT_KEY: '__resolverSnapshot',
    RELAY_RESOLVER_ERROR_KEY: '__resolverError',
    RELAY_RESOLVER_OUTPUT_TYPE_RECORD_IDS: '__resolverOutputTypeRecordIDs',
    formatStorageKey: $75aa09bad22f5af8$var$formatStorageKey,
    getArgumentValue: $75aa09bad22f5af8$var$getArgumentValue,
    getArgumentValues: $75aa09bad22f5af8$var$getArgumentValues,
    getHandleStorageKey: $75aa09bad22f5af8$var$getHandleStorageKey,
    getStorageKey: $75aa09bad22f5af8$var$getStorageKey,
    getStableStorageKey: $75aa09bad22f5af8$var$getStableStorageKey,
    getModuleComponentKey: $75aa09bad22f5af8$var$getModuleComponentKey,
    getModuleOperationKey: $75aa09bad22f5af8$var$getModuleOperationKey
};
module.exports = $75aa09bad22f5af8$var$RelayStoreUtils;

});
parcelRegister("gvI75", function(module, exports) {

var $j5DMw = parcelRequire("j5DMw");

var $7vXph = parcelRequire("7vXph");

var $A9nvM = parcelRequire("A9nvM");

var $89Nxc = parcelRequire("89Nxc");
function $c051c295bb06055a$var$_toConsumableArray(r) {
    return $j5DMw(r) || $7vXph(r) || $A9nvM(r) || $89Nxc();
}
module.exports = $c051c295bb06055a$var$_toConsumableArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("j5DMw", function(module, exports) {

var $e7XTL = parcelRequire("e7XTL");
function $de5d57c4827e7982$var$_arrayWithoutHoles(r) {
    if (Array.isArray(r)) return $e7XTL(r);
}
module.exports = $de5d57c4827e7982$var$_arrayWithoutHoles, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("e7XTL", function(module, exports) {
function $a4902eb325460aa9$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
module.exports = $a4902eb325460aa9$var$_arrayLikeToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("7vXph", function(module, exports) {
function $5789829b07a5177b$var$_iterableToArray(r) {
    if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}
module.exports = $5789829b07a5177b$var$_iterableToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("A9nvM", function(module, exports) {

var $e7XTL = parcelRequire("e7XTL");
function $06caa339e2f8b155$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $e7XTL(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $e7XTL(r, a) : void 0;
    }
}
module.exports = $06caa339e2f8b155$var$_unsupportedIterableToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("89Nxc", function(module, exports) {
function $5f0596878cfa8108$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
module.exports = $5f0596878cfa8108$var$_nonIterableSpread, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("5oZCd", function(module, exports) {
'use strict';

var $f1aE8 = parcelRequire("f1aE8");
var $3eeefd2cfb3c8dcf$var$DEFAULT_HANDLE_KEY = $f1aE8.DEFAULT_HANDLE_KEY;

var $bQThX = parcelRequire("bQThX");
function $3eeefd2cfb3c8dcf$var$getRelayHandleKey(handleName, key, fieldName) {
    if (key && key !== $3eeefd2cfb3c8dcf$var$DEFAULT_HANDLE_KEY) return "__".concat(key, "_").concat(handleName);
    !(fieldName != null) && $bQThX(false);
    return "__".concat(fieldName, "_").concat(handleName);
}
module.exports = $3eeefd2cfb3c8dcf$var$getRelayHandleKey;

});
parcelRegister("f1aE8", function(module, exports) {
'use strict';
module.exports = {
    DEFAULT_HANDLE_KEY: ''
};

});


parcelRegister("9lZfN", function(module, exports) {
'use strict';
var $6cf596f7aafdc5b9$var$RelayConcreteNode = {
    ACTOR_CHANGE: 'ActorChange',
    CATCH_FIELD: 'CatchField',
    CONDITION: 'Condition',
    CLIENT_COMPONENT: 'ClientComponent',
    CLIENT_EDGE_TO_SERVER_OBJECT: 'ClientEdgeToServerObject',
    CLIENT_EDGE_TO_CLIENT_OBJECT: 'ClientEdgeToClientObject',
    CLIENT_EXTENSION: 'ClientExtension',
    DEFER: 'Defer',
    CONNECTION: 'Connection',
    FRAGMENT: 'Fragment',
    FRAGMENT_SPREAD: 'FragmentSpread',
    INLINE_DATA_FRAGMENT_SPREAD: 'InlineDataFragmentSpread',
    INLINE_DATA_FRAGMENT: 'InlineDataFragment',
    INLINE_FRAGMENT: 'InlineFragment',
    LINKED_FIELD: 'LinkedField',
    LINKED_HANDLE: 'LinkedHandle',
    LITERAL: 'Literal',
    LIST_VALUE: 'ListValue',
    LOCAL_ARGUMENT: 'LocalArgument',
    MODULE_IMPORT: 'ModuleImport',
    ALIASED_FRAGMENT_SPREAD: 'AliasedFragmentSpread',
    ALIASED_INLINE_FRAGMENT_SPREAD: 'AliasedInlineFragmentSpread',
    RELAY_RESOLVER: 'RelayResolver',
    RELAY_LIVE_RESOLVER: 'RelayLiveResolver',
    REQUIRED_FIELD: 'RequiredField',
    OBJECT_VALUE: 'ObjectValue',
    OPERATION: 'Operation',
    REQUEST: 'Request',
    ROOT_ARGUMENT: 'RootArgument',
    SCALAR_FIELD: 'ScalarField',
    SCALAR_HANDLE: 'ScalarHandle',
    SPLIT_OPERATION: 'SplitOperation',
    STREAM: 'Stream',
    TYPE_DISCRIMINATOR: 'TypeDiscriminator',
    UPDATABLE_QUERY: 'UpdatableQuery',
    VARIABLE: 'Variable'
};
module.exports = $6cf596f7aafdc5b9$var$RelayConcreteNode;

});

parcelRegister("ahEdt", function(module, exports) {
'use strict';
function $77cab009bd0cfc54$var$stableCopy(value) {
    if (!value || typeof value !== 'object') return value;
    if (Array.isArray(value)) return value.map($77cab009bd0cfc54$var$stableCopy);
    var keys = Object.keys(value).sort();
    var stable = {};
    for(var i = 0; i < keys.length; i++)stable[keys[i]] = $77cab009bd0cfc54$var$stableCopy(value[keys[i]]);
    return stable;
}
module.exports = $77cab009bd0cfc54$var$stableCopy;

});


parcelRegister("lhnaB", function(module, exports) {
'use strict';
var $f7dd289b5b9a0f3f$var$CONNECTION_CALLS = {
    after: true,
    before: true,
    find: true,
    first: true,
    last: true,
    surrounds: true
};
var $f7dd289b5b9a0f3f$var$config = {
    CURSOR: 'cursor',
    EDGES: 'edges',
    END_CURSOR: 'endCursor',
    HAS_NEXT_PAGE: 'hasNextPage',
    HAS_PREV_PAGE: 'hasPreviousPage',
    NODE: 'node',
    PAGE_INFO_TYPE: 'PageInfo',
    PAGE_INFO: 'pageInfo',
    START_CURSOR: 'startCursor'
};
var $f7dd289b5b9a0f3f$var$ConnectionInterface = {
    inject: function inject(newConfig) {
        $f7dd289b5b9a0f3f$var$config = newConfig;
    },
    get: function get() {
        return $f7dd289b5b9a0f3f$var$config;
    },
    isConnectionCall: function isConnectionCall(call) {
        return $f7dd289b5b9a0f3f$var$CONNECTION_CALLS.hasOwnProperty(call.name);
    }
};
module.exports = $f7dd289b5b9a0f3f$var$ConnectionInterface;

});

parcelRegister("hzw7m", function(module, exports) {
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */ 'use strict';

var $ZE2VP = parcelRequire("ZE2VP");
/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */ function $ccae9e7c19d9da4d$var$printWarning(format) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
    var argIndex = 0;
    var message = 'Warning: ' + format.replace(/%s/g, function() {
        return args[argIndex++];
    });
    if (typeof console !== 'undefined') console.error(message);
    try {
        // --- Welcome to debugging React ---
        // This error was thrown as a convenience so that you can use this stack
        // to find the callsite that caused this warning to fire.
        throw new Error(message);
    } catch (x) {}
}
var $ccae9e7c19d9da4d$var$warning = $ZE2VP;
module.exports = $ccae9e7c19d9da4d$var$warning;

});
parcelRegister("ZE2VP", function(module, exports) {
"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */ function $0b94c2fa5959ad3c$var$makeEmptyFunction(arg) {
    return function() {
        return arg;
    };
}
/**
 * This function accepts and discards inputs; it has no side effects. This is
 * primarily useful idiomatically for overridable function endpoints which
 * always need to be callable, since JS lacks a null-call idiom ala Cocoa.
 */ var $0b94c2fa5959ad3c$var$emptyFunction = function emptyFunction() {};
$0b94c2fa5959ad3c$var$emptyFunction.thatReturns = $0b94c2fa5959ad3c$var$makeEmptyFunction;
$0b94c2fa5959ad3c$var$emptyFunction.thatReturnsFalse = $0b94c2fa5959ad3c$var$makeEmptyFunction(false);
$0b94c2fa5959ad3c$var$emptyFunction.thatReturnsTrue = $0b94c2fa5959ad3c$var$makeEmptyFunction(true);
$0b94c2fa5959ad3c$var$emptyFunction.thatReturnsNull = $0b94c2fa5959ad3c$var$makeEmptyFunction(null);
$0b94c2fa5959ad3c$var$emptyFunction.thatReturnsThis = function() {
    return this;
};
$0b94c2fa5959ad3c$var$emptyFunction.thatReturnsArgument = function(arg) {
    return arg;
};
module.exports = $0b94c2fa5959ad3c$var$emptyFunction;

});



parcelRegister("emDuK", function(module, exports) {
'use strict';

var $7dvyf = parcelRequire("7dvyf");
var $a751c1a3efe20252$var$_interopRequireDefault = $7dvyf.default;

var $a751c1a3efe20252$var$_createForOfIteratorHelper2 = $a751c1a3efe20252$var$_interopRequireDefault((parcelRequire("bTRzt")));

var $jnVed = parcelRequire("jnVed");

var $lhnaB = parcelRequire("lhnaB");

var $bQThX = parcelRequire("bQThX");
parcelRequire("hzw7m");
var $a751c1a3efe20252$var$DeleteRecordHandler = {
    update: function update(store, payload) {
        var record = store.get(payload.dataID);
        if (record != null) {
            var idOrIds = record.getValue(payload.fieldKey);
            if (typeof idOrIds === 'string') store["delete"](idOrIds);
            else if (Array.isArray(idOrIds)) idOrIds.forEach(function(id) {
                if (typeof id === 'string') store["delete"](id);
            });
        }
    }
};
var $a751c1a3efe20252$var$DeleteEdgeHandler = {
    update: function update(store, payload) {
        var record = store.get(payload.dataID);
        if (record == null) return;
        var connections = payload.handleArgs.connections;
        !(connections != null) && $bQThX(false);
        var idOrIds = record.getValue(payload.fieldKey);
        var idList = Array.isArray(idOrIds) ? idOrIds : [
            idOrIds
        ];
        idList.forEach(function(id) {
            if (typeof id === 'string') {
                var _iterator = (0, $a751c1a3efe20252$var$_createForOfIteratorHelper2["default"])(connections), _step;
                try {
                    for(_iterator.s(); !(_step = _iterator.n()).done;){
                        var connectionID = _step.value;
                        var connection = store.get(connectionID);
                        if (connection == null) continue;
                        $jnVed.deleteNode(connection, id);
                    }
                } catch (err) {
                    _iterator.e(err);
                } finally{
                    _iterator.f();
                }
            }
        });
    }
};
var $a751c1a3efe20252$var$AppendEdgeHandler = {
    update: $a751c1a3efe20252$var$edgeUpdater($jnVed.insertEdgeAfter)
};
var $a751c1a3efe20252$var$PrependEdgeHandler = {
    update: $a751c1a3efe20252$var$edgeUpdater($jnVed.insertEdgeBefore)
};
var $a751c1a3efe20252$var$AppendNodeHandler = {
    update: $a751c1a3efe20252$var$nodeUpdater($jnVed.insertEdgeAfter)
};
var $a751c1a3efe20252$var$PrependNodeHandler = {
    update: $a751c1a3efe20252$var$nodeUpdater($jnVed.insertEdgeBefore)
};
function $a751c1a3efe20252$var$edgeUpdater(insertFn) {
    return function(store, payload) {
        var _serverEdges;
        var record = store.get(payload.dataID);
        if (record == null) return;
        var connections = payload.handleArgs.connections;
        !(connections != null) && $bQThX(false);
        var singleServerEdge, serverEdges;
        try {
            singleServerEdge = record.getLinkedRecord(payload.fieldKey);
        } catch (_unused) {}
        if (!singleServerEdge) try {
            serverEdges = record.getLinkedRecords(payload.fieldKey);
        } catch (_unused2) {}
        if (singleServerEdge == null && serverEdges == null) return;
        var _ConnectionInterface$ = $lhnaB.get(), NODE = _ConnectionInterface$.NODE, EDGES = _ConnectionInterface$.EDGES;
        var serverEdgeList = (_serverEdges = serverEdges) !== null && _serverEdges !== void 0 ? _serverEdges : [
            singleServerEdge
        ];
        var _iterator2 = (0, $a751c1a3efe20252$var$_createForOfIteratorHelper2["default"])(serverEdgeList), _step2;
        try {
            var _loop = function _loop() {
                var serverEdge = _step2.value;
                if (serverEdge == null) return "continue";
                var serverNode = serverEdge.getLinkedRecord('node');
                if (!serverNode) return "continue";
                var serverNodeId = serverNode.getDataID();
                var _iterator3 = (0, $a751c1a3efe20252$var$_createForOfIteratorHelper2["default"])(connections), _step3;
                try {
                    for(_iterator3.s(); !(_step3 = _iterator3.n()).done;){
                        var connectionID = _step3.value;
                        var connection = store.get(connectionID);
                        if (connection == null) continue;
                        var nodeAlreadyExistsInConnection = (_connection$getLinked = connection.getLinkedRecords(EDGES)) === null || _connection$getLinked === void 0 ? void 0 : _connection$getLinked.some(function(edge) {
                            var _edge$getLinkedRecord;
                            return (edge === null || edge === void 0 ? void 0 : (_edge$getLinkedRecord = edge.getLinkedRecord(NODE)) === null || _edge$getLinkedRecord === void 0 ? void 0 : _edge$getLinkedRecord.getDataID()) === serverNodeId;
                        });
                        if (nodeAlreadyExistsInConnection) continue;
                        var clientEdge = $jnVed.buildConnectionEdge(store, connection, serverEdge);
                        !(clientEdge != null) && $bQThX(false);
                        insertFn(connection, clientEdge);
                    }
                } catch (err) {
                    _iterator3.e(err);
                } finally{
                    _iterator3.f();
                }
            };
            for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
                var _connection$getLinked;
                var _ret = _loop();
                if (_ret === "continue") continue;
            }
        } catch (err) {
            _iterator2.e(err);
        } finally{
            _iterator2.f();
        }
    };
}
function $a751c1a3efe20252$var$nodeUpdater(insertFn) {
    return function(store, payload) {
        var _serverNodes;
        var record = store.get(payload.dataID);
        if (record == null) return;
        var _payload$handleArgs = payload.handleArgs, connections = _payload$handleArgs.connections, edgeTypeName = _payload$handleArgs.edgeTypeName;
        !(connections != null) && $bQThX(false);
        !(edgeTypeName != null) && $bQThX(false);
        var singleServerNode;
        var serverNodes;
        try {
            singleServerNode = record.getLinkedRecord(payload.fieldKey);
        } catch (_unused3) {}
        if (!singleServerNode) try {
            serverNodes = record.getLinkedRecords(payload.fieldKey);
        } catch (_unused4) {}
        if (singleServerNode == null && serverNodes == null) return;
        var _ConnectionInterface$2 = $lhnaB.get(), NODE = _ConnectionInterface$2.NODE, EDGES = _ConnectionInterface$2.EDGES;
        var serverNodeList = (_serverNodes = serverNodes) !== null && _serverNodes !== void 0 ? _serverNodes : [
            singleServerNode
        ];
        var _iterator4 = (0, $a751c1a3efe20252$var$_createForOfIteratorHelper2["default"])(serverNodeList), _step4;
        try {
            var _loop2 = function _loop2() {
                var serverNode = _step4.value;
                if (serverNode == null) return "continue";
                var serverNodeId = serverNode.getDataID();
                var _iterator5 = (0, $a751c1a3efe20252$var$_createForOfIteratorHelper2["default"])(connections), _step5;
                try {
                    for(_iterator5.s(); !(_step5 = _iterator5.n()).done;){
                        var connectionID = _step5.value;
                        var connection = store.get(connectionID);
                        if (connection == null) continue;
                        var nodeAlreadyExistsInConnection = (_connection$getLinked2 = connection.getLinkedRecords(EDGES)) === null || _connection$getLinked2 === void 0 ? void 0 : _connection$getLinked2.some(function(edge) {
                            var _edge$getLinkedRecord2;
                            return (edge === null || edge === void 0 ? void 0 : (_edge$getLinkedRecord2 = edge.getLinkedRecord(NODE)) === null || _edge$getLinkedRecord2 === void 0 ? void 0 : _edge$getLinkedRecord2.getDataID()) === serverNodeId;
                        });
                        if (nodeAlreadyExistsInConnection) continue;
                        var clientEdge = $jnVed.createEdge(store, connection, serverNode, edgeTypeName);
                        !(clientEdge != null) && $bQThX(false);
                        insertFn(connection, clientEdge);
                    }
                } catch (err) {
                    _iterator5.e(err);
                } finally{
                    _iterator5.f();
                }
            };
            for(_iterator4.s(); !(_step4 = _iterator4.n()).done;){
                var _connection$getLinked2;
                var _ret2 = _loop2();
                if (_ret2 === "continue") continue;
            }
        } catch (err) {
            _iterator4.e(err);
        } finally{
            _iterator4.f();
        }
    };
}
module.exports = {
    AppendEdgeHandler: $a751c1a3efe20252$var$AppendEdgeHandler,
    DeleteRecordHandler: $a751c1a3efe20252$var$DeleteRecordHandler,
    PrependEdgeHandler: $a751c1a3efe20252$var$PrependEdgeHandler,
    AppendNodeHandler: $a751c1a3efe20252$var$AppendNodeHandler,
    PrependNodeHandler: $a751c1a3efe20252$var$PrependNodeHandler,
    DeleteEdgeHandler: $a751c1a3efe20252$var$DeleteEdgeHandler
};

});
parcelRegister("bTRzt", function(module, exports) {

var $A9nvM = parcelRequire("A9nvM");
function $8a9e62e04140d90c$var$_createForOfIteratorHelper(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (!t) {
        if (Array.isArray(r) || (t = $A9nvM(r)) || e && r && "number" == typeof r.length) {
            t && (r = t);
            var _n = 0, F = function F() {};
            return {
                s: F,
                n: function n() {
                    return _n >= r.length ? {
                        done: !0
                    } : {
                        done: !1,
                        value: r[_n++]
                    };
                },
                e: function e(r) {
                    throw r;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var o, a = !0, u = !1;
    return {
        s: function s() {
            t = t.call(r);
        },
        n: function n() {
            var r = t.next();
            return a = r.done, r;
        },
        e: function e(r) {
            u = !0, o = r;
        },
        f: function f() {
            try {
                a || null == t["return"] || t["return"]();
            } finally{
                if (u) throw o;
            }
        }
    };
}
module.exports = $8a9e62e04140d90c$var$_createForOfIteratorHelper, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("4LekS", function(module, exports) {
'use strict';

var $jnVed = parcelRequire("jnVed");

var $emDuK = parcelRequire("emDuK");

var $bQThX = parcelRequire("bQThX");
function $3776abf615b3865b$var$RelayDefaultHandlerProvider(handle) {
    switch(handle){
        case 'connection':
            return $jnVed;
        case 'deleteRecord':
            return $emDuK.DeleteRecordHandler;
        case 'deleteEdge':
            return $emDuK.DeleteEdgeHandler;
        case 'appendEdge':
            return $emDuK.AppendEdgeHandler;
        case 'prependEdge':
            return $emDuK.PrependEdgeHandler;
        case 'appendNode':
            return $emDuK.AppendNodeHandler;
        case 'prependNode':
            return $emDuK.PrependNodeHandler;
    }
    $bQThX(false);
}
module.exports = $3776abf615b3865b$var$RelayDefaultHandlerProvider;

});

parcelRegister("d1Rdu", function(module, exports) {
'use strict';

var $8AEJo = parcelRequire("8AEJo");
var $97c4a612bf287f6f$var$getRequest = $8AEJo.getRequest;

var $j6CXw = parcelRequire("j6CXw");

var $ilblc = parcelRequire("ilblc");
var $97c4a612bf287f6f$var$createOperationDescriptor = $ilblc.createOperationDescriptor;

var $jgdIQ = parcelRequire("jgdIQ");

var $bQThX = parcelRequire("bQThX");
function $97c4a612bf287f6f$var$applyOptimisticMutation(environment, config) {
    !$j6CXw(environment) && $bQThX(false);
    var mutation = $97c4a612bf287f6f$var$getRequest(config.mutation);
    if (mutation.params.operationKind !== 'mutation') throw new Error('commitMutation: Expected mutation operation');
    var optimisticUpdater = config.optimisticUpdater;
    var configs = config.configs, optimisticResponse = config.optimisticResponse, variables = config.variables;
    var operation = $97c4a612bf287f6f$var$createOperationDescriptor(mutation, variables);
    if (configs) {
        var _RelayDeclarativeMuta = $jgdIQ.convert(configs, mutation, optimisticUpdater);
        optimisticUpdater = _RelayDeclarativeMuta.optimisticUpdater;
    }
    return environment.applyMutation({
        operation: operation,
        response: optimisticResponse,
        updater: optimisticUpdater
    });
}
module.exports = $97c4a612bf287f6f$var$applyOptimisticMutation;

});
parcelRegister("8AEJo", function(module, exports) {
'use strict';

var $9lZfN = parcelRequire("9lZfN");

var $bQThX = parcelRequire("bQThX");
parcelRequire("hzw7m");
function $641147dcccfc46cc$var$graphql(strings) {
    $bQThX(false);
}
function $641147dcccfc46cc$var$getNode(taggedNode) {
    var node = taggedNode;
    if (typeof node === 'function') node = node();
    else if (node["default"]) node = node["default"];
    return node;
}
function $641147dcccfc46cc$var$isFragment(node) {
    var fragment = $641147dcccfc46cc$var$getNode(node);
    return typeof fragment === 'object' && fragment !== null && fragment.kind === $9lZfN.FRAGMENT;
}
function $641147dcccfc46cc$var$isRequest(node) {
    var request = $641147dcccfc46cc$var$getNode(node);
    return typeof request === 'object' && request !== null && request.kind === $9lZfN.REQUEST;
}
function $641147dcccfc46cc$var$isUpdatableQuery(node) {
    var updatableQuery = $641147dcccfc46cc$var$getNode(node);
    return typeof updatableQuery === 'object' && updatableQuery !== null && updatableQuery.kind === $9lZfN.UPDATABLE_QUERY;
}
function $641147dcccfc46cc$var$isInlineDataFragment(node) {
    var fragment = $641147dcccfc46cc$var$getNode(node);
    return typeof fragment === 'object' && fragment !== null && fragment.kind === $9lZfN.INLINE_DATA_FRAGMENT;
}
function $641147dcccfc46cc$var$getFragment(taggedNode) {
    var fragment = $641147dcccfc46cc$var$getNode(taggedNode);
    !$641147dcccfc46cc$var$isFragment(fragment) && $bQThX(false);
    return fragment;
}
function $641147dcccfc46cc$var$getPaginationFragment(taggedNode) {
    var _fragment$metadata;
    var fragment = $641147dcccfc46cc$var$getFragment(taggedNode);
    var refetch = (_fragment$metadata = fragment.metadata) === null || _fragment$metadata === void 0 ? void 0 : _fragment$metadata.refetch;
    var connection = refetch === null || refetch === void 0 ? void 0 : refetch.connection;
    if (refetch === null || typeof refetch !== 'object' || connection === null || typeof connection !== 'object') return null;
    return fragment;
}
function $641147dcccfc46cc$var$getRefetchableFragment(taggedNode) {
    var _fragment$metadata2;
    var fragment = $641147dcccfc46cc$var$getFragment(taggedNode);
    var refetch = (_fragment$metadata2 = fragment.metadata) === null || _fragment$metadata2 === void 0 ? void 0 : _fragment$metadata2.refetch;
    if (refetch === null || typeof refetch !== 'object') return null;
    return fragment;
}
function $641147dcccfc46cc$var$getRequest(taggedNode) {
    var request = $641147dcccfc46cc$var$getNode(taggedNode);
    !$641147dcccfc46cc$var$isRequest(request) && $bQThX(false);
    return request;
}
function $641147dcccfc46cc$var$getUpdatableQuery(taggedNode) {
    var updatableQuery = $641147dcccfc46cc$var$getNode(taggedNode);
    !$641147dcccfc46cc$var$isUpdatableQuery(updatableQuery) && $bQThX(false);
    return updatableQuery;
}
function $641147dcccfc46cc$var$getInlineDataFragment(taggedNode) {
    var fragment = $641147dcccfc46cc$var$getNode(taggedNode);
    !$641147dcccfc46cc$var$isInlineDataFragment(fragment) && $bQThX(false);
    return fragment;
}
module.exports = {
    getFragment: $641147dcccfc46cc$var$getFragment,
    getNode: $641147dcccfc46cc$var$getNode,
    getPaginationFragment: $641147dcccfc46cc$var$getPaginationFragment,
    getRefetchableFragment: $641147dcccfc46cc$var$getRefetchableFragment,
    getRequest: $641147dcccfc46cc$var$getRequest,
    getUpdatableQuery: $641147dcccfc46cc$var$getUpdatableQuery,
    getInlineDataFragment: $641147dcccfc46cc$var$getInlineDataFragment,
    graphql: $641147dcccfc46cc$var$graphql,
    isFragment: $641147dcccfc46cc$var$isFragment,
    isRequest: $641147dcccfc46cc$var$isRequest,
    isUpdatableQuery: $641147dcccfc46cc$var$isUpdatableQuery,
    isInlineDataFragment: $641147dcccfc46cc$var$isInlineDataFragment
};

});

parcelRegister("j6CXw", function(module, exports) {
'use strict';
function $de8ccc5351faeb1e$var$isRelayModernEnvironment(environment) {
    return Boolean(environment && environment['@@RelayModernEnvironment']);
}
module.exports = $de8ccc5351faeb1e$var$isRelayModernEnvironment;

});

parcelRegister("ilblc", function(module, exports) {
'use strict';
parcelRequire("8YAvI");

var $9ESC3 = parcelRequire("9ESC3");

var $kpcDM = parcelRequire("kpcDM");
var $d5a2fc3c51e89e03$var$getOperationVariables = $kpcDM.getOperationVariables;

var $3o9ph = parcelRequire("3o9ph");
var $d5a2fc3c51e89e03$var$createNormalizationSelector = $3o9ph.createNormalizationSelector, $d5a2fc3c51e89e03$var$createReaderSelector = $3o9ph.createReaderSelector;

var $a6k4O = parcelRequire("a6k4O");
var $d5a2fc3c51e89e03$var$ROOT_ID = $a6k4O.ROOT_ID;
function $d5a2fc3c51e89e03$var$createOperationDescriptor(request, variables, cacheConfig) {
    var dataID = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : $d5a2fc3c51e89e03$var$ROOT_ID;
    var operation = request.operation;
    var operationVariables = $d5a2fc3c51e89e03$var$getOperationVariables(operation, request.params.providedVariables, variables);
    var requestDescriptor = $d5a2fc3c51e89e03$var$createRequestDescriptor(request, operationVariables, cacheConfig);
    var operationDescriptor = {
        fragment: $d5a2fc3c51e89e03$var$createReaderSelector(request.fragment, dataID, operationVariables, requestDescriptor),
        request: requestDescriptor,
        root: $d5a2fc3c51e89e03$var$createNormalizationSelector(operation, dataID, operationVariables)
    };
    return operationDescriptor;
}
function $d5a2fc3c51e89e03$var$createRequestDescriptor(request, variables, cacheConfig) {
    var requestDescriptor = {
        identifier: $9ESC3(request.params, variables),
        node: request,
        variables: variables,
        cacheConfig: cacheConfig
    };
    return requestDescriptor;
}
module.exports = {
    createOperationDescriptor: $d5a2fc3c51e89e03$var$createOperationDescriptor,
    createRequestDescriptor: $d5a2fc3c51e89e03$var$createRequestDescriptor
};

});
parcelRegister("8YAvI", function(module, exports) {
'use strict';
function $68903f8a83767f4e$var$deepFreeze(object) {
    if (!$68903f8a83767f4e$var$shouldBeFrozen(object)) return object;
    Object.freeze(object);
    Object.getOwnPropertyNames(object).forEach(function(name) {
        var property = object[name];
        if (property && typeof property === 'object' && !Object.isFrozen(property)) $68903f8a83767f4e$var$deepFreeze(property);
    });
    return object;
}
function $68903f8a83767f4e$var$shouldBeFrozen(value) {
    return value != null && (Array.isArray(value) || typeof value === 'object' && value.constructor === Object);
}
module.exports = $68903f8a83767f4e$var$deepFreeze;

});

parcelRegister("9ESC3", function(module, exports) {
'use strict';

var $ahEdt = parcelRequire("ahEdt");

var $bQThX = parcelRequire("bQThX");
function $7082366b8c5cc274$var$getRequestIdentifier(parameters, variables) {
    var requestID = parameters.cacheID != null ? parameters.cacheID : parameters.id;
    !(requestID != null) && $bQThX(false);
    return requestID + JSON.stringify($ahEdt(variables));
}
module.exports = $7082366b8c5cc274$var$getRequestIdentifier;

});

parcelRegister("kpcDM", function(module, exports) {
'use strict';

var $7dvyf = parcelRequire("7dvyf");
var $edaff29fe25b1b1d$var$_interopRequireDefault = $7dvyf.default;

var $edaff29fe25b1b1d$var$_objectSpread2 = $edaff29fe25b1b1d$var$_interopRequireDefault((parcelRequire("4N8OD")));

var $a6k4O = parcelRequire("a6k4O");
var $edaff29fe25b1b1d$var$getArgumentValues = $a6k4O.getArgumentValues;

var $bQThX = parcelRequire("bQThX");
function $edaff29fe25b1b1d$var$getFragmentVariables(fragment, rootVariables, argumentVariables) {
    if (fragment.argumentDefinitions == null) return argumentVariables;
    var variables;
    fragment.argumentDefinitions.forEach(function(definition) {
        if (argumentVariables.hasOwnProperty(definition.name)) return;
        variables = variables || (0, $edaff29fe25b1b1d$var$_objectSpread2["default"])({}, argumentVariables);
        switch(definition.kind){
            case 'LocalArgument':
                variables[definition.name] = definition.defaultValue;
                break;
            case 'RootArgument':
                if (!rootVariables.hasOwnProperty(definition.name)) {
                    variables[definition.name] = undefined;
                    break;
                }
                variables[definition.name] = rootVariables[definition.name];
                break;
            default:
                definition;
                $bQThX(false);
        }
    });
    return variables || argumentVariables;
}
function $edaff29fe25b1b1d$var$getOperationVariables(operation, providedVariables, variables) {
    var operationVariables = {};
    operation.argumentDefinitions.forEach(function(def) {
        var value = def.defaultValue;
        if (variables[def.name] != null) value = variables[def.name];
        operationVariables[def.name] = value;
    });
    if (providedVariables != null) Object.keys(providedVariables).forEach(function(varName) {
        operationVariables[varName] = providedVariables[varName].get();
    });
    return operationVariables;
}
function $edaff29fe25b1b1d$var$getLocalVariables(currentVariables, argumentDefinitions, args) {
    if (argumentDefinitions == null) return currentVariables;
    var nextVariables = (0, $edaff29fe25b1b1d$var$_objectSpread2["default"])({}, currentVariables);
    var nextArgs = args ? $edaff29fe25b1b1d$var$getArgumentValues(args, currentVariables) : {};
    argumentDefinitions.forEach(function(def) {
        var _nextArgs$def$name;
        var value = (_nextArgs$def$name = nextArgs[def.name]) !== null && _nextArgs$def$name !== void 0 ? _nextArgs$def$name : def.defaultValue;
        nextVariables[def.name] = value;
    });
    return nextVariables;
}
module.exports = {
    getLocalVariables: $edaff29fe25b1b1d$var$getLocalVariables,
    getFragmentVariables: $edaff29fe25b1b1d$var$getFragmentVariables,
    getOperationVariables: $edaff29fe25b1b1d$var$getOperationVariables
};

});
parcelRegister("4N8OD", function(module, exports) {

var $dW6Ee = parcelRequire("dW6Ee");
function $37d293aa03d0291e$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $37d293aa03d0291e$var$_objectSpread2(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $37d293aa03d0291e$var$ownKeys(Object(t), !0).forEach(function(r) {
            $dW6Ee(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $37d293aa03d0291e$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
module.exports = $37d293aa03d0291e$var$_objectSpread2, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("3o9ph", function(module, exports) {
'use strict';

var $kpcDM = parcelRequire("kpcDM");
var $277ae8fcbad2bd5c$var$getFragmentVariables = $kpcDM.getFragmentVariables;

var $a6k4O = parcelRequire("a6k4O");
var $277ae8fcbad2bd5c$var$CLIENT_EDGE_TRAVERSAL_PATH = $a6k4O.CLIENT_EDGE_TRAVERSAL_PATH, $277ae8fcbad2bd5c$var$FRAGMENT_OWNER_KEY = $a6k4O.FRAGMENT_OWNER_KEY, $277ae8fcbad2bd5c$var$FRAGMENT_POINTER_IS_WITHIN_UNMATCHED_TYPE_REFINEMENT = $a6k4O.FRAGMENT_POINTER_IS_WITHIN_UNMATCHED_TYPE_REFINEMENT, $277ae8fcbad2bd5c$var$FRAGMENTS_KEY = $a6k4O.FRAGMENTS_KEY, $277ae8fcbad2bd5c$var$ID_KEY = $a6k4O.ID_KEY;

var $3Nt2B = parcelRequire("3Nt2B");

var $bQThX = parcelRequire("bQThX");
parcelRequire("hzw7m");
function $277ae8fcbad2bd5c$var$getSingularSelector(fragment, item) {
    !(typeof item === 'object' && item !== null && !Array.isArray(item)) && $bQThX(false);
    var dataID = item[$277ae8fcbad2bd5c$var$ID_KEY];
    var fragments = item[$277ae8fcbad2bd5c$var$FRAGMENTS_KEY];
    var mixedOwner = item[$277ae8fcbad2bd5c$var$FRAGMENT_OWNER_KEY];
    var mixedClientEdgeTraversalPath = item[$277ae8fcbad2bd5c$var$CLIENT_EDGE_TRAVERSAL_PATH];
    if (typeof dataID === 'string' && typeof fragments === 'object' && fragments !== null && typeof fragments[fragment.name] === 'object' && fragments[fragment.name] !== null && typeof mixedOwner === 'object' && mixedOwner !== null && (mixedClientEdgeTraversalPath == null || Array.isArray(mixedClientEdgeTraversalPath))) {
        var owner = mixedOwner;
        var clientEdgeTraversalPath = mixedClientEdgeTraversalPath;
        var argumentVariables = fragments[fragment.name];
        var fragmentVariables = $277ae8fcbad2bd5c$var$getFragmentVariables(fragment, owner.variables, argumentVariables);
        var isWithinUnmatchedTypeRefinement = argumentVariables[$277ae8fcbad2bd5c$var$FRAGMENT_POINTER_IS_WITHIN_UNMATCHED_TYPE_REFINEMENT] === true;
        return $277ae8fcbad2bd5c$var$createReaderSelector(fragment, dataID, fragmentVariables, owner, isWithinUnmatchedTypeRefinement, clientEdgeTraversalPath);
    }
    var stringifiedItem;
    return null;
}
function $277ae8fcbad2bd5c$var$getPluralSelector(fragment, items) {
    var selectors = null;
    items.forEach(function(item, ii) {
        var selector = item != null ? $277ae8fcbad2bd5c$var$getSingularSelector(fragment, item) : null;
        if (selector != null) {
            selectors = selectors || [];
            selectors.push(selector);
        }
    });
    if (selectors == null) return null;
    else return {
        kind: 'PluralReaderSelector',
        selectors: selectors
    };
}
function $277ae8fcbad2bd5c$var$getSelector(fragment, item) {
    if (item == null) return item;
    else if (fragment.metadata && fragment.metadata.plural === true) {
        !Array.isArray(item) && $bQThX(false);
        return $277ae8fcbad2bd5c$var$getPluralSelector(fragment, item);
    } else {
        !!Array.isArray(item) && $bQThX(false);
        return $277ae8fcbad2bd5c$var$getSingularSelector(fragment, item);
    }
}
function $277ae8fcbad2bd5c$var$getSelectorsFromObject(fragments, object) {
    var selectors = {};
    for(var key in fragments)if (fragments.hasOwnProperty(key)) {
        var fragment = fragments[key];
        var item = object[key];
        selectors[key] = $277ae8fcbad2bd5c$var$getSelector(fragment, item);
    }
    return selectors;
}
function $277ae8fcbad2bd5c$var$getDataIDsFromObject(fragments, object) {
    var ids = {};
    for(var key in fragments)if (fragments.hasOwnProperty(key)) {
        var fragment = fragments[key];
        var item = object[key];
        ids[key] = $277ae8fcbad2bd5c$var$getDataIDsFromFragment(fragment, item);
    }
    return ids;
}
function $277ae8fcbad2bd5c$var$getDataIDsFromFragment(fragment, item) {
    if (item == null) return item;
    else if (fragment.metadata && fragment.metadata.plural === true) {
        !Array.isArray(item) && $bQThX(false);
        return $277ae8fcbad2bd5c$var$getDataIDs(fragment, item);
    } else {
        !!Array.isArray(item) && $bQThX(false);
        return $277ae8fcbad2bd5c$var$getDataID(fragment, item);
    }
}
function $277ae8fcbad2bd5c$var$getDataIDs(fragment, items) {
    var ids = null;
    items.forEach(function(item) {
        var id = item != null ? $277ae8fcbad2bd5c$var$getDataID(fragment, item) : null;
        if (id != null) {
            ids = ids || [];
            ids.push(id);
        }
    });
    return ids;
}
function $277ae8fcbad2bd5c$var$getDataID(fragment, item) {
    !(typeof item === 'object' && item !== null && !Array.isArray(item)) && $bQThX(false);
    var dataID = item[$277ae8fcbad2bd5c$var$ID_KEY];
    if (typeof dataID === 'string') return dataID;
    return null;
}
function $277ae8fcbad2bd5c$var$getVariablesFromObject(fragments, object) {
    var variables = {};
    for(var key in fragments)if (fragments.hasOwnProperty(key)) {
        var fragment = fragments[key];
        var item = object[key];
        var itemVariables = $277ae8fcbad2bd5c$var$getVariablesFromFragment(fragment, item);
        Object.assign(variables, itemVariables);
    }
    return variables;
}
function $277ae8fcbad2bd5c$var$getVariablesFromFragment(fragment, item) {
    var _fragment$metadata;
    if (item == null) return {};
    else if (((_fragment$metadata = fragment.metadata) === null || _fragment$metadata === void 0 ? void 0 : _fragment$metadata.plural) === true) {
        !Array.isArray(item) && $bQThX(false);
        return $277ae8fcbad2bd5c$var$getVariablesFromPluralFragment(fragment, item);
    } else {
        !!Array.isArray(item) && $bQThX(false);
        return $277ae8fcbad2bd5c$var$getVariablesFromSingularFragment(fragment, item) || {};
    }
}
function $277ae8fcbad2bd5c$var$getVariablesFromSingularFragment(fragment, item) {
    var selector = $277ae8fcbad2bd5c$var$getSingularSelector(fragment, item);
    if (!selector) return null;
    return selector.variables;
}
function $277ae8fcbad2bd5c$var$getVariablesFromPluralFragment(fragment, items) {
    var variables = {};
    items.forEach(function(value, ii) {
        if (value != null) {
            var itemVariables = $277ae8fcbad2bd5c$var$getVariablesFromSingularFragment(fragment, value);
            if (itemVariables != null) Object.assign(variables, itemVariables);
        }
    });
    return variables;
}
function $277ae8fcbad2bd5c$var$areEqualSingularSelectors(thisSelector, thatSelector) {
    return thisSelector.dataID === thatSelector.dataID && thisSelector.node === thatSelector.node && $3Nt2B(thisSelector.variables, thatSelector.variables) && $277ae8fcbad2bd5c$var$areEqualOwners(thisSelector.owner, thatSelector.owner) && thisSelector.isWithinUnmatchedTypeRefinement === thatSelector.isWithinUnmatchedTypeRefinement && $277ae8fcbad2bd5c$var$areEqualClientEdgeTraversalPaths(thisSelector.clientEdgeTraversalPath, thatSelector.clientEdgeTraversalPath);
}
function $277ae8fcbad2bd5c$var$areEqualOwners(thisOwner, thatOwner) {
    if (thisOwner === thatOwner) return true;
    else return thisOwner.identifier === thatOwner.identifier && $3Nt2B(thisOwner.cacheConfig, thatOwner.cacheConfig);
}
function $277ae8fcbad2bd5c$var$areEqualClientEdgeTraversalPaths(thisPath, thatPath) {
    if (thisPath === thatPath) return true;
    if (thisPath == null || thatPath == null || thisPath.length !== thatPath.length) return false;
    var idx = thisPath.length;
    while(idx--){
        var a = thisPath[idx];
        var b = thatPath[idx];
        if (a === b) continue;
        if (a == null || b == null || a.clientEdgeDestinationID !== b.clientEdgeDestinationID || a.readerClientEdge !== b.readerClientEdge) return false;
    }
    return true;
}
function $277ae8fcbad2bd5c$var$areEqualSelectors(a, b) {
    if (a === b) return true;
    else if (a == null) return b == null;
    else if (b == null) return a == null;
    else if (a.kind === 'SingularReaderSelector' && b.kind === 'SingularReaderSelector') return $277ae8fcbad2bd5c$var$areEqualSingularSelectors(a, b);
    else if (a.kind === 'PluralReaderSelector' && b.kind === 'PluralReaderSelector') return a.selectors.length === b.selectors.length && a.selectors.every(function(s, i) {
        return $277ae8fcbad2bd5c$var$areEqualSingularSelectors(s, b.selectors[i]);
    });
    else return false;
}
function $277ae8fcbad2bd5c$var$createReaderSelector(fragment, dataID, variables, request) {
    var isWithinUnmatchedTypeRefinement = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
    var clientEdgeTraversalPath = arguments.length > 5 ? arguments[5] : undefined;
    return {
        kind: 'SingularReaderSelector',
        dataID: dataID,
        isWithinUnmatchedTypeRefinement: isWithinUnmatchedTypeRefinement,
        clientEdgeTraversalPath: clientEdgeTraversalPath !== null && clientEdgeTraversalPath !== void 0 ? clientEdgeTraversalPath : null,
        node: fragment,
        variables: variables,
        owner: request
    };
}
function $277ae8fcbad2bd5c$var$createNormalizationSelector(node, dataID, variables) {
    return {
        dataID: dataID,
        node: node,
        variables: variables
    };
}
module.exports = {
    areEqualSelectors: $277ae8fcbad2bd5c$var$areEqualSelectors,
    createReaderSelector: $277ae8fcbad2bd5c$var$createReaderSelector,
    createNormalizationSelector: $277ae8fcbad2bd5c$var$createNormalizationSelector,
    getDataIDsFromFragment: $277ae8fcbad2bd5c$var$getDataIDsFromFragment,
    getDataIDsFromObject: $277ae8fcbad2bd5c$var$getDataIDsFromObject,
    getSingularSelector: $277ae8fcbad2bd5c$var$getSingularSelector,
    getPluralSelector: $277ae8fcbad2bd5c$var$getPluralSelector,
    getSelector: $277ae8fcbad2bd5c$var$getSelector,
    getSelectorsFromObject: $277ae8fcbad2bd5c$var$getSelectorsFromObject,
    getVariablesFromSingularFragment: $277ae8fcbad2bd5c$var$getVariablesFromSingularFragment,
    getVariablesFromPluralFragment: $277ae8fcbad2bd5c$var$getVariablesFromPluralFragment,
    getVariablesFromFragment: $277ae8fcbad2bd5c$var$getVariablesFromFragment,
    getVariablesFromObject: $277ae8fcbad2bd5c$var$getVariablesFromObject
};

});
parcelRegister("3Nt2B", function(module, exports) {
"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */ var $2c3c79a509732a78$var$aStackPool = [];
var $2c3c79a509732a78$var$bStackPool = [];
/**
 * Checks if two values are equal. Values may be primitives, arrays, or objects.
 * Returns true if both arguments have the same keys and values.
 *
 * @see http://underscorejs.org
 * @copyright 2009-2013 Jeremy Ashkenas, DocumentCloud Inc.
 * @license MIT
 */ function $2c3c79a509732a78$var$areEqual(a, b) {
    var aStack = $2c3c79a509732a78$var$aStackPool.length ? $2c3c79a509732a78$var$aStackPool.pop() : [];
    var bStack = $2c3c79a509732a78$var$bStackPool.length ? $2c3c79a509732a78$var$bStackPool.pop() : [];
    var result = $2c3c79a509732a78$var$eq(a, b, aStack, bStack);
    aStack.length = 0;
    bStack.length = 0;
    $2c3c79a509732a78$var$aStackPool.push(aStack);
    $2c3c79a509732a78$var$bStackPool.push(bStack);
    return result;
}
function $2c3c79a509732a78$var$eq(a, b, aStack, bStack) {
    if (a === b) // Identical objects are equal. `0 === -0`, but they aren't identical.
    return a !== 0 || 1 / a == 1 / b;
    if (a == null || b == null) // a or b can be `null` or `undefined`
    return false;
    if (typeof a != 'object' || typeof b != 'object') return false;
    var objToStr = Object.prototype.toString;
    var className = objToStr.call(a);
    if (className != objToStr.call(b)) return false;
    switch(className){
        case '[object String]':
            return a == String(b);
        case '[object Number]':
            return isNaN(a) || isNaN(b) ? false : a == Number(b);
        case '[object Date]':
        case '[object Boolean]':
            return +a == +b;
        case '[object RegExp]':
            return a.source == b.source && a.global == b.global && a.multiline == b.multiline && a.ignoreCase == b.ignoreCase;
    } // Assume equality for cyclic structures.
    var length = aStack.length;
    while(length--){
        if (aStack[length] == a) return bStack[length] == b;
    }
    aStack.push(a);
    bStack.push(b);
    var size = 0; // Recursively compare objects and arrays.
    if (className === '[object Array]') {
        size = a.length;
        if (size !== b.length) return false;
         // Deep compare the contents, ignoring non-numeric properties.
        while(size--){
            if (!$2c3c79a509732a78$var$eq(a[size], b[size], aStack, bStack)) return false;
        }
    } else {
        if (a.constructor !== b.constructor) return false;
        if (a.hasOwnProperty('valueOf') && b.hasOwnProperty('valueOf')) return a.valueOf() == b.valueOf();
        var keys = Object.keys(a);
        if (keys.length != Object.keys(b).length) return false;
        for(var i = 0; i < keys.length; i++){
            if (!$2c3c79a509732a78$var$eq(a[keys[i]], b[keys[i]], aStack, bStack)) return false;
        }
    }
    aStack.pop();
    bStack.pop();
    return true;
}
module.exports = $2c3c79a509732a78$var$areEqual;

});



parcelRegister("jgdIQ", function(module, exports) {
'use strict';

var $7dvyf = parcelRequire("7dvyf");
var $e05a27e198729929$var$_interopRequireDefault = $7dvyf.default;

var $e05a27e198729929$var$_createForOfIteratorHelper2 = $e05a27e198729929$var$_interopRequireDefault((parcelRequire("bTRzt")));

var $jnVed = parcelRequire("jnVed");
parcelRequire("hzw7m");
var $e05a27e198729929$var$MutationTypes = Object.freeze({
    RANGE_ADD: 'RANGE_ADD',
    RANGE_DELETE: 'RANGE_DELETE',
    NODE_DELETE: 'NODE_DELETE'
});
var $e05a27e198729929$var$RangeOperations = Object.freeze({
    APPEND: 'append',
    PREPEND: 'prepend'
});
function $e05a27e198729929$var$convert(configs, request, optimisticUpdater, updater) {
    var configOptimisticUpdates = optimisticUpdater ? [
        optimisticUpdater
    ] : [];
    var configUpdates = updater ? [
        updater
    ] : [];
    configs.forEach(function(config) {
        switch(config.type){
            case 'NODE_DELETE':
                var nodeDeleteResult = $e05a27e198729929$var$nodeDelete(config, request);
                if (nodeDeleteResult) {
                    configOptimisticUpdates.push(nodeDeleteResult);
                    configUpdates.push(nodeDeleteResult);
                }
                break;
            case 'RANGE_ADD':
                var rangeAddResult = $e05a27e198729929$var$rangeAdd(config, request);
                if (rangeAddResult) {
                    configOptimisticUpdates.push(rangeAddResult);
                    configUpdates.push(rangeAddResult);
                }
                break;
            case 'RANGE_DELETE':
                var rangeDeleteResult = $e05a27e198729929$var$rangeDelete(config, request);
                if (rangeDeleteResult) {
                    configOptimisticUpdates.push(rangeDeleteResult);
                    configUpdates.push(rangeDeleteResult);
                }
                break;
        }
    });
    return {
        optimisticUpdater: function optimisticUpdater(store, data) {
            configOptimisticUpdates.forEach(function(eachOptimisticUpdater) {
                eachOptimisticUpdater(store, data);
            });
        },
        updater: function updater(store, data) {
            configUpdates.forEach(function(eachUpdater) {
                eachUpdater(store, data);
            });
        }
    };
}
function $e05a27e198729929$var$nodeDelete(config, request) {
    var deletedIDFieldName = config.deletedIDFieldName;
    var rootField = $e05a27e198729929$var$getRootField(request);
    if (!rootField) return null;
    return function(store, data) {
        var payload = store.getRootField(rootField);
        if (!payload) return;
        var deleteID = payload.getValue(deletedIDFieldName);
        var deleteIDs = Array.isArray(deleteID) ? deleteID : [
            deleteID
        ];
        deleteIDs.forEach(function(id) {
            if (id && typeof id === 'string') store["delete"](id);
        });
    };
}
function $e05a27e198729929$var$rangeAdd(config, request) {
    var parentID = config.parentID, connectionInfo = config.connectionInfo, edgeName = config.edgeName;
    if (!parentID) return null;
    var rootField = $e05a27e198729929$var$getRootField(request);
    if (!connectionInfo || !rootField) return null;
    return function(store, data) {
        var parent = store.get(parentID);
        if (!parent) return;
        var payload = store.getRootField(rootField);
        if (!payload) return;
        var serverEdge = payload.getLinkedRecord(edgeName);
        var _iterator = (0, $e05a27e198729929$var$_createForOfIteratorHelper2["default"])(connectionInfo), _step;
        try {
            for(_iterator.s(); !(_step = _iterator.n()).done;){
                var info = _step.value;
                if (!serverEdge) continue;
                var connection = $jnVed.getConnection(parent, info.key, info.filters);
                if (!connection) continue;
                var clientEdge = $jnVed.buildConnectionEdge(store, connection, serverEdge);
                if (!clientEdge) continue;
                switch(info.rangeBehavior){
                    case 'append':
                        $jnVed.insertEdgeAfter(connection, clientEdge);
                        break;
                    case 'prepend':
                        $jnVed.insertEdgeBefore(connection, clientEdge);
                        break;
                    default:
                        break;
                }
            }
        } catch (err) {
            _iterator.e(err);
        } finally{
            _iterator.f();
        }
    };
}
function $e05a27e198729929$var$rangeDelete(config, request) {
    var parentID = config.parentID, connectionKeys = config.connectionKeys, pathToConnection = config.pathToConnection, deletedIDFieldName = config.deletedIDFieldName;
    if (!parentID) return null;
    var rootField = $e05a27e198729929$var$getRootField(request);
    if (!rootField) return null;
    return function(store, data) {
        if (!data) return;
        var deleteIDs = [];
        var deletedIDField = data[rootField];
        if (deletedIDField && Array.isArray(deletedIDFieldName)) {
            var _iterator2 = (0, $e05a27e198729929$var$_createForOfIteratorHelper2["default"])(deletedIDFieldName), _step2;
            try {
                for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
                    var eachField = _step2.value;
                    if (deletedIDField && typeof deletedIDField === 'object') deletedIDField = deletedIDField[eachField];
                }
            } catch (err) {
                _iterator2.e(err);
            } finally{
                _iterator2.f();
            }
            if (Array.isArray(deletedIDField)) deletedIDField.forEach(function(idObject) {
                if (idObject && idObject.id && typeof idObject === 'object' && typeof idObject.id === 'string') deleteIDs.push(idObject.id);
            });
            else if (deletedIDField && deletedIDField.id && typeof deletedIDField.id === 'string') deleteIDs.push(deletedIDField.id);
        } else if (deletedIDField && typeof deletedIDFieldName === 'string' && typeof deletedIDField === 'object') {
            deletedIDField = deletedIDField[deletedIDFieldName];
            if (typeof deletedIDField === 'string') deleteIDs.push(deletedIDField);
            else if (Array.isArray(deletedIDField)) deletedIDField.forEach(function(id) {
                if (typeof id === 'string') deleteIDs.push(id);
            });
        }
        $e05a27e198729929$var$deleteNode(parentID, connectionKeys, pathToConnection, store, deleteIDs);
    };
}
function $e05a27e198729929$var$deleteNode(parentID, connectionKeys, pathToConnection, store, deleteIDs) {
    var parent = store.get(parentID);
    if (!parent) return;
    if (pathToConnection.length < 2) return;
    var recordProxy = parent;
    for(var i = 1; i < pathToConnection.length - 1; i++)if (recordProxy) recordProxy = recordProxy.getLinkedRecord(pathToConnection[i]);
    if (!connectionKeys || !recordProxy) return;
    var _iterator3 = (0, $e05a27e198729929$var$_createForOfIteratorHelper2["default"])(connectionKeys), _step3;
    try {
        var _loop = function _loop() {
            var key = _step3.value;
            var connection = $jnVed.getConnection(recordProxy, key.key, key.filters);
            if (connection) deleteIDs.forEach(function(deleteID) {
                $jnVed.deleteNode(connection, deleteID);
            });
        };
        for(_iterator3.s(); !(_step3 = _iterator3.n()).done;)_loop();
    } catch (err) {
        _iterator3.e(err);
    } finally{
        _iterator3.f();
    }
}
function $e05a27e198729929$var$getRootField(request) {
    if (request.fragment.selections && request.fragment.selections.length > 0 && request.fragment.selections[0].kind === 'LinkedField') return request.fragment.selections[0].name;
    return null;
}
module.exports = {
    MutationTypes: $e05a27e198729929$var$MutationTypes,
    RangeOperations: $e05a27e198729929$var$RangeOperations,
    convert: $e05a27e198729929$var$convert
};

});


parcelRegister("424Ih", function(module, exports) {
'use strict';
function $2efb01452b197d6f$var$commitLocalUpdate(environment, updater) {
    environment.commitUpdate(updater);
}
module.exports = $2efb01452b197d6f$var$commitLocalUpdate;

});

parcelRegister("cEfBU", function(module, exports) {
'use strict';

var $7dvyf = parcelRequire("7dvyf");
var $9355545d4329c59e$var$_interopRequireDefault = $7dvyf.default;

var $9355545d4329c59e$var$_toConsumableArray2 = $9355545d4329c59e$var$_interopRequireDefault((parcelRequire("gvI75")));

var $8AEJo = parcelRequire("8AEJo");
var $9355545d4329c59e$var$getRequest = $8AEJo.getRequest;

var $70q7x = parcelRequire("70q7x");
var $9355545d4329c59e$var$generateUniqueClientID = $70q7x.generateUniqueClientID;

var $j6CXw = parcelRequire("j6CXw");

var $ilblc = parcelRequire("ilblc");
var $9355545d4329c59e$var$createOperationDescriptor = $ilblc.createOperationDescriptor;

var $jgdIQ = parcelRequire("jgdIQ");
parcelRequire("6YsGC");

var $bQThX = parcelRequire("bQThX");
parcelRequire("hzw7m");
function $9355545d4329c59e$var$commitMutation(environment, config) {
    !$j6CXw(environment) && $bQThX(false);
    var mutation = $9355545d4329c59e$var$getRequest(config.mutation);
    if (mutation.params.operationKind !== 'mutation') throw new Error('commitMutation: Expected mutation operation');
    if (mutation.kind !== 'Request') throw new Error('commitMutation: Expected mutation to be of type request');
    var optimisticResponse = config.optimisticResponse, optimisticUpdater = config.optimisticUpdater, updater = config.updater;
    var configs = config.configs, cacheConfig = config.cacheConfig, onError = config.onError, onUnsubscribe = config.onUnsubscribe, variables = config.variables, uploadables = config.uploadables;
    var operation = $9355545d4329c59e$var$createOperationDescriptor(mutation, variables, cacheConfig, $9355545d4329c59e$var$generateUniqueClientID());
    if (typeof optimisticResponse === 'function') optimisticResponse = optimisticResponse();
    if (configs) {
        var _RelayDeclarativeMuta = $jgdIQ.convert(configs, mutation, optimisticUpdater, updater);
        optimisticUpdater = _RelayDeclarativeMuta.optimisticUpdater;
        updater = _RelayDeclarativeMuta.updater;
    }
    var errors = [];
    var subscription = environment.executeMutation({
        operation: operation,
        optimisticResponse: optimisticResponse,
        optimisticUpdater: optimisticUpdater,
        updater: updater,
        uploadables: uploadables
    }).subscribe({
        next: function next(payload) {
            var _config$onNext;
            if (Array.isArray(payload)) payload.forEach(function(item) {
                if (item.errors) errors.push.apply(errors, (0, $9355545d4329c59e$var$_toConsumableArray2["default"])(item.errors));
            });
            else if (payload.errors) errors.push.apply(errors, (0, $9355545d4329c59e$var$_toConsumableArray2["default"])(payload.errors));
            (_config$onNext = config.onNext) === null || _config$onNext === void 0 || _config$onNext.call(config);
        },
        complete: function complete() {
            var onCompleted = config.onCompleted;
            if (onCompleted) {
                var snapshot = environment.lookup(operation.fragment);
                onCompleted(snapshot.data, errors.length !== 0 ? errors : null);
            }
        },
        error: onError,
        unsubscribe: onUnsubscribe
    });
    return {
        dispose: subscription.unsubscribe
    };
}
module.exports = $9355545d4329c59e$var$commitMutation;

});
parcelRegister("6YsGC", function(module, exports) {
'use strict';

var $7dvyf = parcelRequire("7dvyf");
var $513e9930ba0dc1b9$var$_interopRequireDefault = $7dvyf.default;

var $513e9930ba0dc1b9$var$_objectSpread2 = $513e9930ba0dc1b9$var$_interopRequireDefault((parcelRequire("4N8OD")));

var $9lZfN = parcelRequire("9lZfN");
var $513e9930ba0dc1b9$var$ACTOR_CHANGE = $9lZfN.ACTOR_CHANGE, $513e9930ba0dc1b9$var$CLIENT_COMPONENT = $9lZfN.CLIENT_COMPONENT, $513e9930ba0dc1b9$var$CLIENT_EDGE_TO_CLIENT_OBJECT = $9lZfN.CLIENT_EDGE_TO_CLIENT_OBJECT, $513e9930ba0dc1b9$var$CLIENT_EXTENSION = $9lZfN.CLIENT_EXTENSION, $513e9930ba0dc1b9$var$CONDITION = $9lZfN.CONDITION, $513e9930ba0dc1b9$var$DEFER = $9lZfN.DEFER, $513e9930ba0dc1b9$var$FRAGMENT_SPREAD = $9lZfN.FRAGMENT_SPREAD, $513e9930ba0dc1b9$var$INLINE_FRAGMENT = $9lZfN.INLINE_FRAGMENT, $513e9930ba0dc1b9$var$LINKED_FIELD = $9lZfN.LINKED_FIELD, $513e9930ba0dc1b9$var$LINKED_HANDLE = $9lZfN.LINKED_HANDLE, $513e9930ba0dc1b9$var$MODULE_IMPORT = $9lZfN.MODULE_IMPORT, $513e9930ba0dc1b9$var$RELAY_LIVE_RESOLVER = $9lZfN.RELAY_LIVE_RESOLVER, $513e9930ba0dc1b9$var$RELAY_RESOLVER = $9lZfN.RELAY_RESOLVER, $513e9930ba0dc1b9$var$SCALAR_FIELD = $9lZfN.SCALAR_FIELD, $513e9930ba0dc1b9$var$SCALAR_HANDLE = $9lZfN.SCALAR_HANDLE, $513e9930ba0dc1b9$var$STREAM = $9lZfN.STREAM, $513e9930ba0dc1b9$var$TYPE_DISCRIMINATOR = $9lZfN.TYPE_DISCRIMINATOR;
parcelRequire("hzw7m");
var $513e9930ba0dc1b9$var$hasOwnProperty = Object.prototype.hasOwnProperty;
var $513e9930ba0dc1b9$var$validateMutation = function validateMutation() {};
var $513e9930ba0dc1b9$var$addFieldToDiff, $513e9930ba0dc1b9$var$validateSelections, $513e9930ba0dc1b9$var$validateSelection, $513e9930ba0dc1b9$var$validateModuleImport, $513e9930ba0dc1b9$var$validateAbstractKey, $513e9930ba0dc1b9$var$validateField, $513e9930ba0dc1b9$var$validateOptimisticResponse;
module.exports = $513e9930ba0dc1b9$var$validateMutation;

});


parcelRegister("eegbk", function(module, exports) {
'use strict';

var $7c6mq = parcelRequire("7c6mq");

var $kfOS5 = parcelRequire("kfOS5");
var $a5beecd63a6eeb49$var$convertFetch = $kfOS5.convertFetch;

var $bQThX = parcelRequire("bQThX");
function $a5beecd63a6eeb49$var$create(fetchFn, subscribe) {
    var observeFetch = $a5beecd63a6eeb49$var$convertFetch(fetchFn);
    function execute(request, variables, cacheConfig, uploadables, logRequestInfo) {
        var operationVariables = $7c6mq(variables, request.providedVariables);
        if (request.operationKind === 'subscription') {
            !subscribe && $bQThX(false);
            !!uploadables && $bQThX(false);
            return subscribe(request, operationVariables, cacheConfig);
        }
        var pollInterval = cacheConfig.poll;
        if (pollInterval != null) {
            !!uploadables && $bQThX(false);
            return observeFetch(request, operationVariables, {
                force: true
            }).poll(pollInterval);
        }
        return observeFetch(request, operationVariables, cacheConfig, uploadables, logRequestInfo);
    }
    return {
        execute: execute
    };
}
module.exports = {
    create: $a5beecd63a6eeb49$var$create
};

});
parcelRegister("7c6mq", function(module, exports) {
'use strict';
parcelRequire("3Nt2B");
parcelRequire("hzw7m");
var $53ce9685030ccf58$var$WEAKMAP_SUPPORTED = typeof WeakMap === 'function';
var $53ce9685030ccf58$var$debugCache = $53ce9685030ccf58$var$WEAKMAP_SUPPORTED ? new WeakMap() : new Map();
function $53ce9685030ccf58$var$withProvidedVariables(userSuppliedVariables, providedVariables) {
    if (providedVariables != null) {
        var operationVariables = {};
        Object.assign(operationVariables, userSuppliedVariables);
        Object.keys(providedVariables).forEach(function(varName) {
            var providerFunction = providedVariables[varName].get;
            var providerResult = providerFunction();
            if (!$53ce9685030ccf58$var$debugCache.has(providerFunction)) {
                $53ce9685030ccf58$var$debugCache.set(providerFunction, providerResult);
                operationVariables[varName] = providerResult;
            } else {
                var cachedResult = $53ce9685030ccf58$var$debugCache.get(providerFunction);
                operationVariables[varName] = cachedResult;
            }
        });
        return operationVariables;
    } else return userSuppliedVariables;
}
$53ce9685030ccf58$var$withProvidedVariables.tests_only_resetDebugCache = undefined;
module.exports = $53ce9685030ccf58$var$withProvidedVariables;

});

parcelRegister("kfOS5", function(module, exports) {
'use strict';

var $8IVD8 = parcelRequire("8IVD8");
function $ebecab55d7fc9a87$var$convertFetch(fn) {
    return function fetch(request, variables, cacheConfig, uploadables, logRequestInfo) {
        var result = fn(request, variables, cacheConfig, uploadables, logRequestInfo);
        if (result instanceof Error) return $8IVD8.create(function(sink) {
            return sink.error(result);
        });
        return $8IVD8.from(result);
    };
}
module.exports = {
    convertFetch: $ebecab55d7fc9a87$var$convertFetch
};

});
parcelRegister("8IVD8", function(module, exports) {
'use strict';

var $8N9I0 = parcelRequire("8N9I0");
var $659f22f4faeb66c2$var$hostReportError = $659f22f4faeb66c2$var$swallowError;
var $659f22f4faeb66c2$var$RelayObservable = /*#__PURE__*/ function() {
    RelayObservable.create = function create(source) {
        return new RelayObservable(source);
    };
    function RelayObservable(source) {
        this._source = source;
    }
    RelayObservable.onUnhandledError = function onUnhandledError(callback) {
        $659f22f4faeb66c2$var$hostReportError = callback;
    };
    RelayObservable.from = function from(obj) {
        return $659f22f4faeb66c2$var$isObservable(obj) ? $659f22f4faeb66c2$var$fromObservable(obj) : $8N9I0(obj) ? $659f22f4faeb66c2$var$fromPromise(obj) : $659f22f4faeb66c2$var$fromValue(obj);
    };
    var _proto = RelayObservable.prototype;
    _proto["catch"] = function _catch(fn) {
        var _this = this;
        return RelayObservable.create(function(sink) {
            var subscription;
            _this.subscribe({
                start: function start(sub) {
                    subscription = sub;
                },
                next: sink.next,
                complete: sink.complete,
                error: function error(_error2) {
                    try {
                        fn(_error2).subscribe({
                            start: function start(sub) {
                                subscription = sub;
                            },
                            next: sink.next,
                            complete: sink.complete,
                            error: sink.error
                        });
                    } catch (error2) {
                        sink.error(error2, true);
                    }
                }
            });
            return function() {
                return subscription.unsubscribe();
            };
        });
    };
    _proto.concat = function concat(next) {
        var _this2 = this;
        return RelayObservable.create(function(sink) {
            var current;
            _this2.subscribe({
                start: function start(subscription) {
                    current = subscription;
                },
                next: sink.next,
                error: sink.error,
                complete: function complete() {
                    current = next.subscribe(sink);
                }
            });
            return function() {
                current && current.unsubscribe();
            };
        });
    };
    _proto["do"] = function _do(observer) {
        var _this3 = this;
        return RelayObservable.create(function(sink) {
            var both = function both(action) {
                return function() {
                    try {
                        observer[action] && observer[action].apply(observer, arguments);
                    } catch (error) {
                        $659f22f4faeb66c2$var$hostReportError(error, true);
                    }
                    sink[action] && sink[action].apply(sink, arguments);
                };
            };
            return _this3.subscribe({
                start: both('start'),
                next: both('next'),
                error: both('error'),
                complete: both('complete'),
                unsubscribe: both('unsubscribe')
            });
        });
    };
    _proto["finally"] = function _finally(fn) {
        var _this4 = this;
        return RelayObservable.create(function(sink) {
            var subscription = _this4.subscribe(sink);
            return function() {
                subscription.unsubscribe();
                fn();
            };
        });
    };
    _proto.ifEmpty = function ifEmpty(alternate) {
        var _this5 = this;
        return RelayObservable.create(function(sink) {
            var hasValue = false;
            var current;
            current = _this5.subscribe({
                next: function next(value) {
                    hasValue = true;
                    sink.next(value);
                },
                error: sink.error,
                complete: function complete() {
                    if (hasValue) sink.complete();
                    else current = alternate.subscribe(sink);
                }
            });
            return function() {
                current && current.unsubscribe();
            };
        });
    };
    _proto.subscribe = function subscribe(observer) {
        return $659f22f4faeb66c2$var$_subscribe(this._source, observer);
    };
    _proto.map = function map(fn) {
        var _this6 = this;
        return RelayObservable.create(function(sink) {
            var subscription = _this6.subscribe({
                complete: sink.complete,
                error: sink.error,
                next: function next(value) {
                    try {
                        var mapValue = fn(value);
                        sink.next(mapValue);
                    } catch (error) {
                        sink.error(error, true);
                    }
                }
            });
            return function() {
                subscription.unsubscribe();
            };
        });
    };
    _proto.mergeMap = function mergeMap(fn) {
        var _this7 = this;
        return RelayObservable.create(function(sink) {
            var subscriptions = [];
            function start(subscription) {
                this._sub = subscription;
                subscriptions.push(subscription);
            }
            function complete() {
                subscriptions.splice(subscriptions.indexOf(this._sub), 1);
                if (subscriptions.length === 0) sink.complete();
            }
            _this7.subscribe({
                start: start,
                next: function next(value) {
                    try {
                        if (!sink.closed) RelayObservable.from(fn(value)).subscribe({
                            start: start,
                            next: sink.next,
                            error: sink.error,
                            complete: complete
                        });
                    } catch (error) {
                        sink.error(error, true);
                    }
                },
                error: sink.error,
                complete: complete
            });
            return function() {
                subscriptions.forEach(function(sub) {
                    return sub.unsubscribe();
                });
                subscriptions.length = 0;
            };
        });
    };
    _proto.poll = function poll(pollInterval) {
        var _this8 = this;
        return RelayObservable.create(function(sink) {
            var subscription;
            var timeout;
            var poll = function poll() {
                subscription = _this8.subscribe({
                    next: sink.next,
                    error: sink.error,
                    complete: function complete() {
                        timeout = setTimeout(poll, pollInterval);
                    }
                });
            };
            poll();
            return function() {
                clearTimeout(timeout);
                subscription.unsubscribe();
            };
        });
    };
    _proto.toPromise = function toPromise() {
        var _this9 = this;
        return new Promise(function(resolve, reject) {
            var resolved = false;
            _this9.subscribe({
                next: function next(val) {
                    if (!resolved) {
                        resolved = true;
                        resolve(val);
                    }
                },
                error: reject,
                complete: resolve
            });
        });
    };
    return RelayObservable;
}();
function $659f22f4faeb66c2$var$isObservable(obj) {
    return typeof obj === 'object' && obj !== null && typeof obj.subscribe === 'function';
}
function $659f22f4faeb66c2$var$fromObservable(obj) {
    return obj instanceof $659f22f4faeb66c2$var$RelayObservable ? obj : $659f22f4faeb66c2$var$RelayObservable.create(function(sink) {
        return obj.subscribe(sink);
    });
}
function $659f22f4faeb66c2$var$fromPromise(promise) {
    return $659f22f4faeb66c2$var$RelayObservable.create(function(sink) {
        promise.then(function(value) {
            sink.next(value);
            sink.complete();
        }, sink.error);
    });
}
function $659f22f4faeb66c2$var$fromValue(value) {
    return $659f22f4faeb66c2$var$RelayObservable.create(function(sink) {
        sink.next(value);
        sink.complete();
    });
}
function $659f22f4faeb66c2$var$_subscribe(source, observer) {
    var closed = false;
    var cleanup;
    var withClosed = function withClosed(obj) {
        return Object.defineProperty(obj, 'closed', {
            get: function get() {
                return closed;
            }
        });
    };
    function doCleanup() {
        if (cleanup) {
            if (cleanup.unsubscribe) cleanup.unsubscribe();
            else try {
                cleanup();
            } catch (error) {
                $659f22f4faeb66c2$var$hostReportError(error, true);
            }
            cleanup = undefined;
        }
    }
    var subscription = withClosed({
        unsubscribe: function unsubscribe() {
            if (!closed) {
                closed = true;
                try {
                    observer.unsubscribe && observer.unsubscribe(subscription);
                } catch (error) {
                    $659f22f4faeb66c2$var$hostReportError(error, true);
                } finally{
                    doCleanup();
                }
            }
        }
    });
    try {
        observer.start && observer.start(subscription);
    } catch (error) {
        $659f22f4faeb66c2$var$hostReportError(error, true);
    }
    if (closed) return subscription;
    var sink = withClosed({
        next: function next(value) {
            if (!closed && observer.next) try {
                observer.next(value);
            } catch (error) {
                $659f22f4faeb66c2$var$hostReportError(error, true);
            }
        },
        error: function error(_error3, isUncaughtThrownError) {
            if (closed || !observer.error) {
                closed = true;
                $659f22f4faeb66c2$var$hostReportError(_error3, isUncaughtThrownError || false);
                doCleanup();
            } else {
                closed = true;
                try {
                    observer.error(_error3);
                } catch (error2) {
                    $659f22f4faeb66c2$var$hostReportError(error2, true);
                } finally{
                    doCleanup();
                }
            }
        },
        complete: function complete() {
            if (!closed) {
                closed = true;
                try {
                    observer.complete && observer.complete();
                } catch (error) {
                    $659f22f4faeb66c2$var$hostReportError(error, true);
                } finally{
                    doCleanup();
                }
            }
        }
    });
    try {
        cleanup = source(sink);
    } catch (error) {
        sink.error(error, true);
    }
    if (closed) doCleanup();
    return subscription;
}
function $659f22f4faeb66c2$var$swallowError(_error, _isUncaughtThrownError) {}
module.exports = $659f22f4faeb66c2$var$RelayObservable;

});
parcelRegister("8N9I0", function(module, exports) {
'use strict';
function $666a6e500d09df39$var$isPromise(p) {
    return p != null && typeof p === 'object' && typeof p.then === 'function';
}
module.exports = $666a6e500d09df39$var$isPromise;

});




parcelRegister("fDXrH", function(module, exports) {
'use strict';

var $7dvyf = parcelRequire("7dvyf");
var $b6389c3f9c13a941$var$_interopRequireDefault = $7dvyf.default;

var $b6389c3f9c13a941$var$_objectSpread2 = $b6389c3f9c13a941$var$_interopRequireDefault((parcelRequire("4N8OD")));

var $ahEdt = parcelRequire("ahEdt");

var $bQThX = parcelRequire("bQThX");
var $b6389c3f9c13a941$var$RelayQueryResponseCache = /*#__PURE__*/ function() {
    function RelayQueryResponseCache(_ref) {
        var size = _ref.size, ttl = _ref.ttl;
        !(size > 0) && $bQThX(false);
        !(ttl > 0) && $bQThX(false);
        this._responses = new Map();
        this._size = size;
        this._ttl = ttl;
    }
    var _proto = RelayQueryResponseCache.prototype;
    _proto.clear = function clear() {
        this._responses.clear();
    };
    _proto.get = function get(queryID, variables) {
        var _this = this;
        var cacheKey = $b6389c3f9c13a941$var$getCacheKey(queryID, variables);
        this._responses.forEach(function(response, key) {
            if (!$b6389c3f9c13a941$var$isCurrent(response.fetchTime, _this._ttl)) _this._responses["delete"](key);
        });
        var response = this._responses.get(cacheKey);
        if (response == null) return null;
        if (Array.isArray(response.payload)) return response.payload.map(function(payload) {
            return (0, $b6389c3f9c13a941$var$_objectSpread2["default"])((0, $b6389c3f9c13a941$var$_objectSpread2["default"])({}, payload), {}, {
                extensions: (0, $b6389c3f9c13a941$var$_objectSpread2["default"])((0, $b6389c3f9c13a941$var$_objectSpread2["default"])({}, payload.extensions), {}, {
                    cacheTimestamp: response.fetchTime
                })
            });
        });
        return (0, $b6389c3f9c13a941$var$_objectSpread2["default"])((0, $b6389c3f9c13a941$var$_objectSpread2["default"])({}, response.payload), {}, {
            extensions: (0, $b6389c3f9c13a941$var$_objectSpread2["default"])((0, $b6389c3f9c13a941$var$_objectSpread2["default"])({}, response.payload.extensions), {}, {
                cacheTimestamp: response.fetchTime
            })
        });
    };
    _proto.set = function set(queryID, variables, payload) {
        var fetchTime = Date.now();
        var cacheKey = $b6389c3f9c13a941$var$getCacheKey(queryID, variables);
        this._responses["delete"](cacheKey);
        this._responses.set(cacheKey, {
            fetchTime: fetchTime,
            payload: payload
        });
        if (this._responses.size > this._size) {
            var firstKey = this._responses.keys().next();
            if (!firstKey.done) this._responses["delete"](firstKey.value);
        }
    };
    return RelayQueryResponseCache;
}();
function $b6389c3f9c13a941$var$getCacheKey(queryID, variables) {
    return JSON.stringify($ahEdt({
        queryID: queryID,
        variables: variables
    }));
}
function $b6389c3f9c13a941$var$isCurrent(fetchTime, ttl) {
    return fetchTime + ttl >= Date.now();
}
module.exports = $b6389c3f9c13a941$var$RelayQueryResponseCache;

});

parcelRegister("4cNkK", function(module, exports) {
'use strict';

var $7dvyf = parcelRequire("7dvyf");
var $30fe8d10af286eef$var$_interopRequireDefault = $7dvyf.default;

var $30fe8d10af286eef$var$_objectSpread2 = $30fe8d10af286eef$var$_interopRequireDefault((parcelRequire("4N8OD")));

var $8IVD8 = parcelRequire("8IVD8");

var $ilblc = parcelRequire("ilblc");
var $30fe8d10af286eef$var$createOperationDescriptor = $ilblc.createOperationDescriptor;

var $fPxW5 = parcelRequire("fPxW5");

var $fexah = parcelRequire("fexah");

var $8AEJo = parcelRequire("8AEJo");
var $30fe8d10af286eef$var$getRequest = $8AEJo.getRequest;

var $bQThX = parcelRequire("bQThX");
function $30fe8d10af286eef$var$fetchQuery(environment, query, variables, options) {
    var _options$fetchPolicy;
    var queryNode = $30fe8d10af286eef$var$getRequest(query);
    !(queryNode.params.operationKind === 'query') && $bQThX(false);
    var networkCacheConfig = (0, $30fe8d10af286eef$var$_objectSpread2["default"])({
        force: true
    }, options === null || options === void 0 ? void 0 : options.networkCacheConfig);
    var operation = $30fe8d10af286eef$var$createOperationDescriptor(queryNode, variables, networkCacheConfig);
    var fetchPolicy = (_options$fetchPolicy = options === null || options === void 0 ? void 0 : options.fetchPolicy) !== null && _options$fetchPolicy !== void 0 ? _options$fetchPolicy : 'network-only';
    function readData(snapshot) {
        var _queryNode$fragment$m, _queryNode$fragment$m2;
        $fPxW5(environment, snapshot.missingRequiredFields, snapshot.relayResolverErrors, snapshot.errorResponseFields, (_queryNode$fragment$m = (_queryNode$fragment$m2 = queryNode.fragment.metadata) === null || _queryNode$fragment$m2 === void 0 ? void 0 : _queryNode$fragment$m2.throwOnFieldError) !== null && _queryNode$fragment$m !== void 0 ? _queryNode$fragment$m : false);
        return snapshot.data;
    }
    switch(fetchPolicy){
        case 'network-only':
            return $30fe8d10af286eef$var$getNetworkObservable(environment, operation).map(readData);
        case 'store-or-network':
            if (environment.check(operation).status === 'available') return $8IVD8.from(environment.lookup(operation.fragment)).map(readData);
            return $30fe8d10af286eef$var$getNetworkObservable(environment, operation).map(readData);
        default:
            fetchPolicy;
            throw new Error('fetchQuery: Invalid fetchPolicy ' + fetchPolicy);
    }
}
function $30fe8d10af286eef$var$getNetworkObservable(environment, operation) {
    return $fexah.fetchQuery(environment, operation).map(function() {
        return environment.lookup(operation.fragment);
    });
}
module.exports = $30fe8d10af286eef$var$fetchQuery;

});
parcelRegister("fPxW5", function(module, exports) {
'use strict';

var $7dvyf = parcelRequire("7dvyf");
var $b865f165aced4aa7$var$_interopRequireDefault = $7dvyf.default;

var $b865f165aced4aa7$var$_createForOfIteratorHelper2 = $b865f165aced4aa7$var$_interopRequireDefault((parcelRequire("bTRzt")));

var $hOJCp = parcelRequire("hOJCp");

var $b865f165aced4aa7$var$_RelayFeatureFlags = $b865f165aced4aa7$var$_interopRequireDefault((parcelRequire("9DZlA")));
function $b865f165aced4aa7$var$handlePotentialSnapshotErrors(environment, missingRequiredFields, relayResolverErrors, errorResponseFields, throwOnFieldError) {
    var _iterator = (0, $b865f165aced4aa7$var$_createForOfIteratorHelper2["default"])(relayResolverErrors), _step;
    try {
        for(_iterator.s(); !(_step = _iterator.n()).done;){
            var resolverError = _step.value;
            environment.relayFieldLogger({
                kind: 'relay_resolver.error',
                owner: resolverError.field.owner,
                fieldPath: resolverError.field.path,
                error: resolverError.error
            });
        }
    } catch (err) {
        _iterator.e(err);
    } finally{
        _iterator.f();
    }
    if (relayResolverErrors.length > 0 && ($b865f165aced4aa7$var$_RelayFeatureFlags["default"].ENABLE_FIELD_ERROR_HANDLING_THROW_BY_DEFAULT || throwOnFieldError)) throw new $hOJCp.RelayFieldError("Relay: Unexpected resolver exception", relayResolverErrors.map(function(e) {
        return {
            message: e.error.message
        };
    }));
    if (($b865f165aced4aa7$var$_RelayFeatureFlags["default"].ENABLE_FIELD_ERROR_HANDLING || throwOnFieldError) && errorResponseFields != null) {
        if (errorResponseFields != null) {
            var _iterator2 = (0, $b865f165aced4aa7$var$_createForOfIteratorHelper2["default"])(errorResponseFields), _step2;
            try {
                for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
                    var fieldError = _step2.value;
                    var path = fieldError.path, owner = fieldError.owner, error = fieldError.error;
                    environment.relayFieldLogger({
                        kind: 'relay_field_payload.error',
                        owner: owner,
                        fieldPath: path,
                        error: error
                    });
                }
            } catch (err) {
                _iterator2.e(err);
            } finally{
                _iterator2.f();
            }
        }
        if ($b865f165aced4aa7$var$_RelayFeatureFlags["default"].ENABLE_FIELD_ERROR_HANDLING_THROW_BY_DEFAULT || throwOnFieldError) throw new $hOJCp.RelayFieldError("Relay: Unexpected response payload - this object includes an errors property in which you can access the underlying errors", errorResponseFields.map(function(_ref) {
            var error = _ref.error;
            return error;
        }));
    }
    if (missingRequiredFields != null) switch(missingRequiredFields.action){
        case 'THROW':
            var _missingRequiredField = missingRequiredFields.field, _path = _missingRequiredField.path, _owner = _missingRequiredField.owner;
            environment.relayFieldLogger({
                kind: 'missing_field.throw',
                owner: _owner,
                fieldPath: _path
            });
            throw new Error("Relay: Missing @required value at path '".concat(_path, "' in '").concat(_owner, "'."));
        case 'LOG':
            missingRequiredFields.fields.forEach(function(_ref2) {
                var path = _ref2.path, owner = _ref2.owner;
                environment.relayFieldLogger({
                    kind: 'missing_field.log',
                    owner: owner,
                    fieldPath: path
                });
            });
            break;
        default:
            missingRequiredFields.action;
    }
}
module.exports = $b865f165aced4aa7$var$handlePotentialSnapshotErrors;

});
parcelRegister("hOJCp", function(module, exports) {
'use strict';

var $7dvyf = parcelRequire("7dvyf");
var $cf8a7e122d2c7c4b$var$_interopRequireDefault = $7dvyf.default;

var $cf8a7e122d2c7c4b$var$_objectSpread2 = $cf8a7e122d2c7c4b$var$_interopRequireDefault((parcelRequire("4N8OD")));

var $cf8a7e122d2c7c4b$var$_objectWithoutPropertiesLoose2 = $cf8a7e122d2c7c4b$var$_interopRequireDefault((parcelRequire("7o4v7")));

var $cf8a7e122d2c7c4b$var$_createForOfIteratorHelper2 = $cf8a7e122d2c7c4b$var$_interopRequireDefault((parcelRequire("bTRzt")));

var $cf8a7e122d2c7c4b$var$_inheritsLoose2 = $cf8a7e122d2c7c4b$var$_interopRequireDefault((parcelRequire("isJpf")));

var $cf8a7e122d2c7c4b$var$_wrapNativeSuper2 = $cf8a7e122d2c7c4b$var$_interopRequireDefault((parcelRequire("MDCsb")));

var $cf8a7e122d2c7c4b$var$_toConsumableArray2 = $cf8a7e122d2c7c4b$var$_interopRequireDefault((parcelRequire("gvI75")));
var $cf8a7e122d2c7c4b$var$_excluded = [
    "path",
    "locations"
];

var $9DZlA = parcelRequire("9DZlA");
var $cf8a7e122d2c7c4b$var$SELF = Symbol('$SELF');
var $cf8a7e122d2c7c4b$var$RelayFieldError = /*#__PURE__*/ function(_Error) {
    (0, $cf8a7e122d2c7c4b$var$_inheritsLoose2["default"])(RelayFieldError, _Error);
    function RelayFieldError(message) {
        var _this;
        var errors = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
        _this = _Error.call(this, message) || this;
        _this.name = 'RelayFieldError';
        _this.message = message;
        _this.errors = errors;
        return _this;
    }
    return RelayFieldError;
}(/*#__PURE__*/ (0, $cf8a7e122d2c7c4b$var$_wrapNativeSuper2["default"])(Error));
function $cf8a7e122d2c7c4b$var$buildErrorTrie(errors) {
    if (errors == null) return null;
    if (!$9DZlA.ENABLE_FIELD_ERROR_HANDLING) return null;
    var trie = new Map();
    var _iterator = (0, $cf8a7e122d2c7c4b$var$_createForOfIteratorHelper2["default"])(errors), _step;
    try {
        ERRORS: for(_iterator.s(); !(_step = _iterator.n()).done;){
            var _step$value = _step.value, path = _step$value.path, _ = _step$value.locations, error = (0, $cf8a7e122d2c7c4b$var$_objectWithoutPropertiesLoose2["default"])(_step$value, $cf8a7e122d2c7c4b$var$_excluded);
            if (path == null) continue;
            var length = path.length;
            if (length === 0) continue;
            var lastIndex = length - 1;
            var currentTrie = trie;
            for(var index = 0; index < lastIndex; index++){
                var key = path[index];
                var existingValue = currentTrie.get(key);
                if (existingValue instanceof Map) {
                    currentTrie = existingValue;
                    continue;
                }
                var newValue = new Map();
                if (Array.isArray(existingValue)) newValue.set($cf8a7e122d2c7c4b$var$SELF, existingValue);
                currentTrie.set(key, newValue);
                currentTrie = newValue;
            }
            var lastKey = path[lastIndex];
            var container = currentTrie.get(lastKey);
            if (container instanceof Map) {
                currentTrie = container;
                container = currentTrie.get(lastKey);
                lastKey = $cf8a7e122d2c7c4b$var$SELF;
            }
            if (Array.isArray(container)) container.push(error);
            else currentTrie.set(lastKey, [
                error
            ]);
        }
    } catch (err) {
        _iterator.e(err);
    } finally{
        _iterator.f();
    }
    return trie;
}
function $cf8a7e122d2c7c4b$var$getErrorsByKey(trie, key) {
    var value = trie.get(key);
    if (value == null) return null;
    if (Array.isArray(value)) return value;
    var errors = [];
    $cf8a7e122d2c7c4b$var$recursivelyCopyErrorsIntoArray(value, errors);
    return errors;
}
function $cf8a7e122d2c7c4b$var$recursivelyCopyErrorsIntoArray(trieOrSet, errors) {
    var _iterator2 = (0, $cf8a7e122d2c7c4b$var$_createForOfIteratorHelper2["default"])(trieOrSet), _step2;
    try {
        for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
            var _step2$value = _step2.value, childKey = _step2$value[0], value = _step2$value[1];
            var oldLength = errors.length;
            if (Array.isArray(value)) errors.push.apply(errors, (0, $cf8a7e122d2c7c4b$var$_toConsumableArray2["default"])(value));
            else $cf8a7e122d2c7c4b$var$recursivelyCopyErrorsIntoArray(value, errors);
            if (childKey === $cf8a7e122d2c7c4b$var$SELF) continue;
            var newLength = errors.length;
            for(var index = oldLength; index < newLength; index++){
                var error = errors[index];
                if (error.path == null) errors[index] = (0, $cf8a7e122d2c7c4b$var$_objectSpread2["default"])((0, $cf8a7e122d2c7c4b$var$_objectSpread2["default"])({}, error), {}, {
                    path: [
                        childKey
                    ]
                });
                else error.path.unshift(childKey);
            }
        }
    } catch (err) {
        _iterator2.e(err);
    } finally{
        _iterator2.f();
    }
}
function $cf8a7e122d2c7c4b$var$getNestedErrorTrieByKey(trie, key) {
    var value = trie.get(key);
    if (value instanceof Map) return value;
    return null;
}
module.exports = {
    SELF: $cf8a7e122d2c7c4b$var$SELF,
    buildErrorTrie: $cf8a7e122d2c7c4b$var$buildErrorTrie,
    getNestedErrorTrieByKey: $cf8a7e122d2c7c4b$var$getNestedErrorTrieByKey,
    getErrorsByKey: $cf8a7e122d2c7c4b$var$getErrorsByKey,
    RelayFieldError: $cf8a7e122d2c7c4b$var$RelayFieldError
};

});
parcelRegister("isJpf", function(module, exports) {

var $gWoXB = parcelRequire("gWoXB");
function $d70e10458553458e$var$_inheritsLoose(t, o) {
    t.prototype = Object.create(o.prototype), t.prototype.constructor = t, $gWoXB(t, o);
}
module.exports = $d70e10458553458e$var$_inheritsLoose, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("MDCsb", function(module, exports) {

var $iYuz0 = parcelRequire("iYuz0");

var $gWoXB = parcelRequire("gWoXB");

var $oZiIx = parcelRequire("oZiIx");

var $hRB6Q = parcelRequire("hRB6Q");
function $0923375c53822296$var$_wrapNativeSuper(t) {
    var r = "function" == typeof Map ? new Map() : void 0;
    return module.exports = $0923375c53822296$var$_wrapNativeSuper = function _wrapNativeSuper(t) {
        if (null === t || !$oZiIx(t)) return t;
        if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function");
        if (void 0 !== r) {
            if (r.has(t)) return r.get(t);
            r.set(t, Wrapper);
        }
        function Wrapper() {
            return $hRB6Q(t, arguments, $iYuz0(this).constructor);
        }
        return Wrapper.prototype = Object.create(t.prototype, {
            constructor: {
                value: Wrapper,
                enumerable: !1,
                writable: !0,
                configurable: !0
            }
        }), $gWoXB(Wrapper, t);
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, $0923375c53822296$var$_wrapNativeSuper(t);
}
module.exports = $0923375c53822296$var$_wrapNativeSuper, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("oZiIx", function(module, exports) {
function $04b1cb15f32970ca$var$_isNativeFunction(t) {
    try {
        return -1 !== Function.toString.call(t).indexOf("[native code]");
    } catch (n) {
        return "function" == typeof t;
    }
}
module.exports = $04b1cb15f32970ca$var$_isNativeFunction, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("hRB6Q", function(module, exports) {

var $jvgS6 = parcelRequire("jvgS6");

var $gWoXB = parcelRequire("gWoXB");
function $d0142c0898bc6b86$var$_construct(t, e, r) {
    if ($jvgS6()) return Reflect.construct.apply(null, arguments);
    var o = [
        null
    ];
    o.push.apply(o, e);
    var p = new (t.bind.apply(t, o))();
    return r && $gWoXB(p, r.prototype), p;
}
module.exports = $d0142c0898bc6b86$var$_construct, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("jvgS6", function(module, exports) {
function $e32dffe6df1cf8e5$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return (module.exports = $e32dffe6df1cf8e5$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports)();
}
module.exports = $e32dffe6df1cf8e5$var$_isNativeReflectConstruct, module.exports.__esModule = true, module.exports["default"] = module.exports;

});





parcelRegister("fexah", function(module, exports) {
'use strict';

var $8IVD8 = parcelRequire("8IVD8");

var $gxoN7 = parcelRequire("gxoN7");

var $bQThX = parcelRequire("bQThX");
var $b171e3a3515bc38b$var$WEAKMAP_SUPPORTED = typeof WeakMap === 'function';
var $b171e3a3515bc38b$var$requestCachesByEnvironment = $b171e3a3515bc38b$var$WEAKMAP_SUPPORTED ? new WeakMap() : new Map();
function $b171e3a3515bc38b$var$fetchQuery(environment, operation) {
    return $b171e3a3515bc38b$var$fetchQueryDeduped(environment, operation.request.identifier, function() {
        return environment.execute({
            operation: operation
        });
    });
}
function $b171e3a3515bc38b$var$fetchQueryDeduped(environment, identifier, fetchFn) {
    return $8IVD8.create(function(sink) {
        var requestCache = $b171e3a3515bc38b$var$getRequestCache(environment);
        var cachedRequest = requestCache.get(identifier);
        if (!cachedRequest) fetchFn()["finally"](function() {
            return requestCache["delete"](identifier);
        }).subscribe({
            start: function start(subscription) {
                cachedRequest = {
                    identifier: identifier,
                    subject: new $gxoN7(),
                    subjectForInFlightStatus: new $gxoN7(),
                    subscription: subscription,
                    promise: null
                };
                requestCache.set(identifier, cachedRequest);
            },
            next: function next(response) {
                var cachedReq = $b171e3a3515bc38b$var$getCachedRequest(requestCache, identifier);
                cachedReq.subject.next(response);
                cachedReq.subjectForInFlightStatus.next(response);
            },
            error: function error(_error) {
                var cachedReq = $b171e3a3515bc38b$var$getCachedRequest(requestCache, identifier);
                cachedReq.subject.error(_error);
                cachedReq.subjectForInFlightStatus.error(_error);
            },
            complete: function complete() {
                var cachedReq = $b171e3a3515bc38b$var$getCachedRequest(requestCache, identifier);
                cachedReq.subject.complete();
                cachedReq.subjectForInFlightStatus.complete();
            },
            unsubscribe: function unsubscribe(subscription) {
                var cachedReq = $b171e3a3515bc38b$var$getCachedRequest(requestCache, identifier);
                cachedReq.subject.unsubscribe();
                cachedReq.subjectForInFlightStatus.unsubscribe();
            }
        });
        !(cachedRequest != null) && $bQThX(false);
        return $b171e3a3515bc38b$var$getObservableForCachedRequest(requestCache, cachedRequest).subscribe(sink);
    });
}
function $b171e3a3515bc38b$var$getObservableForCachedRequest(requestCache, cachedRequest) {
    return $8IVD8.create(function(sink) {
        var subscription = cachedRequest.subject.subscribe(sink);
        return function() {
            subscription.unsubscribe();
            var cachedRequestInstance = requestCache.get(cachedRequest.identifier);
            if (cachedRequestInstance) {
                var requestSubscription = cachedRequestInstance.subscription;
                if (requestSubscription != null && cachedRequestInstance.subject.getObserverCount() === 0) {
                    requestSubscription.unsubscribe();
                    requestCache["delete"](cachedRequest.identifier);
                }
            }
        };
    });
}
function $b171e3a3515bc38b$var$getActiveStatusObservableForCachedRequest(environment, requestCache, cachedRequest) {
    return $8IVD8.create(function(sink) {
        var subscription = cachedRequest.subjectForInFlightStatus.subscribe({
            error: sink.error,
            next: function next(response) {
                if (!environment.isRequestActive(cachedRequest.identifier)) {
                    sink.complete();
                    return;
                }
                sink.next();
            },
            complete: sink.complete,
            unsubscribe: sink.complete
        });
        return function() {
            subscription.unsubscribe();
        };
    });
}
function $b171e3a3515bc38b$var$getPromiseForActiveRequest(environment, request) {
    var requestCache = $b171e3a3515bc38b$var$getRequestCache(environment);
    var cachedRequest = requestCache.get(request.identifier);
    if (!cachedRequest) return null;
    if (!environment.isRequestActive(cachedRequest.identifier)) return null;
    var promise = new Promise(function(resolve, reject) {
        var resolveOnNext = false;
        $b171e3a3515bc38b$var$getActiveStatusObservableForCachedRequest(environment, requestCache, cachedRequest).subscribe({
            complete: resolve,
            error: reject,
            next: function next(response) {
                if (resolveOnNext) resolve(response);
            }
        });
        resolveOnNext = true;
    });
    return promise;
}
function $b171e3a3515bc38b$var$getObservableForActiveRequest(environment, request) {
    var requestCache = $b171e3a3515bc38b$var$getRequestCache(environment);
    var cachedRequest = requestCache.get(request.identifier);
    if (!cachedRequest) return null;
    if (!environment.isRequestActive(cachedRequest.identifier)) return null;
    return $b171e3a3515bc38b$var$getActiveStatusObservableForCachedRequest(environment, requestCache, cachedRequest);
}
function $b171e3a3515bc38b$var$getRequestCache(environment) {
    var cached = $b171e3a3515bc38b$var$requestCachesByEnvironment.get(environment);
    if (cached != null) return cached;
    var requestCache = new Map();
    $b171e3a3515bc38b$var$requestCachesByEnvironment.set(environment, requestCache);
    return requestCache;
}
function $b171e3a3515bc38b$var$getCachedRequest(requestCache, identifier) {
    var cached = requestCache.get(identifier);
    !(cached != null) && $bQThX(false);
    return cached;
}
module.exports = {
    fetchQuery: $b171e3a3515bc38b$var$fetchQuery,
    fetchQueryDeduped: $b171e3a3515bc38b$var$fetchQueryDeduped,
    getPromiseForActiveRequest: $b171e3a3515bc38b$var$getPromiseForActiveRequest,
    getObservableForActiveRequest: $b171e3a3515bc38b$var$getObservableForActiveRequest
};

});
parcelRegister("gxoN7", function(module, exports) {
'use strict';

var $7dvyf = parcelRequire("7dvyf");
var $c0a2f57097a2c6eb$var$_interopRequireDefault = $7dvyf.default;

var $c0a2f57097a2c6eb$var$_createForOfIteratorHelper2 = $c0a2f57097a2c6eb$var$_interopRequireDefault((parcelRequire("bTRzt")));

var $c0a2f57097a2c6eb$var$_defineProperty2 = $c0a2f57097a2c6eb$var$_interopRequireDefault((parcelRequire("dW6Ee")));

var $8IVD8 = parcelRequire("8IVD8");

var $bQThX = parcelRequire("bQThX");
var $c0a2f57097a2c6eb$var$RelayReplaySubject = /*#__PURE__*/ function() {
    function RelayReplaySubject() {
        var _this = this;
        (0, $c0a2f57097a2c6eb$var$_defineProperty2["default"])(this, "_complete", false);
        (0, $c0a2f57097a2c6eb$var$_defineProperty2["default"])(this, "_events", []);
        (0, $c0a2f57097a2c6eb$var$_defineProperty2["default"])(this, "_sinks", new Set());
        (0, $c0a2f57097a2c6eb$var$_defineProperty2["default"])(this, "_subscription", []);
        this._observable = $8IVD8.create(function(sink) {
            _this._sinks.add(sink);
            var events = _this._events;
            for(var i = 0; i < events.length; i++){
                if (sink.closed) break;
                var event = events[i];
                switch(event.kind){
                    case 'complete':
                        sink.complete();
                        break;
                    case 'error':
                        sink.error(event.error);
                        break;
                    case 'next':
                        sink.next(event.data);
                        break;
                    default:
                        event.kind;
                        $bQThX(false);
                }
            }
            return function() {
                _this._sinks["delete"](sink);
            };
        });
    }
    var _proto = RelayReplaySubject.prototype;
    _proto.complete = function complete() {
        if (this._complete === true) return;
        this._complete = true;
        this._events.push({
            kind: 'complete'
        });
        this._sinks.forEach(function(sink) {
            return sink.complete();
        });
    };
    _proto.error = function error(_error) {
        if (this._complete === true) return;
        this._complete = true;
        this._events.push({
            kind: 'error',
            error: _error
        });
        this._sinks.forEach(function(sink) {
            return sink.error(_error);
        });
    };
    _proto.next = function next(data) {
        if (this._complete === true) return;
        this._events.push({
            kind: 'next',
            data: data
        });
        this._sinks.forEach(function(sink) {
            return sink.next(data);
        });
    };
    _proto.subscribe = function subscribe(observer) {
        var subscription = this._observable.subscribe(observer);
        this._subscription.push(subscription);
        return subscription;
    };
    _proto.unsubscribe = function unsubscribe() {
        var _iterator = (0, $c0a2f57097a2c6eb$var$_createForOfIteratorHelper2["default"])(this._subscription), _step;
        try {
            for(_iterator.s(); !(_step = _iterator.n()).done;){
                var subscription = _step.value;
                subscription.unsubscribe();
            }
        } catch (err) {
            _iterator.e(err);
        } finally{
            _iterator.f();
        }
        this._subscription = [];
    };
    _proto.getObserverCount = function getObserverCount() {
        return this._sinks.size;
    };
    return RelayReplaySubject;
}();
module.exports = $c0a2f57097a2c6eb$var$RelayReplaySubject;

});



parcelRegister("bvrmS", function(module, exports) {
'use strict';

var $ilblc = parcelRequire("ilblc");
var $8607d1ae1daf838a$var$createOperationDescriptor = $ilblc.createOperationDescriptor;

var $8AEJo = parcelRequire("8AEJo");
var $8607d1ae1daf838a$var$getRequest = $8AEJo.getRequest;
function $8607d1ae1daf838a$var$fetchQuery_DEPRECATED(environment, taggedNode, variables, cacheConfig) {
    var query = $8607d1ae1daf838a$var$getRequest(taggedNode);
    if (query.params.operationKind !== 'query') throw new Error('fetchQuery: Expected query operation');
    var operation = $8607d1ae1daf838a$var$createOperationDescriptor(query, variables, cacheConfig);
    return environment.execute({
        operation: operation
    }).map(function() {
        return environment.lookup(operation.fragment).data;
    }).toPromise();
}
module.exports = $8607d1ae1daf838a$var$fetchQuery_DEPRECATED;

});

parcelRegister("cfzqz", function(module, exports) {
'use strict';
var $8eb25df235a3c707$var$PreloadableQueryRegistry = /*#__PURE__*/ function() {
    function PreloadableQueryRegistry() {
        this._preloadableQueries = new Map();
        this._callbacks = new Map();
    }
    var _proto = PreloadableQueryRegistry.prototype;
    _proto.set = function set(key, value) {
        this._preloadableQueries.set(key, value);
        var callbacks = this._callbacks.get(key);
        if (callbacks != null) callbacks.forEach(function(cb) {
            try {
                cb(value);
            } catch (e) {
                setTimeout(function() {
                    throw e;
                }, 0);
            }
        });
    };
    _proto.get = function get(key) {
        return this._preloadableQueries.get(key);
    };
    _proto.onLoad = function onLoad(key, callback) {
        var _this$_callbacks$get;
        var callbacks = (_this$_callbacks$get = this._callbacks.get(key)) !== null && _this$_callbacks$get !== void 0 ? _this$_callbacks$get : new Set();
        callbacks.add(callback);
        var dispose = function dispose() {
            callbacks["delete"](callback);
        };
        this._callbacks.set(key, callbacks);
        return {
            dispose: dispose
        };
    };
    _proto.clear = function clear() {
        this._preloadableQueries.clear();
    };
    return PreloadableQueryRegistry;
}();
var $8eb25df235a3c707$var$preloadableQueryRegistry = new $8eb25df235a3c707$var$PreloadableQueryRegistry();
module.exports = $8eb25df235a3c707$var$preloadableQueryRegistry;

});

parcelRegister("hmKan", function(module, exports) {
'use strict';

var $5vUCK = parcelRequire("5vUCK");
parcelRequire("hzw7m");
function $ca484d6ff7c64c9a$var$createFragmentSpecResolver(context, containerName, fragments, props, rootIsQueryRenderer, callback) {
    var fragmentNames;
    return new $5vUCK(context, fragments, props, callback, rootIsQueryRenderer);
}
module.exports = $ca484d6ff7c64c9a$var$createFragmentSpecResolver;

});
parcelRegister("5vUCK", function(module, exports) {
'use strict';

var $7dvyf = parcelRequire("7dvyf");
var $403bc5529c430a66$var$_interopRequireDefault = $7dvyf.default;

var $403bc5529c430a66$var$_objectSpread2 = $403bc5529c430a66$var$_interopRequireDefault((parcelRequire("4N8OD")));

var $403bc5529c430a66$var$_defineProperty2 = $403bc5529c430a66$var$_interopRequireDefault((parcelRequire("dW6Ee")));

var $HZplc = parcelRequire("HZplc");

var $fPxW5 = parcelRequire("fPxW5");

var $bwVmU = parcelRequire("bwVmU");

var $hrF5e = parcelRequire("hrF5e");

var $9DZlA = parcelRequire("9DZlA");

var $ilblc = parcelRequire("ilblc");
var $403bc5529c430a66$var$createRequestDescriptor = $ilblc.createRequestDescriptor;

var $3o9ph = parcelRequire("3o9ph");
var $403bc5529c430a66$var$areEqualSelectors = $3o9ph.areEqualSelectors, $403bc5529c430a66$var$createReaderSelector = $3o9ph.createReaderSelector, $403bc5529c430a66$var$getSelectorsFromObject = $3o9ph.getSelectorsFromObject;

var $3Nt2B = parcelRequire("3Nt2B");

var $bQThX = parcelRequire("bQThX");
parcelRequire("hzw7m");
var $403bc5529c430a66$var$RelayModernFragmentSpecResolver = /*#__PURE__*/ function() {
    function RelayModernFragmentSpecResolver(context, fragments, props, callback, rootIsQueryRenderer) {
        var _this = this;
        (0, $403bc5529c430a66$var$_defineProperty2["default"])(this, "_onChange", function() {
            _this._stale = true;
            if (typeof _this._callback === 'function') _this._callback();
        });
        this._callback = callback;
        this._context = context;
        this._data = {};
        this._fragments = fragments;
        this._props = {};
        this._resolvers = {};
        this._stale = false;
        this._rootIsQueryRenderer = rootIsQueryRenderer;
        this.setProps(props);
    }
    var _proto = RelayModernFragmentSpecResolver.prototype;
    _proto.dispose = function dispose() {
        for(var key in this._resolvers)if (this._resolvers.hasOwnProperty(key)) $403bc5529c430a66$var$disposeCallback(this._resolvers[key]);
    };
    _proto.resolve = function resolve() {
        if (this._stale) {
            var prevData = this._data;
            var nextData;
            for(var key in this._resolvers)if (this._resolvers.hasOwnProperty(key)) {
                var resolver = this._resolvers[key];
                var prevItem = prevData[key];
                if (resolver) {
                    var nextItem = resolver.resolve();
                    if (nextData || nextItem !== prevItem) {
                        nextData = nextData || (0, $403bc5529c430a66$var$_objectSpread2["default"])({}, prevData);
                        nextData[key] = nextItem;
                    }
                } else {
                    var prop = this._props[key];
                    var _nextItem = prop !== undefined ? prop : null;
                    if (nextData || !$bwVmU(_nextItem, prevItem)) {
                        nextData = nextData || (0, $403bc5529c430a66$var$_objectSpread2["default"])({}, prevData);
                        nextData[key] = _nextItem;
                    }
                }
            }
            this._data = nextData || prevData;
            this._stale = false;
        }
        return this._data;
    };
    _proto.setCallback = function setCallback(props, callback) {
        this._callback = callback;
        if ($9DZlA.ENABLE_CONTAINERS_SUBSCRIBE_ON_COMMIT === true) this.setProps(props);
    };
    _proto.setProps = function setProps(props) {
        this._props = {};
        var ownedSelectors = $403bc5529c430a66$var$getSelectorsFromObject(this._fragments, props);
        for(var key in ownedSelectors)if (ownedSelectors.hasOwnProperty(key)) {
            var ownedSelector = ownedSelectors[key];
            var resolver = this._resolvers[key];
            if (ownedSelector == null) {
                if (resolver != null) resolver.dispose();
                resolver = null;
            } else if (ownedSelector.kind === 'PluralReaderSelector') {
                if (resolver == null) resolver = new $403bc5529c430a66$var$SelectorListResolver(this._context.environment, this._rootIsQueryRenderer, ownedSelector, this._callback != null, this._onChange);
                else {
                    !(resolver instanceof $403bc5529c430a66$var$SelectorListResolver) && $bQThX(false);
                    resolver.setSelector(ownedSelector);
                }
            } else if (resolver == null) resolver = new $403bc5529c430a66$var$SelectorResolver(this._context.environment, this._rootIsQueryRenderer, ownedSelector, this._callback != null, this._onChange);
            else {
                !(resolver instanceof $403bc5529c430a66$var$SelectorResolver) && $bQThX(false);
                resolver.setSelector(ownedSelector);
            }
            this._props[key] = props[key];
            this._resolvers[key] = resolver;
        }
        this._stale = true;
    };
    _proto.setVariables = function setVariables(variables, request) {
        for(var key in this._resolvers)if (this._resolvers.hasOwnProperty(key)) {
            var resolver = this._resolvers[key];
            if (resolver) resolver.setVariables(variables, request);
        }
        this._stale = true;
    };
    return RelayModernFragmentSpecResolver;
}();
var $403bc5529c430a66$var$SelectorResolver = /*#__PURE__*/ function() {
    function SelectorResolver(environment, rootIsQueryRenderer, selector, subscribeOnConstruction, callback) {
        var _this2 = this;
        (0, $403bc5529c430a66$var$_defineProperty2["default"])(this, "_onChange", function(snapshot) {
            _this2._data = snapshot.data;
            _this2._isMissingData = snapshot.isMissingData;
            _this2._missingRequiredFields = snapshot.missingRequiredFields;
            _this2._errorResponseFields = snapshot.errorResponseFields;
            _this2._relayResolverErrors = snapshot.relayResolverErrors;
            _this2._callback();
        });
        var _snapshot = environment.lookup(selector);
        this._callback = callback;
        this._data = _snapshot.data;
        this._isMissingData = _snapshot.isMissingData;
        this._missingRequiredFields = _snapshot.missingRequiredFields;
        this._errorResponseFields = _snapshot.errorResponseFields;
        this._relayResolverErrors = _snapshot.relayResolverErrors;
        this._environment = environment;
        this._rootIsQueryRenderer = rootIsQueryRenderer;
        this._selector = selector;
        if ($9DZlA.ENABLE_CONTAINERS_SUBSCRIBE_ON_COMMIT === true) {
            if (subscribeOnConstruction) this._subscription = environment.subscribe(_snapshot, this._onChange);
        } else this._subscription = environment.subscribe(_snapshot, this._onChange);
    }
    var _proto2 = SelectorResolver.prototype;
    _proto2.dispose = function dispose() {
        if (this._subscription) {
            this._subscription.dispose();
            this._subscription = null;
        }
    };
    _proto2.resolve = function resolve() {
        var _this$_selector$node$, _this$_selector$node$2;
        if (this._isMissingData === true) {
            var pendingOperationsResult = $HZplc(this._environment, this._selector.node, this._selector.owner);
            var promise = pendingOperationsResult === null || pendingOperationsResult === void 0 ? void 0 : pendingOperationsResult.promise;
            if (promise != null) {
                if (this._rootIsQueryRenderer) ;
                else {
                    var _pendingOperationsRes;
                    var pendingOperations = (_pendingOperationsRes = pendingOperationsResult === null || pendingOperationsResult === void 0 ? void 0 : pendingOperationsResult.pendingOperations) !== null && _pendingOperationsRes !== void 0 ? _pendingOperationsRes : [];
                    this._environment.__log({
                        name: 'suspense.fragment',
                        data: this._data,
                        fragment: this._selector.node,
                        isRelayHooks: false,
                        isMissingData: this._isMissingData,
                        isPromiseCached: false,
                        pendingOperations: pendingOperations
                    });
                    throw promise;
                }
            }
        }
        $fPxW5(this._environment, this._missingRequiredFields, this._relayResolverErrors, this._errorResponseFields, (_this$_selector$node$ = (_this$_selector$node$2 = this._selector.node.metadata) === null || _this$_selector$node$2 === void 0 ? void 0 : _this$_selector$node$2.throwOnFieldError) !== null && _this$_selector$node$ !== void 0 ? _this$_selector$node$ : false);
        return this._data;
    };
    _proto2.setSelector = function setSelector(selector) {
        if (this._subscription != null && $403bc5529c430a66$var$areEqualSelectors(selector, this._selector)) return;
        this.dispose();
        var snapshot = this._environment.lookup(selector);
        this._data = $hrF5e(this._data, snapshot.data);
        this._isMissingData = snapshot.isMissingData;
        this._missingRequiredFields = snapshot.missingRequiredFields;
        this._errorResponseFields = snapshot.errorResponseFields;
        this._relayResolverErrors = snapshot.relayResolverErrors;
        this._selector = selector;
        this._subscription = this._environment.subscribe(snapshot, this._onChange);
    };
    _proto2.setVariables = function setVariables(variables, request) {
        if ($3Nt2B(variables, this._selector.variables)) return;
        var requestDescriptor = $403bc5529c430a66$var$createRequestDescriptor(request, variables);
        var selector = $403bc5529c430a66$var$createReaderSelector(this._selector.node, this._selector.dataID, variables, requestDescriptor);
        this.setSelector(selector);
    };
    return SelectorResolver;
}();
var $403bc5529c430a66$var$SelectorListResolver = /*#__PURE__*/ function() {
    function SelectorListResolver(environment, rootIsQueryRenderer, selector, subscribeOnConstruction, callback) {
        var _this3 = this;
        (0, $403bc5529c430a66$var$_defineProperty2["default"])(this, "_onChange", function(data) {
            _this3._stale = true;
            _this3._callback();
        });
        this._callback = callback;
        this._data = [];
        this._environment = environment;
        this._resolvers = [];
        this._stale = true;
        this._rootIsQueryRenderer = rootIsQueryRenderer;
        this._subscribeOnConstruction = subscribeOnConstruction;
        this.setSelector(selector);
    }
    var _proto3 = SelectorListResolver.prototype;
    _proto3.dispose = function dispose() {
        this._resolvers.forEach($403bc5529c430a66$var$disposeCallback);
    };
    _proto3.resolve = function resolve() {
        if (this._stale) {
            var prevData = this._data;
            var nextData;
            for(var ii = 0; ii < this._resolvers.length; ii++){
                var prevItem = prevData[ii];
                var nextItem = this._resolvers[ii].resolve();
                if (nextData || nextItem !== prevItem) {
                    nextData = nextData || prevData.slice(0, ii);
                    nextData.push(nextItem);
                }
            }
            if (!nextData && this._resolvers.length !== prevData.length) nextData = prevData.slice(0, this._resolvers.length);
            this._data = nextData || prevData;
            this._stale = false;
        }
        return this._data;
    };
    _proto3.setSelector = function setSelector(selector) {
        var selectors = selector.selectors;
        while(this._resolvers.length > selectors.length){
            var resolver = this._resolvers.pop();
            resolver.dispose();
        }
        for(var ii = 0; ii < selectors.length; ii++)if (ii < this._resolvers.length) this._resolvers[ii].setSelector(selectors[ii]);
        else this._resolvers[ii] = new $403bc5529c430a66$var$SelectorResolver(this._environment, this._rootIsQueryRenderer, selectors[ii], this._subscribeOnConstruction, this._onChange);
        this._stale = true;
    };
    _proto3.setVariables = function setVariables(variables, request) {
        this._resolvers.forEach(function(resolver) {
            return resolver.setVariables(variables, request);
        });
        this._stale = true;
    };
    return SelectorListResolver;
}();
function $403bc5529c430a66$var$disposeCallback(disposable) {
    disposable && disposable.dispose();
}
module.exports = $403bc5529c430a66$var$RelayModernFragmentSpecResolver;

});
parcelRegister("HZplc", function(module, exports) {
'use strict';

var $fexah = parcelRequire("fexah");
var $0843a68fe5dde82d$var$getPromiseForActiveRequest = $fexah.getPromiseForActiveRequest;
function $0843a68fe5dde82d$var$getPendingOperationsForFragment(environment, fragmentNode, fragmentOwner) {
    var _pendingOperations$ma, _pendingOperations;
    var pendingOperations = [];
    var promise = $0843a68fe5dde82d$var$getPromiseForActiveRequest(environment, fragmentOwner);
    if (promise != null) pendingOperations = [
        fragmentOwner
    ];
    else {
        var _result$pendingOperat, _result$promise;
        var result = environment.getOperationTracker().getPendingOperationsAffectingOwner(fragmentOwner);
        pendingOperations = (_result$pendingOperat = result === null || result === void 0 ? void 0 : result.pendingOperations) !== null && _result$pendingOperat !== void 0 ? _result$pendingOperat : [];
        promise = (_result$promise = result === null || result === void 0 ? void 0 : result.promise) !== null && _result$promise !== void 0 ? _result$promise : null;
    }
    if (!promise) return null;
    var pendingOperationName = (_pendingOperations$ma = (_pendingOperations = pendingOperations) === null || _pendingOperations === void 0 ? void 0 : _pendingOperations.map(function(op) {
        return op.node.params.name;
    }).join(',')) !== null && _pendingOperations$ma !== void 0 ? _pendingOperations$ma : null;
    if (pendingOperationName == null || pendingOperationName.length === 0) pendingOperationName = 'Unknown pending operation';
    var fragmentName = fragmentNode.name;
    var promiseDisplayName = pendingOperationName === fragmentName ? "Relay(".concat(pendingOperationName, ")") : "Relay(".concat(pendingOperationName, ":").concat(fragmentName, ")");
    promise.displayName = promiseDisplayName;
    environment.__log({
        name: 'pendingoperation.found',
        fragment: fragmentNode,
        fragmentOwner: fragmentOwner,
        pendingOperations: pendingOperations
    });
    return {
        promise: promise,
        pendingOperations: pendingOperations
    };
}
module.exports = $0843a68fe5dde82d$var$getPendingOperationsForFragment;

});

parcelRegister("bwVmU", function(module, exports) {
'use strict';
function $864f2f09dc74bffa$var$isScalarAndEqual(valueA, valueB) {
    return valueA === valueB && (valueA === null || typeof valueA !== 'object');
}
module.exports = $864f2f09dc74bffa$var$isScalarAndEqual;

});

parcelRegister("hrF5e", function(module, exports) {
'use strict';
function $cb34d39c8b8ab40f$var$recycleNodesInto(prevData, nextData) {
    return $cb34d39c8b8ab40f$var$recycleNodesIntoImpl(prevData, nextData, true);
}
function $cb34d39c8b8ab40f$var$recycleNodesIntoImpl(prevData, nextData, canMutate) {
    if (prevData === nextData || typeof prevData !== 'object' || !prevData || prevData.constructor !== Object && !Array.isArray(prevData) || typeof nextData !== 'object' || !nextData || nextData.constructor !== Object && !Array.isArray(nextData)) return nextData;
    var canRecycle = false;
    var prevArray = Array.isArray(prevData) ? prevData : null;
    var nextArray = Array.isArray(nextData) ? nextData : null;
    if (prevArray && nextArray) {
        var canMutateNext = canMutate && !Object.isFrozen(nextArray);
        canRecycle = nextArray.reduce(function(wasEqual, nextItem, ii) {
            var prevValue = prevArray[ii];
            var nextValue = $cb34d39c8b8ab40f$var$recycleNodesIntoImpl(prevValue, nextItem, canMutateNext);
            if (nextValue !== nextArray[ii] && canMutateNext) nextArray[ii] = nextValue;
            return wasEqual && nextValue === prevArray[ii];
        }, true) && prevArray.length === nextArray.length;
    } else if (!prevArray && !nextArray) {
        var prevObject = prevData;
        var nextObject = nextData;
        var prevKeys = Object.keys(prevObject);
        var nextKeys = Object.keys(nextObject);
        var _canMutateNext = canMutate && !Object.isFrozen(nextObject);
        canRecycle = nextKeys.reduce(function(wasEqual, key) {
            var prevValue = prevObject[key];
            var nextValue = $cb34d39c8b8ab40f$var$recycleNodesIntoImpl(prevValue, nextObject[key], _canMutateNext);
            if (nextValue !== nextObject[key] && _canMutateNext) nextObject[key] = nextValue;
            return wasEqual && nextValue === prevObject[key];
        }, true) && prevKeys.length === nextKeys.length;
    }
    return canRecycle ? prevData : nextData;
}
module.exports = $cb34d39c8b8ab40f$var$recycleNodesInto;

});



parcelRegister("9XnRn", function(module, exports) {
'use strict';

var $bQThX = parcelRequire("bQThX");
var $73fc21d6475c4a53$var$relayContext;
var $73fc21d6475c4a53$var$firstReact;
function $73fc21d6475c4a53$var$createRelayContext(react) {
    if (!$73fc21d6475c4a53$var$relayContext) {
        $73fc21d6475c4a53$var$relayContext = react.createContext(null);
        $73fc21d6475c4a53$var$firstReact = react;
    }
    !(react === $73fc21d6475c4a53$var$firstReact) && $bQThX(false);
    return $73fc21d6475c4a53$var$relayContext;
}
module.exports = $73fc21d6475c4a53$var$createRelayContext;

});

parcelRegister("gXI8O", function(module, exports) {
'use strict';
var $c59465904535bb95$var$LIVE_RESOLVER_SUSPENSE_SENTINEL = Object.freeze({
    __LIVE_RESOLVER_SUSPENSE_SENTINEL: true
});
function $c59465904535bb95$var$suspenseSentinel() {
    return $c59465904535bb95$var$LIVE_RESOLVER_SUSPENSE_SENTINEL;
}
function $c59465904535bb95$var$isSuspenseSentinel(value) {
    return value === $c59465904535bb95$var$LIVE_RESOLVER_SUSPENSE_SENTINEL;
}
module.exports = {
    isSuspenseSentinel: $c59465904535bb95$var$isSuspenseSentinel,
    suspenseSentinel: $c59465904535bb95$var$suspenseSentinel
};

});

parcelRegister("4gr1T", function(module, exports) {
'use strict';

var $7dvyf = parcelRequire("7dvyf");
var $31ad9f91598e2665$var$_interopRequireDefault = $7dvyf.default;

var $31ad9f91598e2665$var$_objectSpread2 = $31ad9f91598e2665$var$_interopRequireDefault((parcelRequire("4N8OD")));

var $31ad9f91598e2665$var$_RelayModernRecord = $31ad9f91598e2665$var$_interopRequireDefault((parcelRequire("c4ZG3")));

var $31ad9f91598e2665$var$_RelayRecordSource = $31ad9f91598e2665$var$_interopRequireDefault((parcelRequire("fWVgk")));

var $31ad9f91598e2665$var$_RelayResponseNormalizer = $31ad9f91598e2665$var$_interopRequireDefault((parcelRequire("80YOC")));
function $31ad9f91598e2665$var$normalizeResponse(response, selector, typeName, options) {
    var _response$extensions;
    var data = response.data, errors = response.errors;
    var source = $31ad9f91598e2665$var$_RelayRecordSource["default"].create();
    var record = $31ad9f91598e2665$var$_RelayModernRecord["default"].create(selector.dataID, typeName);
    source.set(selector.dataID, record);
    var relayPayload = $31ad9f91598e2665$var$_RelayResponseNormalizer["default"].normalize(source, selector, data, options, errors);
    return (0, $31ad9f91598e2665$var$_objectSpread2["default"])((0, $31ad9f91598e2665$var$_objectSpread2["default"])({}, relayPayload), {}, {
        isFinal: ((_response$extensions = response.extensions) === null || _response$extensions === void 0 ? void 0 : _response$extensions.is_final) === true
    });
}
module.exports = $31ad9f91598e2665$var$normalizeResponse;

});
parcelRegister("c4ZG3", function(module, exports) {
'use strict';

var $7dvyf = parcelRequire("7dvyf");
var $8cb5b390e548ac30$var$_interopRequireDefault = $7dvyf.default;

var $8cb5b390e548ac30$var$_defineProperty2 = $8cb5b390e548ac30$var$_interopRequireDefault((parcelRequire("dW6Ee")));

var $8cb5b390e548ac30$var$_objectWithoutPropertiesLoose2 = $8cb5b390e548ac30$var$_interopRequireDefault((parcelRequire("7o4v7")));

var $8cb5b390e548ac30$var$_toPropertyKey2 = $8cb5b390e548ac30$var$_interopRequireDefault((parcelRequire("64aWY")));

var $8cb5b390e548ac30$var$_objectSpread2 = $8cb5b390e548ac30$var$_interopRequireDefault((parcelRequire("4N8OD")));

var $8YAvI = parcelRequire("8YAvI");

var $70q7x = parcelRequire("70q7x");
var $8cb5b390e548ac30$var$generateClientObjectClientID = $70q7x.generateClientObjectClientID, $8cb5b390e548ac30$var$isClientID = $70q7x.isClientID;

var $gXI8O = parcelRequire("gXI8O");
var $8cb5b390e548ac30$var$isSuspenseSentinel = $gXI8O.isSuspenseSentinel;

var $a6k4O = parcelRequire("a6k4O");
var $8cb5b390e548ac30$var$ACTOR_IDENTIFIER_KEY = $a6k4O.ACTOR_IDENTIFIER_KEY, $8cb5b390e548ac30$var$ERRORS_KEY = $a6k4O.ERRORS_KEY, $8cb5b390e548ac30$var$ID_KEY = $a6k4O.ID_KEY, $8cb5b390e548ac30$var$INVALIDATED_AT_KEY = $a6k4O.INVALIDATED_AT_KEY, $8cb5b390e548ac30$var$REF_KEY = $a6k4O.REF_KEY, $8cb5b390e548ac30$var$REFS_KEY = $a6k4O.REFS_KEY, $8cb5b390e548ac30$var$RELAY_RESOLVER_VALUE_KEY = $a6k4O.RELAY_RESOLVER_VALUE_KEY, $8cb5b390e548ac30$var$ROOT_ID = $a6k4O.ROOT_ID, $8cb5b390e548ac30$var$TYPENAME_KEY = $a6k4O.TYPENAME_KEY;

var $3Nt2B = parcelRequire("3Nt2B");

var $bQThX = parcelRequire("bQThX");
parcelRequire("hzw7m");
function $8cb5b390e548ac30$var$clone(record) {
    return (0, $8cb5b390e548ac30$var$_objectSpread2["default"])({}, record);
}
function $8cb5b390e548ac30$var$copyFields(source, sink) {
    for(var key in source){
        if (source.hasOwnProperty(key)) {
            if (key !== $8cb5b390e548ac30$var$ID_KEY && key !== $8cb5b390e548ac30$var$TYPENAME_KEY) sink[key] = source[key];
        }
    }
}
function $8cb5b390e548ac30$var$create(dataID, typeName) {
    var record = {};
    record[$8cb5b390e548ac30$var$ID_KEY] = dataID;
    record[$8cb5b390e548ac30$var$TYPENAME_KEY] = typeName;
    return record;
}
function $8cb5b390e548ac30$var$fromObject(json) {
    return json;
}
function $8cb5b390e548ac30$var$getDataID(record) {
    return record[$8cb5b390e548ac30$var$ID_KEY];
}
function $8cb5b390e548ac30$var$getFields(record) {
    if ($8cb5b390e548ac30$var$ERRORS_KEY in record) return Object.keys(record).filter(function(field) {
        return field !== $8cb5b390e548ac30$var$ERRORS_KEY;
    });
    return Object.keys(record);
}
function $8cb5b390e548ac30$var$getType(record) {
    return record[$8cb5b390e548ac30$var$TYPENAME_KEY];
}
function $8cb5b390e548ac30$var$getErrors(record, storageKey) {
    var _record$ERRORS_KEY;
    return (_record$ERRORS_KEY = record[$8cb5b390e548ac30$var$ERRORS_KEY]) === null || _record$ERRORS_KEY === void 0 ? void 0 : _record$ERRORS_KEY[storageKey];
}
function $8cb5b390e548ac30$var$getValue(record, storageKey) {
    var value = record[storageKey];
    if (value && typeof value === 'object') !(!value.hasOwnProperty($8cb5b390e548ac30$var$REF_KEY) && !value.hasOwnProperty($8cb5b390e548ac30$var$REFS_KEY)) && $bQThX(false);
    return value;
}
function $8cb5b390e548ac30$var$hasValue(record, storageKey) {
    return storageKey in record;
}
function $8cb5b390e548ac30$var$getLinkedRecordID(record, storageKey) {
    var maybeLink = record[storageKey];
    if (maybeLink == null) return maybeLink;
    var link = maybeLink;
    !(typeof link === 'object' && link && typeof link[$8cb5b390e548ac30$var$REF_KEY] === 'string') && $bQThX(false);
    return link[$8cb5b390e548ac30$var$REF_KEY];
}
function $8cb5b390e548ac30$var$hasLinkedRecordID(record, storageKey) {
    var maybeLink = record[storageKey];
    if (maybeLink == null) return false;
    var link = maybeLink;
    return typeof link === 'object' && link && typeof link[$8cb5b390e548ac30$var$REF_KEY] === 'string';
}
function $8cb5b390e548ac30$var$getLinkedRecordIDs(record, storageKey) {
    var links = record[storageKey];
    if (links == null) return links;
    !(typeof links === 'object' && Array.isArray(links[$8cb5b390e548ac30$var$REFS_KEY])) && $bQThX(false);
    return links[$8cb5b390e548ac30$var$REFS_KEY];
}
function $8cb5b390e548ac30$var$hasLinkedRecordIDs(record, storageKey) {
    var links = record[storageKey];
    if (links == null) return false;
    return typeof links === 'object' && Array.isArray(links[$8cb5b390e548ac30$var$REFS_KEY]) && links[$8cb5b390e548ac30$var$REFS_KEY].every(function(link) {
        return typeof link === 'string';
    });
}
function $8cb5b390e548ac30$var$getInvalidationEpoch(record) {
    if (record == null) return null;
    var invalidatedAt = record[$8cb5b390e548ac30$var$INVALIDATED_AT_KEY];
    if (typeof invalidatedAt !== 'number') return null;
    return invalidatedAt;
}
function $8cb5b390e548ac30$var$update(prevRecord, nextRecord) {
    var _updated2;
    var _getType, _getType2, prevID, nextID, prevType, nextType;
    var prevErrorsByKey = prevRecord[$8cb5b390e548ac30$var$ERRORS_KEY];
    var nextErrorsByKey = nextRecord[$8cb5b390e548ac30$var$ERRORS_KEY];
    var updated = null;
    if (prevErrorsByKey == null && nextErrorsByKey == null) {
        var _updated;
        for(var storageKey in nextRecord)if (updated || !$3Nt2B(prevRecord[storageKey], nextRecord[storageKey])) {
            updated = updated !== null ? updated : (0, $8cb5b390e548ac30$var$_objectSpread2["default"])({}, prevRecord);
            updated[storageKey] = nextRecord[storageKey];
        }
        return (_updated = updated) !== null && _updated !== void 0 ? _updated : prevRecord;
    }
    for(var _storageKey2 in nextRecord){
        if (_storageKey2 === $8cb5b390e548ac30$var$ERRORS_KEY) continue;
        var nextValue = nextRecord[_storageKey2];
        var nextErrors = nextErrorsByKey === null || nextErrorsByKey === void 0 ? void 0 : nextErrorsByKey[_storageKey2];
        if (updated == null) {
            var prevValue = prevRecord[_storageKey2];
            var prevErrors = prevErrorsByKey === null || prevErrorsByKey === void 0 ? void 0 : prevErrorsByKey[_storageKey2];
            if ($3Nt2B(prevValue, nextValue) && $3Nt2B(prevErrors, nextErrors)) continue;
            updated = (0, $8cb5b390e548ac30$var$_objectSpread2["default"])({}, prevRecord);
            if (prevErrorsByKey != null) updated[$8cb5b390e548ac30$var$ERRORS_KEY] = (0, $8cb5b390e548ac30$var$_objectSpread2["default"])({}, prevErrorsByKey);
        }
        $8cb5b390e548ac30$var$setValue(updated, _storageKey2, nextValue);
        $8cb5b390e548ac30$var$setErrors(updated, _storageKey2, nextErrors);
    }
    return (_updated2 = updated) !== null && _updated2 !== void 0 ? _updated2 : prevRecord;
}
function $8cb5b390e548ac30$var$merge(record1, record2) {
    var _getType3, _getType4, prevID, nextID, prevType, nextType;
    if ($8cb5b390e548ac30$var$ERRORS_KEY in record1 || $8cb5b390e548ac30$var$ERRORS_KEY in record2) {
        var errors1 = record1[$8cb5b390e548ac30$var$ERRORS_KEY], fields1 = (0, $8cb5b390e548ac30$var$_objectWithoutPropertiesLoose2["default"])(record1, [
            $8cb5b390e548ac30$var$ERRORS_KEY
        ].map($8cb5b390e548ac30$var$_toPropertyKey2["default"]));
        var errors2 = record2[$8cb5b390e548ac30$var$ERRORS_KEY], fields2 = (0, $8cb5b390e548ac30$var$_objectWithoutPropertiesLoose2["default"])(record2, [
            $8cb5b390e548ac30$var$ERRORS_KEY
        ].map($8cb5b390e548ac30$var$_toPropertyKey2["default"]));
        var updated = (0, $8cb5b390e548ac30$var$_objectSpread2["default"])((0, $8cb5b390e548ac30$var$_objectSpread2["default"])({}, fields1), fields2);
        if (errors1 == null && errors2 == null) return updated;
        var updatedErrors = {};
        for(var storageKey in errors1){
            if (fields2.hasOwnProperty(storageKey)) continue;
            updatedErrors[storageKey] = errors1[storageKey];
        }
        for(var _storageKey3 in errors2)updatedErrors[_storageKey3] = errors2[_storageKey3];
        for(var _storageKey in updatedErrors){
            updated[$8cb5b390e548ac30$var$ERRORS_KEY] = updatedErrors;
            break;
        }
        return updated;
    } else return (0, $8cb5b390e548ac30$var$_objectSpread2["default"])((0, $8cb5b390e548ac30$var$_objectSpread2["default"])({}, record1), record2);
}
function $8cb5b390e548ac30$var$freeze(record) {
    $8YAvI(record);
}
function $8cb5b390e548ac30$var$setErrors(record, storageKey, errors) {
    var errorsByStorageKey = record[$8cb5b390e548ac30$var$ERRORS_KEY];
    if (errors != null && errors.length > 0) {
        if (errorsByStorageKey == null) record[$8cb5b390e548ac30$var$ERRORS_KEY] = (0, $8cb5b390e548ac30$var$_defineProperty2["default"])({}, storageKey, errors);
        else errorsByStorageKey[storageKey] = errors;
    } else if (errorsByStorageKey != null) {
        if (delete errorsByStorageKey[storageKey]) {
            for(var otherStorageKey in errorsByStorageKey){
                if (errorsByStorageKey.hasOwnProperty(otherStorageKey)) return;
            }
            delete record[$8cb5b390e548ac30$var$ERRORS_KEY];
        }
    }
}
function $8cb5b390e548ac30$var$setValue(record, storageKey, value) {
    var prevID, _getType5, prevType, nextType;
    record[storageKey] = value;
}
function $8cb5b390e548ac30$var$setLinkedRecordID(record, storageKey, linkedID) {
    var link = {};
    link[$8cb5b390e548ac30$var$REF_KEY] = linkedID;
    record[storageKey] = link;
}
function $8cb5b390e548ac30$var$setLinkedRecordIDs(record, storageKey, linkedIDs) {
    var links = {};
    links[$8cb5b390e548ac30$var$REFS_KEY] = linkedIDs;
    record[storageKey] = links;
}
function $8cb5b390e548ac30$var$setActorLinkedRecordID(record, storageKey, actorIdentifier, linkedID) {
    var link = {};
    link[$8cb5b390e548ac30$var$REF_KEY] = linkedID;
    link[$8cb5b390e548ac30$var$ACTOR_IDENTIFIER_KEY] = actorIdentifier;
    record[storageKey] = link;
}
function $8cb5b390e548ac30$var$getActorLinkedRecordID(record, storageKey) {
    var link = record[storageKey];
    if (link == null) return link;
    !(typeof link === 'object' && typeof link[$8cb5b390e548ac30$var$REF_KEY] === 'string' && link[$8cb5b390e548ac30$var$ACTOR_IDENTIFIER_KEY] != null) && $bQThX(false);
    return [
        link[$8cb5b390e548ac30$var$ACTOR_IDENTIFIER_KEY],
        link[$8cb5b390e548ac30$var$REF_KEY]
    ];
}
function $8cb5b390e548ac30$var$getResolverLinkedRecordID(record, typeName) {
    var id = $8cb5b390e548ac30$var$getValue(record, $8cb5b390e548ac30$var$RELAY_RESOLVER_VALUE_KEY);
    if (id == null || $8cb5b390e548ac30$var$isSuspenseSentinel(id)) return null;
    if (typeof id === 'object') id = id.id;
    !(typeof id === 'string') && $bQThX(false);
    return $8cb5b390e548ac30$var$generateClientObjectClientID(typeName, id);
}
function $8cb5b390e548ac30$var$getResolverLinkedRecordIDs(record, typeName) {
    var resolverValue = $8cb5b390e548ac30$var$getValue(record, $8cb5b390e548ac30$var$RELAY_RESOLVER_VALUE_KEY);
    if (resolverValue == null || $8cb5b390e548ac30$var$isSuspenseSentinel(resolverValue)) return null;
    !Array.isArray(resolverValue) && $bQThX(false);
    return resolverValue.map(function(id) {
        if (id == null) return null;
        if (typeof id === 'object') id = id.id;
        !(typeof id === 'string') && $bQThX(false);
        return $8cb5b390e548ac30$var$generateClientObjectClientID(typeName, id);
    });
}
function $8cb5b390e548ac30$var$toJSON(record) {
    return record;
}
module.exports = {
    clone: $8cb5b390e548ac30$var$clone,
    copyFields: $8cb5b390e548ac30$var$copyFields,
    create: $8cb5b390e548ac30$var$create,
    freeze: $8cb5b390e548ac30$var$freeze,
    fromObject: $8cb5b390e548ac30$var$fromObject,
    getDataID: $8cb5b390e548ac30$var$getDataID,
    getErrors: $8cb5b390e548ac30$var$getErrors,
    getFields: $8cb5b390e548ac30$var$getFields,
    getInvalidationEpoch: $8cb5b390e548ac30$var$getInvalidationEpoch,
    getLinkedRecordID: $8cb5b390e548ac30$var$getLinkedRecordID,
    getLinkedRecordIDs: $8cb5b390e548ac30$var$getLinkedRecordIDs,
    getType: $8cb5b390e548ac30$var$getType,
    getValue: $8cb5b390e548ac30$var$getValue,
    hasValue: $8cb5b390e548ac30$var$hasValue,
    hasLinkedRecordID: $8cb5b390e548ac30$var$hasLinkedRecordID,
    hasLinkedRecordIDs: $8cb5b390e548ac30$var$hasLinkedRecordIDs,
    merge: $8cb5b390e548ac30$var$merge,
    setErrors: $8cb5b390e548ac30$var$setErrors,
    setValue: $8cb5b390e548ac30$var$setValue,
    setLinkedRecordID: $8cb5b390e548ac30$var$setLinkedRecordID,
    setLinkedRecordIDs: $8cb5b390e548ac30$var$setLinkedRecordIDs,
    update: $8cb5b390e548ac30$var$update,
    getActorLinkedRecordID: $8cb5b390e548ac30$var$getActorLinkedRecordID,
    setActorLinkedRecordID: $8cb5b390e548ac30$var$setActorLinkedRecordID,
    getResolverLinkedRecordID: $8cb5b390e548ac30$var$getResolverLinkedRecordID,
    getResolverLinkedRecordIDs: $8cb5b390e548ac30$var$getResolverLinkedRecordIDs,
    toJSON: $8cb5b390e548ac30$var$toJSON
};

});

parcelRegister("fWVgk", function(module, exports) {
'use strict';

var $7dvyf = parcelRequire("7dvyf");
var $b9c8b0ebe926a21f$var$_interopRequireDefault = $7dvyf.default;

var $b9c8b0ebe926a21f$var$_createForOfIteratorHelper2 = $b9c8b0ebe926a21f$var$_interopRequireDefault((parcelRequire("bTRzt")));

var $c4ZG3 = parcelRequire("c4ZG3");

var $gotsH = parcelRequire("gotsH");
var $b9c8b0ebe926a21f$var$EXISTENT = $gotsH.EXISTENT, $b9c8b0ebe926a21f$var$NONEXISTENT = $gotsH.NONEXISTENT, $b9c8b0ebe926a21f$var$UNKNOWN = $gotsH.UNKNOWN;
var $b9c8b0ebe926a21f$var$RelayRecordSource = /*#__PURE__*/ function() {
    function RelayRecordSource(records) {
        var _this = this;
        this._records = new Map();
        if (records != null) Object.keys(records).forEach(function(key) {
            var object = records[key];
            var record = $c4ZG3.fromObject(object);
            _this._records.set(key, record);
        });
    }
    RelayRecordSource.create = function create(records) {
        return new RelayRecordSource(records);
    };
    var _proto = RelayRecordSource.prototype;
    _proto.clear = function clear() {
        this._records = new Map();
    };
    _proto["delete"] = function _delete(dataID) {
        this._records.set(dataID, null);
    };
    _proto.get = function get(dataID) {
        return this._records.get(dataID);
    };
    _proto.getRecordIDs = function getRecordIDs() {
        return Array.from(this._records.keys());
    };
    _proto.getStatus = function getStatus(dataID) {
        if (!this._records.has(dataID)) return $b9c8b0ebe926a21f$var$UNKNOWN;
        return this._records.get(dataID) == null ? $b9c8b0ebe926a21f$var$NONEXISTENT : $b9c8b0ebe926a21f$var$EXISTENT;
    };
    _proto.has = function has(dataID) {
        return this._records.has(dataID);
    };
    _proto.remove = function remove(dataID) {
        this._records["delete"](dataID);
    };
    _proto.set = function set(dataID, record) {
        this._records.set(dataID, record);
    };
    _proto.size = function size() {
        return this._records.size;
    };
    _proto.toJSON = function toJSON() {
        var obj = {};
        var _iterator = (0, $b9c8b0ebe926a21f$var$_createForOfIteratorHelper2["default"])(this._records), _step;
        try {
            for(_iterator.s(); !(_step = _iterator.n()).done;){
                var _step$value = _step.value, key = _step$value[0], record = _step$value[1];
                obj[key] = $c4ZG3.toJSON(record);
            }
        } catch (err) {
            _iterator.e(err);
        } finally{
            _iterator.f();
        }
        return obj;
    };
    return RelayRecordSource;
}();
module.exports = $b9c8b0ebe926a21f$var$RelayRecordSource;

});
parcelRegister("gotsH", function(module, exports) {
'use strict';
var $bef5bdc079b918fa$var$RelayRecordState = {
    EXISTENT: 'EXISTENT',
    NONEXISTENT: 'NONEXISTENT',
    UNKNOWN: 'UNKNOWN'
};
module.exports = $bef5bdc079b918fa$var$RelayRecordState;

});


parcelRegister("80YOC", function(module, exports) {
'use strict';

var $7dvyf = parcelRequire("7dvyf");
var $5d5d7f7eaeb825d7$var$_interopRequireDefault = $7dvyf.default;

var $5d5d7f7eaeb825d7$var$_createForOfIteratorHelper2 = $5d5d7f7eaeb825d7$var$_interopRequireDefault((parcelRequire("bTRzt")));

var $5d5d7f7eaeb825d7$var$_toConsumableArray2 = $5d5d7f7eaeb825d7$var$_interopRequireDefault((parcelRequire("gvI75")));

var $gP77g = parcelRequire("gP77g");
var $5d5d7f7eaeb825d7$var$ACTOR_IDENTIFIER_FIELD_NAME = $gP77g.ACTOR_IDENTIFIER_FIELD_NAME, $5d5d7f7eaeb825d7$var$getActorIdentifierFromPayload = $gP77g.getActorIdentifierFromPayload;

var $9lZfN = parcelRequire("9lZfN");
var $5d5d7f7eaeb825d7$var$ACTOR_CHANGE = $9lZfN.ACTOR_CHANGE, $5d5d7f7eaeb825d7$var$CLIENT_COMPONENT = $9lZfN.CLIENT_COMPONENT, $5d5d7f7eaeb825d7$var$CLIENT_EDGE_TO_CLIENT_OBJECT = $9lZfN.CLIENT_EDGE_TO_CLIENT_OBJECT, $5d5d7f7eaeb825d7$var$CLIENT_EXTENSION = $9lZfN.CLIENT_EXTENSION, $5d5d7f7eaeb825d7$var$CONDITION = $9lZfN.CONDITION, $5d5d7f7eaeb825d7$var$DEFER = $9lZfN.DEFER, $5d5d7f7eaeb825d7$var$FRAGMENT_SPREAD = $9lZfN.FRAGMENT_SPREAD, $5d5d7f7eaeb825d7$var$INLINE_FRAGMENT = $9lZfN.INLINE_FRAGMENT, $5d5d7f7eaeb825d7$var$LINKED_FIELD = $9lZfN.LINKED_FIELD, $5d5d7f7eaeb825d7$var$LINKED_HANDLE = $9lZfN.LINKED_HANDLE, $5d5d7f7eaeb825d7$var$MODULE_IMPORT = $9lZfN.MODULE_IMPORT, $5d5d7f7eaeb825d7$var$RELAY_LIVE_RESOLVER = $9lZfN.RELAY_LIVE_RESOLVER, $5d5d7f7eaeb825d7$var$RELAY_RESOLVER = $9lZfN.RELAY_RESOLVER, $5d5d7f7eaeb825d7$var$SCALAR_FIELD = $9lZfN.SCALAR_FIELD, $5d5d7f7eaeb825d7$var$SCALAR_HANDLE = $9lZfN.SCALAR_HANDLE, $5d5d7f7eaeb825d7$var$STREAM = $9lZfN.STREAM, $5d5d7f7eaeb825d7$var$TYPE_DISCRIMINATOR = $9lZfN.TYPE_DISCRIMINATOR;

var $70q7x = parcelRequire("70q7x");
var $5d5d7f7eaeb825d7$var$generateClientID = $70q7x.generateClientID, $5d5d7f7eaeb825d7$var$isClientID = $70q7x.isClientID;

var $kpcDM = parcelRequire("kpcDM");
var $5d5d7f7eaeb825d7$var$getLocalVariables = $kpcDM.getLocalVariables;

var $hOJCp = parcelRequire("hOJCp");
var $5d5d7f7eaeb825d7$var$buildErrorTrie = $hOJCp.buildErrorTrie, $5d5d7f7eaeb825d7$var$getErrorsByKey = $hOJCp.getErrorsByKey, $5d5d7f7eaeb825d7$var$getNestedErrorTrieByKey = $hOJCp.getNestedErrorTrieByKey;

var $c4ZG3 = parcelRequire("c4ZG3");

var $3o9ph = parcelRequire("3o9ph");
var $5d5d7f7eaeb825d7$var$createNormalizationSelector = $3o9ph.createNormalizationSelector;

var $a6k4O = parcelRequire("a6k4O");
var $5d5d7f7eaeb825d7$var$ROOT_ID = $a6k4O.ROOT_ID, $5d5d7f7eaeb825d7$var$TYPENAME_KEY = $a6k4O.TYPENAME_KEY, $5d5d7f7eaeb825d7$var$getArgumentValues = $a6k4O.getArgumentValues, $5d5d7f7eaeb825d7$var$getHandleStorageKey = $a6k4O.getHandleStorageKey, $5d5d7f7eaeb825d7$var$getModuleComponentKey = $a6k4O.getModuleComponentKey, $5d5d7f7eaeb825d7$var$getModuleOperationKey = $a6k4O.getModuleOperationKey, $5d5d7f7eaeb825d7$var$getStorageKey = $a6k4O.getStorageKey;

var $cHFgk = parcelRequire("cHFgk");
var $5d5d7f7eaeb825d7$var$TYPE_SCHEMA_TYPE = $cHFgk.TYPE_SCHEMA_TYPE, $5d5d7f7eaeb825d7$var$generateTypeID = $cHFgk.generateTypeID;
parcelRequire("3Nt2B");

var $bQThX = parcelRequire("bQThX");
parcelRequire("hzw7m");
function $5d5d7f7eaeb825d7$var$normalize(recordSource, selector, response, options, errors) {
    var dataID = selector.dataID, node = selector.node, variables = selector.variables;
    var normalizer = new $5d5d7f7eaeb825d7$var$RelayResponseNormalizer(recordSource, variables, options);
    return normalizer.normalizeResponse(node, dataID, response, errors);
}
var $5d5d7f7eaeb825d7$var$RelayResponseNormalizer = /*#__PURE__*/ function() {
    function RelayResponseNormalizer(recordSource, variables, options) {
        this._actorIdentifier = options.actorIdentifier;
        this._getDataId = options.getDataID;
        this._handleFieldPayloads = [];
        this._treatMissingFieldsAsNull = options.treatMissingFieldsAsNull;
        this._incrementalPlaceholders = [];
        this._isClientExtension = false;
        this._isUnmatchedAbstractType = false;
        this._followupPayloads = [];
        this._path = options.path ? (0, $5d5d7f7eaeb825d7$var$_toConsumableArray2["default"])(options.path) : [];
        this._recordSource = recordSource;
        this._variables = variables;
        this._shouldProcessClientComponents = options.shouldProcessClientComponents;
    }
    var _proto = RelayResponseNormalizer.prototype;
    _proto.normalizeResponse = function normalizeResponse(node, dataID, data, errors) {
        var record = this._recordSource.get(dataID);
        !record && $bQThX(false);
        this._assignClientAbstractTypes(node);
        this._errorTrie = $5d5d7f7eaeb825d7$var$buildErrorTrie(errors);
        this._traverseSelections(node, record, data);
        return {
            errors: errors,
            fieldPayloads: this._handleFieldPayloads,
            incrementalPlaceholders: this._incrementalPlaceholders,
            followupPayloads: this._followupPayloads,
            source: this._recordSource,
            isFinal: false
        };
    };
    _proto._assignClientAbstractTypes = function _assignClientAbstractTypes(node) {
        var clientAbstractTypes = node.clientAbstractTypes;
        if (clientAbstractTypes != null) for(var _i = 0, _Object$keys = Object.keys(clientAbstractTypes); _i < _Object$keys.length; _i++){
            var abstractType = _Object$keys[_i];
            var _iterator = (0, $5d5d7f7eaeb825d7$var$_createForOfIteratorHelper2["default"])(clientAbstractTypes[abstractType]), _step;
            try {
                for(_iterator.s(); !(_step = _iterator.n()).done;){
                    var concreteType = _step.value;
                    var typeID = $5d5d7f7eaeb825d7$var$generateTypeID(concreteType);
                    var typeRecord = this._recordSource.get(typeID);
                    if (typeRecord == null) {
                        typeRecord = $c4ZG3.create(typeID, $5d5d7f7eaeb825d7$var$TYPE_SCHEMA_TYPE);
                        this._recordSource.set(typeID, typeRecord);
                    }
                    $c4ZG3.setValue(typeRecord, abstractType, true);
                }
            } catch (err) {
                _iterator.e(err);
            } finally{
                _iterator.f();
            }
        }
    };
    _proto._getVariableValue = function _getVariableValue(name) {
        !this._variables.hasOwnProperty(name) && $bQThX(false);
        return this._variables[name];
    };
    _proto._getRecordType = function _getRecordType(data) {
        var typeName = data[$5d5d7f7eaeb825d7$var$TYPENAME_KEY];
        !(typeName != null) && $bQThX(false);
        return typeName;
    };
    _proto._traverseSelections = function _traverseSelections(node, record, data) {
        for(var i = 0; i < node.selections.length; i++){
            var selection = node.selections[i];
            switch(selection.kind){
                case $5d5d7f7eaeb825d7$var$SCALAR_FIELD:
                case $5d5d7f7eaeb825d7$var$LINKED_FIELD:
                    this._normalizeField(selection, record, data);
                    break;
                case $5d5d7f7eaeb825d7$var$CONDITION:
                    var conditionValue = Boolean(this._getVariableValue(selection.condition));
                    if (conditionValue === selection.passingValue) this._traverseSelections(selection, record, data);
                    break;
                case $5d5d7f7eaeb825d7$var$FRAGMENT_SPREAD:
                    var prevVariables = this._variables;
                    this._variables = $5d5d7f7eaeb825d7$var$getLocalVariables(this._variables, selection.fragment.argumentDefinitions, selection.args);
                    this._traverseSelections(selection.fragment, record, data);
                    this._variables = prevVariables;
                    break;
                case $5d5d7f7eaeb825d7$var$INLINE_FRAGMENT:
                    var abstractKey = selection.abstractKey;
                    if (abstractKey == null) {
                        var typeName = $c4ZG3.getType(record);
                        if (typeName === selection.type) this._traverseSelections(selection, record, data);
                    } else {
                        var implementsInterface = data.hasOwnProperty(abstractKey);
                        var _typeName = $c4ZG3.getType(record);
                        var typeID = $5d5d7f7eaeb825d7$var$generateTypeID(_typeName);
                        var typeRecord = this._recordSource.get(typeID);
                        if (typeRecord == null) {
                            typeRecord = $c4ZG3.create(typeID, $5d5d7f7eaeb825d7$var$TYPE_SCHEMA_TYPE);
                            this._recordSource.set(typeID, typeRecord);
                        }
                        $c4ZG3.setValue(typeRecord, abstractKey, implementsInterface);
                        if (implementsInterface) this._traverseSelections(selection, record, data);
                    }
                    break;
                case $5d5d7f7eaeb825d7$var$TYPE_DISCRIMINATOR:
                    var _abstractKey = selection.abstractKey;
                    var _implementsInterface = data.hasOwnProperty(_abstractKey);
                    var _typeName2 = $c4ZG3.getType(record);
                    var _typeID = $5d5d7f7eaeb825d7$var$generateTypeID(_typeName2);
                    var _typeRecord = this._recordSource.get(_typeID);
                    if (_typeRecord == null) {
                        _typeRecord = $c4ZG3.create(_typeID, $5d5d7f7eaeb825d7$var$TYPE_SCHEMA_TYPE);
                        this._recordSource.set(_typeID, _typeRecord);
                    }
                    $c4ZG3.setValue(_typeRecord, _abstractKey, _implementsInterface);
                    break;
                case $5d5d7f7eaeb825d7$var$LINKED_HANDLE:
                case $5d5d7f7eaeb825d7$var$SCALAR_HANDLE:
                    var args = selection.args ? $5d5d7f7eaeb825d7$var$getArgumentValues(selection.args, this._variables) : {};
                    var fieldKey = $5d5d7f7eaeb825d7$var$getStorageKey(selection, this._variables);
                    var handleKey = $5d5d7f7eaeb825d7$var$getHandleStorageKey(selection, this._variables);
                    this._handleFieldPayloads.push({
                        args: args,
                        dataID: $c4ZG3.getDataID(record),
                        fieldKey: fieldKey,
                        handle: selection.handle,
                        handleKey: handleKey,
                        handleArgs: selection.handleArgs ? $5d5d7f7eaeb825d7$var$getArgumentValues(selection.handleArgs, this._variables) : {}
                    });
                    break;
                case $5d5d7f7eaeb825d7$var$MODULE_IMPORT:
                    this._normalizeModuleImport(selection, record, data);
                    break;
                case $5d5d7f7eaeb825d7$var$DEFER:
                    this._normalizeDefer(selection, record, data);
                    break;
                case $5d5d7f7eaeb825d7$var$STREAM:
                    this._normalizeStream(selection, record, data);
                    break;
                case $5d5d7f7eaeb825d7$var$CLIENT_EXTENSION:
                    var isClientExtension = this._isClientExtension;
                    this._isClientExtension = true;
                    this._traverseSelections(selection, record, data);
                    this._isClientExtension = isClientExtension;
                    break;
                case $5d5d7f7eaeb825d7$var$CLIENT_COMPONENT:
                    if (this._shouldProcessClientComponents === false) break;
                    this._traverseSelections(selection.fragment, record, data);
                    break;
                case $5d5d7f7eaeb825d7$var$ACTOR_CHANGE:
                    this._normalizeActorChange(selection, record, data);
                    break;
                case $5d5d7f7eaeb825d7$var$RELAY_RESOLVER:
                    this._normalizeResolver(selection, record, data);
                    break;
                case $5d5d7f7eaeb825d7$var$RELAY_LIVE_RESOLVER:
                    this._normalizeResolver(selection, record, data);
                    break;
                case $5d5d7f7eaeb825d7$var$CLIENT_EDGE_TO_CLIENT_OBJECT:
                    this._normalizeResolver(selection.backingField, record, data);
                    break;
                default:
                    selection;
                    $bQThX(false);
            }
        }
    };
    _proto._normalizeResolver = function _normalizeResolver(resolver, record, data) {
        if (resolver.fragment != null) this._traverseSelections(resolver.fragment, record, data);
    };
    _proto._normalizeDefer = function _normalizeDefer(defer, record, data) {
        var isDeferred = defer["if"] === null || this._getVariableValue(defer["if"]);
        if (isDeferred === false) this._traverseSelections(defer, record, data);
        else this._incrementalPlaceholders.push({
            kind: 'defer',
            data: data,
            label: defer.label,
            path: (0, $5d5d7f7eaeb825d7$var$_toConsumableArray2["default"])(this._path),
            selector: $5d5d7f7eaeb825d7$var$createNormalizationSelector(defer, $c4ZG3.getDataID(record), this._variables),
            typeName: $c4ZG3.getType(record),
            actorIdentifier: this._actorIdentifier
        });
    };
    _proto._normalizeStream = function _normalizeStream(stream, record, data) {
        this._traverseSelections(stream, record, data);
        var isStreamed = stream["if"] === null || this._getVariableValue(stream["if"]);
        if (isStreamed === true) this._incrementalPlaceholders.push({
            kind: 'stream',
            label: stream.label,
            path: (0, $5d5d7f7eaeb825d7$var$_toConsumableArray2["default"])(this._path),
            parentID: $c4ZG3.getDataID(record),
            node: stream,
            variables: this._variables,
            actorIdentifier: this._actorIdentifier
        });
    };
    _proto._normalizeModuleImport = function _normalizeModuleImport(moduleImport, record, data) {
        !(typeof data === 'object' && data) && $bQThX(false);
        var typeName = $c4ZG3.getType(record);
        var componentKey = $5d5d7f7eaeb825d7$var$getModuleComponentKey(moduleImport.documentName);
        var componentReference = moduleImport.componentModuleProvider || data[componentKey];
        $c4ZG3.setValue(record, componentKey, componentReference !== null && componentReference !== void 0 ? componentReference : null);
        var operationKey = $5d5d7f7eaeb825d7$var$getModuleOperationKey(moduleImport.documentName);
        var operationReference = moduleImport.operationModuleProvider || data[operationKey];
        $c4ZG3.setValue(record, operationKey, operationReference !== null && operationReference !== void 0 ? operationReference : null);
        if (operationReference != null) this._followupPayloads.push({
            kind: 'ModuleImportPayload',
            args: moduleImport.args,
            data: data,
            dataID: $c4ZG3.getDataID(record),
            operationReference: operationReference,
            path: (0, $5d5d7f7eaeb825d7$var$_toConsumableArray2["default"])(this._path),
            typeName: typeName,
            variables: this._variables,
            actorIdentifier: this._actorIdentifier
        });
    };
    _proto._normalizeField = function _normalizeField(selection, record, data) {
        !(typeof data === 'object' && data) && $bQThX(false);
        var responseKey = selection.alias || selection.name;
        var storageKey = $5d5d7f7eaeb825d7$var$getStorageKey(selection, this._variables);
        var fieldValue = data[responseKey];
        if (fieldValue == null) {
            if (fieldValue === undefined) {
                var isOptionalField = this._isClientExtension || this._isUnmatchedAbstractType;
                if (isOptionalField) return;
                else if (!this._treatMissingFieldsAsNull) return;
            }
            $c4ZG3.setValue(record, storageKey, null);
            var errorTrie = this._errorTrie;
            if (errorTrie != null) {
                var errors = $5d5d7f7eaeb825d7$var$getErrorsByKey(errorTrie, responseKey);
                if (errors != null) $c4ZG3.setErrors(record, storageKey, errors);
            }
            return;
        }
        if (selection.kind === $5d5d7f7eaeb825d7$var$SCALAR_FIELD) $c4ZG3.setValue(record, storageKey, fieldValue);
        else if (selection.kind === $5d5d7f7eaeb825d7$var$LINKED_FIELD) {
            this._path.push(responseKey);
            var oldErrorTrie = this._errorTrie;
            this._errorTrie = oldErrorTrie == null ? null : $5d5d7f7eaeb825d7$var$getNestedErrorTrieByKey(oldErrorTrie, responseKey);
            if (selection.plural) this._normalizePluralLink(selection, record, storageKey, fieldValue);
            else this._normalizeLink(selection, record, storageKey, fieldValue);
            this._errorTrie = oldErrorTrie;
            this._path.pop();
        } else {
            selection;
            $bQThX(false);
        }
    };
    _proto._normalizeActorChange = function _normalizeActorChange(selection, record, data) {
        var _field$concreteType;
        var field = selection.linkedField;
        !(typeof data === 'object' && data) && $bQThX(false);
        var responseKey = field.alias || field.name;
        var storageKey = $5d5d7f7eaeb825d7$var$getStorageKey(field, this._variables);
        var fieldValue = data[responseKey];
        if (fieldValue == null) {
            if (fieldValue === undefined) {
                var isOptionalField = this._isClientExtension || this._isUnmatchedAbstractType;
                if (isOptionalField) return;
                else if (!this._treatMissingFieldsAsNull) return;
            }
            $c4ZG3.setValue(record, storageKey, null);
            return;
        }
        var actorIdentifier = $5d5d7f7eaeb825d7$var$getActorIdentifierFromPayload(fieldValue);
        if (actorIdentifier == null) {
            $c4ZG3.setValue(record, storageKey, null);
            return;
        }
        var typeName = (_field$concreteType = field.concreteType) !== null && _field$concreteType !== void 0 ? _field$concreteType : this._getRecordType(fieldValue);
        var nextID = this._getDataId(fieldValue, typeName) || $c4ZG3.getLinkedRecordID(record, storageKey) || $5d5d7f7eaeb825d7$var$generateClientID($c4ZG3.getDataID(record), storageKey);
        !(typeof nextID === 'string') && $bQThX(false);
        $c4ZG3.setActorLinkedRecordID(record, storageKey, actorIdentifier, nextID);
        this._followupPayloads.push({
            kind: 'ActorPayload',
            data: fieldValue,
            dataID: nextID,
            path: [].concat((0, $5d5d7f7eaeb825d7$var$_toConsumableArray2["default"])(this._path), [
                responseKey
            ]),
            typeName: typeName,
            variables: this._variables,
            node: field,
            actorIdentifier: actorIdentifier
        });
    };
    _proto._normalizeLink = function _normalizeLink(field, record, storageKey, fieldValue) {
        var _field$concreteType2;
        !(typeof fieldValue === 'object' && fieldValue) && $bQThX(false);
        var nextID = this._getDataId(fieldValue, (_field$concreteType2 = field.concreteType) !== null && _field$concreteType2 !== void 0 ? _field$concreteType2 : this._getRecordType(fieldValue)) || $c4ZG3.getLinkedRecordID(record, storageKey) || $5d5d7f7eaeb825d7$var$generateClientID($c4ZG3.getDataID(record), storageKey);
        !(typeof nextID === 'string') && $bQThX(false);
        $c4ZG3.setLinkedRecordID(record, storageKey, nextID);
        var nextRecord = this._recordSource.get(nextID);
        if (!nextRecord) {
            var typeName = field.concreteType || this._getRecordType(fieldValue);
            nextRecord = $c4ZG3.create(nextID, typeName);
            this._recordSource.set(nextID, nextRecord);
        }
        this._traverseSelections(field, nextRecord, fieldValue);
    };
    _proto._normalizePluralLink = function _normalizePluralLink(field, record, storageKey, fieldValue) {
        var _this = this;
        !Array.isArray(fieldValue) && $bQThX(false);
        var prevIDs = $c4ZG3.getLinkedRecordIDs(record, storageKey);
        var nextIDs = [];
        fieldValue.forEach(function(item, nextIndex) {
            var _field$concreteType3;
            if (item == null) {
                nextIDs.push(item);
                return;
            }
            _this._path.push(String(nextIndex));
            var oldErrorTrie = _this._errorTrie;
            _this._errorTrie = oldErrorTrie == null ? null : $5d5d7f7eaeb825d7$var$getNestedErrorTrieByKey(oldErrorTrie, nextIndex);
            !(typeof item === 'object') && $bQThX(false);
            var nextID = _this._getDataId(item, (_field$concreteType3 = field.concreteType) !== null && _field$concreteType3 !== void 0 ? _field$concreteType3 : _this._getRecordType(item)) || prevIDs && prevIDs[nextIndex] || $5d5d7f7eaeb825d7$var$generateClientID($c4ZG3.getDataID(record), storageKey, nextIndex);
            !(typeof nextID === 'string') && $bQThX(false);
            nextIDs.push(nextID);
            var nextRecord = _this._recordSource.get(nextID);
            if (!nextRecord) {
                var typeName = field.concreteType || _this._getRecordType(item);
                nextRecord = $c4ZG3.create(nextID, typeName);
                _this._recordSource.set(nextID, nextRecord);
            }
            _this._traverseSelections(field, nextRecord, item);
            _this._errorTrie = oldErrorTrie;
            _this._path.pop();
        });
        $c4ZG3.setLinkedRecordIDs(record, storageKey, nextIDs);
    };
    _proto._validateRecordType = function _validateRecordType(record, field, payload) {
        var _field$concreteType4;
        var typeName = (_field$concreteType4 = field.concreteType) !== null && _field$concreteType4 !== void 0 ? _field$concreteType4 : this._getRecordType(payload);
        var dataID = $c4ZG3.getDataID(record);
    };
    _proto._validateConflictingFieldsWithIdenticalId = function _validateConflictingFieldsWithIdenticalId(record, storageKey, fieldValue) {
        var dataID, previousValue;
    };
    _proto._validateConflictingLinkedFieldsWithIdenticalId = function _validateConflictingLinkedFieldsWithIdenticalId(prevID, nextID, storageKey) {};
    return RelayResponseNormalizer;
}();
module.exports = {
    normalize: $5d5d7f7eaeb825d7$var$normalize
};

});
parcelRegister("gP77g", function(module, exports) {
'use strict';
var $c3f6eddd6685c478$var$ACTOR_IDENTIFIER_FIELD_NAME = 'actor_key';

var $bd1WG = parcelRequire("bd1WG");
var $c3f6eddd6685c478$var$getActorIdentifier = $bd1WG.getActorIdentifier;
function $c3f6eddd6685c478$var$getActorIdentifierFromPayload(payload) {
    if (payload != null && typeof payload === 'object' && typeof payload[$c3f6eddd6685c478$var$ACTOR_IDENTIFIER_FIELD_NAME] === 'string') return $c3f6eddd6685c478$var$getActorIdentifier(payload[$c3f6eddd6685c478$var$ACTOR_IDENTIFIER_FIELD_NAME]);
}
module.exports = {
    ACTOR_IDENTIFIER_FIELD_NAME: $c3f6eddd6685c478$var$ACTOR_IDENTIFIER_FIELD_NAME,
    getActorIdentifierFromPayload: $c3f6eddd6685c478$var$getActorIdentifierFromPayload
};

});
parcelRegister("bd1WG", function(module, exports) {
'use strict';

var $bQThX = parcelRequire("bQThX");
var $82926af4650667ea$var$INTERNAL_ACTOR_IDENTIFIER_DO_NOT_USE = 'INTERNAL_ACTOR_IDENTIFIER_DO_NOT_USE';
function $82926af4650667ea$var$assertInternalActorIdentifier(actorIdentifier) {
    !(actorIdentifier === $82926af4650667ea$var$INTERNAL_ACTOR_IDENTIFIER_DO_NOT_USE) && $bQThX(false);
}
module.exports = {
    assertInternalActorIdentifier: $82926af4650667ea$var$assertInternalActorIdentifier,
    getActorIdentifier: function getActorIdentifier(actorID) {
        return actorID;
    },
    getDefaultActorIdentifier: function getDefaultActorIdentifier() {
        throw new Error('Not Implemented');
    },
    INTERNAL_ACTOR_IDENTIFIER_DO_NOT_USE: $82926af4650667ea$var$INTERNAL_ACTOR_IDENTIFIER_DO_NOT_USE
};

});


parcelRegister("cHFgk", function(module, exports) {
'use strict';
var $93f982082ff0754a$var$PREFIX = 'client:__type:';
var $93f982082ff0754a$var$TYPE_SCHEMA_TYPE = '__TypeSchema';
function $93f982082ff0754a$var$generateTypeID(typeName) {
    return $93f982082ff0754a$var$PREFIX + typeName;
}
function $93f982082ff0754a$var$isTypeID(id) {
    return id.indexOf($93f982082ff0754a$var$PREFIX) === 0;
}
module.exports = {
    generateTypeID: $93f982082ff0754a$var$generateTypeID,
    isTypeID: $93f982082ff0754a$var$isTypeID,
    TYPE_SCHEMA_TYPE: $93f982082ff0754a$var$TYPE_SCHEMA_TYPE
};

});



parcelRegister("bjfzJ", function(module, exports) {
'use strict';

var $8AEJo = parcelRequire("8AEJo");
var $83bd8d009dd16751$var$getInlineDataFragment = $8AEJo.getInlineDataFragment;

var $a6k4O = parcelRequire("a6k4O");
var $83bd8d009dd16751$var$FRAGMENTS_KEY = $a6k4O.FRAGMENTS_KEY;

var $bQThX = parcelRequire("bQThX");
function $83bd8d009dd16751$var$readInlineData(fragment, fragmentRef) {
    var _fragmentRef$FRAGMENT;
    var inlineDataFragment = $83bd8d009dd16751$var$getInlineDataFragment(fragment);
    if (fragmentRef == null) return fragmentRef;
    !(typeof fragmentRef === 'object') && $bQThX(false);
    var inlineData = (_fragmentRef$FRAGMENT = fragmentRef[$83bd8d009dd16751$var$FRAGMENTS_KEY]) === null || _fragmentRef$FRAGMENT === void 0 ? void 0 : _fragmentRef$FRAGMENT[inlineDataFragment.name];
    !(inlineData != null) && $bQThX(false);
    return inlineData;
}
module.exports = $83bd8d009dd16751$var$readInlineData;

});

parcelRegister("4Ai67", function(module, exports) {
'use strict';

var $7dvyf = parcelRequire("7dvyf");
var $35689008602f23e2$var$_interopRequireDefault = $7dvyf.default;

var $35689008602f23e2$var$_objectSpread2 = $35689008602f23e2$var$_interopRequireDefault((parcelRequire("4N8OD")));

var $4LekS = parcelRequire("4LekS");

var $bd1WG = parcelRequire("bd1WG");
var $35689008602f23e2$var$INTERNAL_ACTOR_IDENTIFIER_DO_NOT_USE = $bd1WG.INTERNAL_ACTOR_IDENTIFIER_DO_NOT_USE, $35689008602f23e2$var$assertInternalActorIdentifier = $bd1WG.assertInternalActorIdentifier;

var $8IVD8 = parcelRequire("8IVD8");

var $4XWvG = parcelRequire("4XWvG");

var $3s9KA = parcelRequire("3s9KA");

var $2Xa6u = parcelRequire("2Xa6u");

var $eGOdg = parcelRequire("eGOdg");

var $hmiuT = parcelRequire("hmiuT");

var $4gr1T = parcelRequire("4gr1T");

var $gs7tQ = parcelRequire("gs7tQ");

var $3Flbx = parcelRequire("3Flbx");

var $fWVgk = parcelRequire("fWVgk");
parcelRequire("bQThX");
var $35689008602f23e2$var$RelayModernEnvironment = /*#__PURE__*/ function() {
    function RelayModernEnvironment(config) {
        var _this = this;
        var _config$log, _config$relayFieldLog, _config$UNSTABLE_defa, _config$getDataID, _config$missingFieldH, _config$handlerProvid, _config$scheduler, _config$isServer, _config$normalizeResp, _config$operationTrac;
        this.configName = config.configName;
        this._treatMissingFieldsAsNull = config.treatMissingFieldsAsNull === true;
        var operationLoader = config.operationLoader;
        this.__log = (_config$log = config.log) !== null && _config$log !== void 0 ? _config$log : $35689008602f23e2$var$emptyFunction;
        this.relayFieldLogger = (_config$relayFieldLog = config.relayFieldLogger) !== null && _config$relayFieldLog !== void 0 ? _config$relayFieldLog : $hmiuT;
        this._defaultRenderPolicy = (_config$UNSTABLE_defa = config.UNSTABLE_defaultRenderPolicy) !== null && _config$UNSTABLE_defa !== void 0 ? _config$UNSTABLE_defa : 'partial';
        this._operationLoader = operationLoader;
        this._operationExecutions = new Map();
        this._network = $4XWvG(this, config.network);
        this._getDataID = (_config$getDataID = config.getDataID) !== null && _config$getDataID !== void 0 ? _config$getDataID : $eGOdg;
        this._missingFieldHandlers = (_config$missingFieldH = config.missingFieldHandlers) !== null && _config$missingFieldH !== void 0 ? _config$missingFieldH : [];
        this._publishQueue = new $3Flbx(config.store, (_config$handlerProvid = config.handlerProvider) !== null && _config$handlerProvid !== void 0 ? _config$handlerProvid : $4LekS, this._getDataID, this._missingFieldHandlers);
        this._scheduler = (_config$scheduler = config.scheduler) !== null && _config$scheduler !== void 0 ? _config$scheduler : null;
        this._store = config.store;
        this.options = config.options;
        this._isServer = (_config$isServer = config.isServer) !== null && _config$isServer !== void 0 ? _config$isServer : false;
        this._normalizeResponse = (_config$normalizeResp = config.normalizeResponse) !== null && _config$normalizeResp !== void 0 ? _config$normalizeResp : $4gr1T;
        this.__setNet = function(newNet) {
            return _this._network = $4XWvG(_this, newNet);
        };
        var _require2, inspect;
        this._operationTracker = (_config$operationTrac = config.operationTracker) !== null && _config$operationTrac !== void 0 ? _config$operationTrac : new $3s9KA();
        this._shouldProcessClientComponents = config.shouldProcessClientComponents;
        $2Xa6u(this);
    }
    var _proto = RelayModernEnvironment.prototype;
    _proto.getStore = function getStore() {
        return this._store;
    };
    _proto.getNetwork = function getNetwork() {
        return this._network;
    };
    _proto.getOperationTracker = function getOperationTracker() {
        return this._operationTracker;
    };
    _proto.getScheduler = function getScheduler() {
        return this._scheduler;
    };
    _proto.isRequestActive = function isRequestActive(requestIdentifier) {
        var activeState = this._operationExecutions.get(requestIdentifier);
        return activeState === 'active';
    };
    _proto.UNSTABLE_getDefaultRenderPolicy = function UNSTABLE_getDefaultRenderPolicy() {
        return this._defaultRenderPolicy;
    };
    _proto.applyUpdate = function applyUpdate(optimisticUpdate) {
        var _this2 = this;
        var dispose = function dispose() {
            _this2._scheduleUpdates(function() {
                _this2._publishQueue.revertUpdate(optimisticUpdate);
                _this2._publishQueue.run();
            });
        };
        this._scheduleUpdates(function() {
            _this2._publishQueue.applyUpdate(optimisticUpdate);
            _this2._publishQueue.run();
        });
        return {
            dispose: dispose
        };
    };
    _proto.revertUpdate = function revertUpdate(update) {
        var _this3 = this;
        this._scheduleUpdates(function() {
            _this3._publishQueue.revertUpdate(update);
            _this3._publishQueue.run();
        });
    };
    _proto.replaceUpdate = function replaceUpdate(update, newUpdate) {
        var _this4 = this;
        this._scheduleUpdates(function() {
            _this4._publishQueue.revertUpdate(update);
            _this4._publishQueue.applyUpdate(newUpdate);
            _this4._publishQueue.run();
        });
    };
    _proto.applyMutation = function applyMutation(optimisticConfig) {
        var subscription = this._execute({
            createSource: function createSource() {
                return $8IVD8.create(function(_sink) {});
            },
            isClientPayload: false,
            operation: optimisticConfig.operation,
            optimisticConfig: optimisticConfig,
            updater: null
        }).subscribe({});
        return {
            dispose: function dispose() {
                return subscription.unsubscribe();
            }
        };
    };
    _proto.check = function check(operation) {
        if (this._missingFieldHandlers.length === 0 && !$35689008602f23e2$var$operationHasClientAbstractTypes(operation)) return this._store.check(operation);
        return this._checkSelectorAndHandleMissingFields(operation, this._missingFieldHandlers);
    };
    _proto.commitPayload = function commitPayload(operation, payload) {
        this._execute({
            createSource: function createSource() {
                return $8IVD8.from({
                    data: payload
                });
            },
            isClientPayload: true,
            operation: operation,
            optimisticConfig: null,
            updater: null
        }).subscribe({});
    };
    _proto.commitUpdate = function commitUpdate(updater) {
        var _this5 = this;
        this._scheduleUpdates(function() {
            _this5._publishQueue.commitUpdate(updater);
            _this5._publishQueue.run();
        });
    };
    _proto.lookup = function lookup(readSelector) {
        return this._store.lookup(readSelector);
    };
    _proto.subscribe = function subscribe(snapshot, callback) {
        return this._store.subscribe(snapshot, callback);
    };
    _proto.retain = function retain(operation) {
        return this._store.retain(operation);
    };
    _proto.isServer = function isServer() {
        return this._isServer;
    };
    _proto._checkSelectorAndHandleMissingFields = function _checkSelectorAndHandleMissingFields(operation, handlers) {
        var _this6 = this;
        var target = $fWVgk.create();
        var source = this._store.getSource();
        var result = this._store.check(operation, {
            handlers: handlers,
            defaultActorIdentifier: $35689008602f23e2$var$INTERNAL_ACTOR_IDENTIFIER_DO_NOT_USE,
            getSourceForActor: function getSourceForActor(actorIdentifier) {
                $35689008602f23e2$var$assertInternalActorIdentifier(actorIdentifier);
                return source;
            },
            getTargetForActor: function getTargetForActor(actorIdentifier) {
                $35689008602f23e2$var$assertInternalActorIdentifier(actorIdentifier);
                return target;
            }
        });
        if (target.size() > 0) this._scheduleUpdates(function() {
            _this6._publishQueue.commitSource(target);
            _this6._publishQueue.run();
        });
        return result;
    };
    _proto._scheduleUpdates = function _scheduleUpdates(task) {
        var scheduler = this._scheduler;
        if (scheduler != null) scheduler.schedule(task);
        else task();
    };
    _proto.execute = function execute(_ref) {
        var _this7 = this;
        var operation = _ref.operation;
        return this._execute({
            createSource: function createSource() {
                return _this7.getNetwork().execute(operation.request.node.params, operation.request.variables, operation.request.cacheConfig || {}, null);
            },
            isClientPayload: false,
            operation: operation,
            optimisticConfig: null,
            updater: null
        });
    };
    _proto.executeSubscription = function executeSubscription(_ref2) {
        var _this8 = this;
        var operation = _ref2.operation, updater = _ref2.updater;
        return this._execute({
            createSource: function createSource() {
                return _this8.getNetwork().execute(operation.request.node.params, operation.request.variables, operation.request.cacheConfig || {}, null);
            },
            isClientPayload: false,
            operation: operation,
            optimisticConfig: null,
            updater: updater
        });
    };
    _proto.executeMutation = function executeMutation(_ref3) {
        var _this9 = this;
        var operation = _ref3.operation, optimisticResponse = _ref3.optimisticResponse, optimisticUpdater = _ref3.optimisticUpdater, updater = _ref3.updater, uploadables = _ref3.uploadables;
        var optimisticConfig;
        if (optimisticResponse || optimisticUpdater) optimisticConfig = {
            operation: operation,
            response: optimisticResponse,
            updater: optimisticUpdater
        };
        return this._execute({
            createSource: function createSource() {
                return _this9.getNetwork().execute(operation.request.node.params, operation.request.variables, (0, $35689008602f23e2$var$_objectSpread2["default"])((0, $35689008602f23e2$var$_objectSpread2["default"])({}, operation.request.cacheConfig), {}, {
                    force: true
                }), uploadables);
            },
            isClientPayload: false,
            operation: operation,
            optimisticConfig: optimisticConfig,
            updater: updater
        });
    };
    _proto.executeWithSource = function executeWithSource(_ref4) {
        var operation = _ref4.operation, source = _ref4.source;
        return this._execute({
            createSource: function createSource() {
                return source;
            },
            isClientPayload: false,
            operation: operation,
            optimisticConfig: null,
            updater: null
        });
    };
    _proto.toJSON = function toJSON() {
        var _this$configName;
        return "RelayModernEnvironment(".concat((_this$configName = this.configName) !== null && _this$configName !== void 0 ? _this$configName : '', ")");
    };
    _proto._execute = function _execute(_ref5) {
        var _this10 = this;
        var createSource = _ref5.createSource, isClientPayload = _ref5.isClientPayload, operation = _ref5.operation, optimisticConfig = _ref5.optimisticConfig, updater = _ref5.updater;
        var publishQueue = this._publishQueue;
        var store = this._store;
        return $8IVD8.create(function(sink) {
            var executor = $gs7tQ.execute({
                actorIdentifier: $35689008602f23e2$var$INTERNAL_ACTOR_IDENTIFIER_DO_NOT_USE,
                getDataID: _this10._getDataID,
                isClientPayload: isClientPayload,
                log: _this10.__log,
                operation: operation,
                operationExecutions: _this10._operationExecutions,
                operationLoader: _this10._operationLoader,
                operationTracker: _this10._operationTracker,
                optimisticConfig: optimisticConfig,
                getPublishQueue: function getPublishQueue(actorIdentifier) {
                    $35689008602f23e2$var$assertInternalActorIdentifier(actorIdentifier);
                    return publishQueue;
                },
                scheduler: _this10._scheduler,
                shouldProcessClientComponents: _this10._shouldProcessClientComponents,
                sink: sink,
                source: createSource(),
                getStore: function getStore(actorIdentifier) {
                    $35689008602f23e2$var$assertInternalActorIdentifier(actorIdentifier);
                    return store;
                },
                treatMissingFieldsAsNull: _this10._treatMissingFieldsAsNull,
                updater: updater,
                normalizeResponse: _this10._normalizeResponse
            });
            return function() {
                return executor.cancel();
            };
        });
    };
    return RelayModernEnvironment;
}();
function $35689008602f23e2$var$operationHasClientAbstractTypes(operation) {
    return operation.root.node.kind === 'Operation' && operation.root.node.clientAbstractTypes != null;
}
$35689008602f23e2$var$RelayModernEnvironment.prototype['@@RelayModernEnvironment'] = true;
function $35689008602f23e2$var$emptyFunction() {}
module.exports = $35689008602f23e2$var$RelayModernEnvironment;

});
parcelRegister("4XWvG", function(module, exports) {
'use strict';

var $b5P0t = parcelRequire("b5P0t");
function $39da0ef8af7839be$var$wrapNetworkWithLogObserver(env, network) {
    return {
        execute: function execute(params, variables, cacheConfig, uploadables) {
            var networkRequestId = $b5P0t();
            var logObserver = {
                start: function start(subscription) {
                    env.__log({
                        name: 'network.start',
                        networkRequestId: networkRequestId,
                        params: params,
                        variables: variables,
                        cacheConfig: cacheConfig
                    });
                },
                next: function next(response) {
                    env.__log({
                        name: 'network.next',
                        networkRequestId: networkRequestId,
                        response: response
                    });
                },
                error: function error(_error) {
                    env.__log({
                        name: 'network.error',
                        networkRequestId: networkRequestId,
                        error: _error
                    });
                },
                complete: function complete() {
                    env.__log({
                        name: 'network.complete',
                        networkRequestId: networkRequestId
                    });
                },
                unsubscribe: function unsubscribe() {
                    env.__log({
                        name: 'network.unsubscribe',
                        networkRequestId: networkRequestId
                    });
                }
            };
            var logRequestInfo = function logRequestInfo(info) {
                env.__log({
                    name: 'network.info',
                    networkRequestId: networkRequestId,
                    info: info
                });
            };
            return network.execute(params, variables, cacheConfig, uploadables, logRequestInfo)["do"](logObserver);
        }
    };
}
module.exports = $39da0ef8af7839be$var$wrapNetworkWithLogObserver;

});
parcelRegister("b5P0t", function(module, exports) {
'use strict';
var $8137ba2f659018ef$var$id = 100000;
function $8137ba2f659018ef$var$generateID() {
    return $8137ba2f659018ef$var$id++;
}
module.exports = $8137ba2f659018ef$var$generateID;

});


parcelRegister("3s9KA", function(module, exports) {
'use strict';

var $7dvyf = parcelRequire("7dvyf");
var $283b8cd4f6da2673$var$_interopRequireDefault = $7dvyf.default;

var $283b8cd4f6da2673$var$_createForOfIteratorHelper2 = $283b8cd4f6da2673$var$_interopRequireDefault((parcelRequire("bTRzt")));

var $bQThX = parcelRequire("bQThX");
var $283b8cd4f6da2673$var$RelayOperationTracker = /*#__PURE__*/ function() {
    function RelayOperationTracker() {
        this._ownersToPendingOperations = new Map();
        this._pendingOperationsToOwners = new Map();
        this._ownersToPendingPromise = new Map();
    }
    var _proto = RelayOperationTracker.prototype;
    _proto.update = function update(pendingOperation, affectedOwners) {
        if (affectedOwners.size === 0) return;
        var pendingOperationIdentifier = pendingOperation.identifier;
        var newlyAffectedOwnersIdentifier = new Set();
        var _iterator = (0, $283b8cd4f6da2673$var$_createForOfIteratorHelper2["default"])(affectedOwners), _step;
        try {
            for(_iterator.s(); !(_step = _iterator.n()).done;){
                var owner = _step.value;
                var ownerIdentifier = owner.identifier;
                var pendingOperationsAffectingOwner = this._ownersToPendingOperations.get(ownerIdentifier);
                if (pendingOperationsAffectingOwner != null) {
                    if (!pendingOperationsAffectingOwner.has(pendingOperationIdentifier)) {
                        pendingOperationsAffectingOwner.set(pendingOperationIdentifier, pendingOperation);
                        newlyAffectedOwnersIdentifier.add(ownerIdentifier);
                    }
                } else {
                    this._ownersToPendingOperations.set(ownerIdentifier, new Map([
                        [
                            pendingOperationIdentifier,
                            pendingOperation
                        ]
                    ]));
                    newlyAffectedOwnersIdentifier.add(ownerIdentifier);
                }
            }
        } catch (err) {
            _iterator.e(err);
        } finally{
            _iterator.f();
        }
        if (newlyAffectedOwnersIdentifier.size === 0) return;
        var ownersAffectedByPendingOperation = this._pendingOperationsToOwners.get(pendingOperationIdentifier) || new Set();
        var _iterator2 = (0, $283b8cd4f6da2673$var$_createForOfIteratorHelper2["default"])(newlyAffectedOwnersIdentifier), _step2;
        try {
            for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
                var _ownerIdentifier = _step2.value;
                this._resolveOwnerResolvers(_ownerIdentifier);
                ownersAffectedByPendingOperation.add(_ownerIdentifier);
            }
        } catch (err) {
            _iterator2.e(err);
        } finally{
            _iterator2.f();
        }
        this._pendingOperationsToOwners.set(pendingOperationIdentifier, ownersAffectedByPendingOperation);
    };
    _proto.complete = function complete(pendingOperation) {
        var pendingOperationIdentifier = pendingOperation.identifier;
        var affectedOwnersIdentifier = this._pendingOperationsToOwners.get(pendingOperationIdentifier);
        if (affectedOwnersIdentifier == null) return;
        var completedOwnersIdentifier = new Set();
        var updatedOwnersIdentifier = new Set();
        var _iterator3 = (0, $283b8cd4f6da2673$var$_createForOfIteratorHelper2["default"])(affectedOwnersIdentifier), _step3;
        try {
            for(_iterator3.s(); !(_step3 = _iterator3.n()).done;){
                var ownerIdentifier = _step3.value;
                var pendingOperationsAffectingOwner = this._ownersToPendingOperations.get(ownerIdentifier);
                if (!pendingOperationsAffectingOwner) continue;
                pendingOperationsAffectingOwner["delete"](pendingOperationIdentifier);
                if (pendingOperationsAffectingOwner.size > 0) updatedOwnersIdentifier.add(ownerIdentifier);
                else completedOwnersIdentifier.add(ownerIdentifier);
            }
        } catch (err) {
            _iterator3.e(err);
        } finally{
            _iterator3.f();
        }
        var _iterator4 = (0, $283b8cd4f6da2673$var$_createForOfIteratorHelper2["default"])(completedOwnersIdentifier), _step4;
        try {
            for(_iterator4.s(); !(_step4 = _iterator4.n()).done;){
                var _ownerIdentifier2 = _step4.value;
                this._resolveOwnerResolvers(_ownerIdentifier2);
                this._ownersToPendingOperations["delete"](_ownerIdentifier2);
            }
        } catch (err) {
            _iterator4.e(err);
        } finally{
            _iterator4.f();
        }
        var _iterator5 = (0, $283b8cd4f6da2673$var$_createForOfIteratorHelper2["default"])(updatedOwnersIdentifier), _step5;
        try {
            for(_iterator5.s(); !(_step5 = _iterator5.n()).done;){
                var _ownerIdentifier3 = _step5.value;
                this._resolveOwnerResolvers(_ownerIdentifier3);
            }
        } catch (err) {
            _iterator5.e(err);
        } finally{
            _iterator5.f();
        }
        this._pendingOperationsToOwners["delete"](pendingOperationIdentifier);
    };
    _proto._resolveOwnerResolvers = function _resolveOwnerResolvers(ownerIdentifier) {
        var promiseEntry = this._ownersToPendingPromise.get(ownerIdentifier);
        if (promiseEntry != null) promiseEntry.resolve();
        this._ownersToPendingPromise["delete"](ownerIdentifier);
    };
    _proto.getPendingOperationsAffectingOwner = function getPendingOperationsAffectingOwner(owner) {
        var ownerIdentifier = owner.identifier;
        var pendingOperationsForOwner = this._ownersToPendingOperations.get(ownerIdentifier);
        if (pendingOperationsForOwner == null || pendingOperationsForOwner.size === 0) return null;
        var cachedPromiseEntry = this._ownersToPendingPromise.get(ownerIdentifier);
        if (cachedPromiseEntry != null) return {
            promise: cachedPromiseEntry.promise,
            pendingOperations: cachedPromiseEntry.pendingOperations
        };
        var resolve;
        var promise = new Promise(function(r) {
            resolve = r;
        });
        !(resolve != null) && $bQThX(false);
        var pendingOperations = Array.from(pendingOperationsForOwner.values());
        this._ownersToPendingPromise.set(ownerIdentifier, {
            promise: promise,
            resolve: resolve,
            pendingOperations: pendingOperations
        });
        return {
            promise: promise,
            pendingOperations: pendingOperations
        };
    };
    return RelayOperationTracker;
}();
module.exports = $283b8cd4f6da2673$var$RelayOperationTracker;

});

parcelRegister("2Xa6u", function(module, exports) {
'use strict';
function $2268eddcafff5316$var$registerEnvironmentWithDevTools(environment) {
    var _global = typeof $parcel$global !== 'undefined' ? $parcel$global : typeof window !== 'undefined' ? window : undefined;
    var devToolsHook = _global && _global.__RELAY_DEVTOOLS_HOOK__;
    if (devToolsHook) devToolsHook.registerEnvironment(environment);
}
module.exports = $2268eddcafff5316$var$registerEnvironmentWithDevTools;

});

parcelRegister("eGOdg", function(module, exports) {
'use strict';

var $2Ww7b = parcelRequire("2Ww7b");
var $ab1bf02fd3c76b06$var$VIEWER_ID = $2Ww7b.VIEWER_ID, $ab1bf02fd3c76b06$var$VIEWER_TYPE = $2Ww7b.VIEWER_TYPE;
function $ab1bf02fd3c76b06$var$defaultGetDataID(fieldValue, typeName) {
    if (typeName === $ab1bf02fd3c76b06$var$VIEWER_TYPE) return fieldValue.id == null ? $ab1bf02fd3c76b06$var$VIEWER_ID : fieldValue.id;
    return fieldValue.id;
}
module.exports = $ab1bf02fd3c76b06$var$defaultGetDataID;

});
parcelRegister("2Ww7b", function(module, exports) {
'use strict';

var $70q7x = parcelRequire("70q7x");
var $2249e8dea1f86305$var$generateClientID = $70q7x.generateClientID;

var $a6k4O = parcelRequire("a6k4O");
var $2249e8dea1f86305$var$ROOT_ID = $a6k4O.ROOT_ID;
var $2249e8dea1f86305$var$VIEWER_ID = $2249e8dea1f86305$var$generateClientID($2249e8dea1f86305$var$ROOT_ID, 'viewer');
var $2249e8dea1f86305$var$VIEWER_TYPE = 'Viewer';
module.exports = {
    VIEWER_ID: $2249e8dea1f86305$var$VIEWER_ID,
    VIEWER_TYPE: $2249e8dea1f86305$var$VIEWER_TYPE
};

});


parcelRegister("hmiuT", function(module, exports) {
'use strict';
var $ca32d6eeae407de4$var$defaultRelayFieldLogger = function defaultRelayFieldLogger(event) {};
module.exports = $ca32d6eeae407de4$var$defaultRelayFieldLogger;

});

parcelRegister("gs7tQ", function(module, exports) {
'use strict';

var $7dvyf = parcelRequire("7dvyf");
var $bfa5104fdeff9795$var$_interopRequireDefault = $7dvyf.default;

var $bfa5104fdeff9795$var$_createForOfIteratorHelper2 = $bfa5104fdeff9795$var$_interopRequireDefault((parcelRequire("bTRzt")));

var $bfa5104fdeff9795$var$_toConsumableArray2 = $bfa5104fdeff9795$var$_interopRequireDefault((parcelRequire("gvI75")));

var $8IVD8 = parcelRequire("8IVD8");

var $b5P0t = parcelRequire("b5P0t");

var $1hwTW = parcelRequire("1hwTW");

var $3JkID = parcelRequire("3JkID");

var $9DZlA = parcelRequire("9DZlA");

var $ahEdt = parcelRequire("ahEdt");

var $55nZq = parcelRequire("55nZq");

var $70q7x = parcelRequire("70q7x");
var $bfa5104fdeff9795$var$generateClientID = $70q7x.generateClientID, $bfa5104fdeff9795$var$generateUniqueClientID = $70q7x.generateUniqueClientID;

var $kpcDM = parcelRequire("kpcDM");
var $bfa5104fdeff9795$var$getLocalVariables = $kpcDM.getLocalVariables;

var $c4ZG3 = parcelRequire("c4ZG3");

var $3o9ph = parcelRequire("3o9ph");
var $bfa5104fdeff9795$var$createNormalizationSelector = $3o9ph.createNormalizationSelector, $bfa5104fdeff9795$var$createReaderSelector = $3o9ph.createReaderSelector;

var $fWVgk = parcelRequire("fWVgk");

var $a6k4O = parcelRequire("a6k4O");
var $bfa5104fdeff9795$var$ROOT_TYPE = $a6k4O.ROOT_TYPE, $bfa5104fdeff9795$var$TYPENAME_KEY = $a6k4O.TYPENAME_KEY, $bfa5104fdeff9795$var$getStorageKey = $a6k4O.getStorageKey;

var $bQThX = parcelRequire("bQThX");
parcelRequire("hzw7m");
function $bfa5104fdeff9795$var$execute(config) {
    return new $bfa5104fdeff9795$var$Executor(config);
}
var $bfa5104fdeff9795$var$Executor = /*#__PURE__*/ function() {
    function Executor(_ref2) {
        var _this = this;
        var actorIdentifier = _ref2.actorIdentifier, getDataID = _ref2.getDataID, getPublishQueue = _ref2.getPublishQueue, getStore = _ref2.getStore, isClientPayload = _ref2.isClientPayload, operation = _ref2.operation, operationExecutions = _ref2.operationExecutions, operationLoader = _ref2.operationLoader, operationTracker = _ref2.operationTracker, optimisticConfig = _ref2.optimisticConfig, scheduler = _ref2.scheduler, shouldProcessClientComponents = _ref2.shouldProcessClientComponents, sink = _ref2.sink, source = _ref2.source, treatMissingFieldsAsNull = _ref2.treatMissingFieldsAsNull, updater = _ref2.updater, log = _ref2.log, normalizeResponse = _ref2.normalizeResponse;
        this._actorIdentifier = actorIdentifier;
        this._getDataID = getDataID;
        this._treatMissingFieldsAsNull = treatMissingFieldsAsNull;
        this._incrementalPayloadsPending = false;
        this._incrementalResults = new Map();
        this._log = log;
        this._executeId = $b5P0t();
        this._nextSubscriptionId = 0;
        this._operation = operation;
        this._operationExecutions = operationExecutions;
        this._operationLoader = operationLoader;
        this._operationTracker = operationTracker;
        this._operationUpdateEpochs = new Map();
        this._optimisticUpdates = null;
        this._pendingModulePayloadsCount = 0;
        this._getPublishQueue = getPublishQueue;
        this._scheduler = scheduler;
        this._sink = sink;
        this._source = new Map();
        this._state = 'started';
        this._getStore = getStore;
        this._subscriptions = new Map();
        this._updater = updater;
        this._isClientPayload = isClientPayload === true;
        this._isSubscriptionOperation = this._operation.request.node.params.operationKind === 'subscription';
        this._shouldProcessClientComponents = shouldProcessClientComponents;
        this._retainDisposables = new Map();
        this._seenActors = new Set();
        this._completeFns = [];
        this._normalizeResponse = normalizeResponse;
        var id = this._nextSubscriptionId++;
        if ($9DZlA.PROCESS_OPTIMISTIC_UPDATE_BEFORE_SUBSCRIPTION && optimisticConfig != null) this._processOptimisticResponse(optimisticConfig.response != null ? {
            data: optimisticConfig.response
        } : null, optimisticConfig.updater, false);
        source.subscribe({
            complete: function complete() {
                return _this._complete(id);
            },
            error: function error(_error2) {
                return _this._error(_error2);
            },
            next: function next(response) {
                try {
                    _this._next(id, response);
                } catch (error) {
                    sink.error(error);
                }
            },
            start: function start(subscription) {
                var _this$_operation$requ;
                _this._start(id, subscription);
                _this._log({
                    name: 'execute.start',
                    executeId: _this._executeId,
                    params: _this._operation.request.node.params,
                    variables: _this._operation.request.variables,
                    cacheConfig: (_this$_operation$requ = _this._operation.request.cacheConfig) !== null && _this$_operation$requ !== void 0 ? _this$_operation$requ : {}
                });
            }
        });
        if (!$9DZlA.PROCESS_OPTIMISTIC_UPDATE_BEFORE_SUBSCRIPTION && optimisticConfig != null) this._processOptimisticResponse(optimisticConfig.response != null ? {
            data: optimisticConfig.response
        } : null, optimisticConfig.updater, false);
    }
    var _proto = Executor.prototype;
    _proto.cancel = function cancel() {
        var _this2 = this;
        if (this._state === 'completed') return;
        this._state = 'completed';
        this._operationExecutions["delete"](this._operation.request.identifier);
        if (this._subscriptions.size !== 0) {
            this._subscriptions.forEach(function(sub) {
                return sub.unsubscribe();
            });
            this._subscriptions.clear();
        }
        var optimisticUpdates = this._optimisticUpdates;
        if (optimisticUpdates !== null) {
            this._optimisticUpdates = null;
            optimisticUpdates.forEach(function(update) {
                return _this2._getPublishQueueAndSaveActor().revertUpdate(update);
            });
            this._runPublishQueue();
        }
        this._incrementalResults.clear();
        if (this._asyncStoreUpdateDisposable != null) {
            this._asyncStoreUpdateDisposable.dispose();
            this._asyncStoreUpdateDisposable = null;
        }
        this._completeFns = [];
        this._completeOperationTracker();
        this._disposeRetainedData();
    };
    _proto._updateActiveState = function _updateActiveState() {
        var activeState;
        switch(this._state){
            case 'started':
                activeState = 'active';
                break;
            case 'loading_incremental':
                activeState = 'active';
                break;
            case 'completed':
                activeState = 'inactive';
                break;
            case 'loading_final':
                activeState = this._pendingModulePayloadsCount > 0 ? 'active' : 'inactive';
                break;
            default:
                this._state;
                $bQThX(false);
        }
        this._operationExecutions.set(this._operation.request.identifier, activeState);
    };
    _proto._schedule = function _schedule(task) {
        var _this3 = this;
        var scheduler = this._scheduler;
        if (scheduler != null) {
            var id = this._nextSubscriptionId++;
            $8IVD8.create(function(sink) {
                var cancellationToken = scheduler.schedule(function() {
                    try {
                        task();
                        sink.complete();
                    } catch (error) {
                        sink.error(error);
                    }
                });
                return function() {
                    return scheduler.cancel(cancellationToken);
                };
            }).subscribe({
                complete: function complete() {
                    return _this3._complete(id);
                },
                error: function error(_error3) {
                    return _this3._error(_error3);
                },
                start: function start(subscription) {
                    return _this3._start(id, subscription);
                }
            });
        } else task();
    };
    _proto._complete = function _complete(id) {
        this._subscriptions["delete"](id);
        if (this._subscriptions.size === 0) {
            this.cancel();
            this._sink.complete();
            this._log({
                name: 'execute.complete',
                executeId: this._executeId
            });
        }
    };
    _proto._error = function _error(error) {
        this.cancel();
        this._sink.error(error);
        this._log({
            name: 'execute.error',
            executeId: this._executeId,
            error: error
        });
    };
    _proto._start = function _start(id, subscription) {
        this._subscriptions.set(id, subscription);
        this._updateActiveState();
    };
    _proto._next = function _next(_id, response) {
        var _this4 = this;
        this._schedule(function() {
            var _withDuration = $55nZq(function() {
                _this4._handleNext(response);
                _this4._maybeCompleteSubscriptionOperationTracking();
            }), duration = _withDuration[0];
            _this4._log({
                name: 'execute.next',
                executeId: _this4._executeId,
                response: response,
                duration: duration
            });
        });
    };
    _proto._handleErrorResponse = function _handleErrorResponse(responses) {
        var _this5 = this;
        var results = [];
        responses.forEach(function(response) {
            if (response.data === null && response.extensions != null && !response.hasOwnProperty('errors')) return;
            else if (response.data == null) {
                var errors = response.hasOwnProperty('errors') && response.errors != null ? response.errors : null;
                var messages = errors ? errors.map(function(_ref3) {
                    var message = _ref3.message;
                    return message;
                }).join('\n') : '(No errors)';
                var error = $3JkID.create('RelayNetwork', 'No data returned for operation `' + _this5._operation.request.node.params.name + '`, got error(s):\n' + messages + '\n\nSee the error `source` property for more information.');
                error.source = {
                    errors: errors,
                    operation: _this5._operation.request.node,
                    variables: _this5._operation.request.variables
                };
                error.stack;
                throw error;
            } else {
                var responseWithData = response;
                results.push(responseWithData);
            }
        });
        return results;
    };
    _proto._handleOptimisticResponses = function _handleOptimisticResponses(responses) {
        var _response$extensions;
        if (responses.length > 1) {
            if (responses.some(function(responsePart) {
                var _responsePart$extensi;
                return ((_responsePart$extensi = responsePart.extensions) === null || _responsePart$extensi === void 0 ? void 0 : _responsePart$extensi.isOptimistic) === true;
            })) $bQThX(false);
            return false;
        }
        var response = responses[0];
        var isOptimistic = ((_response$extensions = response.extensions) === null || _response$extensions === void 0 ? void 0 : _response$extensions.isOptimistic) === true;
        if (isOptimistic && this._state !== 'started') $bQThX(false);
        if (isOptimistic) {
            this._processOptimisticResponse(response, null, this._treatMissingFieldsAsNull);
            this._sink.next(response);
            return true;
        }
        return false;
    };
    _proto._handleNext = function _handleNext(response) {
        if (this._state === 'completed') return;
        this._seenActors.clear();
        var responses = Array.isArray(response) ? response : [
            response
        ];
        var responsesWithData = this._handleErrorResponse(responses);
        if (responsesWithData.length === 0) {
            var isFinal = responses.some(function(x) {
                var _x$extensions;
                return ((_x$extensions = x.extensions) === null || _x$extensions === void 0 ? void 0 : _x$extensions.is_final) === true;
            });
            if (isFinal) {
                this._state = 'loading_final';
                this._updateActiveState();
                this._incrementalPayloadsPending = false;
            }
            this._sink.next(response);
            return;
        }
        var isOptimistic = this._handleOptimisticResponses(responsesWithData);
        if (isOptimistic) return;
        var _partitionGraphQLResp = $bfa5104fdeff9795$var$partitionGraphQLResponses(responsesWithData), nonIncrementalResponses = _partitionGraphQLResp[0], incrementalResponses = _partitionGraphQLResp[1];
        var hasNonIncrementalResponses = nonIncrementalResponses.length > 0;
        if (hasNonIncrementalResponses) {
            if (this._isSubscriptionOperation) {
                var nextID = $bfa5104fdeff9795$var$generateUniqueClientID();
                this._operation = {
                    request: this._operation.request,
                    fragment: $bfa5104fdeff9795$var$createReaderSelector(this._operation.fragment.node, nextID, this._operation.fragment.variables, this._operation.fragment.owner),
                    root: $bfa5104fdeff9795$var$createNormalizationSelector(this._operation.root.node, nextID, this._operation.root.variables)
                };
            }
            var payloadFollowups = this._processResponses(nonIncrementalResponses);
            this._processPayloadFollowups(payloadFollowups);
        }
        if (incrementalResponses.length > 0) {
            var _payloadFollowups = this._processIncrementalResponses(incrementalResponses);
            this._processPayloadFollowups(_payloadFollowups);
        }
        if (this._isSubscriptionOperation) {
            if (responsesWithData[0].extensions == null) responsesWithData[0].extensions = {
                __relay_subscription_root_id: this._operation.fragment.dataID
            };
            else responsesWithData[0].extensions.__relay_subscription_root_id = this._operation.fragment.dataID;
        }
        var updatedOwners = this._runPublishQueue(hasNonIncrementalResponses ? this._operation : undefined);
        if (hasNonIncrementalResponses) {
            if (this._incrementalPayloadsPending) this._retainData();
        }
        this._updateOperationTracker(updatedOwners);
        this._sink.next(response);
    };
    _proto._processOptimisticResponse = function _processOptimisticResponse(response, updater, treatMissingFieldsAsNull) {
        var _this6 = this;
        !(this._optimisticUpdates === null) && $bQThX(false);
        if (response == null && updater == null) return;
        var optimisticUpdates = [];
        if (response) {
            var payload = this._normalizeResponse(response, this._operation.root, $bfa5104fdeff9795$var$ROOT_TYPE, {
                actorIdentifier: this._actorIdentifier,
                getDataID: this._getDataID,
                path: [],
                shouldProcessClientComponents: this._shouldProcessClientComponents,
                treatMissingFieldsAsNull: treatMissingFieldsAsNull
            });
            $bfa5104fdeff9795$var$validateOptimisticResponsePayload(payload);
            optimisticUpdates.push({
                operation: this._operation,
                payload: payload,
                updater: updater
            });
            this._processOptimisticFollowups(payload, optimisticUpdates);
        } else if (updater) optimisticUpdates.push({
            operation: this._operation,
            payload: {
                errors: null,
                fieldPayloads: null,
                incrementalPlaceholders: null,
                followupPayloads: null,
                source: $fWVgk.create(),
                isFinal: false
            },
            updater: updater
        });
        this._optimisticUpdates = optimisticUpdates;
        optimisticUpdates.forEach(function(update) {
            return _this6._getPublishQueueAndSaveActor().applyUpdate(update);
        });
        var updatedOwners = this._runPublishQueue();
        if ($9DZlA.ENABLE_OPERATION_TRACKER_OPTIMISTIC_UPDATES) this._updateOperationTracker(updatedOwners);
    };
    _proto._processOptimisticFollowups = function _processOptimisticFollowups(payload, optimisticUpdates) {
        if (payload.followupPayloads && payload.followupPayloads.length) {
            var followupPayloads = payload.followupPayloads;
            var _iterator = (0, $bfa5104fdeff9795$var$_createForOfIteratorHelper2["default"])(followupPayloads), _step;
            try {
                for(_iterator.s(); !(_step = _iterator.n()).done;){
                    var followupPayload = _step.value;
                    switch(followupPayload.kind){
                        case 'ModuleImportPayload':
                            var operationLoader = this._expectOperationLoader();
                            var operation = operationLoader.get(followupPayload.operationReference);
                            if (operation == null) this._processAsyncOptimisticModuleImport(followupPayload);
                            else {
                                var moduleImportOptimisticUpdates = this._processOptimisticModuleImport(operation, followupPayload);
                                optimisticUpdates.push.apply(optimisticUpdates, (0, $bfa5104fdeff9795$var$_toConsumableArray2["default"])(moduleImportOptimisticUpdates));
                            }
                            break;
                        case 'ActorPayload':
                            break;
                        default:
                            followupPayload;
                            $bQThX(false);
                    }
                }
            } catch (err) {
                _iterator.e(err);
            } finally{
                _iterator.f();
            }
        }
    };
    _proto._normalizeFollowupPayload = function _normalizeFollowupPayload(followupPayload, normalizationNode) {
        var variables;
        if (normalizationNode.kind === 'SplitOperation' && followupPayload.kind === 'ModuleImportPayload') variables = $bfa5104fdeff9795$var$getLocalVariables(followupPayload.variables, normalizationNode.argumentDefinitions, followupPayload.args);
        else variables = followupPayload.variables;
        var selector = $bfa5104fdeff9795$var$createNormalizationSelector(normalizationNode, followupPayload.dataID, variables);
        return this._normalizeResponse({
            data: followupPayload.data
        }, selector, followupPayload.typeName, {
            actorIdentifier: this._actorIdentifier,
            getDataID: this._getDataID,
            path: followupPayload.path,
            treatMissingFieldsAsNull: this._treatMissingFieldsAsNull,
            shouldProcessClientComponents: this._shouldProcessClientComponents
        });
    };
    _proto._processOptimisticModuleImport = function _processOptimisticModuleImport(normalizationRootNode, moduleImportPayload) {
        var operation = $1hwTW(normalizationRootNode);
        var optimisticUpdates = [];
        var modulePayload = this._normalizeFollowupPayload(moduleImportPayload, operation);
        $bfa5104fdeff9795$var$validateOptimisticResponsePayload(modulePayload);
        optimisticUpdates.push({
            operation: this._operation,
            payload: modulePayload,
            updater: null
        });
        this._processOptimisticFollowups(modulePayload, optimisticUpdates);
        return optimisticUpdates;
    };
    _proto._processAsyncOptimisticModuleImport = function _processAsyncOptimisticModuleImport(moduleImportPayload) {
        var _this7 = this;
        this._expectOperationLoader().load(moduleImportPayload.operationReference).then(function(operation) {
            if (operation == null || _this7._state !== 'started') return;
            var moduleImportOptimisticUpdates = _this7._processOptimisticModuleImport(operation, moduleImportPayload);
            moduleImportOptimisticUpdates.forEach(function(update) {
                return _this7._getPublishQueueAndSaveActor().applyUpdate(update);
            });
            if (_this7._optimisticUpdates == null) ;
            else {
                var _this$_optimisticUpda;
                (_this$_optimisticUpda = _this7._optimisticUpdates).push.apply(_this$_optimisticUpda, (0, $bfa5104fdeff9795$var$_toConsumableArray2["default"])(moduleImportOptimisticUpdates));
                _this7._runPublishQueue();
            }
        });
    };
    _proto._processResponses = function _processResponses(responses) {
        var _this8 = this;
        if (this._optimisticUpdates !== null) {
            this._optimisticUpdates.forEach(function(update) {
                _this8._getPublishQueueAndSaveActor().revertUpdate(update);
            });
            this._optimisticUpdates = null;
        }
        this._incrementalPayloadsPending = false;
        this._incrementalResults.clear();
        this._source.clear();
        return responses.map(function(payloadPart) {
            var relayPayload = _this8._normalizeResponse(payloadPart, _this8._operation.root, $bfa5104fdeff9795$var$ROOT_TYPE, {
                actorIdentifier: _this8._actorIdentifier,
                getDataID: _this8._getDataID,
                path: [],
                treatMissingFieldsAsNull: _this8._treatMissingFieldsAsNull,
                shouldProcessClientComponents: _this8._shouldProcessClientComponents
            });
            _this8._getPublishQueueAndSaveActor().commitPayload(_this8._operation, relayPayload, _this8._updater);
            return relayPayload;
        });
    };
    _proto._processPayloadFollowups = function _processPayloadFollowups(payloads) {
        var _this9 = this;
        if (this._state === 'completed') return;
        payloads.forEach(function(payload) {
            var incrementalPlaceholders = payload.incrementalPlaceholders, followupPayloads = payload.followupPayloads, isFinal = payload.isFinal;
            _this9._state = isFinal ? 'loading_final' : 'loading_incremental';
            _this9._updateActiveState();
            if (isFinal) _this9._incrementalPayloadsPending = false;
            if (followupPayloads && followupPayloads.length !== 0) followupPayloads.forEach(function(followupPayload) {
                var _followupPayload$acto;
                var prevActorIdentifier = _this9._actorIdentifier;
                _this9._actorIdentifier = (_followupPayload$acto = followupPayload.actorIdentifier) !== null && _followupPayload$acto !== void 0 ? _followupPayload$acto : _this9._actorIdentifier;
                _this9._processFollowupPayload(followupPayload);
                _this9._actorIdentifier = prevActorIdentifier;
            });
            if (incrementalPlaceholders && incrementalPlaceholders.length !== 0) {
                _this9._incrementalPayloadsPending = _this9._state !== 'loading_final';
                incrementalPlaceholders.forEach(function(incrementalPlaceholder) {
                    var _incrementalPlacehold;
                    var prevActorIdentifier = _this9._actorIdentifier;
                    _this9._actorIdentifier = (_incrementalPlacehold = incrementalPlaceholder.actorIdentifier) !== null && _incrementalPlacehold !== void 0 ? _incrementalPlacehold : _this9._actorIdentifier;
                    _this9._processIncrementalPlaceholder(payload, incrementalPlaceholder);
                    _this9._actorIdentifier = prevActorIdentifier;
                });
                if (_this9._isClientPayload || _this9._state === 'loading_final') {
                    var relayPayloads = [];
                    incrementalPlaceholders.forEach(function(placeholder) {
                        if (placeholder.kind === 'defer') relayPayloads.push(_this9._processDeferResponse(placeholder.label, placeholder.path, placeholder, {
                            data: placeholder.data
                        }));
                    });
                    if (relayPayloads.length > 0) _this9._processPayloadFollowups(relayPayloads);
                }
            }
        });
    };
    _proto._maybeCompleteSubscriptionOperationTracking = function _maybeCompleteSubscriptionOperationTracking() {
        if (!this._isSubscriptionOperation) return;
        if (this._pendingModulePayloadsCount === 0 && this._incrementalPayloadsPending === false) this._completeOperationTracker();
    };
    _proto._processFollowupPayload = function _processFollowupPayload(followupPayload) {
        var _this10 = this;
        switch(followupPayload.kind){
            case 'ModuleImportPayload':
                var operationLoader = this._expectOperationLoader();
                var node = operationLoader.get(followupPayload.operationReference);
                if (node != null) this._processFollowupPayloadWithNormalizationNode(followupPayload, $1hwTW(node));
                else {
                    var id = this._nextSubscriptionId++;
                    this._pendingModulePayloadsCount++;
                    var decrementPendingCount = function decrementPendingCount() {
                        _this10._pendingModulePayloadsCount--;
                        _this10._maybeCompleteSubscriptionOperationTracking();
                    };
                    var networkObservable = $8IVD8.from(new Promise(function(resolve, reject) {
                        operationLoader.load(followupPayload.operationReference).then(resolve, reject);
                    }));
                    $8IVD8.create(function(sink) {
                        var cancellationToken;
                        var subscription = networkObservable.subscribe({
                            next: function next(loadedNode) {
                                if (loadedNode != null) {
                                    var publishModuleImportPayload = function publishModuleImportPayload() {
                                        try {
                                            var operation = $1hwTW(loadedNode);
                                            var batchAsyncModuleUpdatesFN = $9DZlA.BATCH_ASYNC_MODULE_UPDATES_FN;
                                            var shouldScheduleAsyncStoreUpdate = batchAsyncModuleUpdatesFN != null && _this10._pendingModulePayloadsCount > 1;
                                            var _withDuration2 = $55nZq(function() {
                                                _this10._handleFollowupPayload(followupPayload, operation);
                                                if (shouldScheduleAsyncStoreUpdate) _this10._scheduleAsyncStoreUpdate(batchAsyncModuleUpdatesFN, sink.complete);
                                                else {
                                                    var updatedOwners = _this10._runPublishQueue();
                                                    _this10._updateOperationTracker(updatedOwners);
                                                }
                                            }), duration = _withDuration2[0];
                                            _this10._log({
                                                name: 'execute.async.module',
                                                executeId: _this10._executeId,
                                                operationName: operation.name,
                                                duration: duration
                                            });
                                            if (!shouldScheduleAsyncStoreUpdate) sink.complete();
                                        } catch (error) {
                                            sink.error(error);
                                        }
                                    };
                                    var scheduler = _this10._scheduler;
                                    if (scheduler == null) publishModuleImportPayload();
                                    else cancellationToken = scheduler.schedule(publishModuleImportPayload);
                                } else sink.complete();
                            },
                            error: sink.error
                        });
                        return function() {
                            subscription.unsubscribe();
                            if (_this10._scheduler != null && cancellationToken != null) _this10._scheduler.cancel(cancellationToken);
                        };
                    }).subscribe({
                        complete: function complete() {
                            _this10._complete(id);
                            decrementPendingCount();
                        },
                        error: function error(_error4) {
                            _this10._error(_error4);
                            decrementPendingCount();
                        },
                        start: function start(subscription) {
                            return _this10._start(id, subscription);
                        }
                    });
                }
                break;
            case 'ActorPayload':
                this._processFollowupPayloadWithNormalizationNode(followupPayload, followupPayload.node);
                break;
            default:
                followupPayload;
                $bQThX(false);
        }
    };
    _proto._processFollowupPayloadWithNormalizationNode = function _processFollowupPayloadWithNormalizationNode(followupPayload, normalizationNode) {
        this._handleFollowupPayload(followupPayload, normalizationNode);
        this._maybeCompleteSubscriptionOperationTracking();
    };
    _proto._handleFollowupPayload = function _handleFollowupPayload(followupPayload, normalizationNode) {
        var relayPayload = this._normalizeFollowupPayload(followupPayload, normalizationNode);
        this._getPublishQueueAndSaveActor().commitPayload(this._operation, relayPayload);
        this._processPayloadFollowups([
            relayPayload
        ]);
    };
    _proto._processIncrementalPlaceholder = function _processIncrementalPlaceholder(relayPayload, placeholder) {
        var _relayPayload$fieldPa;
        var label = placeholder.label, path = placeholder.path;
        var pathKey = path.map(String).join('.');
        var resultForLabel = this._incrementalResults.get(label);
        if (resultForLabel == null) {
            resultForLabel = new Map();
            this._incrementalResults.set(label, resultForLabel);
        }
        var resultForPath = resultForLabel.get(pathKey);
        var pendingResponses = resultForPath != null && resultForPath.kind === 'response' ? resultForPath.responses : null;
        resultForLabel.set(pathKey, {
            kind: 'placeholder',
            placeholder: placeholder
        });
        var parentID;
        if (placeholder.kind === 'stream') parentID = placeholder.parentID;
        else if (placeholder.kind === 'defer') parentID = placeholder.selector.dataID;
        else {
            placeholder;
            $bQThX(false);
        }
        var parentRecord = relayPayload.source.get(parentID);
        var parentPayloads = ((_relayPayload$fieldPa = relayPayload.fieldPayloads) !== null && _relayPayload$fieldPa !== void 0 ? _relayPayload$fieldPa : []).filter(function(fieldPayload) {
            var fieldID = $bfa5104fdeff9795$var$generateClientID(fieldPayload.dataID, fieldPayload.fieldKey);
            return fieldPayload.dataID === parentID || fieldID === parentID;
        });
        !(parentRecord != null) && $bQThX(false);
        var nextParentRecord;
        var nextParentPayloads;
        var previousParentEntry = this._source.get(parentID);
        if (previousParentEntry != null) {
            nextParentRecord = $c4ZG3.update(previousParentEntry.record, parentRecord);
            var handlePayloads = new Map();
            var dedupePayload = function dedupePayload(payload) {
                var key = $bfa5104fdeff9795$var$stableStringify(payload);
                handlePayloads.set(key, payload);
            };
            previousParentEntry.fieldPayloads.forEach(dedupePayload);
            parentPayloads.forEach(dedupePayload);
            nextParentPayloads = Array.from(handlePayloads.values());
        } else {
            nextParentRecord = parentRecord;
            nextParentPayloads = parentPayloads;
        }
        this._source.set(parentID, {
            record: nextParentRecord,
            fieldPayloads: nextParentPayloads
        });
        if (pendingResponses != null) {
            var payloadFollowups = this._processIncrementalResponses(pendingResponses);
            this._processPayloadFollowups(payloadFollowups);
        }
    };
    _proto._processIncrementalResponses = function _processIncrementalResponses(incrementalResponses) {
        var _this11 = this;
        var relayPayloads = [];
        incrementalResponses.forEach(function(incrementalResponse) {
            var label = incrementalResponse.label, path = incrementalResponse.path, response = incrementalResponse.response;
            var resultForLabel = _this11._incrementalResults.get(label);
            if (resultForLabel == null) {
                resultForLabel = new Map();
                _this11._incrementalResults.set(label, resultForLabel);
            }
            if (label.indexOf('$defer$') !== -1) {
                var pathKey = path.map(String).join('.');
                var resultForPath = resultForLabel.get(pathKey);
                if (resultForPath == null) {
                    resultForPath = {
                        kind: 'response',
                        responses: [
                            incrementalResponse
                        ]
                    };
                    resultForLabel.set(pathKey, resultForPath);
                    return;
                } else if (resultForPath.kind === 'response') {
                    resultForPath.responses.push(incrementalResponse);
                    return;
                }
                var placeholder = resultForPath.placeholder;
                !(placeholder.kind === 'defer') && $bQThX(false);
                relayPayloads.push(_this11._processDeferResponse(label, path, placeholder, response));
            } else {
                var _pathKey = path.slice(0, -2).map(String).join('.');
                var _resultForPath = resultForLabel.get(_pathKey);
                if (_resultForPath == null) {
                    _resultForPath = {
                        kind: 'response',
                        responses: [
                            incrementalResponse
                        ]
                    };
                    resultForLabel.set(_pathKey, _resultForPath);
                    return;
                } else if (_resultForPath.kind === 'response') {
                    _resultForPath.responses.push(incrementalResponse);
                    return;
                }
                var _placeholder = _resultForPath.placeholder;
                !(_placeholder.kind === 'stream') && $bQThX(false);
                relayPayloads.push(_this11._processStreamResponse(label, path, _placeholder, response));
            }
        });
        return relayPayloads;
    };
    _proto._processDeferResponse = function _processDeferResponse(label, path, placeholder, response) {
        var _placeholder$actorIde;
        var parentID = placeholder.selector.dataID;
        var prevActorIdentifier = this._actorIdentifier;
        this._actorIdentifier = (_placeholder$actorIde = placeholder.actorIdentifier) !== null && _placeholder$actorIde !== void 0 ? _placeholder$actorIde : this._actorIdentifier;
        var relayPayload = this._normalizeResponse(response, placeholder.selector, placeholder.typeName, {
            actorIdentifier: this._actorIdentifier,
            getDataID: this._getDataID,
            path: placeholder.path,
            treatMissingFieldsAsNull: this._treatMissingFieldsAsNull,
            shouldProcessClientComponents: this._shouldProcessClientComponents
        });
        this._getPublishQueueAndSaveActor().commitPayload(this._operation, relayPayload);
        var parentEntry = this._source.get(parentID);
        !(parentEntry != null) && $bQThX(false);
        var fieldPayloads = parentEntry.fieldPayloads;
        if (fieldPayloads.length !== 0) {
            var _response$extensions2;
            var handleFieldsRelayPayload = {
                errors: null,
                fieldPayloads: fieldPayloads,
                incrementalPlaceholders: null,
                followupPayloads: null,
                source: $fWVgk.create(),
                isFinal: ((_response$extensions2 = response.extensions) === null || _response$extensions2 === void 0 ? void 0 : _response$extensions2.is_final) === true
            };
            this._getPublishQueueAndSaveActor().commitPayload(this._operation, handleFieldsRelayPayload);
        }
        this._actorIdentifier = prevActorIdentifier;
        return relayPayload;
    };
    _proto._processStreamResponse = function _processStreamResponse(label, path, placeholder, response) {
        var parentID = placeholder.parentID, node = placeholder.node, variables = placeholder.variables, actorIdentifier = placeholder.actorIdentifier;
        var prevActorIdentifier = this._actorIdentifier;
        this._actorIdentifier = actorIdentifier !== null && actorIdentifier !== void 0 ? actorIdentifier : this._actorIdentifier;
        var field = node.selections[0];
        !(field != null && field.kind === 'LinkedField' && field.plural === true) && $bQThX(false);
        var _this$_normalizeStrea = this._normalizeStreamItem(response, parentID, field, variables, path, placeholder.path), fieldPayloads = _this$_normalizeStrea.fieldPayloads, itemID = _this$_normalizeStrea.itemID, itemIndex = _this$_normalizeStrea.itemIndex, prevIDs = _this$_normalizeStrea.prevIDs, relayPayload = _this$_normalizeStrea.relayPayload, storageKey = _this$_normalizeStrea.storageKey;
        this._getPublishQueueAndSaveActor().commitPayload(this._operation, relayPayload, function(store) {
            var currentParentRecord = store.get(parentID);
            if (currentParentRecord == null) return;
            var currentItems = currentParentRecord.getLinkedRecords(storageKey);
            if (currentItems == null) return;
            if (currentItems.length !== prevIDs.length || currentItems.some(function(currentItem, index) {
                return prevIDs[index] !== (currentItem && currentItem.getDataID());
            })) return;
            var nextItems = (0, $bfa5104fdeff9795$var$_toConsumableArray2["default"])(currentItems);
            nextItems[itemIndex] = store.get(itemID);
            currentParentRecord.setLinkedRecords(nextItems, storageKey);
        });
        if (fieldPayloads.length !== 0) {
            var handleFieldsRelayPayload = {
                errors: null,
                fieldPayloads: fieldPayloads,
                incrementalPlaceholders: null,
                followupPayloads: null,
                source: $fWVgk.create(),
                isFinal: false
            };
            this._getPublishQueueAndSaveActor().commitPayload(this._operation, handleFieldsRelayPayload);
        }
        this._actorIdentifier = prevActorIdentifier;
        return relayPayload;
    };
    _proto._normalizeStreamItem = function _normalizeStreamItem(response, parentID, field, variables, path, normalizationPath) {
        var _field$alias, _field$concreteType, _ref, _this$_getDataID;
        var data = response.data;
        !(typeof data === 'object') && $bQThX(false);
        var responseKey = (_field$alias = field.alias) !== null && _field$alias !== void 0 ? _field$alias : field.name;
        var storageKey = $bfa5104fdeff9795$var$getStorageKey(field, variables);
        var parentEntry = this._source.get(parentID);
        !(parentEntry != null) && $bQThX(false);
        var parentRecord = parentEntry.record, fieldPayloads = parentEntry.fieldPayloads;
        var prevIDs = $c4ZG3.getLinkedRecordIDs(parentRecord, storageKey);
        !(prevIDs != null) && $bQThX(false);
        var finalPathEntry = path[path.length - 1];
        var itemIndex = parseInt(finalPathEntry, 10);
        !(itemIndex === finalPathEntry && itemIndex >= 0) && $bQThX(false);
        var typeName = (_field$concreteType = field.concreteType) !== null && _field$concreteType !== void 0 ? _field$concreteType : data[$bfa5104fdeff9795$var$TYPENAME_KEY];
        !(typeof typeName === 'string') && $bQThX(false);
        var itemID = (_ref = (_this$_getDataID = this._getDataID(data, typeName)) !== null && _this$_getDataID !== void 0 ? _this$_getDataID : prevIDs === null || prevIDs === void 0 ? void 0 : prevIDs[itemIndex]) !== null && _ref !== void 0 ? _ref : $bfa5104fdeff9795$var$generateClientID(parentID, storageKey, itemIndex);
        !(typeof itemID === 'string') && $bQThX(false);
        var selector = $bfa5104fdeff9795$var$createNormalizationSelector(field, itemID, variables);
        var nextParentRecord = $c4ZG3.clone(parentRecord);
        var nextIDs = (0, $bfa5104fdeff9795$var$_toConsumableArray2["default"])(prevIDs);
        nextIDs[itemIndex] = itemID;
        $c4ZG3.setLinkedRecordIDs(nextParentRecord, storageKey, nextIDs);
        this._source.set(parentID, {
            record: nextParentRecord,
            fieldPayloads: fieldPayloads
        });
        var relayPayload = this._normalizeResponse(response, selector, typeName, {
            actorIdentifier: this._actorIdentifier,
            getDataID: this._getDataID,
            path: [].concat((0, $bfa5104fdeff9795$var$_toConsumableArray2["default"])(normalizationPath), [
                responseKey,
                String(itemIndex)
            ]),
            treatMissingFieldsAsNull: this._treatMissingFieldsAsNull,
            shouldProcessClientComponents: this._shouldProcessClientComponents
        });
        return {
            fieldPayloads: fieldPayloads,
            itemID: itemID,
            itemIndex: itemIndex,
            prevIDs: prevIDs,
            relayPayload: relayPayload,
            storageKey: storageKey
        };
    };
    _proto._scheduleAsyncStoreUpdate = function _scheduleAsyncStoreUpdate(scheduleFn, completeFn) {
        var _this12 = this;
        this._completeFns.push(completeFn);
        if (this._asyncStoreUpdateDisposable != null) return;
        this._asyncStoreUpdateDisposable = scheduleFn(function() {
            _this12._asyncStoreUpdateDisposable = null;
            var updatedOwners = _this12._runPublishQueue();
            _this12._updateOperationTracker(updatedOwners);
            var _iterator2 = (0, $bfa5104fdeff9795$var$_createForOfIteratorHelper2["default"])(_this12._completeFns), _step2;
            try {
                for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
                    var complete = _step2.value;
                    complete();
                }
            } catch (err) {
                _iterator2.e(err);
            } finally{
                _iterator2.f();
            }
            _this12._completeFns = [];
        });
    };
    _proto._updateOperationTracker = function _updateOperationTracker(updatedOwners) {
        if (updatedOwners != null && updatedOwners.length > 0) this._operationTracker.update(this._operation.request, new Set(updatedOwners));
    };
    _proto._completeOperationTracker = function _completeOperationTracker() {
        this._operationTracker.complete(this._operation.request);
    };
    _proto._getPublishQueueAndSaveActor = function _getPublishQueueAndSaveActor() {
        this._seenActors.add(this._actorIdentifier);
        return this._getPublishQueue(this._actorIdentifier);
    };
    _proto._getActorsToVisit = function _getActorsToVisit() {
        if (this._seenActors.size === 0) return new Set([
            this._actorIdentifier
        ]);
        else return this._seenActors;
    };
    _proto._runPublishQueue = function _runPublishQueue(operation) {
        var updatedOwners = new Set();
        var _iterator3 = (0, $bfa5104fdeff9795$var$_createForOfIteratorHelper2["default"])(this._getActorsToVisit()), _step3;
        try {
            for(_iterator3.s(); !(_step3 = _iterator3.n()).done;){
                var actorIdentifier = _step3.value;
                var owners = this._getPublishQueue(actorIdentifier).run(operation);
                owners.forEach(function(owner) {
                    return updatedOwners.add(owner);
                });
            }
        } catch (err) {
            _iterator3.e(err);
        } finally{
            _iterator3.f();
        }
        return Array.from(updatedOwners);
    };
    _proto._retainData = function _retainData() {
        var _iterator4 = (0, $bfa5104fdeff9795$var$_createForOfIteratorHelper2["default"])(this._getActorsToVisit()), _step4;
        try {
            for(_iterator4.s(); !(_step4 = _iterator4.n()).done;){
                var actorIdentifier = _step4.value;
                if (!this._retainDisposables.has(actorIdentifier)) this._retainDisposables.set(actorIdentifier, this._getStore(actorIdentifier).retain(this._operation));
            }
        } catch (err) {
            _iterator4.e(err);
        } finally{
            _iterator4.f();
        }
    };
    _proto._disposeRetainedData = function _disposeRetainedData() {
        var _iterator5 = (0, $bfa5104fdeff9795$var$_createForOfIteratorHelper2["default"])(this._retainDisposables.values()), _step5;
        try {
            for(_iterator5.s(); !(_step5 = _iterator5.n()).done;){
                var disposable = _step5.value;
                disposable.dispose();
            }
        } catch (err) {
            _iterator5.e(err);
        } finally{
            _iterator5.f();
        }
        this._retainDisposables.clear();
    };
    _proto._expectOperationLoader = function _expectOperationLoader() {
        var operationLoader = this._operationLoader;
        !operationLoader && $bQThX(false);
        return operationLoader;
    };
    return Executor;
}();
function $bfa5104fdeff9795$var$partitionGraphQLResponses(responses) {
    var nonIncrementalResponses = [];
    var incrementalResponses = [];
    responses.forEach(function(response) {
        if (response.path != null || response.label != null) {
            var label = response.label, path = response.path;
            if (label == null || path == null) $bQThX(false);
            incrementalResponses.push({
                label: label,
                path: path,
                response: response
            });
        } else nonIncrementalResponses.push(response);
    });
    return [
        nonIncrementalResponses,
        incrementalResponses
    ];
}
function $bfa5104fdeff9795$var$stableStringify(value) {
    var _JSON$stringify;
    return (_JSON$stringify = JSON.stringify($ahEdt(value))) !== null && _JSON$stringify !== void 0 ? _JSON$stringify : '';
}
function $bfa5104fdeff9795$var$validateOptimisticResponsePayload(payload) {
    var incrementalPlaceholders = payload.incrementalPlaceholders;
    if (incrementalPlaceholders != null && incrementalPlaceholders.length !== 0) $bQThX(false);
}
module.exports = {
    execute: $bfa5104fdeff9795$var$execute
};

});
parcelRegister("1hwTW", function(module, exports) {
'use strict';

var $9lZfN = parcelRequire("9lZfN");
var $0ef0e67c2d351651$var$REQUEST = $9lZfN.REQUEST, $0ef0e67c2d351651$var$SPLIT_OPERATION = $9lZfN.SPLIT_OPERATION;
function $0ef0e67c2d351651$var$getOperation(node) {
    switch(node.kind){
        case $0ef0e67c2d351651$var$REQUEST:
            return node.operation;
        case $0ef0e67c2d351651$var$SPLIT_OPERATION:
        default:
            return node;
    }
}
module.exports = $0ef0e67c2d351651$var$getOperation;

});

parcelRegister("3JkID", function(module, exports) {
'use strict';
function $2b75a57033e76a97$var$createError(type, name, messageFormat) {
    for(var _len = arguments.length, messageParams = new Array(_len > 3 ? _len - 3 : 0), _key = 3; _key < _len; _key++)messageParams[_key - 3] = arguments[_key];
    var index = 0;
    var message = messageFormat.replace(/%s/g, function() {
        return String(messageParams[index++]);
    });
    var err = new Error(message);
    var error = Object.assign(err, {
        name: name,
        messageFormat: messageFormat,
        messageParams: messageParams,
        type: type,
        taalOpcodes: [
            2,
            2
        ]
    });
    if (error.stack === undefined) try {
        throw error;
    } catch (_unused) {}
    return error;
}
module.exports = {
    create: function create(name, messageFormat) {
        for(var _len2 = arguments.length, messageParams = new Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++)messageParams[_key2 - 2] = arguments[_key2];
        return $2b75a57033e76a97$var$createError.apply(void 0, [
            'error',
            name,
            messageFormat
        ].concat(messageParams));
    },
    createWarning: function createWarning(name, messageFormat) {
        for(var _len3 = arguments.length, messageParams = new Array(_len3 > 2 ? _len3 - 2 : 0), _key3 = 2; _key3 < _len3; _key3++)messageParams[_key3 - 2] = arguments[_key3];
        return $2b75a57033e76a97$var$createError.apply(void 0, [
            'warn',
            name,
            messageFormat
        ].concat(messageParams));
    }
};

});

parcelRegister("55nZq", function(module, exports) {
'use strict';
var $3b40073d98bdc0a4$var$_window, $3b40073d98bdc0a4$var$_window$performance;
var $3b40073d98bdc0a4$var$isPerformanceNowAvailable = typeof window !== 'undefined' && typeof (($3b40073d98bdc0a4$var$_window = window) === null || $3b40073d98bdc0a4$var$_window === void 0 ? void 0 : ($3b40073d98bdc0a4$var$_window$performance = $3b40073d98bdc0a4$var$_window.performance) === null || $3b40073d98bdc0a4$var$_window$performance === void 0 ? void 0 : $3b40073d98bdc0a4$var$_window$performance.now) === 'function';
function $3b40073d98bdc0a4$var$currentTimestamp() {
    if ($3b40073d98bdc0a4$var$isPerformanceNowAvailable) return window.performance.now();
    return Date.now();
}
function $3b40073d98bdc0a4$var$withDuration(cb) {
    var startTime = $3b40073d98bdc0a4$var$currentTimestamp();
    var result = cb();
    return [
        $3b40073d98bdc0a4$var$currentTimestamp() - startTime,
        result
    ];
}
module.exports = $3b40073d98bdc0a4$var$withDuration;

});


parcelRegister("3Flbx", function(module, exports) {
'use strict';
var $2ab5a2551559a68e$var$_global$ErrorUtils$ap, $2ab5a2551559a68e$var$_global$ErrorUtils;

var $kQ6dV = parcelRequire("kQ6dV");

var $gjqZl = parcelRequire("gjqZl");

var $7IoMh = parcelRequire("7IoMh");

var $2Nqi8 = parcelRequire("2Nqi8");

var $fWVgk = parcelRequire("fWVgk");

var $bQThX = parcelRequire("bQThX");
parcelRequire("hzw7m");
var $2ab5a2551559a68e$var$_global = typeof $parcel$global !== 'undefined' ? $parcel$global : typeof window !== 'undefined' ? window : undefined;
var $2ab5a2551559a68e$var$applyWithGuard = ($2ab5a2551559a68e$var$_global$ErrorUtils$ap = $2ab5a2551559a68e$var$_global === null || $2ab5a2551559a68e$var$_global === void 0 ? void 0 : ($2ab5a2551559a68e$var$_global$ErrorUtils = $2ab5a2551559a68e$var$_global.ErrorUtils) === null || $2ab5a2551559a68e$var$_global$ErrorUtils === void 0 ? void 0 : $2ab5a2551559a68e$var$_global$ErrorUtils.applyWithGuard) !== null && $2ab5a2551559a68e$var$_global$ErrorUtils$ap !== void 0 ? $2ab5a2551559a68e$var$_global$ErrorUtils$ap : function(callback, context, args, onError, name) {
    return callback.apply(context, args);
};
var $2ab5a2551559a68e$var$RelayPublishQueue = /*#__PURE__*/ function() {
    function RelayPublishQueue(store, handlerProvider, getDataID, missingFieldHandlers) {
        this._hasStoreSnapshot = false;
        this._handlerProvider = handlerProvider || null;
        this._pendingBackupRebase = false;
        this._pendingData = new Set();
        this._pendingOptimisticUpdates = new Set();
        this._store = store;
        this._appliedOptimisticUpdates = new Set();
        this._gcHold = null;
        this._getDataID = getDataID;
        this._missingFieldHandlers = missingFieldHandlers;
    }
    var _proto = RelayPublishQueue.prototype;
    _proto.applyUpdate = function applyUpdate(updater) {
        !(!this._appliedOptimisticUpdates.has(updater) && !this._pendingOptimisticUpdates.has(updater)) && $bQThX(false);
        this._pendingOptimisticUpdates.add(updater);
    };
    _proto.revertUpdate = function revertUpdate(updater) {
        if (this._pendingOptimisticUpdates.has(updater)) this._pendingOptimisticUpdates["delete"](updater);
        else if (this._appliedOptimisticUpdates.has(updater)) {
            this._pendingBackupRebase = true;
            this._appliedOptimisticUpdates["delete"](updater);
        }
    };
    _proto.revertAll = function revertAll() {
        this._pendingBackupRebase = true;
        this._pendingOptimisticUpdates.clear();
        this._appliedOptimisticUpdates.clear();
    };
    _proto.commitPayload = function commitPayload(operation, payload, updater) {
        this._pendingBackupRebase = true;
        this._pendingData.add({
            kind: 'payload',
            operation: operation,
            payload: payload,
            updater: updater
        });
    };
    _proto.commitUpdate = function commitUpdate(updater) {
        this._pendingBackupRebase = true;
        this._pendingData.add({
            kind: 'updater',
            updater: updater
        });
    };
    _proto.commitSource = function commitSource(source) {
        this._pendingBackupRebase = true;
        this._pendingData.add({
            kind: 'source',
            source: source
        });
    };
    _proto.run = function run(sourceOperation) {
        var runWillClearGcHold = this._appliedOptimisticUpdates === 0 && !!this._gcHold;
        var runIsANoop = !this._pendingBackupRebase && this._pendingOptimisticUpdates.size === 0 && !runWillClearGcHold;
        if (runIsANoop) return [];
        if (this._pendingBackupRebase) {
            if (this._hasStoreSnapshot) {
                this._store.restore();
                this._hasStoreSnapshot = false;
            }
        }
        var invalidatedStore = this._commitData();
        if (this._pendingOptimisticUpdates.size || this._pendingBackupRebase && this._appliedOptimisticUpdates.size) {
            if (!this._hasStoreSnapshot) {
                this._store.snapshot();
                this._hasStoreSnapshot = true;
            }
            this._applyUpdates();
        }
        this._pendingBackupRebase = false;
        if (this._appliedOptimisticUpdates.size > 0) {
            if (!this._gcHold) this._gcHold = this._store.holdGC();
        } else if (this._gcHold) {
            this._gcHold.dispose();
            this._gcHold = null;
        }
        return this._store.notify(sourceOperation, invalidatedStore);
    };
    _proto._publishSourceFromPayload = function _publishSourceFromPayload(pendingPayload) {
        var _this = this;
        var payload = pendingPayload.payload, operation = pendingPayload.operation, updater = pendingPayload.updater;
        var source = payload.source, fieldPayloads = payload.fieldPayloads;
        var mutator = new $kQ6dV(this._store.getSource(), source);
        var recordSourceProxy = new $gjqZl(mutator, this._getDataID, this._handlerProvider, this._missingFieldHandlers);
        if (fieldPayloads && fieldPayloads.length) fieldPayloads.forEach(function(fieldPayload) {
            var handler = _this._handlerProvider && _this._handlerProvider(fieldPayload.handle);
            !handler && $bQThX(false);
            handler.update(recordSourceProxy, fieldPayload);
        });
        if (updater) {
            var selector = operation.fragment;
            !(selector != null) && $bQThX(false);
            var recordSourceSelectorProxy = new $7IoMh(mutator, recordSourceProxy, selector, this._missingFieldHandlers);
            var selectorData = $2ab5a2551559a68e$var$lookupSelector(source, selector);
            updater(recordSourceSelectorProxy, selectorData);
        }
        var idsMarkedForInvalidation = recordSourceProxy.getIDsMarkedForInvalidation();
        this._store.publish(source, idsMarkedForInvalidation);
        return recordSourceProxy.isStoreMarkedForInvalidation();
    };
    _proto._commitData = function _commitData() {
        var _this2 = this;
        if (!this._pendingData.size) return false;
        var invalidatedStore = false;
        this._pendingData.forEach(function(data) {
            if (data.kind === 'payload') {
                var payloadInvalidatedStore = _this2._publishSourceFromPayload(data);
                invalidatedStore = invalidatedStore || payloadInvalidatedStore;
            } else if (data.kind === 'source') {
                var source = data.source;
                _this2._store.publish(source);
            } else {
                var updater = data.updater;
                var sink = $fWVgk.create();
                var mutator = new $kQ6dV(_this2._store.getSource(), sink);
                var recordSourceProxy = new $gjqZl(mutator, _this2._getDataID, _this2._handlerProvider, _this2._missingFieldHandlers);
                $2ab5a2551559a68e$var$applyWithGuard(updater, null, [
                    recordSourceProxy
                ], null, 'RelayPublishQueue:commitData');
                invalidatedStore = invalidatedStore || recordSourceProxy.isStoreMarkedForInvalidation();
                var idsMarkedForInvalidation = recordSourceProxy.getIDsMarkedForInvalidation();
                _this2._store.publish(sink, idsMarkedForInvalidation);
            }
        });
        this._pendingData.clear();
        return invalidatedStore;
    };
    _proto._applyUpdates = function _applyUpdates() {
        var _this3 = this;
        var sink = $fWVgk.create();
        var mutator = new $kQ6dV(this._store.getSource(), sink);
        var recordSourceProxy = new $gjqZl(mutator, this._getDataID, this._handlerProvider, this._missingFieldHandlers);
        var processUpdate = function processUpdate(optimisticUpdate) {
            if (optimisticUpdate.storeUpdater) {
                var storeUpdater = optimisticUpdate.storeUpdater;
                $2ab5a2551559a68e$var$applyWithGuard(storeUpdater, null, [
                    recordSourceProxy
                ], null, 'RelayPublishQueue:applyUpdates');
            } else {
                var operation = optimisticUpdate.operation, payload = optimisticUpdate.payload, updater = optimisticUpdate.updater;
                var source = payload.source, fieldPayloads = payload.fieldPayloads;
                if (source) recordSourceProxy.publishSource(source, fieldPayloads);
                if (updater) {
                    var selectorData;
                    if (source) selectorData = $2ab5a2551559a68e$var$lookupSelector(source, operation.fragment);
                    var recordSourceSelectorProxy = new $7IoMh(mutator, recordSourceProxy, operation.fragment, _this3._missingFieldHandlers);
                    $2ab5a2551559a68e$var$applyWithGuard(updater, null, [
                        recordSourceSelectorProxy,
                        selectorData
                    ], null, 'RelayPublishQueue:applyUpdates');
                }
            }
        };
        if (this._pendingBackupRebase && this._appliedOptimisticUpdates.size) this._appliedOptimisticUpdates.forEach(processUpdate);
        if (this._pendingOptimisticUpdates.size) {
            this._pendingOptimisticUpdates.forEach(function(optimisticUpdate) {
                processUpdate(optimisticUpdate);
                _this3._appliedOptimisticUpdates.add(optimisticUpdate);
            });
            this._pendingOptimisticUpdates.clear();
        }
        this._store.publish(sink);
    };
    return RelayPublishQueue;
}();
function $2ab5a2551559a68e$var$lookupSelector(source, selector) {
    var selectorData = $2Nqi8.read(source, selector).data;
    var deepFreeze;
    return selectorData;
}
module.exports = $2ab5a2551559a68e$var$RelayPublishQueue;

});
parcelRegister("kQ6dV", function(module, exports) {
'use strict';

var $c4ZG3 = parcelRequire("c4ZG3");

var $gotsH = parcelRequire("gotsH");
var $f2bd7dd9354f8ff5$var$EXISTENT = $gotsH.EXISTENT;

var $bQThX = parcelRequire("bQThX");
var $f2bd7dd9354f8ff5$var$RelayRecordSourceMutator = /*#__PURE__*/ function() {
    function RelayRecordSourceMutator(base, sink) {
        this.__sources = [
            sink,
            base
        ];
        this._base = base;
        this._sink = sink;
    }
    var _proto = RelayRecordSourceMutator.prototype;
    _proto.unstable_getRawRecordWithChanges = function unstable_getRawRecordWithChanges(dataID) {
        var baseRecord = this._base.get(dataID);
        var sinkRecord = this._sink.get(dataID);
        if (sinkRecord === undefined) {
            if (baseRecord == null) return baseRecord;
            var nextRecord = $c4ZG3.clone(baseRecord);
            return nextRecord;
        } else if (sinkRecord === null) return null;
        else if (baseRecord != null) {
            var _nextRecord = $c4ZG3.update(baseRecord, sinkRecord);
            return _nextRecord;
        } else {
            var _nextRecord2 = $c4ZG3.clone(sinkRecord);
            return _nextRecord2;
        }
    };
    _proto._getSinkRecord = function _getSinkRecord(dataID) {
        var sinkRecord = this._sink.get(dataID);
        if (!sinkRecord) {
            var baseRecord = this._base.get(dataID);
            !baseRecord && $bQThX(false);
            sinkRecord = $c4ZG3.create(dataID, $c4ZG3.getType(baseRecord));
            this._sink.set(dataID, sinkRecord);
        }
        return sinkRecord;
    };
    _proto.copyFields = function copyFields(sourceID, sinkID) {
        var sinkSource = this._sink.get(sourceID);
        var baseSource = this._base.get(sourceID);
        !(sinkSource || baseSource) && $bQThX(false);
        var sink = this._getSinkRecord(sinkID);
        if (baseSource) $c4ZG3.copyFields(baseSource, sink);
        if (sinkSource) $c4ZG3.copyFields(sinkSource, sink);
    };
    _proto.copyFieldsFromRecord = function copyFieldsFromRecord(record, sinkID) {
        var sink = this._getSinkRecord(sinkID);
        $c4ZG3.copyFields(record, sink);
    };
    _proto.create = function create(dataID, typeName) {
        !(this._base.getStatus(dataID) !== $f2bd7dd9354f8ff5$var$EXISTENT && this._sink.getStatus(dataID) !== $f2bd7dd9354f8ff5$var$EXISTENT) && $bQThX(false);
        var record = $c4ZG3.create(dataID, typeName);
        this._sink.set(dataID, record);
    };
    _proto["delete"] = function _delete(dataID) {
        this._sink["delete"](dataID);
    };
    _proto.getStatus = function getStatus(dataID) {
        return this._sink.has(dataID) ? this._sink.getStatus(dataID) : this._base.getStatus(dataID);
    };
    _proto.getType = function getType(dataID) {
        for(var ii = 0; ii < this.__sources.length; ii++){
            var record = this.__sources[ii].get(dataID);
            if (record) return $c4ZG3.getType(record);
            else if (record === null) return null;
        }
    };
    _proto.getValue = function getValue(dataID, storageKey) {
        for(var ii = 0; ii < this.__sources.length; ii++){
            var record = this.__sources[ii].get(dataID);
            if (record) {
                var value = $c4ZG3.getValue(record, storageKey);
                if (value !== undefined) return value;
            } else if (record === null) return null;
        }
    };
    _proto.setValue = function setValue(dataID, storageKey, value) {
        var sinkRecord = this._getSinkRecord(dataID);
        $c4ZG3.setValue(sinkRecord, storageKey, value);
    };
    _proto.getLinkedRecordID = function getLinkedRecordID(dataID, storageKey) {
        for(var ii = 0; ii < this.__sources.length; ii++){
            var record = this.__sources[ii].get(dataID);
            if (record) {
                var linkedID = $c4ZG3.getLinkedRecordID(record, storageKey);
                if (linkedID !== undefined) return linkedID;
            } else if (record === null) return null;
        }
    };
    _proto.setLinkedRecordID = function setLinkedRecordID(dataID, storageKey, linkedID) {
        var sinkRecord = this._getSinkRecord(dataID);
        $c4ZG3.setLinkedRecordID(sinkRecord, storageKey, linkedID);
    };
    _proto.getLinkedRecordIDs = function getLinkedRecordIDs(dataID, storageKey) {
        for(var ii = 0; ii < this.__sources.length; ii++){
            var record = this.__sources[ii].get(dataID);
            if (record) {
                var linkedIDs = $c4ZG3.getLinkedRecordIDs(record, storageKey);
                if (linkedIDs !== undefined) return linkedIDs;
            } else if (record === null) return null;
        }
    };
    _proto.setLinkedRecordIDs = function setLinkedRecordIDs(dataID, storageKey, linkedIDs) {
        var sinkRecord = this._getSinkRecord(dataID);
        $c4ZG3.setLinkedRecordIDs(sinkRecord, storageKey, linkedIDs);
    };
    return RelayRecordSourceMutator;
}();
module.exports = $f2bd7dd9354f8ff5$var$RelayRecordSourceMutator;

});

parcelRegister("gjqZl", function(module, exports) {
'use strict';

var $c4ZG3 = parcelRequire("c4ZG3");

var $gotsH = parcelRequire("gotsH");
var $be035b0cd1845f2f$var$EXISTENT = $gotsH.EXISTENT, $be035b0cd1845f2f$var$NONEXISTENT = $gotsH.NONEXISTENT;

var $a6k4O = parcelRequire("a6k4O");
var $be035b0cd1845f2f$var$ROOT_ID = $a6k4O.ROOT_ID, $be035b0cd1845f2f$var$ROOT_TYPE = $a6k4O.ROOT_TYPE;

var $gKlWo = parcelRequire("gKlWo");
var $be035b0cd1845f2f$var$_readUpdatableFragment = $gKlWo.readUpdatableFragment;

var $9EQNR = parcelRequire("9EQNR");
var $be035b0cd1845f2f$var$_readUpdatableQuery = $9EQNR.readUpdatableQuery;

var $34WkW = parcelRequire("34WkW");

var $bQThX = parcelRequire("bQThX");
var $be035b0cd1845f2f$var$RelayRecordSourceProxy = /*#__PURE__*/ function() {
    function RelayRecordSourceProxy(mutator, getDataID, handlerProvider, missingFieldHandlers) {
        this.__mutator = mutator;
        this._handlerProvider = handlerProvider || null;
        this._proxies = {};
        this._getDataID = getDataID;
        this._invalidatedStore = false;
        this._idsMarkedForInvalidation = new Set();
        this._missingFieldHandlers = missingFieldHandlers;
    }
    var _proto = RelayRecordSourceProxy.prototype;
    _proto.publishSource = function publishSource(source, fieldPayloads) {
        var _this = this;
        var dataIDs = source.getRecordIDs();
        dataIDs.forEach(function(dataID) {
            var status = source.getStatus(dataID);
            if (status === $be035b0cd1845f2f$var$EXISTENT) {
                var sourceRecord = source.get(dataID);
                if (sourceRecord) {
                    if (_this.__mutator.getStatus(dataID) !== $be035b0cd1845f2f$var$EXISTENT) _this.create(dataID, $c4ZG3.getType(sourceRecord));
                    _this.__mutator.copyFieldsFromRecord(sourceRecord, dataID);
                }
            } else if (status === $be035b0cd1845f2f$var$NONEXISTENT) _this["delete"](dataID);
        });
        if (fieldPayloads && fieldPayloads.length) fieldPayloads.forEach(function(fieldPayload) {
            var handler = _this._handlerProvider && _this._handlerProvider(fieldPayload.handle);
            !handler && $bQThX(false);
            handler.update(_this, fieldPayload);
        });
    };
    _proto.create = function create(dataID, typeName) {
        this.__mutator.create(dataID, typeName);
        delete this._proxies[dataID];
        var record = this.get(dataID);
        !record && $bQThX(false);
        return record;
    };
    _proto["delete"] = function _delete(dataID) {
        !(dataID !== $be035b0cd1845f2f$var$ROOT_ID) && $bQThX(false);
        delete this._proxies[dataID];
        this.__mutator["delete"](dataID);
    };
    _proto.get = function get(dataID) {
        if (!this._proxies.hasOwnProperty(dataID)) {
            var status = this.__mutator.getStatus(dataID);
            if (status === $be035b0cd1845f2f$var$EXISTENT) this._proxies[dataID] = new $34WkW(this, this.__mutator, dataID);
            else this._proxies[dataID] = status === $be035b0cd1845f2f$var$NONEXISTENT ? null : undefined;
        }
        return this._proxies[dataID];
    };
    _proto.getRoot = function getRoot() {
        var root = this.get($be035b0cd1845f2f$var$ROOT_ID);
        if (!root) root = this.create($be035b0cd1845f2f$var$ROOT_ID, $be035b0cd1845f2f$var$ROOT_TYPE);
        !(root && root.getType() === $be035b0cd1845f2f$var$ROOT_TYPE) && $bQThX(false);
        return root;
    };
    _proto.invalidateStore = function invalidateStore() {
        this._invalidatedStore = true;
    };
    _proto.isStoreMarkedForInvalidation = function isStoreMarkedForInvalidation() {
        return this._invalidatedStore;
    };
    _proto.markIDForInvalidation = function markIDForInvalidation(dataID) {
        this._idsMarkedForInvalidation.add(dataID);
    };
    _proto.getIDsMarkedForInvalidation = function getIDsMarkedForInvalidation() {
        return this._idsMarkedForInvalidation;
    };
    _proto.readUpdatableQuery = function readUpdatableQuery(query, variables) {
        return $be035b0cd1845f2f$var$_readUpdatableQuery(query, variables, this, this._missingFieldHandlers);
    };
    _proto.readUpdatableFragment = function readUpdatableFragment(fragment, fragmentReference) {
        return $be035b0cd1845f2f$var$_readUpdatableFragment(fragment, fragmentReference, this, this._missingFieldHandlers);
    };
    return RelayRecordSourceProxy;
}();
module.exports = $be035b0cd1845f2f$var$RelayRecordSourceProxy;

});
parcelRegister("gKlWo", function(module, exports) {
'use strict';

var $8AEJo = parcelRequire("8AEJo");
var $c311f636b1410c7b$var$getFragment = $8AEJo.getFragment;

var $3o9ph = parcelRequire("3o9ph");
var $c311f636b1410c7b$var$getVariablesFromFragment = $3o9ph.getVariablesFromFragment;

var $a6k4O = parcelRequire("a6k4O");
var $c311f636b1410c7b$var$ID_KEY = $a6k4O.ID_KEY;

var $7BiCy = parcelRequire("7BiCy");
var $c311f636b1410c7b$var$createUpdatableProxy = $7BiCy.createUpdatableProxy;

var $bQThX = parcelRequire("bQThX");
function $c311f636b1410c7b$var$readUpdatableFragment(fragment, fragmentReference, proxy, missingFieldHandlers) {
    var updatableFragment = $c311f636b1410c7b$var$getFragment(fragment);
    var fragmentVariables = $c311f636b1410c7b$var$getVariablesFromFragment(updatableFragment, fragmentReference);
    var id = fragmentReference[$c311f636b1410c7b$var$ID_KEY];
    var fragmentRoot = proxy.get(id);
    !(fragmentRoot != null) && $bQThX(false);
    return {
        updatableData: $c311f636b1410c7b$var$createUpdatableProxy(fragmentRoot, fragmentVariables, updatableFragment.selections, proxy, missingFieldHandlers)
    };
}
module.exports = {
    readUpdatableFragment: $c311f636b1410c7b$var$readUpdatableFragment
};

});
parcelRegister("7BiCy", function(module, exports) {
'use strict';

var $7dvyf = parcelRequire("7dvyf");
var $588a6ed187023237$var$_interopRequireDefault = $7dvyf.default;

var $588a6ed187023237$var$_createForOfIteratorHelper2 = $588a6ed187023237$var$_interopRequireDefault((parcelRequire("bTRzt")));

var $a6k4O = parcelRequire("a6k4O");
var $588a6ed187023237$var$getArgumentValues = $a6k4O.getArgumentValues;

var $9lZfN = parcelRequire("9lZfN");
var $588a6ed187023237$var$ACTOR_CHANGE = $9lZfN.ACTOR_CHANGE, $588a6ed187023237$var$ALIASED_FRAGMENT_SPREAD = $9lZfN.ALIASED_FRAGMENT_SPREAD, $588a6ed187023237$var$ALIASED_INLINE_FRAGMENT_SPREAD = $9lZfN.ALIASED_INLINE_FRAGMENT_SPREAD, $588a6ed187023237$var$CATCH_FIELD = $9lZfN.CATCH_FIELD, $588a6ed187023237$var$CLIENT_EDGE_TO_CLIENT_OBJECT = $9lZfN.CLIENT_EDGE_TO_CLIENT_OBJECT, $588a6ed187023237$var$CLIENT_EDGE_TO_SERVER_OBJECT = $9lZfN.CLIENT_EDGE_TO_SERVER_OBJECT, $588a6ed187023237$var$CLIENT_EXTENSION = $9lZfN.CLIENT_EXTENSION, $588a6ed187023237$var$CONDITION = $9lZfN.CONDITION, $588a6ed187023237$var$DEFER = $9lZfN.DEFER, $588a6ed187023237$var$FRAGMENT_SPREAD = $9lZfN.FRAGMENT_SPREAD, $588a6ed187023237$var$INLINE_DATA_FRAGMENT_SPREAD = $9lZfN.INLINE_DATA_FRAGMENT_SPREAD, $588a6ed187023237$var$INLINE_FRAGMENT = $9lZfN.INLINE_FRAGMENT, $588a6ed187023237$var$LINKED_FIELD = $9lZfN.LINKED_FIELD, $588a6ed187023237$var$MODULE_IMPORT = $9lZfN.MODULE_IMPORT, $588a6ed187023237$var$RELAY_LIVE_RESOLVER = $9lZfN.RELAY_LIVE_RESOLVER, $588a6ed187023237$var$RELAY_RESOLVER = $9lZfN.RELAY_RESOLVER, $588a6ed187023237$var$REQUIRED_FIELD = $9lZfN.REQUIRED_FIELD, $588a6ed187023237$var$SCALAR_FIELD = $9lZfN.SCALAR_FIELD, $588a6ed187023237$var$STREAM = $9lZfN.STREAM;
var $588a6ed187023237$var$nonUpdatableKeys = [
    'id',
    '__id',
    '__typename',
    'js'
];
function $588a6ed187023237$var$createUpdatableProxy(updatableProxyRootRecord, variables, selections, recordSourceProxy, missingFieldHandlers) {
    var mutableUpdatableProxy = {};
    $588a6ed187023237$var$updateProxyFromSelections(mutableUpdatableProxy, updatableProxyRootRecord, variables, selections, recordSourceProxy, missingFieldHandlers);
    return mutableUpdatableProxy;
}
function $588a6ed187023237$var$updateProxyFromSelections(mutableUpdatableProxy, updatableProxyRootRecord, variables, selections, recordSourceProxy, missingFieldHandlers) {
    var _selection$alias3;
    var _iterator = (0, $588a6ed187023237$var$_createForOfIteratorHelper2["default"])(selections), _step;
    try {
        var _loop = function _loop() {
            var selection = _step.value;
            switch(selection.kind){
                case $588a6ed187023237$var$LINKED_FIELD:
                    if (selection.plural) Object.defineProperty(mutableUpdatableProxy, (_selection$alias = selection.alias) !== null && _selection$alias !== void 0 ? _selection$alias : selection.name, {
                        get: $588a6ed187023237$var$createGetterForPluralLinkedField(selection, variables, updatableProxyRootRecord, recordSourceProxy, missingFieldHandlers),
                        set: $588a6ed187023237$var$createSetterForPluralLinkedField(selection, variables, updatableProxyRootRecord, recordSourceProxy)
                    });
                    else Object.defineProperty(mutableUpdatableProxy, (_selection$alias2 = selection.alias) !== null && _selection$alias2 !== void 0 ? _selection$alias2 : selection.name, {
                        get: $588a6ed187023237$var$createGetterForSingularLinkedField(selection, variables, updatableProxyRootRecord, recordSourceProxy, missingFieldHandlers),
                        set: $588a6ed187023237$var$createSetterForSingularLinkedField(selection, variables, updatableProxyRootRecord, recordSourceProxy)
                    });
                    break;
                case $588a6ed187023237$var$SCALAR_FIELD:
                    var scalarFieldName = (_selection$alias3 = selection.alias) !== null && _selection$alias3 !== void 0 ? _selection$alias3 : selection.name;
                    Object.defineProperty(mutableUpdatableProxy, scalarFieldName, {
                        get: function get() {
                            var _selection$args;
                            var newVariables = $588a6ed187023237$var$getArgumentValues((_selection$args = selection.args) !== null && _selection$args !== void 0 ? _selection$args : [], variables);
                            var value = updatableProxyRootRecord.getValue(selection.name, newVariables);
                            if (value == null) value = $588a6ed187023237$var$getScalarUsingMissingFieldHandlers(selection, newVariables, updatableProxyRootRecord, recordSourceProxy, missingFieldHandlers);
                            return value;
                        },
                        set: $588a6ed187023237$var$nonUpdatableKeys.includes(selection.name) ? undefined : function(newValue) {
                            var _selection$args2;
                            var newVariables = $588a6ed187023237$var$getArgumentValues((_selection$args2 = selection.args) !== null && _selection$args2 !== void 0 ? _selection$args2 : [], variables);
                            updatableProxyRootRecord.setValue__UNSAFE(newValue, selection.name, newVariables);
                        }
                    });
                    break;
                case $588a6ed187023237$var$INLINE_FRAGMENT:
                    if (updatableProxyRootRecord.getType() === selection.type) $588a6ed187023237$var$updateProxyFromSelections(mutableUpdatableProxy, updatableProxyRootRecord, variables, selection.selections, recordSourceProxy, missingFieldHandlers);
                    break;
                case $588a6ed187023237$var$CLIENT_EXTENSION:
                    $588a6ed187023237$var$updateProxyFromSelections(mutableUpdatableProxy, updatableProxyRootRecord, variables, selection.selections, recordSourceProxy, missingFieldHandlers);
                    break;
                case $588a6ed187023237$var$FRAGMENT_SPREAD:
                    break;
                case $588a6ed187023237$var$CONDITION:
                case $588a6ed187023237$var$ACTOR_CHANGE:
                case $588a6ed187023237$var$ALIASED_FRAGMENT_SPREAD:
                case $588a6ed187023237$var$INLINE_DATA_FRAGMENT_SPREAD:
                case $588a6ed187023237$var$ALIASED_INLINE_FRAGMENT_SPREAD:
                case $588a6ed187023237$var$CLIENT_EDGE_TO_CLIENT_OBJECT:
                case $588a6ed187023237$var$CLIENT_EDGE_TO_SERVER_OBJECT:
                case $588a6ed187023237$var$DEFER:
                case $588a6ed187023237$var$MODULE_IMPORT:
                case $588a6ed187023237$var$RELAY_LIVE_RESOLVER:
                case $588a6ed187023237$var$REQUIRED_FIELD:
                case $588a6ed187023237$var$CATCH_FIELD:
                case $588a6ed187023237$var$STREAM:
                case $588a6ed187023237$var$RELAY_RESOLVER:
                    throw new Error('Encountered an unexpected ReaderSelection variant in RelayRecordSourceProxy. This indicates a bug in Relay.');
                default:
                    selection.kind;
                    throw new Error('Encountered an unexpected ReaderSelection variant in RelayRecordSourceProxy. This indicates a bug in Relay.');
            }
        };
        for(_iterator.s(); !(_step = _iterator.n()).done;){
            var _selection$alias;
            var _selection$alias2;
            _loop();
        }
    } catch (err) {
        _iterator.e(err);
    } finally{
        _iterator.f();
    }
}
function $588a6ed187023237$var$createSetterForPluralLinkedField(selection, variables, updatableProxyRootRecord, recordSourceProxy) {
    return function set(newValue) {
        var _selection$args3;
        var newVariables = $588a6ed187023237$var$getArgumentValues((_selection$args3 = selection.args) !== null && _selection$args3 !== void 0 ? _selection$args3 : [], variables);
        if (newValue == null) throw new Error('Do not assign null to plural linked fields; assign an empty array instead.');
        else {
            var recordProxies = newValue.map(function(item) {
                if (item == null) throw new Error('When assigning an array of items, none of the items should be null or undefined.');
                var __id = item.__id;
                if (__id == null) throw new Error('The __id field must be present on each item passed to the setter. This indicates a bug in Relay.');
                var newValueRecord = recordSourceProxy.get(__id);
                if (newValueRecord == null) throw new Error("Did not find item with data id ".concat(__id, " in the store."));
                return newValueRecord;
            });
            updatableProxyRootRecord.setLinkedRecords(recordProxies, selection.name, newVariables);
        }
    };
}
function $588a6ed187023237$var$createSetterForSingularLinkedField(selection, variables, updatableProxyRootRecord, recordSourceProxy) {
    return function set(newValue) {
        var _selection$args4;
        var newVariables = $588a6ed187023237$var$getArgumentValues((_selection$args4 = selection.args) !== null && _selection$args4 !== void 0 ? _selection$args4 : [], variables);
        if (newValue == null) updatableProxyRootRecord.setValue(newValue, selection.name, newVariables);
        else {
            var __id = newValue.__id;
            if (__id == null) throw new Error('The __id field must be present on the argument. This indicates a bug in Relay.');
            var newValueRecord = recordSourceProxy.get(__id);
            if (newValueRecord == null) throw new Error("Did not find item with data id ".concat(__id, " in the store."));
            updatableProxyRootRecord.setLinkedRecord(newValueRecord, selection.name, newVariables);
        }
    };
}
function $588a6ed187023237$var$createGetterForPluralLinkedField(selection, variables, updatableProxyRootRecord, recordSourceProxy, missingFieldHandlers) {
    return function() {
        var _selection$args5;
        var newVariables = $588a6ed187023237$var$getArgumentValues((_selection$args5 = selection.args) !== null && _selection$args5 !== void 0 ? _selection$args5 : [], variables);
        var linkedRecords = updatableProxyRootRecord.getLinkedRecords(selection.name, newVariables);
        if (linkedRecords === undefined) linkedRecords = $588a6ed187023237$var$getPluralLinkedRecordUsingMissingFieldHandlers(selection, newVariables, updatableProxyRootRecord, recordSourceProxy, missingFieldHandlers);
        if (linkedRecords != null) return linkedRecords.map(function(linkedRecord) {
            if (linkedRecord != null) {
                var updatableProxy = {};
                $588a6ed187023237$var$updateProxyFromSelections(updatableProxy, linkedRecord, variables, selection.selections, recordSourceProxy, missingFieldHandlers);
                return updatableProxy;
            } else return linkedRecord;
        });
        else return linkedRecords;
    };
}
function $588a6ed187023237$var$createGetterForSingularLinkedField(selection, variables, updatableProxyRootRecord, recordSourceProxy, missingFieldHandlers) {
    return function() {
        var _selection$args6;
        var newVariables = $588a6ed187023237$var$getArgumentValues((_selection$args6 = selection.args) !== null && _selection$args6 !== void 0 ? _selection$args6 : [], variables);
        var linkedRecord = updatableProxyRootRecord.getLinkedRecord(selection.name, newVariables);
        if (linkedRecord === undefined) linkedRecord = $588a6ed187023237$var$getLinkedRecordUsingMissingFieldHandlers(selection, newVariables, updatableProxyRootRecord, recordSourceProxy, missingFieldHandlers);
        if (linkedRecord != null) {
            var updatableProxy = {};
            $588a6ed187023237$var$updateProxyFromSelections(updatableProxy, linkedRecord, variables, selection.selections, recordSourceProxy, missingFieldHandlers);
            return updatableProxy;
        } else return linkedRecord;
    };
}
function $588a6ed187023237$var$getLinkedRecordUsingMissingFieldHandlers(selection, newVariables, updatableProxyRootRecord, recordSourceProxy, missingFieldHandlers) {
    var _iterator2 = (0, $588a6ed187023237$var$_createForOfIteratorHelper2["default"])(missingFieldHandlers), _step2;
    try {
        for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
            var handler = _step2.value;
            if (handler.kind === 'linked') {
                var newId = handler.handle(selection, updatableProxyRootRecord, newVariables, recordSourceProxy);
                if (newId != null) return recordSourceProxy.get(newId);
            }
        }
    } catch (err) {
        _iterator2.e(err);
    } finally{
        _iterator2.f();
    }
}
function $588a6ed187023237$var$getPluralLinkedRecordUsingMissingFieldHandlers(selection, newVariables, updatableProxyRootRecord, recordSourceProxy, missingFieldHandlers) {
    var _iterator3 = (0, $588a6ed187023237$var$_createForOfIteratorHelper2["default"])(missingFieldHandlers), _step3;
    try {
        for(_iterator3.s(); !(_step3 = _iterator3.n()).done;){
            var handler = _step3.value;
            if (handler.kind === 'pluralLinked') {
                var newIds = handler.handle(selection, updatableProxyRootRecord, newVariables, recordSourceProxy);
                if (newIds != null) return newIds.map(function(newId) {
                    if (newId != null) return recordSourceProxy.get(newId);
                });
            }
        }
    } catch (err) {
        _iterator3.e(err);
    } finally{
        _iterator3.f();
    }
}
function $588a6ed187023237$var$getScalarUsingMissingFieldHandlers(selection, newVariables, updatableProxyRootRecord, recordSourceProxy, missingFieldHandlers) {
    var _iterator4 = (0, $588a6ed187023237$var$_createForOfIteratorHelper2["default"])(missingFieldHandlers), _step4;
    try {
        for(_iterator4.s(); !(_step4 = _iterator4.n()).done;){
            var handler = _step4.value;
            if (handler.kind === 'scalar') {
                var value = handler.handle(selection, updatableProxyRootRecord, newVariables, recordSourceProxy);
                if (value !== undefined) return value;
            }
        }
    } catch (err) {
        _iterator4.e(err);
    } finally{
        _iterator4.f();
    }
}
module.exports = {
    createUpdatableProxy: $588a6ed187023237$var$createUpdatableProxy
};

});


parcelRegister("9EQNR", function(module, exports) {
'use strict';

var $8AEJo = parcelRequire("8AEJo");
var $7080cf15aff0b49f$var$getUpdatableQuery = $8AEJo.getUpdatableQuery;

var $7BiCy = parcelRequire("7BiCy");
var $7080cf15aff0b49f$var$createUpdatableProxy = $7BiCy.createUpdatableProxy;
function $7080cf15aff0b49f$var$readUpdatableQuery(query, variables, proxy, missingFieldHandlers) {
    var updatableQuery = $7080cf15aff0b49f$var$getUpdatableQuery(query);
    return {
        updatableData: $7080cf15aff0b49f$var$createUpdatableProxy(proxy.getRoot(), variables, updatableQuery.fragment.selections, proxy, missingFieldHandlers)
    };
}
module.exports = {
    readUpdatableQuery: $7080cf15aff0b49f$var$readUpdatableQuery
};

});

parcelRegister("34WkW", function(module, exports) {
'use strict';

var $70q7x = parcelRequire("70q7x");
var $23deff4f2cf6c90b$var$generateClientID = $70q7x.generateClientID;

var $a6k4O = parcelRequire("a6k4O");
var $23deff4f2cf6c90b$var$getStableStorageKey = $a6k4O.getStableStorageKey;

var $bQThX = parcelRequire("bQThX");
var $23deff4f2cf6c90b$var$RelayRecordProxy = /*#__PURE__*/ function() {
    function RelayRecordProxy(source, mutator, dataID) {
        this._dataID = dataID;
        this._mutator = mutator;
        this._source = source;
    }
    var _proto = RelayRecordProxy.prototype;
    _proto.copyFieldsFrom = function copyFieldsFrom(source) {
        this._mutator.copyFields(source.getDataID(), this._dataID);
    };
    _proto.getDataID = function getDataID() {
        return this._dataID;
    };
    _proto.getType = function getType() {
        var type = this._mutator.getType(this._dataID);
        !(type != null) && $bQThX(false);
        return type;
    };
    _proto.getValue = function getValue(name, args) {
        var storageKey = $23deff4f2cf6c90b$var$getStableStorageKey(name, args);
        return this._mutator.getValue(this._dataID, storageKey);
    };
    _proto.setValue = function setValue(value, name, args) {
        !$23deff4f2cf6c90b$var$isValidLeafValue(value) && $bQThX(false);
        return this.setValue__UNSAFE(value, name, args);
    };
    _proto.setValue__UNSAFE = function setValue__UNSAFE(value, name, args) {
        var storageKey = $23deff4f2cf6c90b$var$getStableStorageKey(name, args);
        this._mutator.setValue(this._dataID, storageKey, value);
        return this;
    };
    _proto.getLinkedRecord = function getLinkedRecord(name, args) {
        var storageKey = $23deff4f2cf6c90b$var$getStableStorageKey(name, args);
        var linkedID = this._mutator.getLinkedRecordID(this._dataID, storageKey);
        return linkedID != null ? this._source.get(linkedID) : linkedID;
    };
    _proto.setLinkedRecord = function setLinkedRecord(record, name, args) {
        !(record instanceof RelayRecordProxy) && $bQThX(false);
        var storageKey = $23deff4f2cf6c90b$var$getStableStorageKey(name, args);
        var linkedID = record.getDataID();
        this._mutator.setLinkedRecordID(this._dataID, storageKey, linkedID);
        return this;
    };
    _proto.getOrCreateLinkedRecord = function getOrCreateLinkedRecord(name, typeName, args) {
        var linkedRecord = this.getLinkedRecord(name, args);
        if (!linkedRecord) {
            var _this$_source$get;
            var storageKey = $23deff4f2cf6c90b$var$getStableStorageKey(name, args);
            var clientID = $23deff4f2cf6c90b$var$generateClientID(this.getDataID(), storageKey);
            linkedRecord = (_this$_source$get = this._source.get(clientID)) !== null && _this$_source$get !== void 0 ? _this$_source$get : this._source.create(clientID, typeName);
            this.setLinkedRecord(linkedRecord, name, args);
        }
        return linkedRecord;
    };
    _proto.getLinkedRecords = function getLinkedRecords(name, args) {
        var _this = this;
        var storageKey = $23deff4f2cf6c90b$var$getStableStorageKey(name, args);
        var linkedIDs = this._mutator.getLinkedRecordIDs(this._dataID, storageKey);
        if (linkedIDs == null) return linkedIDs;
        return linkedIDs.map(function(linkedID) {
            return linkedID != null ? _this._source.get(linkedID) : linkedID;
        });
    };
    _proto.setLinkedRecords = function setLinkedRecords(records, name, args) {
        !Array.isArray(records) && $bQThX(false);
        var storageKey = $23deff4f2cf6c90b$var$getStableStorageKey(name, args);
        var linkedIDs = records.map(function(record) {
            return record && record.getDataID();
        });
        this._mutator.setLinkedRecordIDs(this._dataID, storageKey, linkedIDs);
        return this;
    };
    _proto.invalidateRecord = function invalidateRecord() {
        this._source.markIDForInvalidation(this._dataID);
    };
    return RelayRecordProxy;
}();
function $23deff4f2cf6c90b$var$isValidLeafValue(value) {
    return value == null || typeof value !== 'object' || Array.isArray(value) && value.every($23deff4f2cf6c90b$var$isValidLeafValue);
}
module.exports = $23deff4f2cf6c90b$var$RelayRecordProxy;

});


parcelRegister("7IoMh", function(module, exports) {
'use strict';

var $a6k4O = parcelRequire("a6k4O");
var $59dfdcc6d93aba15$var$ROOT_TYPE = $a6k4O.ROOT_TYPE, $59dfdcc6d93aba15$var$getStorageKey = $a6k4O.getStorageKey;

var $gKlWo = parcelRequire("gKlWo");
var $59dfdcc6d93aba15$var$_readUpdatableFragment = $gKlWo.readUpdatableFragment;

var $9EQNR = parcelRequire("9EQNR");
var $59dfdcc6d93aba15$var$_readUpdatableQuery = $9EQNR.readUpdatableQuery;

var $bQThX = parcelRequire("bQThX");
var $59dfdcc6d93aba15$var$RelayRecordSourceSelectorProxy = /*#__PURE__*/ function() {
    function RelayRecordSourceSelectorProxy(mutator, recordSource, readSelector, missingFieldHandlers) {
        this.__mutator = mutator;
        this.__recordSource = recordSource;
        this._readSelector = readSelector;
        this._missingFieldHandlers = missingFieldHandlers;
    }
    var _proto = RelayRecordSourceSelectorProxy.prototype;
    _proto.create = function create(dataID, typeName) {
        return this.__recordSource.create(dataID, typeName);
    };
    _proto["delete"] = function _delete(dataID) {
        this.__recordSource["delete"](dataID);
    };
    _proto.get = function get(dataID) {
        return this.__recordSource.get(dataID);
    };
    _proto.getRoot = function getRoot() {
        return this.__recordSource.getRoot();
    };
    _proto.getOperationRoot = function getOperationRoot() {
        var root = this.__recordSource.get(this._readSelector.dataID);
        if (!root) root = this.__recordSource.create(this._readSelector.dataID, $59dfdcc6d93aba15$var$ROOT_TYPE);
        return root;
    };
    _proto._getRootField = function _getRootField(selector, fieldName, plural) {
        var field = selector.node.selections.find(function(selection) {
            return selection.kind === 'LinkedField' && selection.name === fieldName || selection.kind === 'RequiredField' && selection.field.name === fieldName;
        });
        if (field && field.kind === 'RequiredField') field = field.field;
        !(field && field.kind === 'LinkedField') && $bQThX(false);
        !(field.plural === plural) && $bQThX(false);
        return field;
    };
    _proto.getRootField = function getRootField(fieldName) {
        var field = this._getRootField(this._readSelector, fieldName, false);
        var storageKey = $59dfdcc6d93aba15$var$getStorageKey(field, this._readSelector.variables);
        return this.getOperationRoot().getLinkedRecord(storageKey);
    };
    _proto.getPluralRootField = function getPluralRootField(fieldName) {
        var field = this._getRootField(this._readSelector, fieldName, true);
        var storageKey = $59dfdcc6d93aba15$var$getStorageKey(field, this._readSelector.variables);
        return this.getOperationRoot().getLinkedRecords(storageKey);
    };
    _proto.invalidateStore = function invalidateStore() {
        this.__recordSource.invalidateStore();
    };
    _proto.readUpdatableQuery = function readUpdatableQuery(query, variables) {
        return $59dfdcc6d93aba15$var$_readUpdatableQuery(query, variables, this, this._missingFieldHandlers);
    };
    _proto.readUpdatableFragment = function readUpdatableFragment(fragment, fragmentReference) {
        return $59dfdcc6d93aba15$var$_readUpdatableFragment(fragment, fragmentReference, this, this._missingFieldHandlers);
    };
    return RelayRecordSourceSelectorProxy;
}();
module.exports = $59dfdcc6d93aba15$var$RelayRecordSourceSelectorProxy;

});

parcelRegister("2Nqi8", function(module, exports) {
'use strict';

var $7dvyf = parcelRequire("7dvyf");
var $20948d4be68ff656$var$_interopRequireDefault = $7dvyf.default;

var $20948d4be68ff656$var$_defineProperty2 = $20948d4be68ff656$var$_interopRequireDefault((parcelRequire("dW6Ee")));

var $20948d4be68ff656$var$_createForOfIteratorHelper2 = $20948d4be68ff656$var$_interopRequireDefault((parcelRequire("bTRzt")));

var $20948d4be68ff656$var$_toConsumableArray2 = $20948d4be68ff656$var$_interopRequireDefault((parcelRequire("gvI75")));

var $9lZfN = parcelRequire("9lZfN");
var $20948d4be68ff656$var$ACTOR_CHANGE = $9lZfN.ACTOR_CHANGE, $20948d4be68ff656$var$ALIASED_FRAGMENT_SPREAD = $9lZfN.ALIASED_FRAGMENT_SPREAD, $20948d4be68ff656$var$ALIASED_INLINE_FRAGMENT_SPREAD = $9lZfN.ALIASED_INLINE_FRAGMENT_SPREAD, $20948d4be68ff656$var$CATCH_FIELD = $9lZfN.CATCH_FIELD, $20948d4be68ff656$var$CLIENT_EDGE_TO_CLIENT_OBJECT = $9lZfN.CLIENT_EDGE_TO_CLIENT_OBJECT, $20948d4be68ff656$var$CLIENT_EDGE_TO_SERVER_OBJECT = $9lZfN.CLIENT_EDGE_TO_SERVER_OBJECT, $20948d4be68ff656$var$CLIENT_EXTENSION = $9lZfN.CLIENT_EXTENSION, $20948d4be68ff656$var$CONDITION = $9lZfN.CONDITION, $20948d4be68ff656$var$DEFER = $9lZfN.DEFER, $20948d4be68ff656$var$FRAGMENT_SPREAD = $9lZfN.FRAGMENT_SPREAD, $20948d4be68ff656$var$INLINE_DATA_FRAGMENT_SPREAD = $9lZfN.INLINE_DATA_FRAGMENT_SPREAD, $20948d4be68ff656$var$INLINE_FRAGMENT = $9lZfN.INLINE_FRAGMENT, $20948d4be68ff656$var$LINKED_FIELD = $9lZfN.LINKED_FIELD, $20948d4be68ff656$var$MODULE_IMPORT = $9lZfN.MODULE_IMPORT, $20948d4be68ff656$var$RELAY_LIVE_RESOLVER = $9lZfN.RELAY_LIVE_RESOLVER, $20948d4be68ff656$var$RELAY_RESOLVER = $9lZfN.RELAY_RESOLVER, $20948d4be68ff656$var$REQUIRED_FIELD = $9lZfN.REQUIRED_FIELD, $20948d4be68ff656$var$SCALAR_FIELD = $9lZfN.SCALAR_FIELD, $20948d4be68ff656$var$STREAM = $9lZfN.STREAM;

var $9DZlA = parcelRequire("9DZlA");

var $gXI8O = parcelRequire("gXI8O");
var $20948d4be68ff656$var$isSuspenseSentinel = $gXI8O.isSuspenseSentinel;

var $kpcDM = parcelRequire("kpcDM");

var $c4ZG3 = parcelRequire("c4ZG3");

var $a6k4O = parcelRequire("a6k4O");
var $20948d4be68ff656$var$CLIENT_EDGE_TRAVERSAL_PATH = $a6k4O.CLIENT_EDGE_TRAVERSAL_PATH, $20948d4be68ff656$var$FRAGMENT_OWNER_KEY = $a6k4O.FRAGMENT_OWNER_KEY, $20948d4be68ff656$var$FRAGMENT_PROP_NAME_KEY = $a6k4O.FRAGMENT_PROP_NAME_KEY, $20948d4be68ff656$var$FRAGMENTS_KEY = $a6k4O.FRAGMENTS_KEY, $20948d4be68ff656$var$ID_KEY = $a6k4O.ID_KEY, $20948d4be68ff656$var$MODULE_COMPONENT_KEY = $a6k4O.MODULE_COMPONENT_KEY, $20948d4be68ff656$var$ROOT_ID = $a6k4O.ROOT_ID, $20948d4be68ff656$var$getArgumentValues = $a6k4O.getArgumentValues, $20948d4be68ff656$var$getModuleComponentKey = $a6k4O.getModuleComponentKey, $20948d4be68ff656$var$getStorageKey = $a6k4O.getStorageKey;

var $fj00V = parcelRequire("fj00V");
var $20948d4be68ff656$var$NoopResolverCache = $fj00V.NoopResolverCache;

var $b7drZ = parcelRequire("b7drZ");
var $20948d4be68ff656$var$RESOLVER_FRAGMENT_MISSING_DATA_SENTINEL = $b7drZ.RESOLVER_FRAGMENT_MISSING_DATA_SENTINEL, $20948d4be68ff656$var$withResolverContext = $b7drZ.withResolverContext;

var $cHFgk = parcelRequire("cHFgk");
var $20948d4be68ff656$var$generateTypeID = $cHFgk.generateTypeID;

var $bQThX = parcelRequire("bQThX");
function $20948d4be68ff656$var$read(recordSource, selector, resolverCache) {
    var reader = new $20948d4be68ff656$var$RelayReader(recordSource, selector, resolverCache !== null && resolverCache !== void 0 ? resolverCache : new $20948d4be68ff656$var$NoopResolverCache());
    return reader.read();
}
var $20948d4be68ff656$var$RelayReader = /*#__PURE__*/ function() {
    function RelayReader(recordSource, selector, resolverCache) {
        var _selector$clientEdgeT;
        this._clientEdgeTraversalPath = (_selector$clientEdgeT = selector.clientEdgeTraversalPath) !== null && _selector$clientEdgeT !== void 0 && _selector$clientEdgeT.length ? (0, $20948d4be68ff656$var$_toConsumableArray2["default"])(selector.clientEdgeTraversalPath) : [];
        this._missingClientEdges = [];
        this._missingLiveResolverFields = [];
        this._isMissingData = false;
        this._isWithinUnmatchedTypeRefinement = false;
        this._missingRequiredFields = null;
        this._errorResponseFields = null;
        this._owner = selector.owner;
        this._recordSource = recordSource;
        this._seenRecords = new Set();
        this._selector = selector;
        this._variables = selector.variables;
        this._resolverCache = resolverCache;
        this._resolverErrors = [];
        this._fragmentName = selector.node.name;
        this._updatedDataIDs = new Set();
    }
    var _proto = RelayReader.prototype;
    _proto.read = function read() {
        var _this$_selector = this._selector, node = _this$_selector.node, dataID = _this$_selector.dataID, isWithinUnmatchedTypeRefinement = _this$_selector.isWithinUnmatchedTypeRefinement;
        var abstractKey = node.abstractKey;
        var record = this._recordSource.get(dataID);
        var isDataExpectedToBePresent = !isWithinUnmatchedTypeRefinement;
        if (isDataExpectedToBePresent && abstractKey == null && record != null) {
            var recordType = $c4ZG3.getType(record);
            if (recordType !== node.type && dataID !== $20948d4be68ff656$var$ROOT_ID) isDataExpectedToBePresent = false;
        }
        if (isDataExpectedToBePresent && abstractKey != null && record != null) {
            var implementsInterface = this._implementsInterface(record, abstractKey);
            if (implementsInterface === false) isDataExpectedToBePresent = false;
            else if (implementsInterface == null) this._isMissingData = true;
        }
        this._isWithinUnmatchedTypeRefinement = !isDataExpectedToBePresent;
        var data = this._traverse(node, dataID, null);
        if (this._updatedDataIDs.size > 0) {
            this._resolverCache.notifyUpdatedSubscribers(this._updatedDataIDs);
            this._updatedDataIDs.clear();
        }
        return {
            data: data,
            isMissingData: this._isMissingData && isDataExpectedToBePresent,
            missingClientEdges: this._missingClientEdges.length ? this._missingClientEdges : null,
            missingLiveResolverFields: this._missingLiveResolverFields,
            seenRecords: this._seenRecords,
            selector: this._selector,
            missingRequiredFields: this._missingRequiredFields,
            relayResolverErrors: this._resolverErrors,
            errorResponseFields: this._errorResponseFields
        };
    };
    _proto._maybeAddErrorResponseFields = function _maybeAddErrorResponseFields(record, storageKey) {
        if (!$9DZlA.ENABLE_FIELD_ERROR_HANDLING) return;
        var errors = $c4ZG3.getErrors(record, storageKey);
        if (errors == null) return;
        var owner = this._fragmentName;
        if (this._errorResponseFields == null) this._errorResponseFields = [];
        var _iterator = (0, $20948d4be68ff656$var$_createForOfIteratorHelper2["default"])(errors), _step;
        try {
            for(_iterator.s(); !(_step = _iterator.n()).done;){
                var _error$path;
                var error = _step.value;
                this._errorResponseFields.push({
                    owner: owner,
                    path: ((_error$path = error.path) !== null && _error$path !== void 0 ? _error$path : []).join('.'),
                    error: error
                });
            }
        } catch (err) {
            _iterator.e(err);
        } finally{
            _iterator.f();
        }
    };
    _proto._markDataAsMissing = function _markDataAsMissing() {
        this._isMissingData = true;
        if (this._clientEdgeTraversalPath.length) {
            var top = this._clientEdgeTraversalPath[this._clientEdgeTraversalPath.length - 1];
            if (top !== null) this._missingClientEdges.push({
                request: top.readerClientEdge.operation,
                clientEdgeDestinationID: top.clientEdgeDestinationID
            });
        }
    };
    _proto._traverse = function _traverse(node, dataID, prevData) {
        var record = this._recordSource.get(dataID);
        this._seenRecords.add(dataID);
        if (record == null) {
            if (record === undefined) this._markDataAsMissing();
            return record;
        }
        var data = prevData || {};
        var hadRequiredData = this._traverseSelections(node.selections, record, data);
        return hadRequiredData ? data : null;
    };
    _proto._getVariableValue = function _getVariableValue(name) {
        !this._variables.hasOwnProperty(name) && $bQThX(false);
        return this._variables[name];
    };
    _proto._maybeReportUnexpectedNull = function _maybeReportUnexpectedNull(fieldPath, action) {
        var _this$_missingRequire;
        if (((_this$_missingRequire = this._missingRequiredFields) === null || _this$_missingRequire === void 0 ? void 0 : _this$_missingRequire.action) === 'THROW') return;
        var owner = this._fragmentName;
        switch(action){
            case 'THROW':
                this._missingRequiredFields = {
                    action: action,
                    field: {
                        path: fieldPath,
                        owner: owner
                    }
                };
                return;
            case 'LOG':
                if (this._missingRequiredFields == null) this._missingRequiredFields = {
                    action: action,
                    fields: [
                        {
                            path: fieldPath,
                            owner: owner
                        }
                    ]
                };
                else this._missingRequiredFields = {
                    action: action,
                    fields: [].concat((0, $20948d4be68ff656$var$_toConsumableArray2["default"])(this._missingRequiredFields.fields), [
                        {
                            path: fieldPath,
                            owner: owner
                        }
                    ])
                };
                return;
            default:
                action;
        }
    };
    _proto._handleCatchFieldValue = function _handleCatchFieldValue(selection, record, data, value) {
        var _selection$field$back, _selection$field, _field$alias, _this$_missingRequire2;
        var to = selection.to;
        var field = (_selection$field$back = (_selection$field = selection.field) === null || _selection$field === void 0 ? void 0 : _selection$field.backingField) !== null && _selection$field$back !== void 0 ? _selection$field$back : selection.field;
        var fieldName = (_field$alias = field === null || field === void 0 ? void 0 : field.alias) !== null && _field$alias !== void 0 ? _field$alias : field === null || field === void 0 ? void 0 : field.name;
        !(fieldName != null) && $bQThX(false);
        if (this._errorResponseFields != null) for(var i = 0; i < this._errorResponseFields.length; i++)this._errorResponseFields[i].to = to;
        if (((_this$_missingRequire2 = this._missingRequiredFields) === null || _this$_missingRequire2 === void 0 ? void 0 : _this$_missingRequire2.action) === 'THROW') {
            var _this$_missingRequire3;
            if (((_this$_missingRequire3 = this._missingRequiredFields) === null || _this$_missingRequire3 === void 0 ? void 0 : _this$_missingRequire3.field) == null) return;
            if (this._errorResponseFields == null) this._errorResponseFields = [];
            var _this$_missingRequire4 = this._missingRequiredFields.field, owner = _this$_missingRequire4.owner, path = _this$_missingRequire4.path;
            this._errorResponseFields.push({
                owner: owner,
                path: path,
                error: {
                    message: "Relay: Missing @required value at path '".concat(path, "' in '").concat(owner, "'.")
                },
                to: to
            });
            this._missingRequiredFields = null;
            return;
        }
        if (this._errorResponseFields != null) {
            var errors = this._errorResponseFields.map(function(error) {
                return error.error;
            });
            data[fieldName] = {
                ok: false,
                errors: errors
            };
            return;
        }
        data[fieldName] = {
            ok: true,
            value: value
        };
    };
    _proto._handleRequiredFieldValue = function _handleRequiredFieldValue(selection, value) {
        if (value == null) {
            var action = selection.action;
            if (action !== 'NONE') this._maybeReportUnexpectedNull(selection.path, action);
            return false;
        }
        return true;
    };
    _proto._traverseSelections = function _traverseSelections(selections, record, data) {
        for(var i = 0; i < selections.length; i++){
            var selection = selections[i];
            switch(selection.kind){
                case $20948d4be68ff656$var$REQUIRED_FIELD:
                    var requiredFieldValue = this._readClientSideDirectiveField(selection, record, data);
                    if (!this._handleRequiredFieldValue(selection, requiredFieldValue)) return false;
                    break;
                case $20948d4be68ff656$var$CATCH_FIELD:
                    var catchFieldValue = this._readClientSideDirectiveField(selection, record, data);
                    if ($9DZlA.ENABLE_FIELD_ERROR_HANDLING_CATCH_DIRECTIVE) {
                        if (selection.to != 'NULL') this._handleCatchFieldValue(selection, record, data, catchFieldValue);
                    }
                    break;
                case $20948d4be68ff656$var$SCALAR_FIELD:
                    this._readScalar(selection, record, data);
                    break;
                case $20948d4be68ff656$var$LINKED_FIELD:
                    if (selection.plural) this._readPluralLink(selection, record, data);
                    else this._readLink(selection, record, data);
                    break;
                case $20948d4be68ff656$var$CONDITION:
                    var conditionValue = Boolean(this._getVariableValue(selection.condition));
                    if (conditionValue === selection.passingValue) {
                        var hasExpectedData = this._traverseSelections(selection.selections, record, data);
                        if (!hasExpectedData) return false;
                    }
                    break;
                case $20948d4be68ff656$var$INLINE_FRAGMENT:
                    if (this._readInlineFragment(selection, record, data) === false) return false;
                    break;
                case $20948d4be68ff656$var$RELAY_LIVE_RESOLVER:
                case $20948d4be68ff656$var$RELAY_RESOLVER:
                    if (!$9DZlA.ENABLE_RELAY_RESOLVERS) throw new Error('Relay Resolver fields are not yet supported.');
                    this._readResolverField(selection, record, data);
                    break;
                case $20948d4be68ff656$var$FRAGMENT_SPREAD:
                    this._createFragmentPointer(selection, record, data);
                    break;
                case $20948d4be68ff656$var$ALIASED_FRAGMENT_SPREAD:
                    data[selection.name] = this._createAliasedFragmentSpread(selection, record);
                    break;
                case $20948d4be68ff656$var$ALIASED_INLINE_FRAGMENT_SPREAD:
                    var fieldValue = this._readInlineFragment(selection.fragment, record, {});
                    if (fieldValue === false) fieldValue = null;
                    data[selection.name] = fieldValue;
                    break;
                case $20948d4be68ff656$var$MODULE_IMPORT:
                    this._readModuleImport(selection, record, data);
                    break;
                case $20948d4be68ff656$var$INLINE_DATA_FRAGMENT_SPREAD:
                    this._createInlineDataOrResolverFragmentPointer(selection, record, data);
                    break;
                case $20948d4be68ff656$var$DEFER:
                case $20948d4be68ff656$var$CLIENT_EXTENSION:
                    var isMissingData = this._isMissingData;
                    var alreadyMissingClientEdges = this._missingClientEdges.length;
                    this._clientEdgeTraversalPath.push(null);
                    var _hasExpectedData = this._traverseSelections(selection.selections, record, data);
                    this._isMissingData = isMissingData || this._missingClientEdges.length > alreadyMissingClientEdges || this._missingLiveResolverFields.length > 0;
                    this._clientEdgeTraversalPath.pop();
                    if (!_hasExpectedData) return false;
                    break;
                case $20948d4be68ff656$var$STREAM:
                    var _hasExpectedData2 = this._traverseSelections(selection.selections, record, data);
                    if (!_hasExpectedData2) return false;
                    break;
                case $20948d4be68ff656$var$ACTOR_CHANGE:
                    this._readActorChange(selection, record, data);
                    break;
                case $20948d4be68ff656$var$CLIENT_EDGE_TO_CLIENT_OBJECT:
                case $20948d4be68ff656$var$CLIENT_EDGE_TO_SERVER_OBJECT:
                    this._readClientEdge(selection, record, data);
                    break;
                default:
                    selection;
                    $bQThX(false);
            }
        }
        return true;
    };
    _proto._readClientSideDirectiveField = function _readClientSideDirectiveField(selection, record, data) {
        switch(selection.field.kind){
            case $20948d4be68ff656$var$SCALAR_FIELD:
                return this._readScalar(selection.field, record, data);
            case $20948d4be68ff656$var$LINKED_FIELD:
                if (selection.field.plural) return this._readPluralLink(selection.field, record, data);
                else return this._readLink(selection.field, record, data);
            case $20948d4be68ff656$var$RELAY_RESOLVER:
                if (!$9DZlA.ENABLE_RELAY_RESOLVERS) throw new Error('Relay Resolver fields are not yet supported.');
                return this._readResolverField(selection.field, record, data);
            case $20948d4be68ff656$var$RELAY_LIVE_RESOLVER:
                if (!$9DZlA.ENABLE_RELAY_RESOLVERS) throw new Error('Relay Resolver fields are not yet supported.');
                return this._readResolverField(selection.field, record, data);
            case $20948d4be68ff656$var$CLIENT_EDGE_TO_CLIENT_OBJECT:
            case $20948d4be68ff656$var$CLIENT_EDGE_TO_SERVER_OBJECT:
                if (!$9DZlA.ENABLE_RELAY_RESOLVERS) throw new Error('Relay Resolver fields are not yet supported.');
                return this._readClientEdge(selection.field, record, data);
            default:
                selection.field.kind;
                $bQThX(false);
        }
    };
    _proto._readResolverField = function _readResolverField(field, record, data) {
        var _field$alias2;
        var parentRecordID = $c4ZG3.getDataID(record);
        var result = this._readResolverFieldImpl(field, parentRecordID);
        var fieldName = (_field$alias2 = field.alias) !== null && _field$alias2 !== void 0 ? _field$alias2 : field.name;
        data[fieldName] = result;
        return result;
    };
    _proto._readResolverFieldImpl = function _readResolverFieldImpl(field, parentRecordID) {
        var _this = this;
        var fragment = field.fragment;
        var snapshot;
        var getDataForResolverFragment = function getDataForResolverFragment(singularReaderSelector) {
            if (snapshot != null) return {
                data: snapshot.data,
                isMissingData: snapshot.isMissingData
            };
            snapshot = $20948d4be68ff656$var$read(_this._recordSource, singularReaderSelector, _this._resolverCache);
            return {
                data: snapshot.data,
                isMissingData: snapshot.isMissingData
            };
        };
        var evaluate = function evaluate() {
            if (fragment != null) {
                var key = {
                    __id: parentRecordID,
                    __fragmentOwner: _this._owner,
                    __fragments: (0, $20948d4be68ff656$var$_defineProperty2["default"])({}, fragment.name, fragment.args ? $20948d4be68ff656$var$getArgumentValues(fragment.args, _this._variables) : {})
                };
                var resolverContext = {
                    getDataForResolverFragment: getDataForResolverFragment
                };
                return $20948d4be68ff656$var$withResolverContext(resolverContext, function() {
                    var _getResolverValue = $20948d4be68ff656$var$getResolverValue(field, _this._variables, key), resolverResult = _getResolverValue[0], resolverError = _getResolverValue[1];
                    return {
                        resolverResult: resolverResult,
                        snapshot: snapshot,
                        error: resolverError
                    };
                });
            } else {
                var _getResolverValue2 = $20948d4be68ff656$var$getResolverValue(field, _this._variables, null), resolverResult = _getResolverValue2[0], _resolverError = _getResolverValue2[1];
                return {
                    resolverResult: resolverResult,
                    snapshot: undefined,
                    error: _resolverError
                };
            }
        };
        var _this$_resolverCache$ = this._resolverCache.readFromCacheOrEvaluate(parentRecordID, field, this._variables, evaluate, getDataForResolverFragment), result = _this$_resolverCache$[0], seenRecord = _this$_resolverCache$[1], resolverError = _this$_resolverCache$[2], cachedSnapshot = _this$_resolverCache$[3], suspenseID = _this$_resolverCache$[4], updatedDataIDs = _this$_resolverCache$[5];
        this._propogateResolverMetadata(field.path, cachedSnapshot, resolverError, seenRecord, suspenseID, updatedDataIDs);
        return result;
    };
    _proto._propogateResolverMetadata = function _propogateResolverMetadata(fieldPath, cachedSnapshot, resolverError, seenRecord, suspenseID, updatedDataIDs) {
        if (cachedSnapshot != null) {
            if (cachedSnapshot.missingRequiredFields != null) this._addMissingRequiredFields(cachedSnapshot.missingRequiredFields);
            if (cachedSnapshot.missingClientEdges != null) {
                var _iterator2 = (0, $20948d4be68ff656$var$_createForOfIteratorHelper2["default"])(cachedSnapshot.missingClientEdges), _step2;
                try {
                    for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
                        var missing = _step2.value;
                        this._missingClientEdges.push(missing);
                    }
                } catch (err) {
                    _iterator2.e(err);
                } finally{
                    _iterator2.f();
                }
            }
            if (cachedSnapshot.missingLiveResolverFields != null) {
                this._isMissingData = this._isMissingData || cachedSnapshot.missingLiveResolverFields.length > 0;
                var _iterator3 = (0, $20948d4be68ff656$var$_createForOfIteratorHelper2["default"])(cachedSnapshot.missingLiveResolverFields), _step3;
                try {
                    for(_iterator3.s(); !(_step3 = _iterator3.n()).done;){
                        var missingResolverField = _step3.value;
                        this._missingLiveResolverFields.push(missingResolverField);
                    }
                } catch (err) {
                    _iterator3.e(err);
                } finally{
                    _iterator3.f();
                }
            }
            var _iterator4 = (0, $20948d4be68ff656$var$_createForOfIteratorHelper2["default"])(cachedSnapshot.relayResolverErrors), _step4;
            try {
                for(_iterator4.s(); !(_step4 = _iterator4.n()).done;){
                    var error = _step4.value;
                    this._resolverErrors.push(error);
                }
            } catch (err) {
                _iterator4.e(err);
            } finally{
                _iterator4.f();
            }
            this._isMissingData = this._isMissingData || cachedSnapshot.isMissingData;
        }
        if (resolverError) this._resolverErrors.push({
            field: {
                path: fieldPath,
                owner: this._fragmentName
            },
            error: resolverError
        });
        if (seenRecord != null) this._seenRecords.add(seenRecord);
        if (suspenseID != null) {
            this._isMissingData = true;
            this._missingLiveResolverFields.push({
                path: "".concat(this._fragmentName, ".").concat(fieldPath),
                liveStateID: suspenseID
            });
        }
        if (updatedDataIDs != null) {
            var _iterator5 = (0, $20948d4be68ff656$var$_createForOfIteratorHelper2["default"])(updatedDataIDs), _step5;
            try {
                for(_iterator5.s(); !(_step5 = _iterator5.n()).done;){
                    var recordID = _step5.value;
                    this._updatedDataIDs.add(recordID);
                }
            } catch (err) {
                _iterator5.e(err);
            } finally{
                _iterator5.f();
            }
        }
    };
    _proto._readClientEdge = function _readClientEdge(field, record, data) {
        var _this2 = this;
        var _backingField$alias;
        var backingField = field.backingField;
        !(backingField.kind !== 'ClientExtension') && $bQThX(false);
        var fieldName = (_backingField$alias = backingField.alias) !== null && _backingField$alias !== void 0 ? _backingField$alias : backingField.name;
        var backingFieldData = {};
        this._traverseSelections([
            backingField
        ], record, backingFieldData);
        var clientEdgeResolverResponse = backingFieldData[fieldName];
        if (clientEdgeResolverResponse == null || $20948d4be68ff656$var$isSuspenseSentinel(clientEdgeResolverResponse)) {
            data[fieldName] = clientEdgeResolverResponse;
            return clientEdgeResolverResponse;
        }
        if (field.linkedField.plural) {
            !Array.isArray(clientEdgeResolverResponse) && $bQThX(false);
            var storeIDs;
            !(field.kind === $20948d4be68ff656$var$CLIENT_EDGE_TO_CLIENT_OBJECT) && $bQThX(false);
            if (field.backingField.normalizationInfo == null) storeIDs = clientEdgeResolverResponse.map(function(itemResponse) {
                var _field$concreteType;
                var concreteType = (_field$concreteType = field.concreteType) !== null && _field$concreteType !== void 0 ? _field$concreteType : itemResponse.__typename;
                !(typeof concreteType === 'string') && $bQThX(false);
                var localId = $20948d4be68ff656$var$extractIdFromResponse(itemResponse);
                var id = _this2._resolverCache.ensureClientRecord(localId, concreteType);
                var modelResolvers = field.modelResolvers;
                if (modelResolvers != null) {
                    var modelResolver = modelResolvers[concreteType];
                    !(modelResolver !== undefined) && $bQThX(false);
                    var model = _this2._readResolverFieldImpl(modelResolver, id);
                    return model != null ? id : null;
                }
                return id;
            });
            else storeIDs = clientEdgeResolverResponse.map($20948d4be68ff656$var$extractIdFromResponse);
            this._clientEdgeTraversalPath.push(null);
            var edgeValues = this._readLinkedIds(field.linkedField, storeIDs, record, data);
            this._clientEdgeTraversalPath.pop();
            data[fieldName] = edgeValues;
            return edgeValues;
        } else {
            var _field$concreteType2;
            var id = $20948d4be68ff656$var$extractIdFromResponse(clientEdgeResolverResponse);
            var storeID;
            var concreteType = (_field$concreteType2 = field.concreteType) !== null && _field$concreteType2 !== void 0 ? _field$concreteType2 : clientEdgeResolverResponse.__typename;
            var traversalPathSegment;
            if (field.kind === $20948d4be68ff656$var$CLIENT_EDGE_TO_CLIENT_OBJECT) {
                if (field.backingField.normalizationInfo == null) {
                    !(typeof concreteType === 'string') && $bQThX(false);
                    storeID = this._resolverCache.ensureClientRecord(id, concreteType);
                    traversalPathSegment = null;
                } else {
                    storeID = id;
                    traversalPathSegment = null;
                }
            } else {
                storeID = id;
                traversalPathSegment = {
                    readerClientEdge: field,
                    clientEdgeDestinationID: id
                };
            }
            var modelResolvers = field.modelResolvers;
            if (modelResolvers != null) {
                !(typeof concreteType === 'string') && $bQThX(false);
                var modelResolver = modelResolvers[concreteType];
                !(modelResolver !== undefined) && $bQThX(false);
                var model = this._readResolverFieldImpl(modelResolver, storeID);
                if (model == null) {
                    data[fieldName] = null;
                    return null;
                }
            }
            this._clientEdgeTraversalPath.push(traversalPathSegment);
            var prevData = data[fieldName];
            !(prevData == null || typeof prevData === 'object') && $bQThX(false);
            var edgeValue = this._traverse(field.linkedField, storeID, prevData);
            this._clientEdgeTraversalPath.pop();
            data[fieldName] = edgeValue;
            return edgeValue;
        }
    };
    _proto._readScalar = function _readScalar(field, record, data) {
        var _field$alias3;
        var fieldName = (_field$alias3 = field.alias) !== null && _field$alias3 !== void 0 ? _field$alias3 : field.name;
        var storageKey = $20948d4be68ff656$var$getStorageKey(field, this._variables);
        var value = $c4ZG3.getValue(record, storageKey);
        if (value === null) this._maybeAddErrorResponseFields(record, storageKey);
        else if (value === undefined) this._markDataAsMissing();
        data[fieldName] = value;
        return value;
    };
    _proto._readLink = function _readLink(field, record, data) {
        var _field$alias4;
        var fieldName = (_field$alias4 = field.alias) !== null && _field$alias4 !== void 0 ? _field$alias4 : field.name;
        var storageKey = $20948d4be68ff656$var$getStorageKey(field, this._variables);
        var linkedID = $c4ZG3.getLinkedRecordID(record, storageKey);
        if (linkedID == null) {
            data[fieldName] = linkedID;
            if (linkedID === null) this._maybeAddErrorResponseFields(record, storageKey);
            else if (linkedID === undefined) this._markDataAsMissing();
            return linkedID;
        }
        var prevData = data[fieldName];
        !(prevData == null || typeof prevData === 'object') && $bQThX(false);
        var value = this._traverse(field, linkedID, prevData);
        data[fieldName] = value;
        return value;
    };
    _proto._readActorChange = function _readActorChange(field, record, data) {
        var _field$alias5;
        var fieldName = (_field$alias5 = field.alias) !== null && _field$alias5 !== void 0 ? _field$alias5 : field.name;
        var storageKey = $20948d4be68ff656$var$getStorageKey(field, this._variables);
        var externalRef = $c4ZG3.getActorLinkedRecordID(record, storageKey);
        if (externalRef == null) {
            data[fieldName] = externalRef;
            if (externalRef === undefined) this._markDataAsMissing();
            else if (externalRef === null) this._maybeAddErrorResponseFields(record, storageKey);
            return data[fieldName];
        }
        var actorIdentifier = externalRef[0], dataID = externalRef[1];
        var fragmentRef = {};
        this._createFragmentPointer(field.fragmentSpread, $c4ZG3.fromObject({
            __id: dataID
        }), fragmentRef);
        data[fieldName] = {
            __fragmentRef: fragmentRef,
            __viewer: actorIdentifier
        };
        return data[fieldName];
    };
    _proto._readPluralLink = function _readPluralLink(field, record, data) {
        var storageKey = $20948d4be68ff656$var$getStorageKey(field, this._variables);
        var linkedIDs = $c4ZG3.getLinkedRecordIDs(record, storageKey);
        if (linkedIDs === null) this._maybeAddErrorResponseFields(record, storageKey);
        return this._readLinkedIds(field, linkedIDs, record, data);
    };
    _proto._readLinkedIds = function _readLinkedIds(field, linkedIDs, record, data) {
        var _this3 = this;
        var _field$alias6;
        var fieldName = (_field$alias6 = field.alias) !== null && _field$alias6 !== void 0 ? _field$alias6 : field.name;
        if (linkedIDs == null) {
            data[fieldName] = linkedIDs;
            if (linkedIDs === undefined) this._markDataAsMissing();
            return linkedIDs;
        }
        var prevData = data[fieldName];
        !(prevData == null || Array.isArray(prevData)) && $bQThX(false);
        var linkedArray = prevData || [];
        linkedIDs.forEach(function(linkedID, nextIndex) {
            if (linkedID == null) {
                if (linkedID === undefined) _this3._markDataAsMissing();
                linkedArray[nextIndex] = linkedID;
                return;
            }
            var prevItem = linkedArray[nextIndex];
            !(prevItem == null || typeof prevItem === 'object') && $bQThX(false);
            linkedArray[nextIndex] = _this3._traverse(field, linkedID, prevItem);
        });
        data[fieldName] = linkedArray;
        return linkedArray;
    };
    _proto._readModuleImport = function _readModuleImport(moduleImport, record, data) {
        var componentKey = $20948d4be68ff656$var$getModuleComponentKey(moduleImport.documentName);
        var component = $c4ZG3.getValue(record, componentKey);
        if (component == null) {
            if (component === undefined) this._markDataAsMissing();
            return;
        }
        this._createFragmentPointer({
            kind: 'FragmentSpread',
            name: moduleImport.fragmentName,
            args: moduleImport.args
        }, record, data);
        data[$20948d4be68ff656$var$FRAGMENT_PROP_NAME_KEY] = moduleImport.fragmentPropName;
        data[$20948d4be68ff656$var$MODULE_COMPONENT_KEY] = component;
    };
    _proto._createAliasedFragmentSpread = function _createAliasedFragmentSpread(namedFragmentSpread, record) {
        var abstractKey = namedFragmentSpread.abstractKey;
        if (abstractKey == null) {
            var typeName = $c4ZG3.getType(record);
            if (typeName == null || typeName !== namedFragmentSpread.type) return null;
        } else {
            var implementsInterface = this._implementsInterface(record, abstractKey);
            if (implementsInterface === false) return null;
            else if (implementsInterface == null) {
                this._markDataAsMissing();
                return undefined;
            }
        }
        var fieldData = {};
        this._createFragmentPointer(namedFragmentSpread.fragment, record, fieldData);
        return $c4ZG3.fromObject(fieldData);
    };
    _proto._readInlineFragment = function _readInlineFragment(inlineFragment, record, data) {
        if (inlineFragment.type == null) {
            var hasExpectedData = this._traverseSelections(inlineFragment.selections, record, data);
            if (hasExpectedData === false) return false;
            return data;
        }
        var abstractKey = inlineFragment.abstractKey;
        if (abstractKey == null) {
            var typeName = $c4ZG3.getType(record);
            if (typeName == null || typeName !== inlineFragment.type) return null;
            else {
                var hasExpectedData = this._traverseSelections(inlineFragment.selections, record, data);
                if (!hasExpectedData) return false;
            }
        } else {
            var implementsInterface = this._implementsInterface(record, abstractKey);
            var parentIsMissingData = this._isMissingData;
            var parentIsWithinUnmatchedTypeRefinement = this._isWithinUnmatchedTypeRefinement;
            this._isWithinUnmatchedTypeRefinement = parentIsWithinUnmatchedTypeRefinement || implementsInterface === false;
            this._traverseSelections(inlineFragment.selections, record, data);
            this._isWithinUnmatchedTypeRefinement = parentIsWithinUnmatchedTypeRefinement;
            if (implementsInterface === false) {
                this._isMissingData = parentIsMissingData;
                return undefined;
            } else if (implementsInterface == null) {
                this._markDataAsMissing();
                return null;
            }
        }
        return data;
    };
    _proto._createFragmentPointer = function _createFragmentPointer(fragmentSpread, record, data) {
        var fragmentPointers = data[$20948d4be68ff656$var$FRAGMENTS_KEY];
        if (fragmentPointers == null) fragmentPointers = data[$20948d4be68ff656$var$FRAGMENTS_KEY] = {};
        !(typeof fragmentPointers === 'object' && fragmentPointers != null) && $bQThX(false);
        if (data[$20948d4be68ff656$var$ID_KEY] == null) data[$20948d4be68ff656$var$ID_KEY] = $c4ZG3.getDataID(record);
        fragmentPointers[fragmentSpread.name] = $20948d4be68ff656$var$getArgumentValues(fragmentSpread.args, this._variables, this._isWithinUnmatchedTypeRefinement);
        data[$20948d4be68ff656$var$FRAGMENT_OWNER_KEY] = this._owner;
        if (this._clientEdgeTraversalPath.length > 0 && this._clientEdgeTraversalPath[this._clientEdgeTraversalPath.length - 1] !== null) data[$20948d4be68ff656$var$CLIENT_EDGE_TRAVERSAL_PATH] = (0, $20948d4be68ff656$var$_toConsumableArray2["default"])(this._clientEdgeTraversalPath);
    };
    _proto._createInlineDataOrResolverFragmentPointer = function _createInlineDataOrResolverFragmentPointer(fragmentSpreadOrFragment, record, data) {
        var fragmentPointers = data[$20948d4be68ff656$var$FRAGMENTS_KEY];
        if (fragmentPointers == null) fragmentPointers = data[$20948d4be68ff656$var$FRAGMENTS_KEY] = {};
        !(typeof fragmentPointers === 'object' && fragmentPointers != null) && $bQThX(false);
        if (data[$20948d4be68ff656$var$ID_KEY] == null) data[$20948d4be68ff656$var$ID_KEY] = $c4ZG3.getDataID(record);
        var inlineData = {};
        var parentFragmentName = this._fragmentName;
        this._fragmentName = fragmentSpreadOrFragment.name;
        var parentVariables = this._variables;
        var argumentVariables = fragmentSpreadOrFragment.args ? $20948d4be68ff656$var$getArgumentValues(fragmentSpreadOrFragment.args, this._variables) : {};
        this._variables = $kpcDM.getFragmentVariables(fragmentSpreadOrFragment, this._owner.variables, argumentVariables);
        this._traverseSelections(fragmentSpreadOrFragment.selections, record, inlineData);
        this._variables = parentVariables;
        this._fragmentName = parentFragmentName;
        fragmentPointers[fragmentSpreadOrFragment.name] = inlineData;
    };
    _proto._addMissingRequiredFields = function _addMissingRequiredFields(additional) {
        if (this._missingRequiredFields == null) {
            this._missingRequiredFields = additional;
            return;
        }
        if (this._missingRequiredFields.action === 'THROW') return;
        if (additional.action === 'THROW') {
            this._missingRequiredFields = additional;
            return;
        }
        this._missingRequiredFields = {
            action: 'LOG',
            fields: [].concat((0, $20948d4be68ff656$var$_toConsumableArray2["default"])(this._missingRequiredFields.fields), (0, $20948d4be68ff656$var$_toConsumableArray2["default"])(additional.fields))
        };
    };
    _proto._implementsInterface = function _implementsInterface(record, abstractKey) {
        var typeName = $c4ZG3.getType(record);
        var typeRecord = this._recordSource.get($20948d4be68ff656$var$generateTypeID(typeName));
        var implementsInterface = typeRecord != null ? $c4ZG3.getValue(typeRecord, abstractKey) : null;
        return implementsInterface;
    };
    return RelayReader;
}();
function $20948d4be68ff656$var$getResolverValue(field, variables, fragmentKey) {
    var resolverFunction = typeof field.resolverModule === 'function' ? field.resolverModule : field.resolverModule["default"];
    var resolverResult = null;
    var resolverError = null;
    try {
        var resolverFunctionArgs = [];
        if (field.fragment != null) resolverFunctionArgs.push(fragmentKey);
        var args = field.args ? $20948d4be68ff656$var$getArgumentValues(field.args, variables) : undefined;
        resolverFunctionArgs.push(args);
        resolverResult = resolverFunction.apply(null, resolverFunctionArgs);
    } catch (e) {
        if (e === $20948d4be68ff656$var$RESOLVER_FRAGMENT_MISSING_DATA_SENTINEL) resolverResult = undefined;
        else resolverError = e;
    }
    return [
        resolverResult,
        resolverError
    ];
}
function $20948d4be68ff656$var$extractIdFromResponse(individualResponse) {
    if (typeof individualResponse === 'string') return individualResponse;
    else if (typeof individualResponse === 'object' && individualResponse != null && typeof individualResponse.id === 'string') return individualResponse.id;
    $bQThX(false);
}
module.exports = {
    read: $20948d4be68ff656$var$read
};

});
parcelRegister("fj00V", function(module, exports) {
'use strict';

var $7dvyf = parcelRequire("7dvyf");
var $b248a426b82f695d$var$_interopRequireDefault = $7dvyf.default;

var $b248a426b82f695d$var$_createForOfIteratorHelper2 = $b248a426b82f695d$var$_interopRequireDefault((parcelRequire("bTRzt")));

var $hrF5e = parcelRequire("hrF5e");

var $9lZfN = parcelRequire("9lZfN");
var $b248a426b82f695d$var$RELAY_LIVE_RESOLVER = $9lZfN.RELAY_LIVE_RESOLVER;

var $9DZlA = parcelRequire("9DZlA");

var $bAYfv = parcelRequire("bAYfv");

var $70q7x = parcelRequire("70q7x");
var $b248a426b82f695d$var$generateClientID = $70q7x.generateClientID;

var $c4ZG3 = parcelRequire("c4ZG3");

var $a6k4O = parcelRequire("a6k4O");
var $b248a426b82f695d$var$RELAY_RESOLVER_ERROR_KEY = $a6k4O.RELAY_RESOLVER_ERROR_KEY, $b248a426b82f695d$var$RELAY_RESOLVER_INVALIDATION_KEY = $a6k4O.RELAY_RESOLVER_INVALIDATION_KEY, $b248a426b82f695d$var$RELAY_RESOLVER_SNAPSHOT_KEY = $a6k4O.RELAY_RESOLVER_SNAPSHOT_KEY, $b248a426b82f695d$var$RELAY_RESOLVER_VALUE_KEY = $a6k4O.RELAY_RESOLVER_VALUE_KEY, $b248a426b82f695d$var$getStorageKey = $a6k4O.getStorageKey;

var $bQThX = parcelRequire("bQThX");
parcelRequire("hzw7m");
var $b248a426b82f695d$var$emptySet = new Set();
var $b248a426b82f695d$var$NoopResolverCache = /*#__PURE__*/ function() {
    function NoopResolverCache() {}
    var _proto = NoopResolverCache.prototype;
    _proto.readFromCacheOrEvaluate = function readFromCacheOrEvaluate(recordID, field, variables, evaluate, getDataForResolverFragment) {
        !(field.kind !== $b248a426b82f695d$var$RELAY_LIVE_RESOLVER) && $bQThX(false);
        var _evaluate = evaluate(), resolverResult = _evaluate.resolverResult, snapshot = _evaluate.snapshot, error = _evaluate.error;
        return [
            resolverResult,
            undefined,
            error,
            snapshot,
            undefined,
            undefined
        ];
    };
    _proto.invalidateDataIDs = function invalidateDataIDs(updatedDataIDs) {};
    _proto.ensureClientRecord = function ensureClientRecord(id, typeName) {
        $bQThX(false);
    };
    _proto.notifyUpdatedSubscribers = function notifyUpdatedSubscribers(updatedDataIDs) {};
    return NoopResolverCache;
}();
function $b248a426b82f695d$var$addDependencyEdge(edges, from, to) {
    var set = edges.get(from);
    if (!set) {
        set = new Set();
        edges.set(from, set);
    }
    set.add(to);
}
var $b248a426b82f695d$var$RecordResolverCache = /*#__PURE__*/ function() {
    function RecordResolverCache(getRecordSource) {
        this._resolverIDToRecordIDs = new Map();
        this._recordIDToResolverIDs = new Map();
        this._getRecordSource = getRecordSource;
    }
    var _proto2 = RecordResolverCache.prototype;
    _proto2.readFromCacheOrEvaluate = function readFromCacheOrEvaluate(recordID, field, variables, evaluate, getDataForResolverFragment) {
        var recordSource = this._getRecordSource();
        var record = recordSource.get(recordID);
        !(record != null) && $bQThX(false);
        var storageKey = $b248a426b82f695d$var$getStorageKey(field, variables);
        var linkedID = $c4ZG3.getLinkedRecordID(record, storageKey);
        var linkedRecord = linkedID == null ? null : recordSource.get(linkedID);
        if (linkedRecord == null || this._isInvalid(linkedRecord, getDataForResolverFragment)) {
            var _linkedID;
            linkedID = (_linkedID = linkedID) !== null && _linkedID !== void 0 ? _linkedID : $b248a426b82f695d$var$generateClientID(recordID, storageKey);
            linkedRecord = $c4ZG3.create(linkedID, '__RELAY_RESOLVER__');
            var evaluationResult = evaluate();
            $bAYfv(evaluationResult.resolverResult);
            $c4ZG3.setValue(linkedRecord, $b248a426b82f695d$var$RELAY_RESOLVER_VALUE_KEY, evaluationResult.resolverResult);
            $c4ZG3.setValue(linkedRecord, $b248a426b82f695d$var$RELAY_RESOLVER_SNAPSHOT_KEY, evaluationResult.snapshot);
            $c4ZG3.setValue(linkedRecord, $b248a426b82f695d$var$RELAY_RESOLVER_ERROR_KEY, evaluationResult.error);
            recordSource.set(linkedID, linkedRecord);
            var currentRecord = recordSource.get(recordID);
            !(currentRecord != null) && $bQThX(false);
            var nextRecord = $c4ZG3.clone(currentRecord);
            $c4ZG3.setLinkedRecordID(nextRecord, storageKey, linkedID);
            recordSource.set(recordID, nextRecord);
            if (field.fragment != null) {
                var _evaluationResult$sna;
                var fragmentStorageKey = $b248a426b82f695d$var$getStorageKey(field.fragment, variables);
                var resolverID = $b248a426b82f695d$var$generateClientID(recordID, fragmentStorageKey);
                $b248a426b82f695d$var$addDependencyEdge(this._resolverIDToRecordIDs, resolverID, linkedID);
                $b248a426b82f695d$var$addDependencyEdge(this._recordIDToResolverIDs, recordID, resolverID);
                var seenRecordIds = (_evaluationResult$sna = evaluationResult.snapshot) === null || _evaluationResult$sna === void 0 ? void 0 : _evaluationResult$sna.seenRecords;
                if (seenRecordIds != null) {
                    var _iterator = (0, $b248a426b82f695d$var$_createForOfIteratorHelper2["default"])(seenRecordIds), _step;
                    try {
                        for(_iterator.s(); !(_step = _iterator.n()).done;){
                            var seenRecordID = _step.value;
                            $b248a426b82f695d$var$addDependencyEdge(this._recordIDToResolverIDs, seenRecordID, resolverID);
                        }
                    } catch (err) {
                        _iterator.e(err);
                    } finally{
                        _iterator.f();
                    }
                }
            }
        }
        var answer = $c4ZG3.getValue(linkedRecord, $b248a426b82f695d$var$RELAY_RESOLVER_VALUE_KEY);
        var snapshot = $c4ZG3.getValue(linkedRecord, $b248a426b82f695d$var$RELAY_RESOLVER_SNAPSHOT_KEY);
        var error = $c4ZG3.getValue(linkedRecord, $b248a426b82f695d$var$RELAY_RESOLVER_ERROR_KEY);
        return [
            answer,
            linkedID,
            error,
            snapshot,
            undefined,
            undefined
        ];
    };
    _proto2.invalidateDataIDs = function invalidateDataIDs(updatedDataIDs) {
        var recordSource = this._getRecordSource();
        var visited = new Set();
        var recordsToVisit = Array.from(updatedDataIDs);
        while(recordsToVisit.length){
            var recordID = recordsToVisit.pop();
            updatedDataIDs.add(recordID);
            var _iterator2 = (0, $b248a426b82f695d$var$_createForOfIteratorHelper2["default"])((_this$_recordIDToReso = this._recordIDToResolverIDs.get(recordID)) !== null && _this$_recordIDToReso !== void 0 ? _this$_recordIDToReso : $b248a426b82f695d$var$emptySet), _step2;
            try {
                for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
                    var _this$_recordIDToReso;
                    var fragment = _step2.value;
                    if (!visited.has(fragment)) {
                        var _iterator3 = (0, $b248a426b82f695d$var$_createForOfIteratorHelper2["default"])((_this$_resolverIDToRe = this._resolverIDToRecordIDs.get(fragment)) !== null && _this$_resolverIDToRe !== void 0 ? _this$_resolverIDToRe : $b248a426b82f695d$var$emptySet), _step3;
                        try {
                            for(_iterator3.s(); !(_step3 = _iterator3.n()).done;){
                                var _this$_resolverIDToRe;
                                var anotherRecordID = _step3.value;
                                this._markInvalidatedResolverRecord(anotherRecordID, recordSource, updatedDataIDs);
                                if (!visited.has(anotherRecordID)) recordsToVisit.push(anotherRecordID);
                            }
                        } catch (err) {
                            _iterator3.e(err);
                        } finally{
                            _iterator3.f();
                        }
                    }
                }
            } catch (err) {
                _iterator2.e(err);
            } finally{
                _iterator2.f();
            }
        }
    };
    _proto2._markInvalidatedResolverRecord = function _markInvalidatedResolverRecord(dataID, recordSource, updatedDataIDs) {
        var record = recordSource.get(dataID);
        if (!record) return;
        var nextRecord = $c4ZG3.clone(record);
        $c4ZG3.setValue(nextRecord, $b248a426b82f695d$var$RELAY_RESOLVER_INVALIDATION_KEY, true);
        recordSource.set(dataID, nextRecord);
    };
    _proto2._isInvalid = function _isInvalid(record, getDataForResolverFragment) {
        if (!$c4ZG3.getValue(record, $b248a426b82f695d$var$RELAY_RESOLVER_INVALIDATION_KEY)) return false;
        var snapshot = $c4ZG3.getValue(record, $b248a426b82f695d$var$RELAY_RESOLVER_SNAPSHOT_KEY);
        var originalInputs = snapshot === null || snapshot === void 0 ? void 0 : snapshot.data;
        var readerSelector = snapshot === null || snapshot === void 0 ? void 0 : snapshot.selector;
        if (originalInputs == null || readerSelector == null) return true;
        var _getDataForResolverFr = getDataForResolverFragment(readerSelector), latestValues = _getDataForResolverFr.data;
        var recycled = $hrF5e(originalInputs, latestValues);
        if (recycled !== originalInputs) return true;
        if ($9DZlA.MARK_RESOLVER_VALUES_AS_CLEAN_AFTER_FRAGMENT_REREAD) {
            var nextRecord = $c4ZG3.clone(record);
            $c4ZG3.setValue(nextRecord, $b248a426b82f695d$var$RELAY_RESOLVER_INVALIDATION_KEY, false);
            var recordSource = this._getRecordSource();
            recordSource.set($c4ZG3.getDataID(record), nextRecord);
        }
        return false;
    };
    _proto2.ensureClientRecord = function ensureClientRecord(id, typename) {
        $bQThX(false);
    };
    _proto2.notifyUpdatedSubscribers = function notifyUpdatedSubscribers(updatedDataIDs) {
        $bQThX(false);
    };
    return RecordResolverCache;
}();
module.exports = {
    NoopResolverCache: $b248a426b82f695d$var$NoopResolverCache,
    RecordResolverCache: $b248a426b82f695d$var$RecordResolverCache
};

});
parcelRegister("bAYfv", function(module, exports) {
'use strict';
module.exports = function shallowFreeze(value) {
    if (typeof value === 'object' && value != null && (Array.isArray(value) || value.constructor === Object)) Object.freeze(value);
};

});


parcelRegister("b7drZ", function(module, exports) {
'use strict';

var $8AEJo = parcelRequire("8AEJo");
var $817ac81d73778f2f$var$getFragment = $8AEJo.getFragment;

var $3o9ph = parcelRequire("3o9ph");
var $817ac81d73778f2f$var$getSelector = $3o9ph.getSelector;

var $bQThX = parcelRequire("bQThX");
var $817ac81d73778f2f$var$contextStack = [];
function $817ac81d73778f2f$var$withResolverContext(context, cb) {
    $817ac81d73778f2f$var$contextStack.push(context);
    try {
        return cb();
    } finally{
        $817ac81d73778f2f$var$contextStack.pop();
    }
}
function $817ac81d73778f2f$var$readFragment(fragmentInput, fragmentKey) {
    if (!$817ac81d73778f2f$var$contextStack.length) throw new Error('readFragment should be called only from within a Relay Resolver function.');
    var context = $817ac81d73778f2f$var$contextStack[$817ac81d73778f2f$var$contextStack.length - 1];
    var fragmentNode = $817ac81d73778f2f$var$getFragment(fragmentInput);
    var fragmentSelector = $817ac81d73778f2f$var$getSelector(fragmentNode, fragmentKey);
    !(fragmentSelector != null) && $bQThX(false);
    !(fragmentSelector.kind === 'SingularReaderSelector') && $bQThX(false);
    var _context$getDataForRe = context.getDataForResolverFragment(fragmentSelector, fragmentKey), data = _context$getDataForRe.data, isMissingData = _context$getDataForRe.isMissingData;
    if (isMissingData) throw $817ac81d73778f2f$var$RESOLVER_FRAGMENT_MISSING_DATA_SENTINEL;
    return data;
}
var $817ac81d73778f2f$var$RESOLVER_FRAGMENT_MISSING_DATA_SENTINEL = {};
module.exports = {
    readFragment: $817ac81d73778f2f$var$readFragment,
    withResolverContext: $817ac81d73778f2f$var$withResolverContext,
    RESOLVER_FRAGMENT_MISSING_DATA_SENTINEL: $817ac81d73778f2f$var$RESOLVER_FRAGMENT_MISSING_DATA_SENTINEL
};

});




parcelRegister("gJ2QW", function(module, exports) {
'use strict';

var $7dvyf = parcelRequire("7dvyf");
var $c2d30fd2010d65c4$var$_interopRequireDefault = $7dvyf.default;

var $c2d30fd2010d65c4$var$_createForOfIteratorHelper2 = $c2d30fd2010d65c4$var$_interopRequireDefault((parcelRequire("bTRzt")));

var $c2d30fd2010d65c4$var$_defineProperty2 = $c2d30fd2010d65c4$var$_interopRequireDefault((parcelRequire("dW6Ee")));

var $bd1WG = parcelRequire("bd1WG");
var $c2d30fd2010d65c4$var$INTERNAL_ACTOR_IDENTIFIER_DO_NOT_USE = $bd1WG.INTERNAL_ACTOR_IDENTIFIER_DO_NOT_USE, $c2d30fd2010d65c4$var$assertInternalActorIdentifier = $bd1WG.assertInternalActorIdentifier;
parcelRequire("8YAvI");

var $9DZlA = parcelRequire("9DZlA");

var $8yHCQ = parcelRequire("8yHCQ");

var $5wm2f = parcelRequire("5wm2f");

var $eGOdg = parcelRequire("eGOdg");

var $c4ZG3 = parcelRequire("c4ZG3");

var $hprpJ = parcelRequire("hprpJ");

var $2Nqi8 = parcelRequire("2Nqi8");

var $b7ANd = parcelRequire("b7ANd");

var $7sSWY = parcelRequire("7sSWY");

var $a6k4O = parcelRequire("a6k4O");

var $a6k4O = parcelRequire("a6k4O");
var $c2d30fd2010d65c4$var$ROOT_ID = $a6k4O.ROOT_ID, $c2d30fd2010d65c4$var$ROOT_TYPE = $a6k4O.ROOT_TYPE;

var $fj00V = parcelRequire("fj00V");
var $c2d30fd2010d65c4$var$RecordResolverCache = $fj00V.RecordResolverCache;

var $bQThX = parcelRequire("bQThX");
var $c2d30fd2010d65c4$var$DEFAULT_RELEASE_BUFFER_SIZE = 10;
var $c2d30fd2010d65c4$var$RelayModernStore = /*#__PURE__*/ function() {
    function RelayModernStore(source, options) {
        var _this = this;
        var _options$gcReleaseBuf, _options$gcScheduler, _options$getDataID, _options$log, _options$operationLoa;
        (0, $c2d30fd2010d65c4$var$_defineProperty2["default"])(this, "_gcStep", function() {
            if (_this._gcRun) {
                if (_this._gcRun.next().done) _this._gcRun = null;
                else _this._gcScheduler(_this._gcStep);
            }
        });
        var storeIDs, ii, record;
        this._currentWriteEpoch = 0;
        this._gcHoldCounter = 0;
        this._gcReleaseBufferSize = (_options$gcReleaseBuf = options === null || options === void 0 ? void 0 : options.gcReleaseBufferSize) !== null && _options$gcReleaseBuf !== void 0 ? _options$gcReleaseBuf : $c2d30fd2010d65c4$var$DEFAULT_RELEASE_BUFFER_SIZE;
        this._gcRun = null;
        this._gcScheduler = (_options$gcScheduler = options === null || options === void 0 ? void 0 : options.gcScheduler) !== null && _options$gcScheduler !== void 0 ? _options$gcScheduler : $8yHCQ;
        this._getDataID = (_options$getDataID = options === null || options === void 0 ? void 0 : options.getDataID) !== null && _options$getDataID !== void 0 ? _options$getDataID : $eGOdg;
        this._globalInvalidationEpoch = null;
        this._invalidationSubscriptions = new Set();
        this._invalidatedRecordIDs = new Set();
        this.__log = (_options$log = options === null || options === void 0 ? void 0 : options.log) !== null && _options$log !== void 0 ? _options$log : null;
        this._queryCacheExpirationTime = options === null || options === void 0 ? void 0 : options.queryCacheExpirationTime;
        this._operationLoader = (_options$operationLoa = options === null || options === void 0 ? void 0 : options.operationLoader) !== null && _options$operationLoa !== void 0 ? _options$operationLoa : null;
        this._optimisticSource = null;
        this._recordSource = source;
        this._releaseBuffer = [];
        this._roots = new Map();
        this._shouldScheduleGC = false;
        this._resolverCache = new $c2d30fd2010d65c4$var$RecordResolverCache(function() {
            return _this._getMutableRecordSource();
        });
        this._storeSubscriptions = new $7sSWY(options === null || options === void 0 ? void 0 : options.log, this._resolverCache);
        this._updatedRecordIDs = new Set();
        this._shouldProcessClientComponents = options === null || options === void 0 ? void 0 : options.shouldProcessClientComponents;
        $c2d30fd2010d65c4$var$initializeRecordSource(this._recordSource);
    }
    var _proto = RelayModernStore.prototype;
    _proto.getSource = function getSource() {
        var _this$_optimisticSour;
        return (_this$_optimisticSour = this._optimisticSource) !== null && _this$_optimisticSour !== void 0 ? _this$_optimisticSour : this._recordSource;
    };
    _proto._getMutableRecordSource = function _getMutableRecordSource() {
        var _this$_optimisticSour2;
        return (_this$_optimisticSour2 = this._optimisticSource) !== null && _this$_optimisticSour2 !== void 0 ? _this$_optimisticSour2 : this._recordSource;
    };
    _proto.check = function check(operation, options) {
        var _options$handlers, _options$getSourceFor, _options$getTargetFor, _options$defaultActor;
        var selector = operation.root;
        var source = this._getMutableRecordSource();
        var globalInvalidationEpoch = this._globalInvalidationEpoch;
        var rootEntry = this._roots.get(operation.request.identifier);
        var operationLastWrittenAt = rootEntry != null ? rootEntry.epoch : null;
        if (globalInvalidationEpoch != null) {
            if (operationLastWrittenAt == null || operationLastWrittenAt <= globalInvalidationEpoch) return {
                status: 'stale'
            };
        }
        var handlers = (_options$handlers = options === null || options === void 0 ? void 0 : options.handlers) !== null && _options$handlers !== void 0 ? _options$handlers : [];
        var getSourceForActor = (_options$getSourceFor = options === null || options === void 0 ? void 0 : options.getSourceForActor) !== null && _options$getSourceFor !== void 0 ? _options$getSourceFor : function(actorIdentifier) {
            $c2d30fd2010d65c4$var$assertInternalActorIdentifier(actorIdentifier);
            return source;
        };
        var getTargetForActor = (_options$getTargetFor = options === null || options === void 0 ? void 0 : options.getTargetForActor) !== null && _options$getTargetFor !== void 0 ? _options$getTargetFor : function(actorIdentifier) {
            $c2d30fd2010d65c4$var$assertInternalActorIdentifier(actorIdentifier);
            return source;
        };
        var operationAvailability = $5wm2f.check(getSourceForActor, getTargetForActor, (_options$defaultActor = options === null || options === void 0 ? void 0 : options.defaultActorIdentifier) !== null && _options$defaultActor !== void 0 ? _options$defaultActor : $c2d30fd2010d65c4$var$INTERNAL_ACTOR_IDENTIFIER_DO_NOT_USE, selector, handlers, this._operationLoader, this._getDataID, this._shouldProcessClientComponents);
        return $c2d30fd2010d65c4$var$getAvailabilityStatus(operationAvailability, operationLastWrittenAt, rootEntry === null || rootEntry === void 0 ? void 0 : rootEntry.fetchTime, this._queryCacheExpirationTime);
    };
    _proto.retain = function retain(operation) {
        var _this2 = this;
        var id = operation.request.identifier;
        var disposed = false;
        var dispose = function dispose() {
            if (disposed) return;
            disposed = true;
            var rootEntry = _this2._roots.get(id);
            if (rootEntry == null) return;
            rootEntry.refCount--;
            if (rootEntry.refCount === 0) {
                var _queryCacheExpirationTime = _this2._queryCacheExpirationTime;
                var rootEntryIsStale = rootEntry.fetchTime != null && _queryCacheExpirationTime != null && rootEntry.fetchTime <= Date.now() - _queryCacheExpirationTime;
                if (rootEntryIsStale) {
                    _this2._roots["delete"](id);
                    _this2.scheduleGC();
                } else {
                    _this2._releaseBuffer.push(id);
                    if (_this2._releaseBuffer.length > _this2._gcReleaseBufferSize) {
                        var _id = _this2._releaseBuffer.shift();
                        _this2._roots["delete"](_id);
                        _this2.scheduleGC();
                    }
                }
            }
        };
        var rootEntry = this._roots.get(id);
        if (rootEntry != null) {
            if (rootEntry.refCount === 0) this._releaseBuffer = this._releaseBuffer.filter(function(_id) {
                return _id !== id;
            });
            rootEntry.refCount += 1;
        } else this._roots.set(id, {
            operation: operation,
            refCount: 1,
            epoch: null,
            fetchTime: null
        });
        return {
            dispose: dispose
        };
    };
    _proto.lookup = function lookup(selector) {
        var source = this.getSource();
        var snapshot = $2Nqi8.read(source, selector, this._resolverCache);
        return snapshot;
    };
    _proto.notify = function notify(sourceOperation, invalidateStore) {
        var _this3 = this;
        var log = this.__log;
        if (log != null) log({
            name: 'store.notify.start',
            sourceOperation: sourceOperation
        });
        this._currentWriteEpoch++;
        if (invalidateStore === true) this._globalInvalidationEpoch = this._currentWriteEpoch;
        if ($9DZlA.ENABLE_RELAY_RESOLVERS) this._resolverCache.invalidateDataIDs(this._updatedRecordIDs);
        var source = this.getSource();
        var updatedOwners = [];
        this._storeSubscriptions.updateSubscriptions(source, this._updatedRecordIDs, updatedOwners, sourceOperation);
        this._invalidationSubscriptions.forEach(function(subscription) {
            _this3._updateInvalidationSubscription(subscription, invalidateStore === true);
        });
        if (log != null) log({
            name: 'store.notify.complete',
            sourceOperation: sourceOperation,
            updatedRecordIDs: this._updatedRecordIDs,
            invalidatedRecordIDs: this._invalidatedRecordIDs
        });
        this._updatedRecordIDs.clear();
        this._invalidatedRecordIDs.clear();
        if (sourceOperation != null) {
            var id = sourceOperation.request.identifier;
            var rootEntry = this._roots.get(id);
            if (rootEntry != null) {
                rootEntry.epoch = this._currentWriteEpoch;
                rootEntry.fetchTime = Date.now();
            } else if (sourceOperation.request.node.params.operationKind === 'query' && this._gcReleaseBufferSize > 0 && this._releaseBuffer.length < this._gcReleaseBufferSize) {
                var temporaryRootEntry = {
                    operation: sourceOperation,
                    refCount: 0,
                    epoch: this._currentWriteEpoch,
                    fetchTime: Date.now()
                };
                this._releaseBuffer.push(id);
                this._roots.set(id, temporaryRootEntry);
            }
        }
        return updatedOwners;
    };
    _proto.publish = function publish(source, idsMarkedForInvalidation) {
        var target = this._getMutableRecordSource();
        $c2d30fd2010d65c4$var$updateTargetFromSource(target, source, this._currentWriteEpoch + 1, idsMarkedForInvalidation, this._updatedRecordIDs, this._invalidatedRecordIDs);
        var log = this.__log;
        if (log != null) log({
            name: 'store.publish',
            source: source,
            optimistic: target === this._optimisticSource
        });
    };
    _proto.subscribe = function subscribe(snapshot, callback) {
        return this._storeSubscriptions.subscribe(snapshot, callback);
    };
    _proto.holdGC = function holdGC() {
        var _this4 = this;
        if (this._gcRun) {
            this._gcRun = null;
            this._shouldScheduleGC = true;
        }
        this._gcHoldCounter++;
        var dispose = function dispose() {
            if (_this4._gcHoldCounter > 0) {
                _this4._gcHoldCounter--;
                if (_this4._gcHoldCounter === 0 && _this4._shouldScheduleGC) {
                    _this4.scheduleGC();
                    _this4._shouldScheduleGC = false;
                }
            }
        };
        return {
            dispose: dispose
        };
    };
    _proto.toJSON = function toJSON() {
        return 'RelayModernStore()';
    };
    _proto.getEpoch = function getEpoch() {
        return this._currentWriteEpoch;
    };
    _proto.__getUpdatedRecordIDs = function __getUpdatedRecordIDs() {
        return this._updatedRecordIDs;
    };
    _proto.lookupInvalidationState = function lookupInvalidationState(dataIDs) {
        var _this5 = this;
        var invalidations = new Map();
        dataIDs.forEach(function(dataID) {
            var _RelayModernRecord$ge;
            var record = _this5.getSource().get(dataID);
            invalidations.set(dataID, (_RelayModernRecord$ge = $c4ZG3.getInvalidationEpoch(record)) !== null && _RelayModernRecord$ge !== void 0 ? _RelayModernRecord$ge : null);
        });
        invalidations.set('global', this._globalInvalidationEpoch);
        return {
            dataIDs: dataIDs,
            invalidations: invalidations
        };
    };
    _proto.checkInvalidationState = function checkInvalidationState(prevInvalidationState) {
        var latestInvalidationState = this.lookupInvalidationState(prevInvalidationState.dataIDs);
        var currentInvalidations = latestInvalidationState.invalidations;
        var prevInvalidations = prevInvalidationState.invalidations;
        if (currentInvalidations.get('global') !== prevInvalidations.get('global')) return true;
        var _iterator = (0, $c2d30fd2010d65c4$var$_createForOfIteratorHelper2["default"])(prevInvalidationState.dataIDs), _step;
        try {
            for(_iterator.s(); !(_step = _iterator.n()).done;){
                var dataID = _step.value;
                if (currentInvalidations.get(dataID) !== prevInvalidations.get(dataID)) return true;
            }
        } catch (err) {
            _iterator.e(err);
        } finally{
            _iterator.f();
        }
        return false;
    };
    _proto.subscribeToInvalidationState = function subscribeToInvalidationState(invalidationState, callback) {
        var _this6 = this;
        var subscription = {
            callback: callback,
            invalidationState: invalidationState
        };
        var dispose = function dispose() {
            _this6._invalidationSubscriptions["delete"](subscription);
        };
        this._invalidationSubscriptions.add(subscription);
        return {
            dispose: dispose
        };
    };
    _proto._updateInvalidationSubscription = function _updateInvalidationSubscription(subscription, invalidatedStore) {
        var _this7 = this;
        var callback = subscription.callback, invalidationState = subscription.invalidationState;
        var dataIDs = invalidationState.dataIDs;
        var isSubscribedToInvalidatedIDs = invalidatedStore || dataIDs.some(function(dataID) {
            return _this7._invalidatedRecordIDs.has(dataID);
        });
        if (!isSubscribedToInvalidatedIDs) return;
        callback();
    };
    _proto.snapshot = function snapshot() {
        !(this._optimisticSource == null) && $bQThX(false);
        var log = this.__log;
        if (log != null) log({
            name: 'store.snapshot'
        });
        this._storeSubscriptions.snapshotSubscriptions(this.getSource());
        if (this._gcRun) {
            this._gcRun = null;
            this._shouldScheduleGC = true;
        }
        this._optimisticSource = $hprpJ.create(this.getSource());
    };
    _proto.restore = function restore() {
        !(this._optimisticSource != null) && $bQThX(false);
        var log = this.__log;
        if (log != null) log({
            name: 'store.restore'
        });
        this._optimisticSource = null;
        if (this._shouldScheduleGC) this.scheduleGC();
        this._storeSubscriptions.restoreSubscriptions();
    };
    _proto.scheduleGC = function scheduleGC() {
        if (this._gcHoldCounter > 0) {
            this._shouldScheduleGC = true;
            return;
        }
        if (this._gcRun) return;
        this._gcRun = this._collect();
        this._gcScheduler(this._gcStep);
    };
    _proto.__gc = function __gc() {
        if (this._optimisticSource != null) return;
        var gcRun = this._collect();
        while(!gcRun.next().done);
    };
    _proto._collect = function* _collect() {
        top: while(true){
            var startEpoch = this._currentWriteEpoch;
            var references = new Set();
            var _iterator2 = (0, $c2d30fd2010d65c4$var$_createForOfIteratorHelper2["default"])(this._roots.values()), _step2;
            try {
                for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
                    var operation = _step2.value.operation;
                    var selector = operation.root;
                    $b7ANd.mark(this._recordSource, selector, references, this._operationLoader, this._shouldProcessClientComponents);
                    yield;
                    if (startEpoch !== this._currentWriteEpoch) continue top;
                }
            } catch (err) {
                _iterator2.e(err);
            } finally{
                _iterator2.f();
            }
            var log = this.__log;
            if (log != null) log({
                name: 'store.gc',
                references: references
            });
            if (references.size === 0) this._recordSource.clear();
            else {
                var storeIDs = this._recordSource.getRecordIDs();
                for(var ii = 0; ii < storeIDs.length; ii++){
                    var dataID = storeIDs[ii];
                    if (!references.has(dataID)) this._recordSource.remove(dataID);
                }
            }
            return;
        }
    };
    return RelayModernStore;
}();
function $c2d30fd2010d65c4$var$initializeRecordSource(target) {
    if (!target.has($c2d30fd2010d65c4$var$ROOT_ID)) {
        var rootRecord = $c4ZG3.create($c2d30fd2010d65c4$var$ROOT_ID, $c2d30fd2010d65c4$var$ROOT_TYPE);
        target.set($c2d30fd2010d65c4$var$ROOT_ID, rootRecord);
    }
}
function $c2d30fd2010d65c4$var$updateTargetFromSource(target, source, currentWriteEpoch, idsMarkedForInvalidation, updatedRecordIDs, invalidatedRecordIDs) {
    if (idsMarkedForInvalidation) idsMarkedForInvalidation.forEach(function(dataID) {
        var targetRecord = target.get(dataID);
        var sourceRecord = source.get(dataID);
        if (sourceRecord === null) return;
        var nextRecord;
        if (targetRecord != null) nextRecord = $c4ZG3.clone(targetRecord);
        else nextRecord = sourceRecord != null ? $c4ZG3.clone(sourceRecord) : null;
        if (!nextRecord) return;
        $c4ZG3.setValue(nextRecord, $a6k4O.INVALIDATED_AT_KEY, currentWriteEpoch);
        invalidatedRecordIDs.add(dataID);
        target.set(dataID, nextRecord);
    });
    var dataIDs = source.getRecordIDs();
    for(var ii = 0; ii < dataIDs.length; ii++){
        var dataID = dataIDs[ii];
        var sourceRecord = source.get(dataID);
        var targetRecord = target.get(dataID);
        if (sourceRecord && targetRecord) {
            var nextRecord = $c4ZG3.update(targetRecord, sourceRecord);
            if (nextRecord !== targetRecord) {
                updatedRecordIDs.add(dataID);
                target.set(dataID, nextRecord);
            }
        } else if (sourceRecord === null) {
            target["delete"](dataID);
            if (targetRecord !== null) updatedRecordIDs.add(dataID);
        } else if (sourceRecord) {
            target.set(dataID, sourceRecord);
            updatedRecordIDs.add(dataID);
        }
    }
}
function $c2d30fd2010d65c4$var$getAvailabilityStatus(operationAvailability, operationLastWrittenAt, operationFetchTime, queryCacheExpirationTime) {
    var mostRecentlyInvalidatedAt = operationAvailability.mostRecentlyInvalidatedAt, status = operationAvailability.status;
    if (typeof mostRecentlyInvalidatedAt === 'number') {
        if (operationLastWrittenAt == null || mostRecentlyInvalidatedAt > operationLastWrittenAt) return {
            status: 'stale'
        };
    }
    if (status === 'missing') return {
        status: 'missing'
    };
    if (operationFetchTime != null && queryCacheExpirationTime != null) {
        var isStale = operationFetchTime <= Date.now() - queryCacheExpirationTime;
        if (isStale) return {
            status: 'stale'
        };
    }
    return {
        status: 'available',
        fetchTime: operationFetchTime !== null && operationFetchTime !== void 0 ? operationFetchTime : null
    };
}
module.exports = $c2d30fd2010d65c4$var$RelayModernStore;

});
parcelRegister("8yHCQ", function(module, exports) {
'use strict';
var $63b356d1cb40301d$var$resolvedPromise = Promise.resolve();
function $63b356d1cb40301d$var$resolveImmediate(callback) {
    $63b356d1cb40301d$var$resolvedPromise.then(callback)["catch"]($63b356d1cb40301d$var$throwNext);
}
function $63b356d1cb40301d$var$throwNext(error) {
    setTimeout(function() {
        throw error;
    }, 0);
}
module.exports = $63b356d1cb40301d$var$resolveImmediate;

});

parcelRegister("5wm2f", function(module, exports) {
'use strict';

var $7dvyf = parcelRequire("7dvyf");
var $405108a3498f087b$var$_interopRequireDefault = $7dvyf.default;

var $405108a3498f087b$var$_createForOfIteratorHelper2 = $405108a3498f087b$var$_interopRequireDefault((parcelRequire("bTRzt")));

var $kQ6dV = parcelRequire("kQ6dV");

var $gjqZl = parcelRequire("gjqZl");

var $1hwTW = parcelRequire("1hwTW");

var $9lZfN = parcelRequire("9lZfN");

var $70q7x = parcelRequire("70q7x");
var $405108a3498f087b$var$isClientID = $70q7x.isClientID;

var $h6vu6 = parcelRequire("h6vu6");

var $jdaO9 = parcelRequire("jdaO9");

var $kpcDM = parcelRequire("kpcDM");
var $405108a3498f087b$var$getLocalVariables = $kpcDM.getLocalVariables;

var $c4ZG3 = parcelRequire("c4ZG3");

var $gotsH = parcelRequire("gotsH");
var $405108a3498f087b$var$EXISTENT = $gotsH.EXISTENT, $405108a3498f087b$var$UNKNOWN = $gotsH.UNKNOWN;

var $a6k4O = parcelRequire("a6k4O");

var $cHFgk = parcelRequire("cHFgk");
var $405108a3498f087b$var$TYPE_SCHEMA_TYPE = $cHFgk.TYPE_SCHEMA_TYPE, $405108a3498f087b$var$generateTypeID = $cHFgk.generateTypeID;

var $bQThX = parcelRequire("bQThX");
var $405108a3498f087b$var$ACTOR_CHANGE = $9lZfN.ACTOR_CHANGE, $405108a3498f087b$var$CONDITION = $9lZfN.CONDITION, $405108a3498f087b$var$CLIENT_COMPONENT = $9lZfN.CLIENT_COMPONENT, $405108a3498f087b$var$CLIENT_EXTENSION = $9lZfN.CLIENT_EXTENSION, $405108a3498f087b$var$CLIENT_EDGE_TO_CLIENT_OBJECT = $9lZfN.CLIENT_EDGE_TO_CLIENT_OBJECT, $405108a3498f087b$var$DEFER = $9lZfN.DEFER, $405108a3498f087b$var$FRAGMENT_SPREAD = $9lZfN.FRAGMENT_SPREAD, $405108a3498f087b$var$INLINE_FRAGMENT = $9lZfN.INLINE_FRAGMENT, $405108a3498f087b$var$LINKED_FIELD = $9lZfN.LINKED_FIELD, $405108a3498f087b$var$LINKED_HANDLE = $9lZfN.LINKED_HANDLE, $405108a3498f087b$var$MODULE_IMPORT = $9lZfN.MODULE_IMPORT, $405108a3498f087b$var$RELAY_RESOLVER = $9lZfN.RELAY_RESOLVER, $405108a3498f087b$var$RELAY_LIVE_RESOLVER = $9lZfN.RELAY_LIVE_RESOLVER, $405108a3498f087b$var$SCALAR_FIELD = $9lZfN.SCALAR_FIELD, $405108a3498f087b$var$SCALAR_HANDLE = $9lZfN.SCALAR_HANDLE, $405108a3498f087b$var$STREAM = $9lZfN.STREAM, $405108a3498f087b$var$TYPE_DISCRIMINATOR = $9lZfN.TYPE_DISCRIMINATOR;
var $405108a3498f087b$var$getModuleOperationKey = $a6k4O.getModuleOperationKey, $405108a3498f087b$var$getStorageKey = $a6k4O.getStorageKey, $405108a3498f087b$var$getArgumentValues = $a6k4O.getArgumentValues;
function $405108a3498f087b$var$check(getSourceForActor, getTargetForActor, defaultActorIdentifier, selector, handlers, operationLoader, getDataID, shouldProcessClientComponents) {
    var dataID = selector.dataID, node = selector.node, variables = selector.variables;
    var checker = new $405108a3498f087b$var$DataChecker(getSourceForActor, getTargetForActor, defaultActorIdentifier, variables, handlers, operationLoader, getDataID, shouldProcessClientComponents);
    return checker.check(node, dataID);
}
var $405108a3498f087b$var$DataChecker = /*#__PURE__*/ function() {
    function DataChecker(getSourceForActor, getTargetForActor, defaultActorIdentifier, variables, handlers, operationLoader, getDataID, shouldProcessClientComponents) {
        this._getSourceForActor = getSourceForActor;
        this._getTargetForActor = getTargetForActor;
        this._getDataID = getDataID;
        this._source = getSourceForActor(defaultActorIdentifier);
        this._mutatorRecordSourceProxyCache = new Map();
        var _this$_getMutatorAndR = this._getMutatorAndRecordProxyForActor(defaultActorIdentifier), mutator = _this$_getMutatorAndR[0], recordSourceProxy = _this$_getMutatorAndR[1];
        this._mostRecentlyInvalidatedAt = null;
        this._handlers = handlers;
        this._mutator = mutator;
        this._operationLoader = operationLoader !== null && operationLoader !== void 0 ? operationLoader : null;
        this._recordSourceProxy = recordSourceProxy;
        this._recordWasMissing = false;
        this._variables = variables;
        this._shouldProcessClientComponents = shouldProcessClientComponents;
    }
    var _proto = DataChecker.prototype;
    _proto._getMutatorAndRecordProxyForActor = function _getMutatorAndRecordProxyForActor(actorIdentifier) {
        var tuple = this._mutatorRecordSourceProxyCache.get(actorIdentifier);
        if (tuple == null) {
            var target = this._getTargetForActor(actorIdentifier);
            var mutator = new $kQ6dV(this._getSourceForActor(actorIdentifier), target);
            var recordSourceProxy = new $gjqZl(mutator, this._getDataID, undefined, this._handlers);
            tuple = [
                mutator,
                recordSourceProxy
            ];
            this._mutatorRecordSourceProxyCache.set(actorIdentifier, tuple);
        }
        return tuple;
    };
    _proto.check = function check(node, dataID) {
        this._assignClientAbstractTypes(node);
        this._traverse(node, dataID);
        return this._recordWasMissing === true ? {
            status: 'missing',
            mostRecentlyInvalidatedAt: this._mostRecentlyInvalidatedAt
        } : {
            status: 'available',
            mostRecentlyInvalidatedAt: this._mostRecentlyInvalidatedAt
        };
    };
    _proto._getVariableValue = function _getVariableValue(name) {
        !this._variables.hasOwnProperty(name) && $bQThX(false);
        return this._variables[name];
    };
    _proto._handleMissing = function _handleMissing() {
        this._recordWasMissing = true;
    };
    _proto._handleMissingScalarField = function _handleMissingScalarField(field, dataID) {
        if (field.name === 'id' && field.alias == null && $405108a3498f087b$var$isClientID(dataID)) return undefined;
        var args = field.args != undefined ? $405108a3498f087b$var$getArgumentValues(field.args, this._variables) : {};
        var _iterator = (0, $405108a3498f087b$var$_createForOfIteratorHelper2["default"])(this._handlers), _step;
        try {
            for(_iterator.s(); !(_step = _iterator.n()).done;){
                var handler = _step.value;
                if (handler.kind === 'scalar') {
                    var newValue = handler.handle(field, this._recordSourceProxy.get(dataID), args, this._recordSourceProxy);
                    if (newValue !== undefined) return newValue;
                }
            }
        } catch (err) {
            _iterator.e(err);
        } finally{
            _iterator.f();
        }
        this._handleMissing();
    };
    _proto._handleMissingLinkField = function _handleMissingLinkField(field, dataID) {
        var args = field.args != undefined ? $405108a3498f087b$var$getArgumentValues(field.args, this._variables) : {};
        var _iterator2 = (0, $405108a3498f087b$var$_createForOfIteratorHelper2["default"])(this._handlers), _step2;
        try {
            for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
                var handler = _step2.value;
                if (handler.kind === 'linked') {
                    var newValue = handler.handle(field, this._recordSourceProxy.get(dataID), args, this._recordSourceProxy);
                    if (newValue !== undefined && (newValue === null || this._mutator.getStatus(newValue) === $405108a3498f087b$var$EXISTENT)) return newValue;
                }
            }
        } catch (err) {
            _iterator2.e(err);
        } finally{
            _iterator2.f();
        }
        this._handleMissing();
    };
    _proto._handleMissingPluralLinkField = function _handleMissingPluralLinkField(field, dataID) {
        var _this = this;
        var args = field.args != undefined ? $405108a3498f087b$var$getArgumentValues(field.args, this._variables) : {};
        var _iterator3 = (0, $405108a3498f087b$var$_createForOfIteratorHelper2["default"])(this._handlers), _step3;
        try {
            for(_iterator3.s(); !(_step3 = _iterator3.n()).done;){
                var handler = _step3.value;
                if (handler.kind === 'pluralLinked') {
                    var newValue = handler.handle(field, this._recordSourceProxy.get(dataID), args, this._recordSourceProxy);
                    if (newValue != null) {
                        var allItemsKnown = newValue.every(function(linkedID) {
                            return linkedID != null && _this._mutator.getStatus(linkedID) === $405108a3498f087b$var$EXISTENT;
                        });
                        if (allItemsKnown) return newValue;
                    } else if (newValue === null) return null;
                }
            }
        } catch (err) {
            _iterator3.e(err);
        } finally{
            _iterator3.f();
        }
        this._handleMissing();
    };
    _proto._traverse = function _traverse(node, dataID) {
        var status = this._mutator.getStatus(dataID);
        if (status === $405108a3498f087b$var$UNKNOWN) this._handleMissing();
        if (status === $405108a3498f087b$var$EXISTENT) {
            var record = this._source.get(dataID);
            var invalidatedAt = $c4ZG3.getInvalidationEpoch(record);
            if (invalidatedAt != null) this._mostRecentlyInvalidatedAt = this._mostRecentlyInvalidatedAt != null ? Math.max(this._mostRecentlyInvalidatedAt, invalidatedAt) : invalidatedAt;
            this._traverseSelections(node.selections, dataID);
        }
    };
    _proto._traverseSelections = function _traverseSelections(selections, dataID) {
        var _this2 = this;
        selections.forEach(function(selection) {
            switch(selection.kind){
                case $405108a3498f087b$var$SCALAR_FIELD:
                    _this2._checkScalar(selection, dataID);
                    break;
                case $405108a3498f087b$var$LINKED_FIELD:
                    if (selection.plural) _this2._checkPluralLink(selection, dataID);
                    else _this2._checkLink(selection, dataID);
                    break;
                case $405108a3498f087b$var$ACTOR_CHANGE:
                    _this2._checkActorChange(selection.linkedField, dataID);
                    break;
                case $405108a3498f087b$var$CONDITION:
                    var conditionValue = Boolean(_this2._getVariableValue(selection.condition));
                    if (conditionValue === selection.passingValue) _this2._traverseSelections(selection.selections, dataID);
                    break;
                case $405108a3498f087b$var$INLINE_FRAGMENT:
                    var _abstractKey = selection.abstractKey;
                    if (_abstractKey == null) {
                        var typeName = _this2._mutator.getType(dataID);
                        if (typeName === selection.type) _this2._traverseSelections(selection.selections, dataID);
                    } else {
                        var _recordType = _this2._mutator.getType(dataID);
                        !(_recordType != null) && $bQThX(false);
                        var _typeID = $405108a3498f087b$var$generateTypeID(_recordType);
                        var _implementsInterface = _this2._mutator.getValue(_typeID, _abstractKey);
                        if (_implementsInterface === true) _this2._traverseSelections(selection.selections, dataID);
                        else if (_implementsInterface == null) _this2._handleMissing();
                    }
                    break;
                case $405108a3498f087b$var$LINKED_HANDLE:
                    var handleField = $h6vu6(selection, selections, _this2._variables);
                    if (handleField.plural) _this2._checkPluralLink(handleField, dataID);
                    else _this2._checkLink(handleField, dataID);
                    break;
                case $405108a3498f087b$var$SCALAR_HANDLE:
                    var _handleField = $jdaO9(selection, selections, _this2._variables);
                    _this2._checkScalar(_handleField, dataID);
                    break;
                case $405108a3498f087b$var$MODULE_IMPORT:
                    _this2._checkModuleImport(selection, dataID);
                    break;
                case $405108a3498f087b$var$DEFER:
                case $405108a3498f087b$var$STREAM:
                    _this2._traverseSelections(selection.selections, dataID);
                    break;
                case $405108a3498f087b$var$FRAGMENT_SPREAD:
                    var prevVariables = _this2._variables;
                    _this2._variables = $405108a3498f087b$var$getLocalVariables(_this2._variables, selection.fragment.argumentDefinitions, selection.args);
                    _this2._traverseSelections(selection.fragment.selections, dataID);
                    _this2._variables = prevVariables;
                    break;
                case $405108a3498f087b$var$CLIENT_EXTENSION:
                    var recordWasMissing = _this2._recordWasMissing;
                    _this2._traverseSelections(selection.selections, dataID);
                    _this2._recordWasMissing = recordWasMissing;
                    break;
                case $405108a3498f087b$var$TYPE_DISCRIMINATOR:
                    var abstractKey = selection.abstractKey;
                    var recordType = _this2._mutator.getType(dataID);
                    !(recordType != null) && $bQThX(false);
                    var typeID = $405108a3498f087b$var$generateTypeID(recordType);
                    var implementsInterface = _this2._mutator.getValue(typeID, abstractKey);
                    if (implementsInterface == null) _this2._handleMissing();
                    break;
                case $405108a3498f087b$var$CLIENT_COMPONENT:
                    if (_this2._shouldProcessClientComponents === false) break;
                    _this2._traverseSelections(selection.fragment.selections, dataID);
                    break;
                case $405108a3498f087b$var$RELAY_RESOLVER:
                    _this2._checkResolver(selection, dataID);
                    break;
                case $405108a3498f087b$var$RELAY_LIVE_RESOLVER:
                    _this2._checkResolver(selection, dataID);
                    break;
                case $405108a3498f087b$var$CLIENT_EDGE_TO_CLIENT_OBJECT:
                    _this2._checkResolver(selection.backingField, dataID);
                    break;
                default:
                    selection;
                    $bQThX(false);
            }
        });
    };
    _proto._checkResolver = function _checkResolver(resolver, dataID) {
        if (resolver.fragment) this._traverseSelections([
            resolver.fragment
        ], dataID);
    };
    _proto._checkModuleImport = function _checkModuleImport(moduleImport, dataID) {
        var operationLoader = this._operationLoader;
        !(operationLoader !== null) && $bQThX(false);
        var operationKey = $405108a3498f087b$var$getModuleOperationKey(moduleImport.documentName);
        var operationReference = this._mutator.getValue(dataID, operationKey);
        if (operationReference == null) {
            if (operationReference === undefined) this._handleMissing();
            return;
        }
        var normalizationRootNode = operationLoader.get(operationReference);
        if (normalizationRootNode != null) {
            var operation = $1hwTW(normalizationRootNode);
            var prevVariables = this._variables;
            this._variables = $405108a3498f087b$var$getLocalVariables(this._variables, operation.argumentDefinitions, moduleImport.args);
            this._traverse(operation, dataID);
            this._variables = prevVariables;
        } else this._handleMissing();
    };
    _proto._checkScalar = function _checkScalar(field, dataID) {
        var storageKey = $405108a3498f087b$var$getStorageKey(field, this._variables);
        var fieldValue = this._mutator.getValue(dataID, storageKey);
        if (fieldValue === undefined) {
            fieldValue = this._handleMissingScalarField(field, dataID);
            if (fieldValue !== undefined) this._mutator.setValue(dataID, storageKey, fieldValue);
        }
    };
    _proto._checkLink = function _checkLink(field, dataID) {
        var storageKey = $405108a3498f087b$var$getStorageKey(field, this._variables);
        var linkedID = this._mutator.getLinkedRecordID(dataID, storageKey);
        if (linkedID === undefined) {
            linkedID = this._handleMissingLinkField(field, dataID);
            if (linkedID != null) this._mutator.setLinkedRecordID(dataID, storageKey, linkedID);
            else if (linkedID === null) this._mutator.setValue(dataID, storageKey, null);
        }
        if (linkedID != null) this._traverse(field, linkedID);
    };
    _proto._checkPluralLink = function _checkPluralLink(field, dataID) {
        var _this3 = this;
        var storageKey = $405108a3498f087b$var$getStorageKey(field, this._variables);
        var linkedIDs = this._mutator.getLinkedRecordIDs(dataID, storageKey);
        if (linkedIDs === undefined) {
            linkedIDs = this._handleMissingPluralLinkField(field, dataID);
            if (linkedIDs != null) this._mutator.setLinkedRecordIDs(dataID, storageKey, linkedIDs);
            else if (linkedIDs === null) this._mutator.setValue(dataID, storageKey, null);
        }
        if (linkedIDs) linkedIDs.forEach(function(linkedID) {
            if (linkedID != null) _this3._traverse(field, linkedID);
        });
    };
    _proto._checkActorChange = function _checkActorChange(field, dataID) {
        var storageKey = $405108a3498f087b$var$getStorageKey(field, this._variables);
        var record = this._source.get(dataID);
        var tuple = record != null ? $c4ZG3.getActorLinkedRecordID(record, storageKey) : record;
        if (tuple == null) {
            if (tuple === undefined) this._handleMissing();
        } else {
            var actorIdentifier = tuple[0], linkedID = tuple[1];
            var prevSource = this._source;
            var prevMutator = this._mutator;
            var prevRecordSourceProxy = this._recordSourceProxy;
            var _this$_getMutatorAndR2 = this._getMutatorAndRecordProxyForActor(actorIdentifier), mutator = _this$_getMutatorAndR2[0], recordSourceProxy = _this$_getMutatorAndR2[1];
            this._source = this._getSourceForActor(actorIdentifier);
            this._mutator = mutator;
            this._recordSourceProxy = recordSourceProxy;
            this._assignClientAbstractTypes(field);
            this._traverse(field, linkedID);
            this._source = prevSource;
            this._mutator = prevMutator;
            this._recordSourceProxy = prevRecordSourceProxy;
        }
    };
    _proto._assignClientAbstractTypes = function _assignClientAbstractTypes(node) {
        var clientAbstractTypes = node.clientAbstractTypes;
        if (clientAbstractTypes != null) for(var _i = 0, _Object$keys = Object.keys(clientAbstractTypes); _i < _Object$keys.length; _i++){
            var abstractType = _Object$keys[_i];
            var _iterator4 = (0, $405108a3498f087b$var$_createForOfIteratorHelper2["default"])(clientAbstractTypes[abstractType]), _step4;
            try {
                for(_iterator4.s(); !(_step4 = _iterator4.n()).done;){
                    var concreteType = _step4.value;
                    var typeID = $405108a3498f087b$var$generateTypeID(concreteType);
                    if (this._source.get(typeID) == null) this._mutator.create(typeID, $405108a3498f087b$var$TYPE_SCHEMA_TYPE);
                    if (this._mutator.getValue(typeID, abstractType) == null) this._mutator.setValue(typeID, abstractType, true);
                }
            } catch (err) {
                _iterator4.e(err);
            } finally{
                _iterator4.f();
            }
        }
    };
    return DataChecker;
}();
module.exports = {
    check: $405108a3498f087b$var$check
};

});
parcelRegister("h6vu6", function(module, exports) {
'use strict';

var $9lZfN = parcelRequire("9lZfN");
var $c73b6b5f0d0de3b9$var$LINKED_FIELD = $9lZfN.LINKED_FIELD;

var $a6k4O = parcelRequire("a6k4O");
var $c73b6b5f0d0de3b9$var$getHandleStorageKey = $a6k4O.getHandleStorageKey;

var $3Nt2B = parcelRequire("3Nt2B");

var $bQThX = parcelRequire("bQThX");
function $c73b6b5f0d0de3b9$var$cloneRelayHandleSourceField(handleField, selections, variables) {
    var sourceField = selections.find(function(source) {
        return source.kind === $c73b6b5f0d0de3b9$var$LINKED_FIELD && source.name === handleField.name && source.alias === handleField.alias && $3Nt2B(source.args, handleField.args);
    });
    !(sourceField && sourceField.kind === $c73b6b5f0d0de3b9$var$LINKED_FIELD) && $bQThX(false);
    var handleKey = $c73b6b5f0d0de3b9$var$getHandleStorageKey(handleField, variables);
    return {
        kind: 'LinkedField',
        alias: sourceField.alias,
        name: handleKey,
        storageKey: handleKey,
        args: null,
        concreteType: sourceField.concreteType,
        plural: sourceField.plural,
        selections: sourceField.selections
    };
}
module.exports = $c73b6b5f0d0de3b9$var$cloneRelayHandleSourceField;

});

parcelRegister("jdaO9", function(module, exports) {
'use strict';

var $9lZfN = parcelRequire("9lZfN");
var $dfc79d6f934f501c$var$SCALAR_FIELD = $9lZfN.SCALAR_FIELD;

var $a6k4O = parcelRequire("a6k4O");
var $dfc79d6f934f501c$var$getHandleStorageKey = $a6k4O.getHandleStorageKey;

var $3Nt2B = parcelRequire("3Nt2B");

var $bQThX = parcelRequire("bQThX");
function $dfc79d6f934f501c$var$cloneRelayScalarHandleSourceField(handleField, selections, variables) {
    var sourceField = selections.find(function(source) {
        return source.kind === $dfc79d6f934f501c$var$SCALAR_FIELD && source.name === handleField.name && source.alias === handleField.alias && $3Nt2B(source.args, handleField.args);
    });
    !(sourceField && sourceField.kind === $dfc79d6f934f501c$var$SCALAR_FIELD) && $bQThX(false);
    var handleKey = $dfc79d6f934f501c$var$getHandleStorageKey(handleField, variables);
    return {
        kind: 'ScalarField',
        alias: sourceField.alias,
        name: handleKey,
        storageKey: handleKey,
        args: null
    };
}
module.exports = $dfc79d6f934f501c$var$cloneRelayScalarHandleSourceField;

});


parcelRegister("hprpJ", function(module, exports) {
'use strict';

var $7dvyf = parcelRequire("7dvyf");
var $caca09592409a8ae$var$_interopRequireDefault = $7dvyf.default;

var $caca09592409a8ae$var$_objectSpread2 = $caca09592409a8ae$var$_interopRequireDefault((parcelRequire("4N8OD")));

var $c4ZG3 = parcelRequire("c4ZG3");

var $fWVgk = parcelRequire("fWVgk");

var $bQThX = parcelRequire("bQThX");
var $caca09592409a8ae$var$UNPUBLISH_RECORD_SENTINEL = $c4ZG3.fromObject(Object.freeze({
    __UNPUBLISH_RECORD_SENTINEL: true
}));
var $caca09592409a8ae$var$RelayOptimisticRecordSource = /*#__PURE__*/ function() {
    function RelayOptimisticRecordSource(base) {
        this._base = base;
        this._sink = $fWVgk.create();
    }
    var _proto = RelayOptimisticRecordSource.prototype;
    _proto.has = function has(dataID) {
        if (this._sink.has(dataID)) {
            var sinkRecord = this._sink.get(dataID);
            return sinkRecord !== $caca09592409a8ae$var$UNPUBLISH_RECORD_SENTINEL;
        } else return this._base.has(dataID);
    };
    _proto.get = function get(dataID) {
        if (this._sink.has(dataID)) {
            var sinkRecord = this._sink.get(dataID);
            if (sinkRecord === $caca09592409a8ae$var$UNPUBLISH_RECORD_SENTINEL) return undefined;
            else return sinkRecord;
        } else return this._base.get(dataID);
    };
    _proto.getStatus = function getStatus(dataID) {
        var record = this.get(dataID);
        if (record === undefined) return 'UNKNOWN';
        else if (record === null) return 'NONEXISTENT';
        else return 'EXISTENT';
    };
    _proto.clear = function clear() {
        this._base = $fWVgk.create();
        this._sink.clear();
    };
    _proto["delete"] = function _delete(dataID) {
        this._sink["delete"](dataID);
    };
    _proto.remove = function remove(dataID) {
        this._sink.set(dataID, $caca09592409a8ae$var$UNPUBLISH_RECORD_SENTINEL);
    };
    _proto.set = function set(dataID, record) {
        this._sink.set(dataID, record);
    };
    _proto.getRecordIDs = function getRecordIDs() {
        return Object.keys(this.toJSON());
    };
    _proto.size = function size() {
        return Object.keys(this.toJSON()).length;
    };
    _proto.toJSON = function toJSON() {
        var _this = this;
        var merged = (0, $caca09592409a8ae$var$_objectSpread2["default"])({}, this._base.toJSON());
        this._sink.getRecordIDs().forEach(function(dataID) {
            var record = _this.get(dataID);
            if (record === undefined) delete merged[dataID];
            else merged[dataID] = $c4ZG3.toJSON(record);
        });
        return merged;
    };
    _proto.getOptimisticRecordIDs = function getOptimisticRecordIDs() {
        return new Set(this._sink.getRecordIDs());
    };
    return RelayOptimisticRecordSource;
}();
function $caca09592409a8ae$var$create(base) {
    return new $caca09592409a8ae$var$RelayOptimisticRecordSource(base);
}
function $caca09592409a8ae$var$getOptimisticRecordIDs(source) {
    !(source instanceof $caca09592409a8ae$var$RelayOptimisticRecordSource) && $bQThX(false);
    return source.getOptimisticRecordIDs();
}
module.exports = {
    create: $caca09592409a8ae$var$create,
    getOptimisticRecordIDs: $caca09592409a8ae$var$getOptimisticRecordIDs
};

});

parcelRegister("b7ANd", function(module, exports) {
'use strict';

var $7dvyf = parcelRequire("7dvyf");
var $818ce36e321e5b29$var$_interopRequireDefault = $7dvyf.default;

var $818ce36e321e5b29$var$_createForOfIteratorHelper2 = $818ce36e321e5b29$var$_interopRequireDefault((parcelRequire("bTRzt")));

var $1hwTW = parcelRequire("1hwTW");

var $9lZfN = parcelRequire("9lZfN");

var $h6vu6 = parcelRequire("h6vu6");

var $2EioI = parcelRequire("2EioI");

var $kpcDM = parcelRequire("kpcDM");
var $818ce36e321e5b29$var$getLocalVariables = $kpcDM.getLocalVariables;

var $c4ZG3 = parcelRequire("c4ZG3");

var $a6k4O = parcelRequire("a6k4O");

var $cHFgk = parcelRequire("cHFgk");
var $818ce36e321e5b29$var$generateTypeID = $cHFgk.generateTypeID;

var $bQThX = parcelRequire("bQThX");
var $818ce36e321e5b29$var$ACTOR_CHANGE = $9lZfN.ACTOR_CHANGE, $818ce36e321e5b29$var$CONDITION = $9lZfN.CONDITION, $818ce36e321e5b29$var$CLIENT_COMPONENT = $9lZfN.CLIENT_COMPONENT, $818ce36e321e5b29$var$CLIENT_EXTENSION = $9lZfN.CLIENT_EXTENSION, $818ce36e321e5b29$var$DEFER = $9lZfN.DEFER, $818ce36e321e5b29$var$FRAGMENT_SPREAD = $9lZfN.FRAGMENT_SPREAD, $818ce36e321e5b29$var$INLINE_FRAGMENT = $9lZfN.INLINE_FRAGMENT, $818ce36e321e5b29$var$LINKED_FIELD = $9lZfN.LINKED_FIELD, $818ce36e321e5b29$var$MODULE_IMPORT = $9lZfN.MODULE_IMPORT, $818ce36e321e5b29$var$LINKED_HANDLE = $9lZfN.LINKED_HANDLE, $818ce36e321e5b29$var$SCALAR_FIELD = $9lZfN.SCALAR_FIELD, $818ce36e321e5b29$var$SCALAR_HANDLE = $9lZfN.SCALAR_HANDLE, $818ce36e321e5b29$var$STREAM = $9lZfN.STREAM, $818ce36e321e5b29$var$TYPE_DISCRIMINATOR = $9lZfN.TYPE_DISCRIMINATOR, $818ce36e321e5b29$var$RELAY_RESOLVER = $9lZfN.RELAY_RESOLVER, $818ce36e321e5b29$var$RELAY_LIVE_RESOLVER = $9lZfN.RELAY_LIVE_RESOLVER, $818ce36e321e5b29$var$CLIENT_EDGE_TO_CLIENT_OBJECT = $9lZfN.CLIENT_EDGE_TO_CLIENT_OBJECT;
var $818ce36e321e5b29$var$getStorageKey = $a6k4O.getStorageKey, $818ce36e321e5b29$var$getModuleOperationKey = $a6k4O.getModuleOperationKey;
function $818ce36e321e5b29$var$mark(recordSource, selector, references, operationLoader, shouldProcessClientComponents) {
    var dataID = selector.dataID, node = selector.node, variables = selector.variables;
    var marker = new $818ce36e321e5b29$var$RelayReferenceMarker(recordSource, variables, references, operationLoader, shouldProcessClientComponents);
    marker.mark(node, dataID);
}
var $818ce36e321e5b29$var$RelayReferenceMarker = /*#__PURE__*/ function() {
    function RelayReferenceMarker(recordSource, variables, references, operationLoader, shouldProcessClientComponents) {
        this._operationLoader = operationLoader !== null && operationLoader !== void 0 ? operationLoader : null;
        this._operationName = null;
        this._recordSource = recordSource;
        this._references = references;
        this._variables = variables;
        this._shouldProcessClientComponents = shouldProcessClientComponents;
    }
    var _proto = RelayReferenceMarker.prototype;
    _proto.mark = function mark(node, dataID) {
        if (node.kind === 'Operation' || node.kind === 'SplitOperation') this._operationName = node.name;
        this._traverse(node, dataID);
    };
    _proto._traverse = function _traverse(node, dataID) {
        this._references.add(dataID);
        var record = this._recordSource.get(dataID);
        if (record == null) return;
        this._traverseSelections(node.selections, record);
    };
    _proto._getVariableValue = function _getVariableValue(name) {
        !this._variables.hasOwnProperty(name) && $bQThX(false);
        return this._variables[name];
    };
    _proto._traverseSelections = function _traverseSelections(selections, record) {
        var _this = this;
        selections.forEach(function(selection) {
            switch(selection.kind){
                case $818ce36e321e5b29$var$ACTOR_CHANGE:
                    _this._traverseLink(selection.linkedField, record);
                    break;
                case $818ce36e321e5b29$var$LINKED_FIELD:
                    if (selection.plural) _this._traversePluralLink(selection, record);
                    else _this._traverseLink(selection, record);
                    break;
                case $818ce36e321e5b29$var$CONDITION:
                    var conditionValue = Boolean(_this._getVariableValue(selection.condition));
                    if (conditionValue === selection.passingValue) _this._traverseSelections(selection.selections, record);
                    break;
                case $818ce36e321e5b29$var$INLINE_FRAGMENT:
                    if (selection.abstractKey == null) {
                        var typeName = $c4ZG3.getType(record);
                        if (typeName != null && typeName === selection.type || typeName === $a6k4O.ROOT_TYPE) _this._traverseSelections(selection.selections, record);
                    } else {
                        var _typeName = $c4ZG3.getType(record);
                        var typeID = $818ce36e321e5b29$var$generateTypeID(_typeName);
                        _this._references.add(typeID);
                        _this._traverseSelections(selection.selections, record);
                    }
                    break;
                case $818ce36e321e5b29$var$FRAGMENT_SPREAD:
                    var prevVariables = _this._variables;
                    _this._variables = $818ce36e321e5b29$var$getLocalVariables(_this._variables, selection.fragment.argumentDefinitions, selection.args);
                    _this._traverseSelections(selection.fragment.selections, record);
                    _this._variables = prevVariables;
                    break;
                case $818ce36e321e5b29$var$LINKED_HANDLE:
                    var handleField = $h6vu6(selection, selections, _this._variables);
                    if (handleField.plural) _this._traversePluralLink(handleField, record);
                    else _this._traverseLink(handleField, record);
                    break;
                case $818ce36e321e5b29$var$DEFER:
                case $818ce36e321e5b29$var$STREAM:
                    _this._traverseSelections(selection.selections, record);
                    break;
                case $818ce36e321e5b29$var$SCALAR_FIELD:
                case $818ce36e321e5b29$var$SCALAR_HANDLE:
                    break;
                case $818ce36e321e5b29$var$TYPE_DISCRIMINATOR:
                    var _typeName2 = $c4ZG3.getType(record);
                    var _typeID = $818ce36e321e5b29$var$generateTypeID(_typeName2);
                    _this._references.add(_typeID);
                    break;
                case $818ce36e321e5b29$var$MODULE_IMPORT:
                    _this._traverseModuleImport(selection, record);
                    break;
                case $818ce36e321e5b29$var$CLIENT_EXTENSION:
                    _this._traverseSelections(selection.selections, record);
                    break;
                case $818ce36e321e5b29$var$CLIENT_COMPONENT:
                    if (_this._shouldProcessClientComponents === false) break;
                    _this._traverseSelections(selection.fragment.selections, record);
                    break;
                case $818ce36e321e5b29$var$RELAY_RESOLVER:
                    _this._traverseResolverField(selection, record);
                    break;
                case $818ce36e321e5b29$var$RELAY_LIVE_RESOLVER:
                    _this._traverseResolverField(selection, record);
                    break;
                case $818ce36e321e5b29$var$CLIENT_EDGE_TO_CLIENT_OBJECT:
                    _this._traverseClientEdgeToClientObject(selection, record);
                    break;
                default:
                    selection;
                    $bQThX(false);
            }
        });
    };
    _proto._traverseClientEdgeToClientObject = function _traverseClientEdgeToClientObject(field, record) {
        var dataID = this._traverseResolverField(field.backingField, record);
        if (dataID == null) return;
        var resolverRecord = this._recordSource.get(dataID);
        if (resolverRecord == null) return;
        if (field.backingField.isOutputType) {
            var outputTypeRecordIDs = $2EioI(resolverRecord);
            if (outputTypeRecordIDs != null) {
                var _iterator = (0, $818ce36e321e5b29$var$_createForOfIteratorHelper2["default"])(outputTypeRecordIDs), _step;
                try {
                    for(_iterator.s(); !(_step = _iterator.n()).done;){
                        var _dataID = _step.value;
                        this._references.add(_dataID);
                    }
                } catch (err) {
                    _iterator.e(err);
                } finally{
                    _iterator.f();
                }
            }
        } else {
            var linkedField = field.linkedField;
            var concreteType = linkedField.concreteType;
            if (concreteType == null) return;
            if (linkedField.plural) {
                var dataIDs = $c4ZG3.getResolverLinkedRecordIDs(resolverRecord, concreteType);
                if (dataIDs != null) {
                    var _iterator2 = (0, $818ce36e321e5b29$var$_createForOfIteratorHelper2["default"])(dataIDs), _step2;
                    try {
                        for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
                            var _dataID2 = _step2.value;
                            if (_dataID2 != null) this._traverse(linkedField, _dataID2);
                        }
                    } catch (err) {
                        _iterator2.e(err);
                    } finally{
                        _iterator2.f();
                    }
                }
            } else {
                var _dataID3 = $c4ZG3.getResolverLinkedRecordID(resolverRecord, concreteType);
                if (_dataID3 != null) this._traverse(linkedField, _dataID3);
            }
        }
    };
    _proto._traverseResolverField = function _traverseResolverField(field, record) {
        var storageKey = $818ce36e321e5b29$var$getStorageKey(field, this._variables);
        var dataID = $c4ZG3.getLinkedRecordID(record, storageKey);
        if (dataID != null) this._references.add(dataID);
        var fragment = field.fragment;
        if (fragment != null) this._traverseSelections([
            fragment
        ], record);
        return dataID;
    };
    _proto._traverseModuleImport = function _traverseModuleImport(moduleImport, record) {
        var _this$_operationName;
        var operationLoader = this._operationLoader;
        !(operationLoader !== null) && $bQThX(false);
        var operationKey = $818ce36e321e5b29$var$getModuleOperationKey(moduleImport.documentName);
        var operationReference = $c4ZG3.getValue(record, operationKey);
        if (operationReference == null) return;
        var normalizationRootNode = operationLoader.get(operationReference);
        if (normalizationRootNode != null) {
            var operation = $1hwTW(normalizationRootNode);
            var prevVariables = this._variables;
            this._variables = $818ce36e321e5b29$var$getLocalVariables(this._variables, operation.argumentDefinitions, moduleImport.args);
            this._traverseSelections(operation.selections, record);
            this._variables = prevVariables;
        }
    };
    _proto._traverseLink = function _traverseLink(field, record) {
        var storageKey = $818ce36e321e5b29$var$getStorageKey(field, this._variables);
        var linkedID = $c4ZG3.getLinkedRecordID(record, storageKey);
        if (linkedID == null) return;
        this._traverse(field, linkedID);
    };
    _proto._traversePluralLink = function _traversePluralLink(field, record) {
        var _this2 = this;
        var storageKey = $818ce36e321e5b29$var$getStorageKey(field, this._variables);
        var linkedIDs = $c4ZG3.getLinkedRecordIDs(record, storageKey);
        if (linkedIDs == null) return;
        linkedIDs.forEach(function(linkedID) {
            if (linkedID != null) _this2._traverse(field, linkedID);
        });
    };
    return RelayReferenceMarker;
}();
module.exports = {
    mark: $818ce36e321e5b29$var$mark
};

});
parcelRegister("2EioI", function(module, exports) {
'use strict';

var $c4ZG3 = parcelRequire("c4ZG3");

var $a6k4O = parcelRequire("a6k4O");
var $1edd9693163981b4$var$RELAY_RESOLVER_OUTPUT_TYPE_RECORD_IDS = $a6k4O.RELAY_RESOLVER_OUTPUT_TYPE_RECORD_IDS;

var $bQThX = parcelRequire("bQThX");
function $1edd9693163981b4$var$getOutputTypeRecordIDs(record) {
    var maybeOutputTypeRecordIDs = $c4ZG3.getValue(record, $1edd9693163981b4$var$RELAY_RESOLVER_OUTPUT_TYPE_RECORD_IDS);
    if (maybeOutputTypeRecordIDs == null) return null;
    !(maybeOutputTypeRecordIDs instanceof Set) && $bQThX(false);
    return maybeOutputTypeRecordIDs;
}
module.exports = $1edd9693163981b4$var$getOutputTypeRecordIDs;

});


parcelRegister("7sSWY", function(module, exports) {
'use strict';
parcelRequire("8YAvI");

var $hrF5e = parcelRequire("hrF5e");

var $9DZlA = parcelRequire("9DZlA");

var $axO8n = parcelRequire("axO8n");

var $1GImb = parcelRequire("1GImb");

var $2Nqi8 = parcelRequire("2Nqi8");
var $56f5c5ea753397d0$var$RelayStoreSubscriptions = /*#__PURE__*/ function() {
    function RelayStoreSubscriptions(log, resolverCache) {
        this._subscriptions = new Set();
        this.__log = log;
        this._resolverCache = resolverCache;
    }
    var _proto = RelayStoreSubscriptions.prototype;
    _proto.subscribe = function subscribe(snapshot, callback) {
        var _this = this;
        var subscription = {
            backup: null,
            callback: callback,
            snapshot: snapshot,
            stale: false
        };
        var dispose = function dispose() {
            _this._subscriptions["delete"](subscription);
        };
        this._subscriptions.add(subscription);
        return {
            dispose: dispose
        };
    };
    _proto.snapshotSubscriptions = function snapshotSubscriptions(source) {
        var _this2 = this;
        this._subscriptions.forEach(function(subscription) {
            if (!subscription.stale) {
                subscription.backup = subscription.snapshot;
                return;
            }
            var snapshot = subscription.snapshot;
            var backup = $2Nqi8.read(source, snapshot.selector, _this2._resolverCache);
            var nextData = $hrF5e(snapshot.data, backup.data);
            backup.data = nextData;
            subscription.backup = backup;
        });
    };
    _proto.restoreSubscriptions = function restoreSubscriptions() {
        this._subscriptions.forEach(function(subscription) {
            var backup = subscription.backup;
            subscription.backup = null;
            if (backup) {
                if (backup.data !== subscription.snapshot.data) subscription.stale = true;
                subscription.snapshot = {
                    data: subscription.snapshot.data,
                    isMissingData: backup.isMissingData,
                    missingClientEdges: backup.missingClientEdges,
                    missingLiveResolverFields: backup.missingLiveResolverFields,
                    seenRecords: backup.seenRecords,
                    selector: backup.selector,
                    missingRequiredFields: backup.missingRequiredFields,
                    relayResolverErrors: backup.relayResolverErrors,
                    errorResponseFields: backup.errorResponseFields
                };
            } else subscription.stale = true;
        });
    };
    _proto.updateSubscriptions = function updateSubscriptions(source, updatedRecordIDs, updatedOwners, sourceOperation) {
        var _this3 = this;
        var hasUpdatedRecords = updatedRecordIDs.size !== 0;
        this._subscriptions.forEach(function(subscription) {
            var owner = _this3._updateSubscription(source, subscription, updatedRecordIDs, hasUpdatedRecords, sourceOperation);
            if (owner != null) updatedOwners.push(owner);
        });
    };
    _proto._updateSubscription = function _updateSubscription(source, subscription, updatedRecordIDs, hasUpdatedRecords, sourceOperation) {
        var backup = subscription.backup, callback = subscription.callback, snapshot = subscription.snapshot, stale = subscription.stale;
        var hasOverlappingUpdates = hasUpdatedRecords && $axO8n(snapshot.seenRecords, updatedRecordIDs);
        if (!stale && !hasOverlappingUpdates) return;
        var nextSnapshot = hasOverlappingUpdates || !backup ? $2Nqi8.read(source, snapshot.selector, this._resolverCache) : backup;
        var nextData = $hrF5e(snapshot.data, nextSnapshot.data);
        nextSnapshot = {
            data: nextData,
            isMissingData: nextSnapshot.isMissingData,
            missingClientEdges: nextSnapshot.missingClientEdges,
            missingLiveResolverFields: nextSnapshot.missingLiveResolverFields,
            seenRecords: nextSnapshot.seenRecords,
            selector: nextSnapshot.selector,
            missingRequiredFields: nextSnapshot.missingRequiredFields,
            relayResolverErrors: nextSnapshot.relayResolverErrors,
            errorResponseFields: nextSnapshot.errorResponseFields
        };
        subscription.snapshot = nextSnapshot;
        subscription.stale = false;
        if (nextSnapshot.data !== snapshot.data) {
            if (this.__log && $9DZlA.ENABLE_NOTIFY_SUBSCRIPTION) this.__log({
                name: 'store.notify.subscription',
                sourceOperation: sourceOperation,
                snapshot: snapshot,
                nextSnapshot: nextSnapshot
            });
            callback(nextSnapshot);
            return snapshot.selector.owner;
        }
        if ($9DZlA.ENABLE_LOOSE_SUBSCRIPTION_ATTRIBUTION && (stale || $1GImb(snapshot.seenRecords, updatedRecordIDs))) return snapshot.selector.owner;
    };
    return RelayStoreSubscriptions;
}();
module.exports = $56f5c5ea753397d0$var$RelayStoreSubscriptions;

});
parcelRegister("axO8n", function(module, exports) {
'use strict';
var $7ad3e005b89e3072$var$ITERATOR_KEY = Symbol.iterator;
function $7ad3e005b89e3072$var$hasOverlappingIDs(seenRecords, updatedRecordIDs) {
    var iterator = seenRecords[$7ad3e005b89e3072$var$ITERATOR_KEY]();
    var next = iterator.next();
    while(!next.done){
        var key = next.value;
        if (updatedRecordIDs.has(key)) return true;
        next = iterator.next();
    }
    return false;
}
module.exports = $7ad3e005b89e3072$var$hasOverlappingIDs;

});

parcelRegister("1GImb", function(module, exports) {
'use strict';

var $a6k4O = parcelRequire("a6k4O");
var $13ac1f081bbab764$var$ROOT_ID = $a6k4O.ROOT_ID;

var $2Ww7b = parcelRequire("2Ww7b");
var $13ac1f081bbab764$var$VIEWER_ID = $2Ww7b.VIEWER_ID;
var $13ac1f081bbab764$var$ITERATOR_KEY = Symbol.iterator;
function $13ac1f081bbab764$var$hasSignificantOverlappingIDs(seenRecords, updatedRecordIDs) {
    var iterator = seenRecords[$13ac1f081bbab764$var$ITERATOR_KEY]();
    var next = iterator.next();
    while(!next.done){
        var key = next.value;
        if (updatedRecordIDs.has(key) && key !== $13ac1f081bbab764$var$ROOT_ID && key !== $13ac1f081bbab764$var$VIEWER_ID) return true;
        next = iterator.next();
    }
    return false;
}
module.exports = $13ac1f081bbab764$var$hasSignificantOverlappingIDs;

});



parcelRegister("Olnt2", function(module, exports) {
'use strict';

var $jgdIQ = parcelRequire("jgdIQ");

var $8AEJo = parcelRequire("8AEJo");
var $097540c0e8950ba5$var$getRequest = $8AEJo.getRequest;

var $ilblc = parcelRequire("ilblc");
var $097540c0e8950ba5$var$createOperationDescriptor = $ilblc.createOperationDescriptor;

var $3o9ph = parcelRequire("3o9ph");
var $097540c0e8950ba5$var$createReaderSelector = $3o9ph.createReaderSelector;
parcelRequire("hzw7m");
function $097540c0e8950ba5$var$requestSubscription(environment, config) {
    var subscription = $097540c0e8950ba5$var$getRequest(config.subscription);
    if (subscription.params.operationKind !== 'subscription') throw new Error('requestSubscription: Must use Subscription operation');
    var configs = config.configs, onCompleted = config.onCompleted, onError = config.onError, onNext = config.onNext, variables = config.variables, cacheConfig = config.cacheConfig;
    var operation = $097540c0e8950ba5$var$createOperationDescriptor(subscription, variables, cacheConfig);
    var _ref = configs ? $jgdIQ.convert(configs, subscription, null, config.updater) : config, updater = _ref.updater;
    var sub = environment.executeSubscription({
        operation: operation,
        updater: updater
    }).subscribe({
        next: function next(responses) {
            if (onNext != null) {
                var selector = operation.fragment;
                var nextID;
                if (Array.isArray(responses)) {
                    var _responses$, _responses$$extension;
                    nextID = (_responses$ = responses[0]) === null || _responses$ === void 0 ? void 0 : (_responses$$extension = _responses$.extensions) === null || _responses$$extension === void 0 ? void 0 : _responses$$extension.__relay_subscription_root_id;
                } else {
                    var _responses$extensions;
                    nextID = (_responses$extensions = responses.extensions) === null || _responses$extensions === void 0 ? void 0 : _responses$extensions.__relay_subscription_root_id;
                }
                if (typeof nextID === 'string') selector = $097540c0e8950ba5$var$createReaderSelector(selector.node, nextID, selector.variables, selector.owner);
                var data = environment.lookup(selector).data;
                onNext(data);
            }
        },
        error: onError,
        complete: onCompleted
    });
    return {
        dispose: sub.unsubscribe
    };
}
module.exports = $097540c0e8950ba5$var$requestSubscription;

});

parcelRegister("8oDak", function(module, exports) {
'use strict';

var $7dvyf = parcelRequire("7dvyf");
var $61cef212cd8b1619$var$_interopRequireDefault = $7dvyf.default;

var $61cef212cd8b1619$var$_objectSpread2 = $61cef212cd8b1619$var$_interopRequireDefault((parcelRequire("4N8OD")));

var $a6k4O = parcelRequire("a6k4O");
var $61cef212cd8b1619$var$getModuleComponentKey = $a6k4O.getModuleComponentKey, $61cef212cd8b1619$var$getModuleOperationKey = $a6k4O.getModuleOperationKey;
function $61cef212cd8b1619$var$createPayloadFor3DField(name, operation, component, response) {
    var data = (0, $61cef212cd8b1619$var$_objectSpread2["default"])({}, response);
    data[$61cef212cd8b1619$var$getModuleComponentKey(name)] = component;
    data[$61cef212cd8b1619$var$getModuleOperationKey(name)] = operation;
    return data;
}
module.exports = $61cef212cd8b1619$var$createPayloadFor3DField;

});

parcelRegister("inxuq", function(module, exports) {
'use strict';

var $3o9ph = parcelRequire("3o9ph");
var $d6145a5c07c4a52d$var$getDataIDsFromFragment = $3o9ph.getDataIDsFromFragment, $d6145a5c07c4a52d$var$getSelector = $3o9ph.getSelector, $d6145a5c07c4a52d$var$getVariablesFromFragment = $3o9ph.getVariablesFromFragment;

var $5p1SR = parcelRequire("5p1SR");

var $9DZlA = parcelRequire("9DZlA");

var $ahEdt = parcelRequire("ahEdt");

var $lnxjc = parcelRequire("lnxjc");
var $d6145a5c07c4a52d$var$intern = $lnxjc.intern;
function $d6145a5c07c4a52d$var$getFragmentIdentifier(fragmentNode, fragmentRef) {
    var selector = $d6145a5c07c4a52d$var$getSelector(fragmentNode, fragmentRef);
    var fragmentOwnerIdentifier = selector == null ? 'null' : selector.kind === 'SingularReaderSelector' ? selector.owner.identifier : '[' + selector.selectors.map(function(sel) {
        return sel.owner.identifier;
    }).join(',') + ']';
    var fragmentVariables = $d6145a5c07c4a52d$var$getVariablesFromFragment(fragmentNode, fragmentRef);
    var dataIDs = $d6145a5c07c4a52d$var$getDataIDsFromFragment(fragmentNode, fragmentRef);
    if ($9DZlA.ENABLE_GETFRAGMENTIDENTIFIER_OPTIMIZATION) {
        var ids = typeof dataIDs === 'undefined' ? 'missing' : dataIDs == null ? 'null' : Array.isArray(dataIDs) ? '[' + dataIDs.join(',') + ']' : dataIDs;
        ids = $9DZlA.STRING_INTERN_LEVEL <= 1 ? ids : $d6145a5c07c4a52d$var$intern(ids, $9DZlA.MAX_DATA_ID_LENGTH);
        return fragmentOwnerIdentifier + '/' + fragmentNode.name + '/' + (fragmentVariables == null || $5p1SR(fragmentVariables) ? '{}' : JSON.stringify($ahEdt(fragmentVariables))) + '/' + ids;
    } else {
        var _JSON$stringify;
        var _ids = (_JSON$stringify = JSON.stringify(dataIDs)) !== null && _JSON$stringify !== void 0 ? _JSON$stringify : 'missing';
        _ids = $9DZlA.STRING_INTERN_LEVEL <= 1 ? _ids : $d6145a5c07c4a52d$var$intern(_ids, $9DZlA.MAX_DATA_ID_LENGTH);
        return fragmentOwnerIdentifier + '/' + fragmentNode.name + '/' + JSON.stringify($ahEdt(fragmentVariables)) + '/' + _ids;
    }
}
module.exports = $d6145a5c07c4a52d$var$getFragmentIdentifier;

});
parcelRegister("5p1SR", function(module, exports) {
'use strict';
var $3ef0bfa68c535f13$var$hasOwnProperty = Object.prototype.hasOwnProperty;
function $3ef0bfa68c535f13$var$isEmptyObject(obj) {
    for(var _key in obj){
        if ($3ef0bfa68c535f13$var$hasOwnProperty.call(obj, _key)) return false;
    }
    return true;
}
module.exports = $3ef0bfa68c535f13$var$isEmptyObject;

});


parcelRegister("8duCX", function(module, exports) {
'use strict';

var $6FEiH = parcelRequire("6FEiH");

var $bQThX = parcelRequire("bQThX");
function $5fb74b9627b6d3bf$var$getPaginationMetadata(fragmentNode, componentDisplayName) {
    var _fragmentNode$metadat, _fragmentNode$metadat2;
    var _getRefetchMetadata = $6FEiH(fragmentNode, componentDisplayName), paginationRequest = _getRefetchMetadata.refetchableRequest, refetchMetadata = _getRefetchMetadata.refetchMetadata;
    var paginationMetadata = refetchMetadata.connection;
    !(paginationMetadata != null) && $bQThX(false);
    var connectionPathInFragmentData = paginationMetadata.path;
    var connectionMetadata = ((_fragmentNode$metadat = (_fragmentNode$metadat2 = fragmentNode.metadata) === null || _fragmentNode$metadat2 === void 0 ? void 0 : _fragmentNode$metadat2.connection) !== null && _fragmentNode$metadat !== void 0 ? _fragmentNode$metadat : [])[0];
    !(connectionMetadata != null) && $bQThX(false);
    var identifierInfo = refetchMetadata.identifierInfo;
    !((identifierInfo === null || identifierInfo === void 0 ? void 0 : identifierInfo.identifierField) == null || typeof identifierInfo.identifierField === 'string') && $bQThX(false);
    return {
        connectionPathInFragmentData: connectionPathInFragmentData,
        identifierField: identifierInfo === null || identifierInfo === void 0 ? void 0 : identifierInfo.identifierField,
        paginationRequest: paginationRequest,
        paginationMetadata: paginationMetadata,
        stream: connectionMetadata.stream === true
    };
}
module.exports = $5fb74b9627b6d3bf$var$getPaginationMetadata;

});
parcelRegister("6FEiH", function(module, exports) {
'use strict';

var $bQThX = parcelRequire("bQThX");
function $4db5d54b1a6c3559$var$getRefetchMetadata(fragmentNode, componentDisplayName) {
    var _fragmentNode$metadat, _fragmentNode$metadat2;
    !(((_fragmentNode$metadat = fragmentNode.metadata) === null || _fragmentNode$metadat === void 0 ? void 0 : _fragmentNode$metadat.plural) !== true) && $bQThX(false);
    var refetchMetadata = (_fragmentNode$metadat2 = fragmentNode.metadata) === null || _fragmentNode$metadat2 === void 0 ? void 0 : _fragmentNode$metadat2.refetch;
    !(refetchMetadata != null) && $bQThX(false);
    var refetchableRequest = refetchMetadata.operation["default"] ? refetchMetadata.operation["default"] : refetchMetadata.operation;
    var fragmentRefPathInResponse = refetchMetadata.fragmentPathInResult;
    !(typeof refetchableRequest !== 'string') && $bQThX(false);
    var identifierInfo = refetchMetadata.identifierInfo;
    if (identifierInfo != null) {
        !(identifierInfo.identifierField == null || typeof identifierInfo.identifierField === 'string') && $bQThX(false);
        !(identifierInfo.identifierQueryVariableName == null || typeof identifierInfo.identifierQueryVariableName === 'string') && $bQThX(false);
    }
    return {
        fragmentRefPathInResponse: fragmentRefPathInResponse,
        identifierInfo: identifierInfo,
        refetchableRequest: refetchableRequest,
        refetchMetadata: refetchMetadata
    };
}
module.exports = $4db5d54b1a6c3559$var$getRefetchMetadata;

});


parcelRegister("8wd6q", function(module, exports) {
'use strict';

var $7dvyf = parcelRequire("7dvyf");
var $633b79c98357b681$var$_interopRequireDefault = $7dvyf.default;

var $633b79c98357b681$var$_defineProperty2 = $633b79c98357b681$var$_interopRequireDefault((parcelRequire("dW6Ee")));

var $633b79c98357b681$var$_objectSpread4 = $633b79c98357b681$var$_interopRequireDefault((parcelRequire("4N8OD")));

var $bQThX = parcelRequire("bQThX");
parcelRequire("hzw7m");
function $633b79c98357b681$var$getPaginationVariables(direction, count, cursor, baseVariables, extraVariables, paginationMetadata) {
    var _objectSpread3;
    var backwardMetadata = paginationMetadata.backward, forwardMetadata = paginationMetadata.forward;
    if (direction === 'backward') {
        var _objectSpread2;
        !(backwardMetadata != null && backwardMetadata.count != null && backwardMetadata.cursor != null) && $bQThX(false);
        var _paginationVariables = (0, $633b79c98357b681$var$_objectSpread4["default"])((0, $633b79c98357b681$var$_objectSpread4["default"])((0, $633b79c98357b681$var$_objectSpread4["default"])({}, baseVariables), extraVariables), {}, (_objectSpread2 = {}, (0, $633b79c98357b681$var$_defineProperty2["default"])(_objectSpread2, backwardMetadata.cursor, cursor), (0, $633b79c98357b681$var$_defineProperty2["default"])(_objectSpread2, backwardMetadata.count, count), _objectSpread2));
        if (forwardMetadata && forwardMetadata.cursor) _paginationVariables[forwardMetadata.cursor] = null;
        if (forwardMetadata && forwardMetadata.count) _paginationVariables[forwardMetadata.count] = null;
        return _paginationVariables;
    }
    !(forwardMetadata != null && forwardMetadata.count != null && forwardMetadata.cursor != null) && $bQThX(false);
    var paginationVariables = (0, $633b79c98357b681$var$_objectSpread4["default"])((0, $633b79c98357b681$var$_objectSpread4["default"])((0, $633b79c98357b681$var$_objectSpread4["default"])({}, baseVariables), extraVariables), {}, (_objectSpread3 = {}, (0, $633b79c98357b681$var$_defineProperty2["default"])(_objectSpread3, forwardMetadata.cursor, cursor), (0, $633b79c98357b681$var$_defineProperty2["default"])(_objectSpread3, forwardMetadata.count, count), _objectSpread3));
    if (backwardMetadata && backwardMetadata.cursor) paginationVariables[backwardMetadata.cursor] = null;
    if (backwardMetadata && backwardMetadata.count) paginationVariables[backwardMetadata.count] = null;
    return paginationVariables;
}
module.exports = $633b79c98357b681$var$getPaginationVariables;

});

parcelRegister("lSrhQ", function(module, exports) {
'use strict';

var $7dvyf = parcelRequire("7dvyf");
var $fed3ceba89845078$var$_interopRequireDefault = $7dvyf.default;

var $fed3ceba89845078$var$_createForOfIteratorHelper2 = $fed3ceba89845078$var$_interopRequireDefault((parcelRequire("bTRzt")));

var $bQThX = parcelRequire("bQThX");
function $fed3ceba89845078$var$getValueAtPath(data, path) {
    var result = data;
    var _iterator = (0, $fed3ceba89845078$var$_createForOfIteratorHelper2["default"])(path), _step;
    try {
        for(_iterator.s(); !(_step = _iterator.n()).done;){
            var key = _step.value;
            if (result == null) return null;
            if (typeof key === 'number') {
                !Array.isArray(result) && $bQThX(false);
                result = result[key];
            } else {
                !(typeof result === 'object' && !Array.isArray(result)) && $bQThX(false);
                result = result[key];
            }
        }
    } catch (err) {
        _iterator.e(err);
    } finally{
        _iterator.f();
    }
    return result;
}
module.exports = $fed3ceba89845078$var$getValueAtPath;

});

parcelRegister("8xKQX", function(module, exports) {
'use strict';
var $6385bfda6cb0c891$var$profileHandlersByName = {};
var $6385bfda6cb0c891$var$defaultProfiler = {
    stop: function stop() {}
};
var $6385bfda6cb0c891$var$RelayProfiler = {
    profile: function profile(name, state) {
        var handlers = $6385bfda6cb0c891$var$profileHandlersByName[name];
        if (handlers && handlers.length > 0) {
            var stopHandlers = [];
            for(var ii = handlers.length - 1; ii >= 0; ii--){
                var stopHandler = handlers[ii](name, state);
                stopHandlers.unshift(stopHandler);
            }
            return {
                stop: function stop(error) {
                    stopHandlers.forEach(function(stopHandler) {
                        return stopHandler(error);
                    });
                }
            };
        }
        return $6385bfda6cb0c891$var$defaultProfiler;
    },
    attachProfileHandler: function attachProfileHandler(name, handler) {
        if (!$6385bfda6cb0c891$var$profileHandlersByName.hasOwnProperty(name)) $6385bfda6cb0c891$var$profileHandlersByName[name] = [];
        $6385bfda6cb0c891$var$profileHandlersByName[name].push(handler);
    },
    detachProfileHandler: function detachProfileHandler(name, handler) {
        if ($6385bfda6cb0c891$var$profileHandlersByName.hasOwnProperty(name)) $6385bfda6cb0c891$var$removeFromArray($6385bfda6cb0c891$var$profileHandlersByName[name], handler);
    }
};
function $6385bfda6cb0c891$var$removeFromArray(array, element) {
    var index = array.indexOf(element);
    if (index !== -1) array.splice(index, 1);
}
module.exports = $6385bfda6cb0c891$var$RelayProfiler;

});




parcelRegister("gUSPY", function(module, exports) {
'use strict';

var $7dvyf = parcelRequire("7dvyf");
var $c50c69d71d6ca91b$var$_interopRequireDefault = $7dvyf.default;

var $c50c69d71d6ca91b$var$_extends2 = $c50c69d71d6ca91b$var$_interopRequireDefault((parcelRequire("l1aCK")));

var $c50c69d71d6ca91b$var$_objectWithoutPropertiesLoose2 = $c50c69d71d6ca91b$var$_interopRequireDefault((parcelRequire("7o4v7")));

var $c50c69d71d6ca91b$var$_assertThisInitialized2 = $c50c69d71d6ca91b$var$_interopRequireDefault((parcelRequire("jRtfH")));

var $c50c69d71d6ca91b$var$_inheritsLoose2 = $c50c69d71d6ca91b$var$_interopRequireDefault((parcelRequire("isJpf")));

var $c50c69d71d6ca91b$var$_defineProperty2 = $c50c69d71d6ca91b$var$_interopRequireDefault((parcelRequire("dW6Ee")));
var $c50c69d71d6ca91b$var$_excluded = [
    "componentRef",
    "__relayContext",
    "__rootIsQueryRenderer"
];

var $fpqUS = parcelRequire("fpqUS");

var $aDTyX = parcelRequire("aDTyX");
var $c50c69d71d6ca91b$var$getContainerName = $aDTyX.getContainerName;

var $9TNTX = parcelRequire("9TNTX");
var $c50c69d71d6ca91b$var$assertRelayContext = $9TNTX.assertRelayContext;

var $3Nt2B = parcelRequire("3Nt2B");

var $gwFzn = parcelRequire("gwFzn");

var $lan9D = parcelRequire("lan9D");
var $c50c69d71d6ca91b$var$createFragmentSpecResolver = $lan9D.createFragmentSpecResolver, $c50c69d71d6ca91b$var$getDataIDsFromObject = $lan9D.getDataIDsFromObject, $c50c69d71d6ca91b$var$isScalarAndEqual = $lan9D.isScalarAndEqual;
function $c50c69d71d6ca91b$var$createContainerWithFragments(Component, fragments) {
    var _class;
    var containerName = $c50c69d71d6ca91b$var$getContainerName(Component);
    return _class = /*#__PURE__*/ function(_React$Component) {
        (0, $c50c69d71d6ca91b$var$_inheritsLoose2["default"])(_class, _React$Component);
        function _class(props) {
            var _props$__rootIsQueryR, _this;
            _this = _React$Component.call(this, props) || this;
            (0, $c50c69d71d6ca91b$var$_defineProperty2["default"])((0, $c50c69d71d6ca91b$var$_assertThisInitialized2["default"])(_this), "_handleFragmentDataUpdate", function() {
                var resolverFromThisUpdate = _this.state.resolver;
                _this.setState(function(updatedState) {
                    return resolverFromThisUpdate === updatedState.resolver ? {
                        data: updatedState.resolver.resolve(),
                        relayProp: $c50c69d71d6ca91b$var$getRelayProp(updatedState.relayProp.environment)
                    } : null;
                });
            });
            var relayContext = $c50c69d71d6ca91b$var$assertRelayContext(props.__relayContext);
            var rootIsQueryRenderer = (_props$__rootIsQueryR = props.__rootIsQueryRenderer) !== null && _props$__rootIsQueryR !== void 0 ? _props$__rootIsQueryR : false;
            var resolver = $c50c69d71d6ca91b$var$createFragmentSpecResolver(relayContext, containerName, fragments, props, rootIsQueryRenderer);
            _this.state = {
                data: resolver.resolve(),
                prevProps: props,
                prevPropsContext: relayContext,
                relayProp: $c50c69d71d6ca91b$var$getRelayProp(relayContext.environment),
                resolver: resolver
            };
            return _this;
        }
        _class.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps, prevState) {
            var _nextProps$__rootIsQu;
            var prevProps = prevState.prevProps;
            var relayContext = $c50c69d71d6ca91b$var$assertRelayContext(nextProps.__relayContext);
            var rootIsQueryRenderer = (_nextProps$__rootIsQu = nextProps.__rootIsQueryRenderer) !== null && _nextProps$__rootIsQu !== void 0 ? _nextProps$__rootIsQu : false;
            var prevIDs = $c50c69d71d6ca91b$var$getDataIDsFromObject(fragments, prevProps);
            var nextIDs = $c50c69d71d6ca91b$var$getDataIDsFromObject(fragments, nextProps);
            var resolver = prevState.resolver;
            if (prevState.prevPropsContext.environment !== relayContext.environment || !$3Nt2B(prevIDs, nextIDs)) {
                resolver = $c50c69d71d6ca91b$var$createFragmentSpecResolver(relayContext, containerName, fragments, nextProps, rootIsQueryRenderer);
                return {
                    data: resolver.resolve(),
                    prevPropsContext: relayContext,
                    prevProps: nextProps,
                    relayProp: $c50c69d71d6ca91b$var$getRelayProp(relayContext.environment),
                    resolver: resolver
                };
            } else {
                resolver.setProps(nextProps);
                var data = resolver.resolve();
                if (data !== prevState.data) return {
                    data: data,
                    prevProps: nextProps,
                    prevPropsContext: relayContext,
                    relayProp: $c50c69d71d6ca91b$var$getRelayProp(relayContext.environment)
                };
            }
            return null;
        };
        var _proto = _class.prototype;
        _proto.componentDidMount = function componentDidMount() {
            this._subscribeToNewResolverAndRerenderIfStoreHasChanged();
        };
        _proto.componentDidUpdate = function componentDidUpdate(prevProps, prevState) {
            if (this.state.resolver !== prevState.resolver) {
                prevState.resolver.dispose();
                this._subscribeToNewResolverAndRerenderIfStoreHasChanged();
            } else this._rerenderIfStoreHasChanged();
        };
        _proto.componentWillUnmount = function componentWillUnmount() {
            this.state.resolver.dispose();
        };
        _proto.shouldComponentUpdate = function shouldComponentUpdate(nextProps, nextState) {
            if (nextState.data !== this.state.data) return true;
            var keys = Object.keys(nextProps);
            for(var ii = 0; ii < keys.length; ii++){
                var key = keys[ii];
                if (key === '__relayContext') {
                    if (nextState.prevPropsContext.environment !== this.state.prevPropsContext.environment) return true;
                } else {
                    if (!fragments.hasOwnProperty(key) && !$c50c69d71d6ca91b$var$isScalarAndEqual(nextProps[key], this.props[key])) return true;
                }
            }
            return false;
        };
        _proto._rerenderIfStoreHasChanged = function _rerenderIfStoreHasChanged() {
            var _this$state = this.state, data = _this$state.data, resolver = _this$state.resolver;
            var maybeNewData = resolver.resolve();
            if (data !== maybeNewData) this.setState({
                data: maybeNewData
            });
        };
        _proto._subscribeToNewResolverAndRerenderIfStoreHasChanged = function _subscribeToNewResolverAndRerenderIfStoreHasChanged() {
            var _this$state2 = this.state, data = _this$state2.data, resolver = _this$state2.resolver;
            var maybeNewData = resolver.resolve();
            resolver.setCallback(this.props, this._handleFragmentDataUpdate);
            if (data !== maybeNewData) this.setState({
                data: maybeNewData
            });
        };
        _proto.render = function render() {
            var _this$props = this.props, componentRef = _this$props.componentRef, __relayContext = _this$props.__relayContext, __rootIsQueryRenderer = _this$props.__rootIsQueryRenderer, props = (0, $c50c69d71d6ca91b$var$_objectWithoutPropertiesLoose2["default"])(_this$props, $c50c69d71d6ca91b$var$_excluded);
            return /*#__PURE__*/ $gwFzn.createElement(Component, (0, $c50c69d71d6ca91b$var$_extends2["default"])({}, props, this.state.data, {
                ref: componentRef,
                relay: this.state.relayProp
            }));
        };
        return _class;
    }($gwFzn.Component), (0, $c50c69d71d6ca91b$var$_defineProperty2["default"])(_class, "displayName", containerName), _class;
}
function $c50c69d71d6ca91b$var$getRelayProp(environment) {
    return {
        environment: environment
    };
}
function $c50c69d71d6ca91b$var$createContainer(Component, fragmentSpec) {
    return $fpqUS(Component, fragmentSpec, $c50c69d71d6ca91b$var$createContainerWithFragments);
}
module.exports = {
    createContainer: $c50c69d71d6ca91b$var$createContainer
};

});
parcelRegister("fpqUS", function(module, exports) {
'use strict';

var $7dvyf = parcelRequire("7dvyf");
var $b37e11dcdbbf2d8f$var$_interopRequireDefault = $7dvyf.default;

var $b37e11dcdbbf2d8f$var$_extends2 = $b37e11dcdbbf2d8f$var$_interopRequireDefault((parcelRequire("l1aCK")));

var $aWP7J = parcelRequire("aWP7J");

var $aDTyX = parcelRequire("aDTyX");
var $b37e11dcdbbf2d8f$var$getComponentName = $aDTyX.getComponentName, $b37e11dcdbbf2d8f$var$getContainerName = $aDTyX.getContainerName;

var $ddePm = parcelRequire("ddePm");

var $l8g1G = parcelRequire("l8g1G");

var $bQThX = parcelRequire("bQThX");

var $gwFzn = parcelRequire("gwFzn");

var $lan9D = parcelRequire("lan9D");
var $b37e11dcdbbf2d8f$var$getFragment = $lan9D.getFragment;
var $b37e11dcdbbf2d8f$var$useContext = $gwFzn.useContext;
function $b37e11dcdbbf2d8f$var$buildReactRelayContainer(ComponentClass, fragmentSpec, createContainerWithFragments) {
    var containerName = $b37e11dcdbbf2d8f$var$getContainerName(ComponentClass);
    $aWP7J($b37e11dcdbbf2d8f$var$getComponentName(ComponentClass), fragmentSpec);
    var fragments = {};
    for(var key in fragmentSpec)fragments[key] = $b37e11dcdbbf2d8f$var$getFragment(fragmentSpec[key]);
    var Container = createContainerWithFragments(ComponentClass, fragments);
    Container.displayName = containerName;
    function ForwardRef(props, ref) {
        var _queryRendererContext;
        var context = $b37e11dcdbbf2d8f$var$useContext($ddePm);
        !(context != null) && $bQThX(false);
        var queryRendererContext = $b37e11dcdbbf2d8f$var$useContext($l8g1G);
        return /*#__PURE__*/ $gwFzn.createElement(Container, (0, $b37e11dcdbbf2d8f$var$_extends2["default"])({}, props, {
            __relayContext: context,
            __rootIsQueryRenderer: (_queryRendererContext = queryRendererContext === null || queryRendererContext === void 0 ? void 0 : queryRendererContext.rootIsQueryRenderer) !== null && _queryRendererContext !== void 0 ? _queryRendererContext : false,
            componentRef: props.componentRef || ref
        }));
    }
    ForwardRef.displayName = containerName;
    var ForwardContainer = $gwFzn.forwardRef(ForwardRef);
    return ForwardContainer;
}
module.exports = $b37e11dcdbbf2d8f$var$buildReactRelayContainer;

});
parcelRegister("aWP7J", function(module, exports) {
'use strict';

var $bQThX = parcelRequire("bQThX");
function $7f86fa449c468e86$var$assertFragmentMap(componentName, fragmentSpec) {
    !(fragmentSpec && typeof fragmentSpec === 'object') && $bQThX(false);
    for(var key in fragmentSpec)if (fragmentSpec.hasOwnProperty(key)) {
        var fragment = fragmentSpec[key];
        !(fragment && (typeof fragment === 'object' || typeof fragment === 'function')) && $bQThX(false);
    }
}
module.exports = $7f86fa449c468e86$var$assertFragmentMap;

});

parcelRegister("aDTyX", function(module, exports) {
'use strict';
function $7bf8a581c5d26b5f$var$getComponentName(component) {
    return component.displayName || component.name || 'Component';
}
function $7bf8a581c5d26b5f$var$getContainerName(Component) {
    return 'Relay(' + $7bf8a581c5d26b5f$var$getComponentName(Component) + ')';
}
module.exports = {
    getComponentName: $7bf8a581c5d26b5f$var$getComponentName,
    getContainerName: $7bf8a581c5d26b5f$var$getContainerName
};

});

parcelRegister("l8g1G", function(module, exports) {
'use strict';

var $gwFzn = parcelRequire("gwFzn");
module.exports = $gwFzn.createContext({
    rootIsQueryRenderer: false
});

});


parcelRegister("9TNTX", function(module, exports) {
'use strict';

var $2SIQL = parcelRequire("2SIQL");

var $bQThX = parcelRequire("bQThX");
function $734ff584ffeceb64$var$assertRelayContext(relay) {
    !$734ff584ffeceb64$var$isRelayContext(relay) && $bQThX(false);
    return relay;
}
function $734ff584ffeceb64$var$isRelayContext(context) {
    return typeof context === 'object' && context !== null && !Array.isArray(context) && $2SIQL(context.environment);
}
module.exports = {
    assertRelayContext: $734ff584ffeceb64$var$assertRelayContext,
    isRelayContext: $734ff584ffeceb64$var$isRelayContext
};

});
parcelRegister("2SIQL", function(module, exports) {
'use strict';
function $21936a37ebbf3cbe$var$isRelayEnvironment(environment) {
    return typeof environment === 'object' && environment !== null && typeof environment.check === 'function' && typeof environment.lookup === 'function' && typeof environment.retain === 'function' && typeof environment.execute === 'function' && typeof environment.subscribe === 'function';
}
module.exports = $21936a37ebbf3cbe$var$isRelayEnvironment;

});



parcelRegister("7nf8e", function(module, exports) {
'use strict';

var $ddePm = parcelRequire("ddePm");

var $l8g1G = parcelRequire("l8g1G");

var $3Nt2B = parcelRequire("3Nt2B");

var $gwFzn = parcelRequire("gwFzn");

var $lan9D = parcelRequire("lan9D");
var $55e66b431464b80a$var$createOperationDescriptor = $lan9D.createOperationDescriptor, $55e66b431464b80a$var$deepFreeze = $lan9D.deepFreeze, $55e66b431464b80a$var$getRequest = $lan9D.getRequest;
var $55e66b431464b80a$var$useLayoutEffect = $gwFzn.useLayoutEffect, $55e66b431464b80a$var$useState = $gwFzn.useState, $55e66b431464b80a$var$useRef = $gwFzn.useRef, $55e66b431464b80a$var$useMemo = $gwFzn.useMemo;
var $55e66b431464b80a$var$queryRendererContext = {
    rootIsQueryRenderer: true
};
function $55e66b431464b80a$var$useDeepCompare(value) {
    var latestValue = $gwFzn.useRef(value);
    if (!$3Nt2B(latestValue.current, value)) latestValue.current = value;
    return latestValue.current;
}
function $55e66b431464b80a$var$ReactRelayLocalQueryRenderer(props) {
    var environment = props.environment, query = props.query, variables = props.variables, render = props.render;
    var latestVariables = $55e66b431464b80a$var$useDeepCompare(variables);
    var operation = $55e66b431464b80a$var$useMemo(function() {
        var request = $55e66b431464b80a$var$getRequest(query);
        return $55e66b431464b80a$var$createOperationDescriptor(request, latestVariables);
    }, [
        query,
        latestVariables
    ]);
    var relayContext = $55e66b431464b80a$var$useMemo(function() {
        return {
            environment: environment
        };
    }, [
        environment
    ]);
    var dataRef = $55e66b431464b80a$var$useRef(null);
    var _useState = $55e66b431464b80a$var$useState(null), forceUpdate = _useState[1];
    var cleanupFnRef = $55e66b431464b80a$var$useRef(null);
    var snapshot = $55e66b431464b80a$var$useMemo(function() {
        environment.check(operation);
        var res = environment.lookup(operation.fragment);
        dataRef.current = res.data;
        var retainDisposable = environment.retain(operation);
        var subscribeDisposable = environment.subscribe(res, function(newSnapshot) {
            dataRef.current = newSnapshot.data;
            forceUpdate(dataRef.current);
        });
        var disposed = false;
        function nextCleanupFn() {
            if (!disposed) {
                disposed = true;
                cleanupFnRef.current = null;
                retainDisposable.dispose();
                subscribeDisposable.dispose();
            }
        }
        if (cleanupFnRef.current) cleanupFnRef.current();
        cleanupFnRef.current = nextCleanupFn;
        return res;
    }, [
        environment,
        operation
    ]);
    $55e66b431464b80a$var$useLayoutEffect(function() {
        var cleanupFn = cleanupFnRef.current;
        return function() {
            cleanupFn && cleanupFn();
        };
    }, [
        snapshot
    ]);
    return /*#__PURE__*/ $gwFzn.createElement($ddePm.Provider, {
        value: relayContext
    }, /*#__PURE__*/ $gwFzn.createElement($l8g1G.Provider, {
        value: $55e66b431464b80a$var$queryRendererContext
    }, render({
        props: dataRef.current
    })));
}
module.exports = $55e66b431464b80a$var$ReactRelayLocalQueryRenderer;

});

parcelRegister("8nBV4", function(module, exports) {
'use strict';

var $7dvyf = parcelRequire("7dvyf");
var $619de2c0266a2ba1$var$_interopRequireDefault = $7dvyf.default;

var $619de2c0266a2ba1$var$_extends2 = $619de2c0266a2ba1$var$_interopRequireDefault((parcelRequire("l1aCK")));

var $619de2c0266a2ba1$var$_objectWithoutPropertiesLoose2 = $619de2c0266a2ba1$var$_interopRequireDefault((parcelRequire("7o4v7")));

var $619de2c0266a2ba1$var$_assertThisInitialized2 = $619de2c0266a2ba1$var$_interopRequireDefault((parcelRequire("jRtfH")));

var $619de2c0266a2ba1$var$_inheritsLoose2 = $619de2c0266a2ba1$var$_interopRequireDefault((parcelRequire("isJpf")));

var $619de2c0266a2ba1$var$_defineProperty2 = $619de2c0266a2ba1$var$_interopRequireDefault((parcelRequire("dW6Ee")));

var $619de2c0266a2ba1$var$_objectSpread3 = $619de2c0266a2ba1$var$_interopRequireDefault((parcelRequire("4N8OD")));
var $619de2c0266a2ba1$var$_excluded = [
    "componentRef"
], $619de2c0266a2ba1$var$_excluded2 = [
    "componentRef",
    "__relayContext",
    "__rootIsQueryRenderer"
], $619de2c0266a2ba1$var$_excluded3 = [
    "componentRef",
    "__relayContext",
    "__rootIsQueryRenderer"
];

var $fpqUS = parcelRequire("fpqUS");

var $lNLJb = parcelRequire("lNLJb");

var $aDTyX = parcelRequire("aDTyX");
var $619de2c0266a2ba1$var$getComponentName = $aDTyX.getComponentName, $619de2c0266a2ba1$var$getContainerName = $aDTyX.getContainerName;

var $ddePm = parcelRequire("ddePm");

var $iphc9 = parcelRequire("iphc9");

var $9TNTX = parcelRequire("9TNTX");
var $619de2c0266a2ba1$var$assertRelayContext = $9TNTX.assertRelayContext;

var $3Nt2B = parcelRequire("3Nt2B");

var $bQThX = parcelRequire("bQThX");

var $gwFzn = parcelRequire("gwFzn");

var $lan9D = parcelRequire("lan9D");
var $619de2c0266a2ba1$var$ConnectionInterface = $lan9D.ConnectionInterface, $619de2c0266a2ba1$var$Observable = $lan9D.Observable, $619de2c0266a2ba1$var$RelayFeatureFlags = $lan9D.RelayFeatureFlags, $619de2c0266a2ba1$var$createFragmentSpecResolver = $lan9D.createFragmentSpecResolver, $619de2c0266a2ba1$var$createOperationDescriptor = $lan9D.createOperationDescriptor, $619de2c0266a2ba1$var$getDataIDsFromObject = $lan9D.getDataIDsFromObject, $619de2c0266a2ba1$var$getRequest = $lan9D.getRequest, $619de2c0266a2ba1$var$getVariablesFromObject = $lan9D.getVariablesFromObject, $619de2c0266a2ba1$var$isScalarAndEqual = $lan9D.isScalarAndEqual;
parcelRequire("hzw7m");
var $619de2c0266a2ba1$var$FORWARD = 'forward';
function $619de2c0266a2ba1$var$createGetConnectionFromProps(metadata) {
    var path = metadata.path;
    !path && $bQThX(false);
    return function(props) {
        var data = props[metadata.fragmentName];
        for(var i = 0; i < path.length; i++){
            if (!data || typeof data !== 'object') return null;
            data = data[path[i]];
        }
        return data;
    };
}
function $619de2c0266a2ba1$var$createGetFragmentVariables(metadata) {
    var countVariable = metadata.count;
    !countVariable && $bQThX(false);
    return function(prevVars, totalCount) {
        return (0, $619de2c0266a2ba1$var$_objectSpread3["default"])((0, $619de2c0266a2ba1$var$_objectSpread3["default"])({}, prevVars), {}, (0, $619de2c0266a2ba1$var$_defineProperty2["default"])({}, countVariable, totalCount));
    };
}
function $619de2c0266a2ba1$var$findConnectionMetadata(fragments) {
    var foundConnectionMetadata = null;
    var isRelayModern = false;
    for(var fragmentName in fragments){
        var fragment = fragments[fragmentName];
        var connectionMetadata = fragment.metadata && fragment.metadata.connection;
        if (fragment.metadata !== undefined) isRelayModern = true;
        if (connectionMetadata) {
            !(connectionMetadata.length === 1) && $bQThX(false);
            !!foundConnectionMetadata && $bQThX(false);
            foundConnectionMetadata = (0, $619de2c0266a2ba1$var$_objectSpread3["default"])((0, $619de2c0266a2ba1$var$_objectSpread3["default"])({}, connectionMetadata[0]), {}, {
                fragmentName: fragmentName
            });
        }
    }
    !(!isRelayModern || foundConnectionMetadata !== null) && $bQThX(false);
    return foundConnectionMetadata || {};
}
function $619de2c0266a2ba1$var$toObserver(observerOrCallback) {
    return typeof observerOrCallback === 'function' ? {
        error: observerOrCallback,
        complete: observerOrCallback,
        unsubscribe: function unsubscribe(subscription) {
            typeof observerOrCallback === 'function' && observerOrCallback();
        }
    } : observerOrCallback || {};
}
function $619de2c0266a2ba1$var$createContainerWithFragments(Component, fragments, connectionConfig) {
    var _class;
    var componentName = $619de2c0266a2ba1$var$getComponentName(Component);
    var containerName = $619de2c0266a2ba1$var$getContainerName(Component);
    var metadata = $619de2c0266a2ba1$var$findConnectionMetadata(fragments);
    var getConnectionFromProps = connectionConfig.getConnectionFromProps || $619de2c0266a2ba1$var$createGetConnectionFromProps(metadata);
    var direction = connectionConfig.direction || metadata.direction;
    !direction && $bQThX(false);
    var getFragmentVariables = connectionConfig.getFragmentVariables || $619de2c0266a2ba1$var$createGetFragmentVariables(metadata);
    return _class = /*#__PURE__*/ function(_React$Component) {
        (0, $619de2c0266a2ba1$var$_inheritsLoose2["default"])(_class, _React$Component);
        function _class(props) {
            var _props$__rootIsQueryR, _this;
            _this = _React$Component.call(this, props) || this;
            (0, $619de2c0266a2ba1$var$_defineProperty2["default"])((0, $619de2c0266a2ba1$var$_assertThisInitialized2["default"])(_this), "_handleFragmentDataUpdate", function() {
                _this.setState({
                    data: _this._resolver.resolve()
                });
            });
            (0, $619de2c0266a2ba1$var$_defineProperty2["default"])((0, $619de2c0266a2ba1$var$_assertThisInitialized2["default"])(_this), "_hasMore", function() {
                var connectionData = _this._getConnectionData();
                return !!(connectionData && connectionData.hasMore && connectionData.cursor);
            });
            (0, $619de2c0266a2ba1$var$_defineProperty2["default"])((0, $619de2c0266a2ba1$var$_assertThisInitialized2["default"])(_this), "_isLoading", function() {
                return !!_this._refetchSubscription;
            });
            (0, $619de2c0266a2ba1$var$_defineProperty2["default"])((0, $619de2c0266a2ba1$var$_assertThisInitialized2["default"])(_this), "_refetchConnection", function(totalCount, observerOrCallback, refetchVariables) {
                if (!_this._canFetchPage('refetchConnection')) return {
                    dispose: function dispose() {}
                };
                _this._refetchVariables = refetchVariables;
                var paginatingVariables = {
                    count: totalCount,
                    cursor: null,
                    totalCount: totalCount
                };
                var fetch = _this._fetchPage(paginatingVariables, $619de2c0266a2ba1$var$toObserver(observerOrCallback), {
                    force: true
                });
                return {
                    dispose: fetch.unsubscribe
                };
            });
            (0, $619de2c0266a2ba1$var$_defineProperty2["default"])((0, $619de2c0266a2ba1$var$_assertThisInitialized2["default"])(_this), "_loadMore", function(pageSize, observerOrCallback, options) {
                if (!_this._canFetchPage('loadMore')) return {
                    dispose: function dispose() {}
                };
                var observer = $619de2c0266a2ba1$var$toObserver(observerOrCallback);
                var connectionData = _this._getConnectionData();
                if (!connectionData) {
                    $619de2c0266a2ba1$var$Observable.create(function(sink) {
                        return sink.complete();
                    }).subscribe(observer);
                    return null;
                }
                var totalCount = connectionData.edgeCount + pageSize;
                if (options && options.force) return _this._refetchConnection(totalCount, observerOrCallback);
                var _ConnectionInterface$ = $619de2c0266a2ba1$var$ConnectionInterface.get(), END_CURSOR = _ConnectionInterface$.END_CURSOR, START_CURSOR = _ConnectionInterface$.START_CURSOR;
                var cursor = connectionData.cursor;
                var paginatingVariables = {
                    count: pageSize,
                    cursor: cursor,
                    totalCount: totalCount
                };
                var fetch = _this._fetchPage(paginatingVariables, observer, options);
                return {
                    dispose: fetch.unsubscribe
                };
            });
            var relayContext = $619de2c0266a2ba1$var$assertRelayContext(props.__relayContext);
            var rootIsQueryRenderer = (_props$__rootIsQueryR = props.__rootIsQueryRenderer) !== null && _props$__rootIsQueryR !== void 0 ? _props$__rootIsQueryR : false;
            _this._isARequestInFlight = false;
            _this._refetchSubscription = null;
            _this._refetchVariables = null;
            if ($619de2c0266a2ba1$var$RelayFeatureFlags.ENABLE_CONTAINERS_SUBSCRIBE_ON_COMMIT === true) _this._resolver = $619de2c0266a2ba1$var$createFragmentSpecResolver(relayContext, containerName, fragments, props, rootIsQueryRenderer);
            else _this._resolver = $619de2c0266a2ba1$var$createFragmentSpecResolver(relayContext, containerName, fragments, props, rootIsQueryRenderer, _this._handleFragmentDataUpdate);
            _this.state = {
                data: _this._resolver.resolve(),
                prevContext: relayContext,
                contextForChildren: relayContext,
                relayProp: _this._buildRelayProp(relayContext),
                resolverGeneration: 0
            };
            _this._isUnmounted = false;
            _this._hasFetched = false;
            return _this;
        }
        var _proto = _class.prototype;
        _proto.componentDidMount = function componentDidMount() {
            this._isUnmounted = false;
            if ($619de2c0266a2ba1$var$RelayFeatureFlags.ENABLE_CONTAINERS_SUBSCRIBE_ON_COMMIT === true) this._subscribeToNewResolverAndRerenderIfStoreHasChanged();
        };
        _proto.componentDidUpdate = function componentDidUpdate(prevProps, prevState) {
            if ($619de2c0266a2ba1$var$RelayFeatureFlags.ENABLE_CONTAINERS_SUBSCRIBE_ON_COMMIT === true) {
                if (prevState.resolverGeneration !== this.state.resolverGeneration) this._subscribeToNewResolverAndRerenderIfStoreHasChanged();
                else this._rerenderIfStoreHasChanged();
            }
        };
        _proto.UNSAFE_componentWillReceiveProps = function UNSAFE_componentWillReceiveProps(nextProps) {
            var _this2 = this;
            var _nextProps$__rootIsQu;
            var relayContext = $619de2c0266a2ba1$var$assertRelayContext(nextProps.__relayContext);
            var rootIsQueryRenderer = (_nextProps$__rootIsQu = nextProps.__rootIsQueryRenderer) !== null && _nextProps$__rootIsQu !== void 0 ? _nextProps$__rootIsQu : false;
            var prevIDs = $619de2c0266a2ba1$var$getDataIDsFromObject(fragments, this.props);
            var nextIDs = $619de2c0266a2ba1$var$getDataIDsFromObject(fragments, nextProps);
            var prevRootVariables = $lNLJb(fragments, this.props);
            var nextRootVariables = $lNLJb(fragments, nextProps);
            if (relayContext.environment !== this.state.prevContext.environment || !$3Nt2B(prevRootVariables, nextRootVariables) || !$3Nt2B(prevIDs, nextIDs)) {
                this._cleanup();
                if ($619de2c0266a2ba1$var$RelayFeatureFlags.ENABLE_CONTAINERS_SUBSCRIBE_ON_COMMIT === true) this._resolver = $619de2c0266a2ba1$var$createFragmentSpecResolver(relayContext, containerName, fragments, nextProps, rootIsQueryRenderer);
                else this._resolver = $619de2c0266a2ba1$var$createFragmentSpecResolver(relayContext, containerName, fragments, nextProps, rootIsQueryRenderer, this._handleFragmentDataUpdate);
                this.setState(function(prevState) {
                    return {
                        prevContext: relayContext,
                        contextForChildren: relayContext,
                        relayProp: _this2._buildRelayProp(relayContext),
                        resolverGeneration: prevState.resolverGeneration + 1
                    };
                });
            } else if (!this._hasFetched) this._resolver.setProps(nextProps);
            var data = this._resolver.resolve();
            if (data !== this.state.data) this.setState({
                data: data
            });
        };
        _proto.componentWillUnmount = function componentWillUnmount() {
            this._isUnmounted = true;
            this._cleanup();
        };
        _proto.shouldComponentUpdate = function shouldComponentUpdate(nextProps, nextState) {
            if (nextState.data !== this.state.data || nextState.relayProp !== this.state.relayProp || nextState.resolverGeneration !== this.state.resolverGeneration) return true;
            var keys = Object.keys(nextProps);
            for(var ii = 0; ii < keys.length; ii++){
                var key = keys[ii];
                if (key === '__relayContext') {
                    if (nextState.prevContext.environment !== this.state.prevContext.environment) return true;
                } else {
                    if (!fragments.hasOwnProperty(key) && !$619de2c0266a2ba1$var$isScalarAndEqual(nextProps[key], this.props[key])) return true;
                }
            }
            return false;
        };
        _proto._buildRelayProp = function _buildRelayProp(relayContext) {
            return {
                hasMore: this._hasMore,
                isLoading: this._isLoading,
                loadMore: this._loadMore,
                refetchConnection: this._refetchConnection,
                environment: relayContext.environment
            };
        };
        _proto._rerenderIfStoreHasChanged = function _rerenderIfStoreHasChanged() {
            var data = this.state.data;
            var maybeNewData = this._resolver.resolve();
            if (data !== maybeNewData) this.setState({
                data: maybeNewData
            });
        };
        _proto._subscribeToNewResolverAndRerenderIfStoreHasChanged = function _subscribeToNewResolverAndRerenderIfStoreHasChanged() {
            var data = this.state.data;
            var maybeNewData = this._resolver.resolve();
            this._resolver.setCallback(this.props, this._handleFragmentDataUpdate);
            if (data !== maybeNewData) this.setState({
                data: maybeNewData
            });
        };
        _proto._getConnectionData = function _getConnectionData() {
            var _this$props = this.props, _ = _this$props.componentRef, restProps = (0, $619de2c0266a2ba1$var$_objectWithoutPropertiesLoose2["default"])(_this$props, $619de2c0266a2ba1$var$_excluded);
            var props = (0, $619de2c0266a2ba1$var$_objectSpread3["default"])((0, $619de2c0266a2ba1$var$_objectSpread3["default"])({}, restProps), this.state.data);
            var connectionData = getConnectionFromProps(props);
            if (connectionData == null) return null;
            var _ConnectionInterface$2 = $619de2c0266a2ba1$var$ConnectionInterface.get(), EDGES = _ConnectionInterface$2.EDGES, PAGE_INFO = _ConnectionInterface$2.PAGE_INFO, HAS_NEXT_PAGE = _ConnectionInterface$2.HAS_NEXT_PAGE, HAS_PREV_PAGE = _ConnectionInterface$2.HAS_PREV_PAGE, END_CURSOR = _ConnectionInterface$2.END_CURSOR, START_CURSOR = _ConnectionInterface$2.START_CURSOR;
            !(typeof connectionData === 'object') && $bQThX(false);
            var edges = connectionData[EDGES];
            var pageInfo = connectionData[PAGE_INFO];
            if (edges == null || pageInfo == null) return null;
            !Array.isArray(edges) && $bQThX(false);
            !(typeof pageInfo === 'object') && $bQThX(false);
            var hasMore = direction === $619de2c0266a2ba1$var$FORWARD ? pageInfo[HAS_NEXT_PAGE] : pageInfo[HAS_PREV_PAGE];
            var cursor = direction === $619de2c0266a2ba1$var$FORWARD ? pageInfo[END_CURSOR] : pageInfo[START_CURSOR];
            if (typeof hasMore !== 'boolean' || edges.length !== 0 && typeof cursor === 'undefined') return null;
            return {
                cursor: cursor,
                edgeCount: edges.length,
                hasMore: hasMore
            };
        };
        _proto._getQueryFetcher = function _getQueryFetcher() {
            if (!this._queryFetcher) this._queryFetcher = new $iphc9();
            return this._queryFetcher;
        };
        _proto._canFetchPage = function _canFetchPage(method) {
            if (this._isUnmounted) return false;
            return true;
        };
        _proto._fetchPage = function _fetchPage(paginatingVariables, observer, options) {
            var _this3 = this;
            var _assertRelayContext = $619de2c0266a2ba1$var$assertRelayContext(this.props.__relayContext), environment = _assertRelayContext.environment;
            var _this$props2 = this.props, _ = _this$props2.componentRef, __relayContext = _this$props2.__relayContext, __rootIsQueryRenderer = _this$props2.__rootIsQueryRenderer, restProps = (0, $619de2c0266a2ba1$var$_objectWithoutPropertiesLoose2["default"])(_this$props2, $619de2c0266a2ba1$var$_excluded2);
            var props = (0, $619de2c0266a2ba1$var$_objectSpread3["default"])((0, $619de2c0266a2ba1$var$_objectSpread3["default"])({}, restProps), this.state.data);
            var fragmentVariables;
            var rootVariables = $lNLJb(fragments, restProps);
            fragmentVariables = $619de2c0266a2ba1$var$getVariablesFromObject(fragments, restProps);
            fragmentVariables = (0, $619de2c0266a2ba1$var$_objectSpread3["default"])((0, $619de2c0266a2ba1$var$_objectSpread3["default"])((0, $619de2c0266a2ba1$var$_objectSpread3["default"])({}, rootVariables), fragmentVariables), this._refetchVariables);
            var fetchVariables = connectionConfig.getVariables(props, {
                count: paginatingVariables.count,
                cursor: paginatingVariables.cursor
            }, fragmentVariables);
            !(typeof fetchVariables === 'object' && fetchVariables !== null) && $bQThX(false);
            fetchVariables = (0, $619de2c0266a2ba1$var$_objectSpread3["default"])((0, $619de2c0266a2ba1$var$_objectSpread3["default"])({}, fetchVariables), this._refetchVariables);
            fragmentVariables = (0, $619de2c0266a2ba1$var$_objectSpread3["default"])((0, $619de2c0266a2ba1$var$_objectSpread3["default"])({}, fetchVariables), fragmentVariables);
            var cacheConfig = options ? {
                force: !!options.force
            } : undefined;
            if (cacheConfig != null && (options === null || options === void 0 ? void 0 : options.metadata) != null) cacheConfig.metadata = options === null || options === void 0 ? void 0 : options.metadata;
            var request = $619de2c0266a2ba1$var$getRequest(connectionConfig.query);
            var operation = $619de2c0266a2ba1$var$createOperationDescriptor(request, fetchVariables, cacheConfig);
            var refetchSubscription = null;
            if (this._refetchSubscription) this._refetchSubscription.unsubscribe();
            this._hasFetched = true;
            var onNext = function onNext(payload, complete) {
                var prevData = _this3._resolver.resolve();
                _this3._resolver.setVariables(getFragmentVariables(fragmentVariables, paginatingVariables.totalCount), operation.request.node);
                var nextData = _this3._resolver.resolve();
                if (!$3Nt2B(prevData, nextData)) _this3.setState({
                    data: nextData,
                    contextForChildren: {
                        environment: _this3.props.__relayContext.environment
                    }
                }, complete);
                else complete();
            };
            var cleanup = function cleanup() {
                if (_this3._refetchSubscription === refetchSubscription) {
                    _this3._refetchSubscription = null;
                    _this3._isARequestInFlight = false;
                }
            };
            this._isARequestInFlight = true;
            refetchSubscription = this._getQueryFetcher().execute({
                environment: environment,
                operation: operation,
                preservePreviousReferences: true
            }).mergeMap(function(payload) {
                return $619de2c0266a2ba1$var$Observable.create(function(sink) {
                    onNext(payload, function() {
                        sink.next();
                        sink.complete();
                    });
                });
            })["do"]({
                error: cleanup,
                complete: cleanup,
                unsubscribe: cleanup
            }).subscribe(observer || {});
            this._refetchSubscription = this._isARequestInFlight ? refetchSubscription : null;
            return refetchSubscription;
        };
        _proto._cleanup = function _cleanup() {
            this._resolver.dispose();
            this._refetchVariables = null;
            this._hasFetched = false;
            if (this._refetchSubscription) {
                this._refetchSubscription.unsubscribe();
                this._refetchSubscription = null;
                this._isARequestInFlight = false;
            }
            if (this._queryFetcher) this._queryFetcher.dispose();
        };
        _proto.render = function render() {
            var _this$props3 = this.props, componentRef = _this$props3.componentRef, __relayContext = _this$props3.__relayContext, __rootIsQueryRenderer = _this$props3.__rootIsQueryRenderer, props = (0, $619de2c0266a2ba1$var$_objectWithoutPropertiesLoose2["default"])(_this$props3, $619de2c0266a2ba1$var$_excluded3);
            return /*#__PURE__*/ $gwFzn.createElement($ddePm.Provider, {
                value: this.state.contextForChildren
            }, /*#__PURE__*/ $gwFzn.createElement(Component, (0, $619de2c0266a2ba1$var$_extends2["default"])({}, props, this.state.data, {
                ref: componentRef,
                relay: this.state.relayProp
            })));
        };
        return _class;
    }($gwFzn.Component), (0, $619de2c0266a2ba1$var$_defineProperty2["default"])(_class, "displayName", containerName), _class;
}
function $619de2c0266a2ba1$var$createContainer(Component, fragmentSpec, connectionConfig) {
    return $fpqUS(Component, fragmentSpec, function(ComponentClass, fragments) {
        return $619de2c0266a2ba1$var$createContainerWithFragments(ComponentClass, fragments, connectionConfig);
    });
}
module.exports = {
    createContainer: $619de2c0266a2ba1$var$createContainer
};

});
parcelRegister("lNLJb", function(module, exports) {
'use strict';

var $7dvyf = parcelRequire("7dvyf");
var $fdf3324f696797c6$var$_interopRequireDefault = $7dvyf.default;

var $fdf3324f696797c6$var$_objectSpread2 = $fdf3324f696797c6$var$_interopRequireDefault((parcelRequire("4N8OD")));

var $lan9D = parcelRequire("lan9D");
var $fdf3324f696797c6$var$getSelector = $lan9D.getSelector;
function $fdf3324f696797c6$var$getRootVariablesForFragments(fragments, props) {
    var rootVariables = {};
    Object.keys(fragments).forEach(function(key) {
        var _selector$selectors$, _selector$selectors$2, _selector$owner$varia;
        var fragmentNode = fragments[key];
        var fragmentRef = props[key];
        var selector = $fdf3324f696797c6$var$getSelector(fragmentNode, fragmentRef);
        var fragmentOwnerVariables = selector != null && selector.kind === 'PluralReaderSelector' ? (_selector$selectors$ = (_selector$selectors$2 = selector.selectors[0]) === null || _selector$selectors$2 === void 0 ? void 0 : _selector$selectors$2.owner.variables) !== null && _selector$selectors$ !== void 0 ? _selector$selectors$ : {} : (_selector$owner$varia = selector === null || selector === void 0 ? void 0 : selector.owner.variables) !== null && _selector$owner$varia !== void 0 ? _selector$owner$varia : {};
        rootVariables = (0, $fdf3324f696797c6$var$_objectSpread2["default"])((0, $fdf3324f696797c6$var$_objectSpread2["default"])({}, rootVariables), fragmentOwnerVariables);
    });
    return rootVariables;
}
module.exports = $fdf3324f696797c6$var$getRootVariablesForFragments;

});

parcelRegister("iphc9", function(module, exports) {
'use strict';

var $7dvyf = parcelRequire("7dvyf");
var $d667e660776b3a98$var$_interopRequireDefault = $7dvyf.default;

var $d667e660776b3a98$var$_defineProperty2 = $d667e660776b3a98$var$_interopRequireDefault((parcelRequire("dW6Ee")));

var $bQThX = parcelRequire("bQThX");

var $lan9D = parcelRequire("lan9D");
var $d667e660776b3a98$var$fetchQuery = $lan9D.__internal.fetchQuery, $d667e660776b3a98$var$createOperationDescriptor = $lan9D.createOperationDescriptor, $d667e660776b3a98$var$isRelayModernEnvironment = $lan9D.isRelayModernEnvironment;
var $d667e660776b3a98$var$ReactRelayQueryFetcher = /*#__PURE__*/ function() {
    function ReactRelayQueryFetcher(args) {
        (0, $d667e660776b3a98$var$_defineProperty2["default"])(this, "_selectionReferences", []);
        (0, $d667e660776b3a98$var$_defineProperty2["default"])(this, "_didFetchFinish", false);
        if (args != null) {
            this._cacheSelectionReference = args.cacheSelectionReference;
            this._selectionReferences = args.selectionReferences;
        }
    }
    var _proto = ReactRelayQueryFetcher.prototype;
    _proto.getSelectionReferences = function getSelectionReferences() {
        return {
            cacheSelectionReference: this._cacheSelectionReference,
            selectionReferences: this._selectionReferences
        };
    };
    _proto.lookupInStore = function lookupInStore(environment, operation, fetchPolicy) {
        if (fetchPolicy === 'store-and-network' || fetchPolicy === 'store-or-network') {
            if (environment.check(operation).status === 'available') {
                this._retainCachedOperation(environment, operation);
                return environment.lookup(operation.fragment);
            }
        }
        return null;
    };
    _proto.getFetchResult = function getFetchResult() {
        if (this._didFetchFinish) {
            if (this._error != null) return {
                error: this._error
            };
            else if (this._snapshot != null) return {
                snapshot: this._snapshot
            };
        } else return null;
    };
    _proto.execute = function execute(_ref) {
        var _this = this;
        var environment = _ref.environment, operation = _ref.operation, _ref$preservePrevious = _ref.preservePreviousReferences, preservePreviousReferences = _ref$preservePrevious === void 0 ? false : _ref$preservePrevious;
        var reference = environment.retain(operation);
        var error = function error() {
            _this._selectionReferences = _this._selectionReferences.concat(reference);
        };
        var complete = function complete() {
            if (!preservePreviousReferences) _this.disposeSelectionReferences();
            _this._selectionReferences = _this._selectionReferences.concat(reference);
        };
        var unsubscribe = function unsubscribe() {
            _this._selectionReferences = _this._selectionReferences.concat(reference);
        };
        if (!$d667e660776b3a98$var$isRelayModernEnvironment(environment)) return environment.execute({
            operation: operation
        })["do"]({
            error: error,
            complete: complete,
            unsubscribe: unsubscribe
        });
        return $d667e660776b3a98$var$fetchQuery(environment, operation)["do"]({
            error: error,
            complete: complete,
            unsubscribe: unsubscribe
        });
    };
    _proto.setOnDataChange = function setOnDataChange(onDataChange) {
        !this._fetchOptions && $bQThX(false);
        if (typeof onDataChange === 'function') {
            this._fetchOptions.onDataChangeCallbacks = this._fetchOptions.onDataChangeCallbacks || [];
            this._fetchOptions.onDataChangeCallbacks.push(onDataChange);
            if (this._didFetchFinish) {
                if (this._error != null) onDataChange({
                    error: this._error
                });
                else if (this._snapshot != null) onDataChange({
                    snapshot: this._snapshot
                });
            }
        }
    };
    _proto.fetch = function fetch(fetchOptions, cacheConfigOverride) {
        var _this2 = this;
        var environment = fetchOptions.environment, operation = fetchOptions.operation, onDataChange = fetchOptions.onDataChange;
        var fetchHasReturned = false;
        var _error;
        this.disposeRequest();
        var oldOnDataChangeCallbacks = this._fetchOptions && this._fetchOptions.onDataChangeCallbacks;
        this._fetchOptions = {
            environment: environment,
            onDataChangeCallbacks: oldOnDataChangeCallbacks || [],
            operation: operation
        };
        if (onDataChange && this._fetchOptions.onDataChangeCallbacks.indexOf(onDataChange) === -1) this._fetchOptions.onDataChangeCallbacks.push(onDataChange);
        var operationOverride = cacheConfigOverride ? $d667e660776b3a98$var$createOperationDescriptor(operation.request.node, operation.request.variables, cacheConfigOverride) : operation;
        var request = this.execute({
            environment: environment,
            operation: operationOverride
        })["finally"](function() {
            _this2._pendingRequest = null;
        }).subscribe({
            next: function next() {
                _this2._didFetchFinish = true;
                _this2._error = null;
                _this2._onQueryDataAvailable({
                    notifyFirstResult: fetchHasReturned
                });
            },
            error: function error(err) {
                _this2._didFetchFinish = true;
                _this2._error = err;
                _this2._snapshot = null;
                var onDataChangeCallbacks = _this2._fetchOptions && _this2._fetchOptions.onDataChangeCallbacks;
                if (fetchHasReturned) {
                    if (onDataChangeCallbacks) onDataChangeCallbacks.forEach(function(onDataChange) {
                        onDataChange({
                            error: err
                        });
                    });
                } else _error = err;
            }
        });
        this._pendingRequest = {
            dispose: function dispose() {
                request.unsubscribe();
            }
        };
        fetchHasReturned = true;
        if (_error) throw _error;
        return this._snapshot;
    };
    _proto.retry = function retry(cacheConfigOverride) {
        !this._fetchOptions && $bQThX(false);
        return this.fetch({
            environment: this._fetchOptions.environment,
            operation: this._fetchOptions.operation,
            onDataChange: null
        }, cacheConfigOverride);
    };
    _proto.dispose = function dispose() {
        this.disposeRequest();
        this.disposeSelectionReferences();
    };
    _proto.disposeRequest = function disposeRequest() {
        this._error = null;
        this._snapshot = null;
        if (this._pendingRequest) this._pendingRequest.dispose();
        if (this._rootSubscription) {
            this._rootSubscription.dispose();
            this._rootSubscription = null;
        }
    };
    _proto._retainCachedOperation = function _retainCachedOperation(environment, operation) {
        this._disposeCacheSelectionReference();
        this._cacheSelectionReference = environment.retain(operation);
    };
    _proto._disposeCacheSelectionReference = function _disposeCacheSelectionReference() {
        this._cacheSelectionReference && this._cacheSelectionReference.dispose();
        this._cacheSelectionReference = null;
    };
    _proto.disposeSelectionReferences = function disposeSelectionReferences() {
        this._disposeCacheSelectionReference();
        this._selectionReferences.forEach(function(r) {
            return r.dispose();
        });
        this._selectionReferences = [];
    };
    _proto._onQueryDataAvailable = function _onQueryDataAvailable(_ref2) {
        var _this3 = this;
        var notifyFirstResult = _ref2.notifyFirstResult;
        !this._fetchOptions && $bQThX(false);
        var _this$_fetchOptions = this._fetchOptions, environment = _this$_fetchOptions.environment, onDataChangeCallbacks = _this$_fetchOptions.onDataChangeCallbacks, operation = _this$_fetchOptions.operation;
        if (this._snapshot) return;
        this._snapshot = environment.lookup(operation.fragment);
        this._rootSubscription = environment.subscribe(this._snapshot, function(snapshot) {
            if (_this3._fetchOptions != null) {
                var maybeNewOnDataChangeCallbacks = _this3._fetchOptions.onDataChangeCallbacks;
                if (Array.isArray(maybeNewOnDataChangeCallbacks)) maybeNewOnDataChangeCallbacks.forEach(function(onDataChange) {
                    return onDataChange({
                        snapshot: snapshot
                    });
                });
            }
        });
        if (this._snapshot && notifyFirstResult && Array.isArray(onDataChangeCallbacks)) {
            var snapshot = this._snapshot;
            onDataChangeCallbacks.forEach(function(onDataChange) {
                return onDataChange({
                    snapshot: snapshot
                });
            });
        }
    };
    return ReactRelayQueryFetcher;
}();
module.exports = $d667e660776b3a98$var$ReactRelayQueryFetcher;

});


parcelRegister("fuHNx", function(module, exports) {
'use strict';

var $7dvyf = parcelRequire("7dvyf");
var $b47ba1bd6a4e6d20$var$_interopRequireDefault = $7dvyf.default;

var $b47ba1bd6a4e6d20$var$_objectSpread2 = $b47ba1bd6a4e6d20$var$_interopRequireDefault((parcelRequire("4N8OD")));

var $b47ba1bd6a4e6d20$var$_assertThisInitialized2 = $b47ba1bd6a4e6d20$var$_interopRequireDefault((parcelRequire("jRtfH")));

var $b47ba1bd6a4e6d20$var$_inheritsLoose2 = $b47ba1bd6a4e6d20$var$_interopRequireDefault((parcelRequire("isJpf")));

var $b47ba1bd6a4e6d20$var$_defineProperty2 = $b47ba1bd6a4e6d20$var$_interopRequireDefault((parcelRequire("dW6Ee")));

var $ddePm = parcelRequire("ddePm");

var $iphc9 = parcelRequire("iphc9");

var $l8g1G = parcelRequire("l8g1G");

var $3Nt2B = parcelRequire("3Nt2B");

var $gwFzn = parcelRequire("gwFzn");

var $lan9D = parcelRequire("lan9D");
var $b47ba1bd6a4e6d20$var$createOperationDescriptor = $lan9D.createOperationDescriptor, $b47ba1bd6a4e6d20$var$deepFreeze = $lan9D.deepFreeze, $b47ba1bd6a4e6d20$var$getRequest = $lan9D.getRequest;
var $b47ba1bd6a4e6d20$var$requestCache = {};
var $b47ba1bd6a4e6d20$var$queryRendererContext = {
    rootIsQueryRenderer: true
};
var $b47ba1bd6a4e6d20$var$ReactRelayQueryRenderer = /*#__PURE__*/ function(_React$Component) {
    (0, $b47ba1bd6a4e6d20$var$_inheritsLoose2["default"])(ReactRelayQueryRenderer, _React$Component);
    function ReactRelayQueryRenderer(props) {
        var _this;
        _this = _React$Component.call(this, props) || this;
        (0, $b47ba1bd6a4e6d20$var$_defineProperty2["default"])((0, $b47ba1bd6a4e6d20$var$_assertThisInitialized2["default"])(_this), "_handleDataChange", function(params) {
            var error = params.error == null ? null : params.error;
            var snapshot = params.snapshot == null ? null : params.snapshot;
            _this.setState(function(prevState) {
                var prevRequestCacheKey = prevState.requestCacheKey;
                if (prevRequestCacheKey) delete $b47ba1bd6a4e6d20$var$requestCache[prevRequestCacheKey];
                if (snapshot === prevState.snapshot && error === prevState.error) return null;
                return {
                    renderProps: $b47ba1bd6a4e6d20$var$getRenderProps(error, snapshot, prevState.queryFetcher, prevState.retryCallbacks),
                    snapshot: snapshot,
                    requestCacheKey: null
                };
            });
        });
        var retryCallbacks = {
            handleDataChange: null,
            handleRetryAfterError: null
        };
        var queryFetcher;
        var requestCacheKey;
        if (props.query) {
            var query = props.query;
            var request = $b47ba1bd6a4e6d20$var$getRequest(query);
            requestCacheKey = $b47ba1bd6a4e6d20$var$getRequestCacheKey(request.params, props.variables);
            queryFetcher = $b47ba1bd6a4e6d20$var$requestCache[requestCacheKey] ? $b47ba1bd6a4e6d20$var$requestCache[requestCacheKey].queryFetcher : new $iphc9();
        } else queryFetcher = new $iphc9();
        _this._maybeHiddenOrFastRefresh = false;
        _this.state = (0, $b47ba1bd6a4e6d20$var$_objectSpread2["default"])({
            prevPropsEnvironment: props.environment,
            prevPropsVariables: props.variables,
            prevQuery: props.query,
            queryFetcher: queryFetcher,
            retryCallbacks: retryCallbacks
        }, $b47ba1bd6a4e6d20$var$fetchQueryAndComputeStateFromProps(props, queryFetcher, retryCallbacks, requestCacheKey));
        return _this;
    }
    ReactRelayQueryRenderer.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps, prevState) {
        if (prevState.prevQuery !== nextProps.query || prevState.prevPropsEnvironment !== nextProps.environment || !$3Nt2B(prevState.prevPropsVariables, nextProps.variables)) return $b47ba1bd6a4e6d20$var$resetQueryStateForUpdate(nextProps, prevState);
        return null;
    };
    var _proto = ReactRelayQueryRenderer.prototype;
    _proto.componentDidMount = function componentDidMount() {
        var _this2 = this;
        if (this._maybeHiddenOrFastRefresh === true) {
            this._maybeHiddenOrFastRefresh = false;
            this.setState(function(prevState) {
                var newState = $b47ba1bd6a4e6d20$var$resetQueryStateForUpdate(_this2.props, prevState);
                var requestCacheKey = newState.requestCacheKey, queryFetcher = newState.queryFetcher;
                if (requestCacheKey != null && $b47ba1bd6a4e6d20$var$requestCache[requestCacheKey] != null) queryFetcher.setOnDataChange(_this2._handleDataChange);
                return newState;
            });
            return;
        }
        var _this$state = this.state, retryCallbacks = _this$state.retryCallbacks, queryFetcher = _this$state.queryFetcher, requestCacheKey = _this$state.requestCacheKey;
        if (requestCacheKey) delete $b47ba1bd6a4e6d20$var$requestCache[requestCacheKey];
        retryCallbacks.handleDataChange = this._handleDataChange;
        retryCallbacks.handleRetryAfterError = function(error) {
            return _this2.setState(function(prevState) {
                var prevRequestCacheKey = prevState.requestCacheKey;
                if (prevRequestCacheKey) delete $b47ba1bd6a4e6d20$var$requestCache[prevRequestCacheKey];
                return {
                    renderProps: $b47ba1bd6a4e6d20$var$getLoadingRenderProps(),
                    requestCacheKey: null
                };
            });
        };
        if (this.props.query) queryFetcher.setOnDataChange(this._handleDataChange);
    };
    _proto.componentDidUpdate = function componentDidUpdate(_prevProps, prevState) {
        var _this$state2 = this.state, queryFetcher = _this$state2.queryFetcher, requestCacheKey = _this$state2.requestCacheKey;
        if (requestCacheKey) {
            delete $b47ba1bd6a4e6d20$var$requestCache[requestCacheKey];
            delete this.state.requestCacheKey;
        }
        if (this.props.query && queryFetcher !== prevState.queryFetcher) queryFetcher.setOnDataChange(this._handleDataChange);
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        this.state.queryFetcher.dispose();
        this._maybeHiddenOrFastRefresh = true;
    };
    _proto.shouldComponentUpdate = function shouldComponentUpdate(nextProps, nextState) {
        return nextProps.render !== this.props.render || nextState.renderProps !== this.state.renderProps;
    };
    _proto.render = function render() {
        var _this$state3 = this.state, renderProps = _this$state3.renderProps, relayContext = _this$state3.relayContext;
        return /*#__PURE__*/ $gwFzn.createElement($ddePm.Provider, {
            value: relayContext
        }, /*#__PURE__*/ $gwFzn.createElement($l8g1G.Provider, {
            value: $b47ba1bd6a4e6d20$var$queryRendererContext
        }, this.props.render(renderProps)));
    };
    return ReactRelayQueryRenderer;
}($gwFzn.Component);
function $b47ba1bd6a4e6d20$var$getLoadingRenderProps() {
    return {
        error: null,
        props: null,
        retry: null
    };
}
function $b47ba1bd6a4e6d20$var$getEmptyRenderProps() {
    return {
        error: null,
        props: {},
        retry: null
    };
}
function $b47ba1bd6a4e6d20$var$getRenderProps(error, snapshot, queryFetcher, retryCallbacks) {
    return {
        error: error ? error : null,
        props: snapshot ? snapshot.data : null,
        retry: function retry(cacheConfigOverride) {
            var syncSnapshot = queryFetcher.retry(cacheConfigOverride);
            if (syncSnapshot && typeof retryCallbacks.handleDataChange === 'function') retryCallbacks.handleDataChange({
                snapshot: syncSnapshot
            });
            else if (error && typeof retryCallbacks.handleRetryAfterError === 'function') retryCallbacks.handleRetryAfterError(error);
        }
    };
}
function $b47ba1bd6a4e6d20$var$getRequestCacheKey(request, variables) {
    return JSON.stringify({
        id: request.cacheID ? request.cacheID : request.id,
        variables: variables
    });
}
function $b47ba1bd6a4e6d20$var$resetQueryStateForUpdate(props, prevState) {
    var query = props.query;
    var prevSelectionReferences = prevState.queryFetcher.getSelectionReferences();
    prevState.queryFetcher.disposeRequest();
    var queryFetcher;
    if (query) {
        var request = $b47ba1bd6a4e6d20$var$getRequest(query);
        var requestCacheKey = $b47ba1bd6a4e6d20$var$getRequestCacheKey(request.params, props.variables);
        queryFetcher = $b47ba1bd6a4e6d20$var$requestCache[requestCacheKey] ? $b47ba1bd6a4e6d20$var$requestCache[requestCacheKey].queryFetcher : new $iphc9(prevSelectionReferences);
    } else queryFetcher = new $iphc9(prevSelectionReferences);
    return (0, $b47ba1bd6a4e6d20$var$_objectSpread2["default"])({
        prevQuery: props.query,
        prevPropsEnvironment: props.environment,
        prevPropsVariables: props.variables,
        queryFetcher: queryFetcher
    }, $b47ba1bd6a4e6d20$var$fetchQueryAndComputeStateFromProps(props, queryFetcher, prevState.retryCallbacks));
}
function $b47ba1bd6a4e6d20$var$fetchQueryAndComputeStateFromProps(props, queryFetcher, retryCallbacks, requestCacheKey) {
    var environment = props.environment, query = props.query, variables = props.variables, cacheConfig = props.cacheConfig;
    var genericEnvironment = environment;
    if (query) {
        var request = $b47ba1bd6a4e6d20$var$getRequest(query);
        var operation = $b47ba1bd6a4e6d20$var$createOperationDescriptor(request, variables, cacheConfig);
        var relayContext = {
            environment: genericEnvironment
        };
        if (typeof requestCacheKey === 'string' && $b47ba1bd6a4e6d20$var$requestCache[requestCacheKey]) {
            var snapshot = $b47ba1bd6a4e6d20$var$requestCache[requestCacheKey].snapshot;
            if (snapshot) return {
                error: null,
                relayContext: relayContext,
                renderProps: $b47ba1bd6a4e6d20$var$getRenderProps(null, snapshot, queryFetcher, retryCallbacks),
                snapshot: snapshot,
                requestCacheKey: requestCacheKey
            };
            else return {
                error: null,
                relayContext: relayContext,
                renderProps: $b47ba1bd6a4e6d20$var$getLoadingRenderProps(),
                snapshot: null,
                requestCacheKey: requestCacheKey
            };
        }
        try {
            var storeSnapshot = queryFetcher.lookupInStore(genericEnvironment, operation, props.fetchPolicy);
            var querySnapshot = queryFetcher.fetch({
                environment: genericEnvironment,
                onDataChange: null,
                operation: operation
            });
            var _snapshot = querySnapshot || storeSnapshot;
            requestCacheKey = requestCacheKey || $b47ba1bd6a4e6d20$var$getRequestCacheKey(request.params, props.variables);
            $b47ba1bd6a4e6d20$var$requestCache[requestCacheKey] = {
                queryFetcher: queryFetcher,
                snapshot: _snapshot
            };
            if (!_snapshot) return {
                error: null,
                relayContext: relayContext,
                renderProps: $b47ba1bd6a4e6d20$var$getLoadingRenderProps(),
                snapshot: null,
                requestCacheKey: requestCacheKey
            };
            return {
                error: null,
                relayContext: relayContext,
                renderProps: $b47ba1bd6a4e6d20$var$getRenderProps(null, _snapshot, queryFetcher, retryCallbacks),
                snapshot: _snapshot,
                requestCacheKey: requestCacheKey
            };
        } catch (error) {
            return {
                error: error,
                relayContext: relayContext,
                renderProps: $b47ba1bd6a4e6d20$var$getRenderProps(error, null, queryFetcher, retryCallbacks),
                snapshot: null,
                requestCacheKey: requestCacheKey
            };
        }
    } else {
        queryFetcher.dispose();
        var _relayContext = {
            environment: genericEnvironment
        };
        return {
            error: null,
            relayContext: _relayContext,
            renderProps: $b47ba1bd6a4e6d20$var$getEmptyRenderProps(),
            requestCacheKey: null
        };
    }
}
module.exports = $b47ba1bd6a4e6d20$var$ReactRelayQueryRenderer;

});

parcelRegister("6ZmAE", function(module, exports) {
'use strict';

var $7dvyf = parcelRequire("7dvyf");
var $5169f6840ade8dc1$var$_interopRequireDefault = $7dvyf.default;

var $5169f6840ade8dc1$var$_extends2 = $5169f6840ade8dc1$var$_interopRequireDefault((parcelRequire("l1aCK")));

var $5169f6840ade8dc1$var$_objectWithoutPropertiesLoose2 = $5169f6840ade8dc1$var$_interopRequireDefault((parcelRequire("7o4v7")));

var $5169f6840ade8dc1$var$_objectSpread2 = $5169f6840ade8dc1$var$_interopRequireDefault((parcelRequire("4N8OD")));

var $5169f6840ade8dc1$var$_assertThisInitialized2 = $5169f6840ade8dc1$var$_interopRequireDefault((parcelRequire("jRtfH")));

var $5169f6840ade8dc1$var$_inheritsLoose2 = $5169f6840ade8dc1$var$_interopRequireDefault((parcelRequire("isJpf")));

var $5169f6840ade8dc1$var$_defineProperty2 = $5169f6840ade8dc1$var$_interopRequireDefault((parcelRequire("dW6Ee")));
var $5169f6840ade8dc1$var$_excluded = [
    "componentRef",
    "__relayContext",
    "__rootIsQueryRenderer"
];

var $fpqUS = parcelRequire("fpqUS");

var $lNLJb = parcelRequire("lNLJb");

var $aDTyX = parcelRequire("aDTyX");
var $5169f6840ade8dc1$var$getContainerName = $aDTyX.getContainerName;

var $ddePm = parcelRequire("ddePm");

var $iphc9 = parcelRequire("iphc9");

var $9TNTX = parcelRequire("9TNTX");
var $5169f6840ade8dc1$var$assertRelayContext = $9TNTX.assertRelayContext;

var $3Nt2B = parcelRequire("3Nt2B");

var $gwFzn = parcelRequire("gwFzn");

var $lan9D = parcelRequire("lan9D");
var $5169f6840ade8dc1$var$Observable = $lan9D.Observable, $5169f6840ade8dc1$var$createFragmentSpecResolver = $lan9D.createFragmentSpecResolver, $5169f6840ade8dc1$var$createOperationDescriptor = $lan9D.createOperationDescriptor, $5169f6840ade8dc1$var$getDataIDsFromObject = $lan9D.getDataIDsFromObject, $5169f6840ade8dc1$var$getRequest = $lan9D.getRequest, $5169f6840ade8dc1$var$getVariablesFromObject = $lan9D.getVariablesFromObject, $5169f6840ade8dc1$var$isScalarAndEqual = $lan9D.isScalarAndEqual;
parcelRequire("hzw7m");
function $5169f6840ade8dc1$var$createContainerWithFragments(Component, fragments, taggedNode) {
    var _class;
    var containerName = $5169f6840ade8dc1$var$getContainerName(Component);
    return _class = /*#__PURE__*/ function(_React$Component) {
        (0, $5169f6840ade8dc1$var$_inheritsLoose2["default"])(_class, _React$Component);
        function _class(props) {
            var _props$__rootIsQueryR, _this;
            _this = _React$Component.call(this, props) || this;
            (0, $5169f6840ade8dc1$var$_defineProperty2["default"])((0, $5169f6840ade8dc1$var$_assertThisInitialized2["default"])(_this), "_handleFragmentDataUpdate", function() {
                var resolverFromThisUpdate = _this.state.resolver;
                _this.setState(function(updatedState) {
                    return resolverFromThisUpdate === updatedState.resolver ? {
                        data: updatedState.resolver.resolve()
                    } : null;
                });
            });
            (0, $5169f6840ade8dc1$var$_defineProperty2["default"])((0, $5169f6840ade8dc1$var$_assertThisInitialized2["default"])(_this), "_refetch", function(refetchVariables, renderVariables, observerOrCallback, options) {
                if (_this._isUnmounted) return {
                    dispose: function dispose() {}
                };
                var _assertRelayContext = $5169f6840ade8dc1$var$assertRelayContext(_this.props.__relayContext), environment = _assertRelayContext.environment;
                var rootVariables = $lNLJb(fragments, _this.props);
                var fetchVariables = typeof refetchVariables === 'function' ? refetchVariables(_this._getFragmentVariables()) : refetchVariables;
                fetchVariables = (0, $5169f6840ade8dc1$var$_objectSpread2["default"])((0, $5169f6840ade8dc1$var$_objectSpread2["default"])({}, rootVariables), fetchVariables);
                var fragmentVariables = renderVariables ? (0, $5169f6840ade8dc1$var$_objectSpread2["default"])((0, $5169f6840ade8dc1$var$_objectSpread2["default"])({}, fetchVariables), renderVariables) : fetchVariables;
                var cacheConfig = options ? {
                    force: !!options.force
                } : undefined;
                if (cacheConfig != null && (options === null || options === void 0 ? void 0 : options.metadata) != null) cacheConfig.metadata = options === null || options === void 0 ? void 0 : options.metadata;
                var observer = typeof observerOrCallback === 'function' ? {
                    next: observerOrCallback,
                    error: observerOrCallback
                } : observerOrCallback || {};
                var query = $5169f6840ade8dc1$var$getRequest(taggedNode);
                var operation = $5169f6840ade8dc1$var$createOperationDescriptor(query, fetchVariables, cacheConfig);
                _this.state.localVariables = fetchVariables;
                _this._refetchSubscription && _this._refetchSubscription.unsubscribe();
                var refetchSubscription;
                var storeSnapshot = _this._getQueryFetcher().lookupInStore(environment, operation, options === null || options === void 0 ? void 0 : options.fetchPolicy);
                if (storeSnapshot != null) {
                    _this.state.resolver.setVariables(fragmentVariables, operation.request.node);
                    _this.setState(function(latestState) {
                        return {
                            data: latestState.resolver.resolve(),
                            contextForChildren: {
                                environment: _this.props.__relayContext.environment
                            }
                        };
                    }, function() {
                        observer.next && observer.next();
                        observer.complete && observer.complete();
                    });
                    return {
                        dispose: function dispose() {}
                    };
                }
                _this._getQueryFetcher().execute({
                    environment: environment,
                    operation: operation,
                    preservePreviousReferences: true
                }).mergeMap(function(response) {
                    _this.state.resolver.setVariables(fragmentVariables, operation.request.node);
                    return $5169f6840ade8dc1$var$Observable.create(function(sink) {
                        return _this.setState(function(latestState) {
                            return {
                                data: latestState.resolver.resolve(),
                                contextForChildren: {
                                    environment: _this.props.__relayContext.environment
                                }
                            };
                        }, function() {
                            sink.next();
                            sink.complete();
                        });
                    });
                })["finally"](function() {
                    if (_this._refetchSubscription === refetchSubscription) _this._refetchSubscription = null;
                }).subscribe((0, $5169f6840ade8dc1$var$_objectSpread2["default"])((0, $5169f6840ade8dc1$var$_objectSpread2["default"])({}, observer), {}, {
                    start: function start(subscription) {
                        _this._refetchSubscription = refetchSubscription = subscription;
                        observer.start && observer.start(subscription);
                    }
                }));
                return {
                    dispose: function dispose() {
                        refetchSubscription && refetchSubscription.unsubscribe();
                    }
                };
            });
            var relayContext = $5169f6840ade8dc1$var$assertRelayContext(props.__relayContext);
            var rootIsQueryRenderer = (_props$__rootIsQueryR = props.__rootIsQueryRenderer) !== null && _props$__rootIsQueryR !== void 0 ? _props$__rootIsQueryR : false;
            _this._refetchSubscription = null;
            var resolver = $5169f6840ade8dc1$var$createFragmentSpecResolver(relayContext, containerName, fragments, props, rootIsQueryRenderer);
            _this.state = {
                data: resolver.resolve(),
                localVariables: null,
                prevProps: props,
                prevPropsContext: relayContext,
                contextForChildren: relayContext,
                relayProp: $5169f6840ade8dc1$var$getRelayProp(relayContext.environment, _this._refetch),
                resolver: resolver
            };
            _this._isUnmounted = false;
            return _this;
        }
        var _proto = _class.prototype;
        _proto.componentDidMount = function componentDidMount() {
            this._isUnmounted = false;
            this._subscribeToNewResolverAndRerenderIfStoreHasChanged();
        };
        _proto.componentDidUpdate = function componentDidUpdate(prevProps, prevState) {
            if (this.state.resolver !== prevState.resolver) {
                prevState.resolver.dispose();
                this._queryFetcher && this._queryFetcher.dispose();
                this._refetchSubscription && this._refetchSubscription.unsubscribe();
                this._subscribeToNewResolverAndRerenderIfStoreHasChanged();
            } else this._rerenderIfStoreHasChanged();
        };
        _class.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps, prevState) {
            var _nextProps$__rootIsQu;
            var prevProps = prevState.prevProps;
            var relayContext = $5169f6840ade8dc1$var$assertRelayContext(nextProps.__relayContext);
            var rootIsQueryRenderer = (_nextProps$__rootIsQu = nextProps.__rootIsQueryRenderer) !== null && _nextProps$__rootIsQu !== void 0 ? _nextProps$__rootIsQu : false;
            var prevIDs = $5169f6840ade8dc1$var$getDataIDsFromObject(fragments, prevProps);
            var nextIDs = $5169f6840ade8dc1$var$getDataIDsFromObject(fragments, nextProps);
            var prevRootVariables = $lNLJb(fragments, prevProps);
            var nextRootVariables = $lNLJb(fragments, nextProps);
            var resolver = prevState.resolver;
            if (prevState.prevPropsContext.environment !== relayContext.environment || !$3Nt2B(prevRootVariables, nextRootVariables) || !$3Nt2B(prevIDs, nextIDs)) {
                resolver = $5169f6840ade8dc1$var$createFragmentSpecResolver(relayContext, containerName, fragments, nextProps, rootIsQueryRenderer);
                return {
                    data: resolver.resolve(),
                    localVariables: null,
                    prevProps: nextProps,
                    prevPropsContext: relayContext,
                    contextForChildren: relayContext,
                    relayProp: $5169f6840ade8dc1$var$getRelayProp(relayContext.environment, prevState.relayProp.refetch),
                    resolver: resolver
                };
            } else if (!prevState.localVariables) resolver.setProps(nextProps);
            var data = resolver.resolve();
            if (data !== prevState.data) return {
                data: data,
                prevProps: nextProps
            };
            return null;
        };
        _proto.componentWillUnmount = function componentWillUnmount() {
            this._isUnmounted = true;
            this.state.resolver.dispose();
            this._queryFetcher && this._queryFetcher.dispose();
            this._refetchSubscription && this._refetchSubscription.unsubscribe();
        };
        _proto.shouldComponentUpdate = function shouldComponentUpdate(nextProps, nextState) {
            if (nextState.data !== this.state.data || nextState.relayProp !== this.state.relayProp) return true;
            var keys = Object.keys(nextProps);
            for(var ii = 0; ii < keys.length; ii++){
                var key = keys[ii];
                if (key === '__relayContext') {
                    if (this.state.prevPropsContext.environment !== nextState.prevPropsContext.environment) return true;
                } else {
                    if (!fragments.hasOwnProperty(key) && !$5169f6840ade8dc1$var$isScalarAndEqual(nextProps[key], this.props[key])) return true;
                }
            }
            return false;
        };
        _proto._rerenderIfStoreHasChanged = function _rerenderIfStoreHasChanged() {
            var _this$state = this.state, data = _this$state.data, resolver = _this$state.resolver;
            var maybeNewData = resolver.resolve();
            if (data !== maybeNewData) this.setState({
                data: maybeNewData
            });
        };
        _proto._subscribeToNewResolverAndRerenderIfStoreHasChanged = function _subscribeToNewResolverAndRerenderIfStoreHasChanged() {
            var _this$state2 = this.state, data = _this$state2.data, resolver = _this$state2.resolver;
            var maybeNewData = resolver.resolve();
            resolver.setCallback(this.props, this._handleFragmentDataUpdate);
            if (data !== maybeNewData) this.setState({
                data: maybeNewData
            });
        };
        _proto._getFragmentVariables = function _getFragmentVariables() {
            return $5169f6840ade8dc1$var$getVariablesFromObject(fragments, this.props);
        };
        _proto._getQueryFetcher = function _getQueryFetcher() {
            if (!this._queryFetcher) this._queryFetcher = new $iphc9();
            return this._queryFetcher;
        };
        _proto.render = function render() {
            var _this$props = this.props, componentRef = _this$props.componentRef, __relayContext = _this$props.__relayContext, __rootIsQueryRenderer = _this$props.__rootIsQueryRenderer, props = (0, $5169f6840ade8dc1$var$_objectWithoutPropertiesLoose2["default"])(_this$props, $5169f6840ade8dc1$var$_excluded);
            var _this$state3 = this.state, relayProp = _this$state3.relayProp, contextForChildren = _this$state3.contextForChildren;
            return /*#__PURE__*/ $gwFzn.createElement($ddePm.Provider, {
                value: contextForChildren
            }, /*#__PURE__*/ $gwFzn.createElement(Component, (0, $5169f6840ade8dc1$var$_extends2["default"])({}, props, this.state.data, {
                ref: componentRef,
                relay: relayProp
            })));
        };
        return _class;
    }($gwFzn.Component), (0, $5169f6840ade8dc1$var$_defineProperty2["default"])(_class, "displayName", containerName), _class;
}
function $5169f6840ade8dc1$var$getRelayProp(environment, refetch) {
    return {
        environment: environment,
        refetch: refetch
    };
}
function $5169f6840ade8dc1$var$createContainer(Component, fragmentSpec, taggedNode) {
    return $fpqUS(Component, fragmentSpec, function(ComponentClass, fragments) {
        return $5169f6840ade8dc1$var$createContainerWithFragments(ComponentClass, fragments, taggedNode);
    });
}
module.exports = {
    createContainer: $5169f6840ade8dc1$var$createContainer
};

});

parcelRegister("b8i1g", function(module, exports) {
'use strict';

var $fWBut = parcelRequire("fWBut");

var $cdYu4 = parcelRequire("cdYu4");

var $gwFzn = parcelRequire("gwFzn");

var $gwFzn = parcelRequire("gwFzn");
var $81ae6b521de005a3$var$useContext = $gwFzn.useContext, $81ae6b521de005a3$var$useEffect = $gwFzn.useEffect;
parcelRequire("hzw7m");
function $81ae6b521de005a3$var$EntryPointContainer(_ref) {
    var entryPointReference = _ref.entryPointReference, props = _ref.props;
    var getComponent = entryPointReference.getComponent, queries = entryPointReference.queries, entryPoints = entryPointReference.entryPoints, extraProps = entryPointReference.extraProps, rootModuleID = entryPointReference.rootModuleID;
    var Component = getComponent();
    var profilerContext = $81ae6b521de005a3$var$useContext($fWBut);
    var environment = $cdYu4();
    $81ae6b521de005a3$var$useEffect(function() {
        environment.__log({
            name: 'entrypoint.root.consume',
            profilerContext: profilerContext,
            rootModuleID: rootModuleID
        });
    }, [
        environment,
        profilerContext,
        rootModuleID
    ]);
    return /*#__PURE__*/ $gwFzn.createElement(Component, {
        entryPoints: entryPoints,
        extraProps: extraProps,
        props: props,
        queries: queries
    });
}
module.exports = $81ae6b521de005a3$var$EntryPointContainer;

});
parcelRegister("fWBut", function(module, exports) {
'use strict';

var $gwFzn = parcelRequire("gwFzn");
var $b9b95aa29733bede$var$ProfilerContext = $gwFzn.createContext({
    wrapPrepareQueryResource: function wrapPrepareQueryResource(cb) {
        return cb();
    }
});
module.exports = $b9b95aa29733bede$var$ProfilerContext;

});

parcelRegister("cdYu4", function(module, exports) {
'use strict';

var $ddePm = parcelRequire("ddePm");

var $bQThX = parcelRequire("bQThX");

var $gwFzn = parcelRequire("gwFzn");
var $8e659dd04c3ecce3$var$useContext = $gwFzn.useContext;
function $8e659dd04c3ecce3$var$useRelayEnvironment() {
    var context = $8e659dd04c3ecce3$var$useContext($ddePm);
    !(context != null) && $bQThX(false);
    return context.environment;
}
module.exports = $8e659dd04c3ecce3$var$useRelayEnvironment;

});


parcelRegister("itR7S", function(module, exports) {
'use strict';

var $kgUNJ = parcelRequire("kgUNJ");
var $d7442523017f3e65$var$loadQuery = $kgUNJ.loadQuery;
function $d7442523017f3e65$var$loadEntryPoint(environmentProvider, entryPoint, entryPointParams) {
    var loadingPromise = null;
    if (entryPoint.root.getModuleIfRequired() == null) loadingPromise = entryPoint.root.load();
    var preloadProps = entryPoint.getPreloadProps(entryPointParams);
    var queries = preloadProps.queries, entryPoints = preloadProps.entryPoints, extraProps = preloadProps.extraProps;
    var preloadedQueries = {};
    var preloadedEntryPoints = {};
    if (queries != null) {
        var queriesPropNames = Object.keys(queries);
        queriesPropNames.forEach(function(queryPropName) {
            var _queries$queryPropNam = queries[queryPropName], environmentProviderOptions = _queries$queryPropNam.environmentProviderOptions, options = _queries$queryPropNam.options, parameters = _queries$queryPropNam.parameters, variables = _queries$queryPropNam.variables;
            var environment = environmentProvider.getEnvironment(environmentProviderOptions);
            preloadedQueries[queryPropName] = $d7442523017f3e65$var$loadQuery(environment, parameters, variables, {
                fetchPolicy: options === null || options === void 0 ? void 0 : options.fetchPolicy,
                networkCacheConfig: options === null || options === void 0 ? void 0 : options.networkCacheConfig,
                __nameForWarning: 'loadEntryPoint'
            }, environmentProviderOptions);
        });
    }
    if (entryPoints != null) {
        var entryPointPropNames = Object.keys(entryPoints);
        entryPointPropNames.forEach(function(entryPointPropName) {
            var entryPointDescription = entryPoints[entryPointPropName];
            if (entryPointDescription == null) return;
            var nestedEntryPoint = entryPointDescription.entryPoint, nestedParams = entryPointDescription.entryPointParams;
            preloadedEntryPoints[entryPointPropName] = $d7442523017f3e65$var$loadEntryPoint(environmentProvider, nestedEntryPoint, nestedParams);
        });
    }
    var isDisposed = false;
    return {
        dispose: function dispose() {
            if (isDisposed) return;
            if (preloadedQueries != null) Object.values(preloadedQueries).forEach(function(_ref) {
                var innerDispose = _ref.dispose;
                innerDispose();
            });
            if (preloadedEntryPoints != null) Object.values(preloadedEntryPoints).forEach(function(_ref2) {
                var innerDispose = _ref2.dispose;
                innerDispose();
            });
            isDisposed = true;
        },
        entryPoints: preloadedEntryPoints,
        extraProps: extraProps !== null && extraProps !== void 0 ? extraProps : null,
        getComponent: function getComponent() {
            var componentModule = entryPoint.root.getModuleIfRequired();
            if (componentModule == null) {
                var _loadingPromise;
                loadingPromise = (_loadingPromise = loadingPromise) !== null && _loadingPromise !== void 0 ? _loadingPromise : entryPoint.root.load();
                throw loadingPromise;
            }
            var component = componentModule["default"] != null ? componentModule["default"] : componentModule;
            return component;
        },
        get isDisposed () {
            return isDisposed;
        },
        queries: preloadedQueries,
        rootModuleID: entryPoint.root.getModuleId()
    };
}
module.exports = $d7442523017f3e65$var$loadEntryPoint;

});
parcelRegister("kgUNJ", function(module, exports) {
'use strict';

var $7dvyf = parcelRequire("7dvyf");
var $ec215cccfd8e5d74$var$_interopRequireDefault = $7dvyf.default;

var $ec215cccfd8e5d74$var$_objectSpread2 = $ec215cccfd8e5d74$var$_interopRequireDefault((parcelRequire("4N8OD")));

var $bQThX = parcelRequire("bQThX");

var $gwFzn = parcelRequire("gwFzn");

var $lan9D = parcelRequire("lan9D");
var $ec215cccfd8e5d74$var$fetchQueryDeduped = $lan9D.__internal.fetchQueryDeduped, $ec215cccfd8e5d74$var$Observable = $lan9D.Observable, $ec215cccfd8e5d74$var$PreloadableQueryRegistry = $lan9D.PreloadableQueryRegistry, $ec215cccfd8e5d74$var$RelayFeatureFlags = $lan9D.RelayFeatureFlags, $ec215cccfd8e5d74$var$ReplaySubject = $lan9D.ReplaySubject, $ec215cccfd8e5d74$var$createOperationDescriptor = $lan9D.createOperationDescriptor, $ec215cccfd8e5d74$var$getRequest = $lan9D.getRequest, $ec215cccfd8e5d74$var$getRequestIdentifier = $lan9D.getRequestIdentifier;
parcelRequire("hzw7m");
var $ec215cccfd8e5d74$var$RenderDispatcher = null;
var $ec215cccfd8e5d74$var$fetchKey = 100001;
function $ec215cccfd8e5d74$var$useTrackLoadQueryInRender() {
    if ($ec215cccfd8e5d74$var$RenderDispatcher === null) {
        var _React$__SECRET_INTER, _React$__SECRET_INTER2;
        $ec215cccfd8e5d74$var$RenderDispatcher = (_React$__SECRET_INTER = $gwFzn.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED) === null || _React$__SECRET_INTER === void 0 ? void 0 : (_React$__SECRET_INTER2 = _React$__SECRET_INTER.ReactCurrentDispatcher) === null || _React$__SECRET_INTER2 === void 0 ? void 0 : _React$__SECRET_INTER2.current;
    }
}
function $ec215cccfd8e5d74$var$loadQuery(environment, preloadableRequest, variables, options, environmentProviderOptions) {
    var _React$__SECRET_INTER3, _React$__SECRET_INTER4, _options$__nameForWar, _options$fetchPolicy;
    var CurrentDispatcher = (_React$__SECRET_INTER3 = $gwFzn.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED) === null || _React$__SECRET_INTER3 === void 0 ? void 0 : (_React$__SECRET_INTER4 = _React$__SECRET_INTER3.ReactCurrentDispatcher) === null || _React$__SECRET_INTER4 === void 0 ? void 0 : _React$__SECRET_INTER4.current;
    $ec215cccfd8e5d74$var$fetchKey++;
    var fetchPolicy = (_options$fetchPolicy = options === null || options === void 0 ? void 0 : options.fetchPolicy) !== null && _options$fetchPolicy !== void 0 ? _options$fetchPolicy : 'store-or-network';
    var networkCacheConfig = (0, $ec215cccfd8e5d74$var$_objectSpread2["default"])((0, $ec215cccfd8e5d74$var$_objectSpread2["default"])({}, options === null || options === void 0 ? void 0 : options.networkCacheConfig), {}, {
        force: true
    });
    var retainReference;
    var didExecuteNetworkSource = false;
    var executeWithNetworkSource = function executeWithNetworkSource(operation, networkObservable) {
        didExecuteNetworkSource = true;
        return environment.executeWithSource({
            operation: operation,
            source: networkObservable
        });
    };
    var executionSubject = new $ec215cccfd8e5d74$var$ReplaySubject();
    var returnedObservable = $ec215cccfd8e5d74$var$Observable.create(function(sink) {
        return executionSubject.subscribe(sink);
    });
    var unsubscribeFromNetworkRequest;
    var networkError = null;
    var didMakeNetworkRequest = false;
    var makeNetworkRequest = function makeNetworkRequest(params) {
        didMakeNetworkRequest = true;
        var observable;
        var subject = new $ec215cccfd8e5d74$var$ReplaySubject();
        if ($ec215cccfd8e5d74$var$RelayFeatureFlags.ENABLE_LOAD_QUERY_REQUEST_DEDUPING === true) {
            var identifier = 'raw-network-request-' + $ec215cccfd8e5d74$var$getRequestIdentifier(params, variables);
            observable = $ec215cccfd8e5d74$var$fetchQueryDeduped(environment, identifier, function() {
                var network = environment.getNetwork();
                return network.execute(params, variables, networkCacheConfig);
            });
        } else {
            var network = environment.getNetwork();
            observable = network.execute(params, variables, networkCacheConfig);
        }
        var _observable$subscribe = observable.subscribe({
            error: function error(err) {
                networkError = err;
                subject.error(err);
            },
            next: function next(data) {
                subject.next(data);
            },
            complete: function complete() {
                subject.complete();
            }
        }), unsubscribe = _observable$subscribe.unsubscribe;
        unsubscribeFromNetworkRequest = unsubscribe;
        return $ec215cccfd8e5d74$var$Observable.create(function(sink) {
            var subjectSubscription = subject.subscribe(sink);
            return function() {
                subjectSubscription.unsubscribe();
                unsubscribeFromNetworkRequest();
            };
        });
    };
    var unsubscribeFromExecution;
    var executeDeduped = function executeDeduped(operation, fetchFn) {
        if ($ec215cccfd8e5d74$var$RelayFeatureFlags.ENABLE_LOAD_QUERY_REQUEST_DEDUPING === true) didMakeNetworkRequest = true;
        var _fetchQueryDeduped$su = $ec215cccfd8e5d74$var$fetchQueryDeduped(environment, operation.request.identifier, fetchFn).subscribe({
            error: function error(err) {
                executionSubject.error(err);
            },
            next: function next(data) {
                executionSubject.next(data);
            },
            complete: function complete() {
                executionSubject.complete();
            }
        });
        unsubscribeFromExecution = _fetchQueryDeduped$su.unsubscribe;
    };
    var checkAvailabilityAndExecute = function checkAvailabilityAndExecute(concreteRequest) {
        var operation = $ec215cccfd8e5d74$var$createOperationDescriptor(concreteRequest, variables, networkCacheConfig);
        retainReference = environment.retain(operation);
        if (fetchPolicy === 'store-only') return;
        var shouldFetch = fetchPolicy !== 'store-or-network' || environment.check(operation).status !== 'available';
        if (shouldFetch) executeDeduped(operation, function() {
            var networkObservable = makeNetworkRequest(concreteRequest.params);
            var executeObservable = executeWithNetworkSource(operation, networkObservable);
            return executeObservable;
        });
    };
    var params;
    var cancelOnLoadCallback;
    var queryId;
    if (preloadableRequest.kind === 'PreloadableConcreteRequest') {
        var preloadableConcreteRequest = preloadableRequest;
        params = preloadableConcreteRequest.params;
        var _params = params;
        queryId = _params.id;
        !(queryId !== null) && $bQThX(false);
        var _module = $ec215cccfd8e5d74$var$PreloadableQueryRegistry.get(queryId);
        if (_module != null) checkAvailabilityAndExecute(_module);
        else {
            var networkObservable = fetchPolicy === 'store-only' ? null : makeNetworkRequest(params);
            var _PreloadableQueryRegi = $ec215cccfd8e5d74$var$PreloadableQueryRegistry.onLoad(queryId, function(preloadedModule) {
                cancelOnLoadCallback();
                var operation = $ec215cccfd8e5d74$var$createOperationDescriptor(preloadedModule, variables, networkCacheConfig);
                retainReference = environment.retain(operation);
                if (networkObservable != null) executeDeduped(operation, function() {
                    return executeWithNetworkSource(operation, networkObservable);
                });
            });
            cancelOnLoadCallback = _PreloadableQueryRegi.dispose;
        }
    } else {
        var graphQlTaggedNode = preloadableRequest;
        var request = $ec215cccfd8e5d74$var$getRequest(graphQlTaggedNode);
        params = request.params;
        queryId = params.cacheID != null ? params.cacheID : params.id;
        checkAvailabilityAndExecute(request);
    }
    var isDisposed = false;
    var isReleased = false;
    var isNetworkRequestCancelled = false;
    var releaseQuery = function releaseQuery() {
        if (isReleased) return;
        retainReference && retainReference.dispose();
        isReleased = true;
    };
    var cancelNetworkRequest = function cancelNetworkRequest() {
        if (isNetworkRequestCancelled) return;
        if (didExecuteNetworkSource) unsubscribeFromExecution && unsubscribeFromExecution();
        else unsubscribeFromNetworkRequest && unsubscribeFromNetworkRequest();
        cancelOnLoadCallback && cancelOnLoadCallback();
        isNetworkRequestCancelled = true;
    };
    return {
        kind: 'PreloadedQuery',
        environment: environment,
        environmentProviderOptions: environmentProviderOptions,
        dispose: function dispose() {
            if (isDisposed) return;
            releaseQuery();
            cancelNetworkRequest();
            isDisposed = true;
        },
        releaseQuery: releaseQuery,
        cancelNetworkRequest: cancelNetworkRequest,
        fetchKey: $ec215cccfd8e5d74$var$fetchKey,
        id: queryId,
        get isDisposed () {
            return isDisposed || isReleased;
        },
        get networkError () {
            return networkError;
        },
        name: params.name,
        networkCacheConfig: networkCacheConfig,
        fetchPolicy: fetchPolicy,
        source: didMakeNetworkRequest ? returnedObservable : undefined,
        variables: variables
    };
}
module.exports = {
    loadQuery: $ec215cccfd8e5d74$var$loadQuery,
    useTrackLoadQueryInRender: $ec215cccfd8e5d74$var$useTrackLoadQueryInRender
};

});


parcelRegister("2AmqJ", function(module, exports) {
'use strict';

var $ddePm = parcelRequire("ddePm");

var $gwFzn = parcelRequire("gwFzn");
var $1e2057b500da6bba$var$useMemo = $gwFzn.useMemo;
function $1e2057b500da6bba$var$RelayEnvironmentProvider(props) {
    var children = props.children, environment = props.environment, getEnvironmentForActor = props.getEnvironmentForActor;
    var context = $1e2057b500da6bba$var$useMemo(function() {
        return {
            environment: environment,
            getEnvironmentForActor: getEnvironmentForActor
        };
    }, [
        environment,
        getEnvironmentForActor
    ]);
    return /*#__PURE__*/ $gwFzn.createElement($ddePm.Provider, {
        value: context
    }, children);
}
module.exports = $1e2057b500da6bba$var$RelayEnvironmentProvider;

});

parcelRegister("76WCZ", function(module, exports) {
'use strict';

var $7dvyf = parcelRequire("7dvyf");
var $52d69233a20cd863$var$_interopRequireDefault = $7dvyf.default;

var $52d69233a20cd863$var$_objectSpread2 = $52d69233a20cd863$var$_interopRequireDefault((parcelRequire("4N8OD")));

var $ktUWe = parcelRequire("ktUWe");
function $52d69233a20cd863$var$useClientQuery(gqlQuery, variables, options) {
    var query = gqlQuery;
    return $ktUWe(query, variables, (0, $52d69233a20cd863$var$_objectSpread2["default"])((0, $52d69233a20cd863$var$_objectSpread2["default"])({}, options), {}, {
        fetchPolicy: 'store-only'
    }));
}
module.exports = $52d69233a20cd863$var$useClientQuery;

});
parcelRegister("ktUWe", function(module, exports) {
'use strict';

var $kgUNJ = parcelRequire("kgUNJ");
var $ee92aed10fe4587b$var$useTrackLoadQueryInRender = $kgUNJ.useTrackLoadQueryInRender;

var $2VcGn = parcelRequire("2VcGn");

var $ax2Om = parcelRequire("ax2Om");

var $cdYu4 = parcelRequire("cdYu4");

var $lan9D = parcelRequire("lan9D");
var $ee92aed10fe4587b$var$fetchQuery = $lan9D.__internal.fetchQuery;
function $ee92aed10fe4587b$var$useLazyLoadQuery(gqlQuery, variables, options) {
    $ee92aed10fe4587b$var$useTrackLoadQueryInRender();
    var environment = $cdYu4();
    var query = $ax2Om(gqlQuery, variables, options && options.networkCacheConfig ? options.networkCacheConfig : {
        force: true
    });
    var data = $2VcGn({
        componentDisplayName: 'useLazyLoadQuery()',
        fetchKey: options === null || options === void 0 ? void 0 : options.fetchKey,
        fetchObservable: $ee92aed10fe4587b$var$fetchQuery(environment, query),
        fetchPolicy: options === null || options === void 0 ? void 0 : options.fetchPolicy,
        query: query,
        renderPolicy: options === null || options === void 0 ? void 0 : options.UNSTABLE_renderPolicy
    });
    return data;
}
module.exports = $ee92aed10fe4587b$var$useLazyLoadQuery;

});
parcelRegister("2VcGn", function(module, exports) {
'use strict';

var $fWBut = parcelRequire("fWBut");

var $eaErg = parcelRequire("eaErg");
var $220abe1929da9ece$var$getQueryCacheIdentifier = $eaErg.getQueryCacheIdentifier, $220abe1929da9ece$var$getQueryResourceForEnvironment = $eaErg.getQueryResourceForEnvironment;

var $5U6n8 = parcelRequire("5U6n8");

var $lO358 = parcelRequire("lO358");

var $cdYu4 = parcelRequire("cdYu4");

var $gwFzn = parcelRequire("gwFzn");
var $220abe1929da9ece$var$useContext = $gwFzn.useContext, $220abe1929da9ece$var$useEffect = $gwFzn.useEffect, $220abe1929da9ece$var$useState = $gwFzn.useState, $220abe1929da9ece$var$useRef = $gwFzn.useRef;
function $220abe1929da9ece$var$useLazyLoadQueryNode(_ref) {
    var query = _ref.query, componentDisplayName = _ref.componentDisplayName, fetchObservable = _ref.fetchObservable, fetchPolicy = _ref.fetchPolicy, fetchKey = _ref.fetchKey, renderPolicy = _ref.renderPolicy;
    var environment = $cdYu4();
    var profilerContext = $220abe1929da9ece$var$useContext($fWBut);
    var QueryResource = $220abe1929da9ece$var$getQueryResourceForEnvironment(environment);
    var _useState = $220abe1929da9ece$var$useState(0), forceUpdateKey = _useState[0], forceUpdate = _useState[1];
    var _useFetchTrackingRef = $5U6n8(), startFetch = _useFetchTrackingRef.startFetch, completeFetch = _useFetchTrackingRef.completeFetch;
    var cacheBreaker = "".concat(forceUpdateKey, "-").concat(fetchKey !== null && fetchKey !== void 0 ? fetchKey : '');
    var cacheIdentifier = $220abe1929da9ece$var$getQueryCacheIdentifier(environment, query, fetchPolicy, renderPolicy, cacheBreaker);
    var preparedQueryResult = profilerContext.wrapPrepareQueryResource(function() {
        return QueryResource.prepareWithIdentifier(cacheIdentifier, query, fetchObservable, fetchPolicy, renderPolicy, {
            start: startFetch,
            complete: completeFetch,
            error: completeFetch
        }, profilerContext);
    });
    var maybeHiddenOrFastRefresh = $220abe1929da9ece$var$useRef(false);
    $220abe1929da9ece$var$useEffect(function() {
        return function() {
            maybeHiddenOrFastRefresh.current = true;
        };
    }, []);
    $220abe1929da9ece$var$useEffect(function() {
        if (maybeHiddenOrFastRefresh.current === true) {
            maybeHiddenOrFastRefresh.current = false;
            forceUpdate(function(n) {
                return n + 1;
            });
            return;
        }
        var disposable = QueryResource.retain(preparedQueryResult, profilerContext);
        return function() {
            disposable.dispose();
        };
    }, [
        environment,
        cacheIdentifier
    ]);
    $220abe1929da9ece$var$useEffect(function() {
        QueryResource.releaseTemporaryRetain(preparedQueryResult);
    });
    var fragmentNode = preparedQueryResult.fragmentNode, fragmentRef = preparedQueryResult.fragmentRef;
    var data = $lO358(fragmentNode, fragmentRef, componentDisplayName);
    return data;
}
module.exports = $220abe1929da9ece$var$useLazyLoadQueryNode;

});
parcelRegister("eaErg", function(module, exports) {
'use strict';

var $7dvyf = parcelRequire("7dvyf");
var $a5115e2747e7e2db$var$_interopRequireDefault = $7dvyf.default;

var $a5115e2747e7e2db$var$_objectSpread2 = $a5115e2747e7e2db$var$_interopRequireDefault((parcelRequire("4N8OD")));

var $a5115e2747e7e2db$var$_defineProperty2 = $a5115e2747e7e2db$var$_interopRequireDefault((parcelRequire("dW6Ee")));

var $dtwv9 = parcelRequire("dtwv9");

var $kR6em = parcelRequire("kR6em");

var $bQThX = parcelRequire("bQThX");

var $lan9D = parcelRequire("lan9D");
var $a5115e2747e7e2db$var$isPromise = $lan9D.isPromise;
parcelRequire("hzw7m");
var $a5115e2747e7e2db$var$CACHE_CAPACITY = 1000;
var $a5115e2747e7e2db$var$DEFAULT_FETCH_POLICY = 'store-or-network';
var $a5115e2747e7e2db$var$DEFAULT_LIVE_FETCH_POLICY = 'store-and-network';
var $a5115e2747e7e2db$var$WEAKMAP_SUPPORTED = typeof WeakMap === 'function';
function $a5115e2747e7e2db$var$operationIsLiveQuery(operation) {
    return operation.request.node.params.metadata.live !== undefined;
}
function $a5115e2747e7e2db$var$getQueryCacheIdentifier(environment, operation, maybeFetchPolicy, maybeRenderPolicy, cacheBreaker) {
    var fetchPolicy = maybeFetchPolicy !== null && maybeFetchPolicy !== void 0 ? maybeFetchPolicy : $a5115e2747e7e2db$var$operationIsLiveQuery(operation) ? $a5115e2747e7e2db$var$DEFAULT_LIVE_FETCH_POLICY : $a5115e2747e7e2db$var$DEFAULT_FETCH_POLICY;
    var renderPolicy = maybeRenderPolicy !== null && maybeRenderPolicy !== void 0 ? maybeRenderPolicy : environment.UNSTABLE_getDefaultRenderPolicy();
    var cacheIdentifier = "".concat(fetchPolicy, "-").concat(renderPolicy, "-").concat(operation.request.identifier);
    if (cacheBreaker != null) return "".concat(cacheIdentifier, "-").concat(cacheBreaker);
    return cacheIdentifier;
}
function $a5115e2747e7e2db$var$getQueryResult(operation, cacheIdentifier) {
    var rootFragmentRef = {
        __id: operation.fragment.dataID,
        __fragments: (0, $a5115e2747e7e2db$var$_defineProperty2["default"])({}, operation.fragment.node.name, operation.request.variables),
        __fragmentOwner: operation.request
    };
    return {
        cacheIdentifier: cacheIdentifier,
        fragmentNode: operation.request.node.fragment,
        fragmentRef: rootFragmentRef,
        operation: operation
    };
}
var $a5115e2747e7e2db$var$nextID = 200000;
function $a5115e2747e7e2db$var$createCacheEntry(cacheIdentifier, operation, operationAvailability, value, networkSubscription, onDispose) {
    var isLiveQuery = $a5115e2747e7e2db$var$operationIsLiveQuery(operation);
    var currentValue = value;
    var currentNetworkSubscription = networkSubscription;
    var suspenseResource = new $kR6em(function(environment) {
        var retention = environment.retain(operation);
        return {
            dispose: function dispose() {
                if (isLiveQuery && currentNetworkSubscription != null) currentNetworkSubscription.unsubscribe();
                retention.dispose();
                onDispose(cacheEntry);
            }
        };
    });
    var cacheEntry = {
        cacheIdentifier: cacheIdentifier,
        id: $a5115e2747e7e2db$var$nextID++,
        processedPayloadsCount: 0,
        operationAvailability: operationAvailability,
        getValue: function getValue() {
            return currentValue;
        },
        setValue: function setValue(val) {
            currentValue = val;
        },
        setNetworkSubscription: function setNetworkSubscription(subscription) {
            if (isLiveQuery && currentNetworkSubscription != null) currentNetworkSubscription.unsubscribe();
            currentNetworkSubscription = subscription;
        },
        temporaryRetain: function temporaryRetain(environment) {
            return suspenseResource.temporaryRetain(environment);
        },
        permanentRetain: function permanentRetain(environment) {
            return suspenseResource.permanentRetain(environment);
        },
        releaseTemporaryRetain: function releaseTemporaryRetain() {
            suspenseResource.releaseTemporaryRetain();
        }
    };
    return cacheEntry;
}
var $a5115e2747e7e2db$var$QueryResourceImpl = /*#__PURE__*/ function() {
    function QueryResourceImpl(environment) {
        var _this = this;
        (0, $a5115e2747e7e2db$var$_defineProperty2["default"])(this, "_clearCacheEntry", function(cacheEntry) {
            _this._cache["delete"](cacheEntry.cacheIdentifier);
        });
        this._environment = environment;
        this._cache = $dtwv9.create($a5115e2747e7e2db$var$CACHE_CAPACITY);
    }
    var _proto = QueryResourceImpl.prototype;
    _proto.prepare = function prepare(operation, fetchObservable, maybeFetchPolicy, maybeRenderPolicy, observer, cacheBreaker, profilerContext) {
        var cacheIdentifier = $a5115e2747e7e2db$var$getQueryCacheIdentifier(this._environment, operation, maybeFetchPolicy, maybeRenderPolicy, cacheBreaker);
        return this.prepareWithIdentifier(cacheIdentifier, operation, fetchObservable, maybeFetchPolicy, maybeRenderPolicy, observer, profilerContext);
    };
    _proto.prepareWithIdentifier = function prepareWithIdentifier(cacheIdentifier, operation, fetchObservable, maybeFetchPolicy, maybeRenderPolicy, observer, profilerContext) {
        var environment = this._environment;
        var fetchPolicy = maybeFetchPolicy !== null && maybeFetchPolicy !== void 0 ? maybeFetchPolicy : $a5115e2747e7e2db$var$operationIsLiveQuery(operation) ? $a5115e2747e7e2db$var$DEFAULT_LIVE_FETCH_POLICY : $a5115e2747e7e2db$var$DEFAULT_FETCH_POLICY;
        var renderPolicy = maybeRenderPolicy !== null && maybeRenderPolicy !== void 0 ? maybeRenderPolicy : environment.UNSTABLE_getDefaultRenderPolicy();
        var cacheEntry = this._cache.get(cacheIdentifier);
        var temporaryRetainDisposable = null;
        var entryWasCached = cacheEntry != null;
        if (cacheEntry == null) cacheEntry = this._fetchAndSaveQuery(cacheIdentifier, operation, fetchObservable, fetchPolicy, renderPolicy, profilerContext, (0, $a5115e2747e7e2db$var$_objectSpread2["default"])((0, $a5115e2747e7e2db$var$_objectSpread2["default"])({}, observer), {}, {
            unsubscribe: function unsubscribe(subscription) {
                if (temporaryRetainDisposable != null) temporaryRetainDisposable.dispose();
                var observerUnsubscribe = observer === null || observer === void 0 ? void 0 : observer.unsubscribe;
                observerUnsubscribe && observerUnsubscribe(subscription);
            }
        }));
        temporaryRetainDisposable = cacheEntry.temporaryRetain(environment);
        var cachedValue = cacheEntry.getValue();
        if ($a5115e2747e7e2db$var$isPromise(cachedValue)) {
            environment.__log({
                name: 'suspense.query',
                fetchPolicy: fetchPolicy,
                isPromiseCached: entryWasCached,
                operation: operation,
                queryAvailability: cacheEntry.operationAvailability,
                renderPolicy: renderPolicy
            });
            throw cachedValue;
        }
        if (cachedValue instanceof Error) throw cachedValue;
        return cachedValue;
    };
    _proto.retain = function retain(queryResult, profilerContext) {
        var environment = this._environment;
        var cacheIdentifier = queryResult.cacheIdentifier, operation = queryResult.operation;
        var cacheEntry = this._getOrCreateCacheEntry(cacheIdentifier, operation, null, queryResult, null);
        var disposable = cacheEntry.permanentRetain(environment);
        environment.__log({
            name: 'queryresource.retain',
            profilerContext: profilerContext,
            resourceID: cacheEntry.id
        });
        return {
            dispose: function dispose() {
                disposable.dispose();
            }
        };
    };
    _proto.releaseTemporaryRetain = function releaseTemporaryRetain(queryResult) {
        var cacheEntry = this._cache.get(queryResult.cacheIdentifier);
        if (cacheEntry != null) cacheEntry.releaseTemporaryRetain();
    };
    _proto.TESTS_ONLY__getCacheEntry = function TESTS_ONLY__getCacheEntry(operation, maybeFetchPolicy, maybeRenderPolicy, cacheBreaker) {
        var environment = this._environment;
        var cacheIdentifier = $a5115e2747e7e2db$var$getQueryCacheIdentifier(environment, operation, maybeFetchPolicy, maybeRenderPolicy, cacheBreaker);
        return this._cache.get(cacheIdentifier);
    };
    _proto._getOrCreateCacheEntry = function _getOrCreateCacheEntry(cacheIdentifier, operation, operationAvailability, value, networkSubscription) {
        var cacheEntry = this._cache.get(cacheIdentifier);
        if (cacheEntry == null) {
            cacheEntry = $a5115e2747e7e2db$var$createCacheEntry(cacheIdentifier, operation, operationAvailability, value, networkSubscription, this._clearCacheEntry);
            this._cache.set(cacheIdentifier, cacheEntry);
        }
        return cacheEntry;
    };
    _proto._fetchAndSaveQuery = function _fetchAndSaveQuery(cacheIdentifier, operation, fetchObservable, fetchPolicy, renderPolicy, profilerContext, observer) {
        var _this2 = this;
        var environment = this._environment;
        var queryAvailability = environment.check(operation);
        var queryStatus = queryAvailability.status;
        var hasFullQuery = queryStatus === 'available';
        var canPartialRender = hasFullQuery || renderPolicy === 'partial' && queryStatus !== 'stale';
        var shouldFetch;
        var shouldAllowRender;
        var resolveNetworkPromise = function resolveNetworkPromise() {};
        switch(fetchPolicy){
            case 'store-only':
                shouldFetch = false;
                shouldAllowRender = true;
                break;
            case 'store-or-network':
                shouldFetch = !hasFullQuery;
                shouldAllowRender = canPartialRender;
                break;
            case 'store-and-network':
                shouldFetch = true;
                shouldAllowRender = canPartialRender;
                break;
            case 'network-only':
            default:
                shouldFetch = true;
                shouldAllowRender = false;
                break;
        }
        if (shouldAllowRender) {
            var queryResult = $a5115e2747e7e2db$var$getQueryResult(operation, cacheIdentifier);
            var _cacheEntry = $a5115e2747e7e2db$var$createCacheEntry(cacheIdentifier, operation, queryAvailability, queryResult, null, this._clearCacheEntry);
            this._cache.set(cacheIdentifier, _cacheEntry);
        }
        if (shouldFetch) {
            var _queryResult = $a5115e2747e7e2db$var$getQueryResult(operation, cacheIdentifier);
            var networkSubscription;
            fetchObservable.subscribe({
                start: function start(subscription) {
                    networkSubscription = subscription;
                    var cacheEntry = _this2._cache.get(cacheIdentifier);
                    if (cacheEntry) cacheEntry.setNetworkSubscription(networkSubscription);
                    var observerStart = observer === null || observer === void 0 ? void 0 : observer.start;
                    if (observerStart) {
                        var subscriptionWithConditionalCancelation = (0, $a5115e2747e7e2db$var$_objectSpread2["default"])((0, $a5115e2747e7e2db$var$_objectSpread2["default"])({}, subscription), {}, {
                            unsubscribe: function unsubscribe() {
                                if ($a5115e2747e7e2db$var$operationIsLiveQuery(operation)) subscription.unsubscribe();
                            }
                        });
                        observerStart(subscriptionWithConditionalCancelation);
                    }
                },
                next: function next() {
                    var cacheEntry = _this2._getOrCreateCacheEntry(cacheIdentifier, operation, queryAvailability, _queryResult, networkSubscription);
                    cacheEntry.processedPayloadsCount += 1;
                    cacheEntry.setValue(_queryResult);
                    resolveNetworkPromise();
                    var observerNext = observer === null || observer === void 0 ? void 0 : observer.next;
                    if (observerNext != null) {
                        var snapshot = environment.lookup(operation.fragment);
                        observerNext(snapshot);
                    }
                },
                error: function error(_error) {
                    var cacheEntry = _this2._getOrCreateCacheEntry(cacheIdentifier, operation, queryAvailability, _error, networkSubscription);
                    if (cacheEntry.processedPayloadsCount === 0) cacheEntry.setValue(_error);
                    resolveNetworkPromise();
                    networkSubscription = null;
                    cacheEntry.setNetworkSubscription(null);
                    var observerError = observer === null || observer === void 0 ? void 0 : observer.error;
                    observerError && observerError(_error);
                },
                complete: function complete() {
                    resolveNetworkPromise();
                    networkSubscription = null;
                    var cacheEntry = _this2._cache.get(cacheIdentifier);
                    if (cacheEntry) cacheEntry.setNetworkSubscription(null);
                    var observerComplete = observer === null || observer === void 0 ? void 0 : observer.complete;
                    observerComplete && observerComplete();
                },
                unsubscribe: observer === null || observer === void 0 ? void 0 : observer.unsubscribe
            });
            var _cacheEntry2 = this._cache.get(cacheIdentifier);
            if (!_cacheEntry2) {
                var networkPromise = new Promise(function(resolve) {
                    resolveNetworkPromise = resolve;
                });
                networkPromise.displayName = 'Relay(' + operation.fragment.node.name + ')';
                _cacheEntry2 = $a5115e2747e7e2db$var$createCacheEntry(cacheIdentifier, operation, queryAvailability, networkPromise, networkSubscription, this._clearCacheEntry);
                this._cache.set(cacheIdentifier, _cacheEntry2);
            }
        } else {
            var observerComplete = observer === null || observer === void 0 ? void 0 : observer.complete;
            observerComplete && observerComplete();
        }
        var cacheEntry = this._cache.get(cacheIdentifier);
        !(cacheEntry != null) && $bQThX(false);
        environment.__log({
            name: 'queryresource.fetch',
            resourceID: cacheEntry.id,
            operation: operation,
            profilerContext: profilerContext,
            fetchPolicy: fetchPolicy,
            renderPolicy: renderPolicy,
            queryAvailability: queryAvailability,
            shouldFetch: shouldFetch
        });
        return cacheEntry;
    };
    return QueryResourceImpl;
}();
function $a5115e2747e7e2db$var$createQueryResource(environment) {
    return new $a5115e2747e7e2db$var$QueryResourceImpl(environment);
}
var $a5115e2747e7e2db$var$dataResources = $a5115e2747e7e2db$var$WEAKMAP_SUPPORTED ? new WeakMap() : new Map();
function $a5115e2747e7e2db$var$getQueryResourceForEnvironment(environment) {
    var cached = $a5115e2747e7e2db$var$dataResources.get(environment);
    if (cached) return cached;
    var newDataResource = $a5115e2747e7e2db$var$createQueryResource(environment);
    $a5115e2747e7e2db$var$dataResources.set(environment, newDataResource);
    return newDataResource;
}
module.exports = {
    createQueryResource: $a5115e2747e7e2db$var$createQueryResource,
    getQueryResourceForEnvironment: $a5115e2747e7e2db$var$getQueryResourceForEnvironment,
    getQueryCacheIdentifier: $a5115e2747e7e2db$var$getQueryCacheIdentifier
};

});
parcelRegister("dtwv9", function(module, exports) {
'use strict';

var $bQThX = parcelRequire("bQThX");
var $9cf731e8e3db4832$var$LRUCache = /*#__PURE__*/ function() {
    function LRUCache(capacity) {
        this._capacity = capacity;
        !(this._capacity > 0) && $bQThX(false);
        this._map = new Map();
    }
    var _proto = LRUCache.prototype;
    _proto.set = function set(key, value) {
        this._map["delete"](key);
        this._map.set(key, value);
        if (this._map.size > this._capacity) {
            var firstKey = this._map.keys().next();
            if (!firstKey.done) this._map["delete"](firstKey.value);
        }
    };
    _proto.get = function get(key) {
        var value = this._map.get(key);
        if (value != null) {
            this._map["delete"](key);
            this._map.set(key, value);
        }
        return value;
    };
    _proto.has = function has(key) {
        return this._map.has(key);
    };
    _proto["delete"] = function _delete(key) {
        this._map["delete"](key);
    };
    _proto.size = function size() {
        return this._map.size;
    };
    _proto.capacity = function capacity() {
        return this._capacity - this._map.size;
    };
    _proto.clear = function clear() {
        this._map.clear();
    };
    return LRUCache;
}();
function $9cf731e8e3db4832$var$create(capacity) {
    return new $9cf731e8e3db4832$var$LRUCache(capacity);
}
module.exports = {
    create: $9cf731e8e3db4832$var$create
};

});

parcelRegister("kR6em", function(module, exports) {
'use strict';

var $7dvyf = parcelRequire("7dvyf");
var $f2ed972e0ca582a1$var$_interopRequireDefault = $7dvyf.default;

var $f2ed972e0ca582a1$var$_defineProperty2 = $f2ed972e0ca582a1$var$_interopRequireDefault((parcelRequire("dW6Ee")));
parcelRequire("hzw7m");
var $f2ed972e0ca582a1$var$TEMPORARY_RETAIN_DURATION_MS = 300000;
var $f2ed972e0ca582a1$var$SuspenseResource = /*#__PURE__*/ function() {
    function SuspenseResource(retain) {
        var _this = this;
        (0, $f2ed972e0ca582a1$var$_defineProperty2["default"])(this, "_retainCount", 0);
        (0, $f2ed972e0ca582a1$var$_defineProperty2["default"])(this, "_retainDisposable", null);
        (0, $f2ed972e0ca582a1$var$_defineProperty2["default"])(this, "_releaseTemporaryRetain", null);
        this._retain = function(environment) {
            _this._retainCount++;
            if (_this._retainCount === 1) _this._retainDisposable = retain(environment);
            return {
                dispose: function dispose() {
                    _this._retainCount = Math.max(0, _this._retainCount - 1);
                    if (_this._retainCount === 0) {
                        if (_this._retainDisposable != null) {
                            _this._retainDisposable.dispose();
                            _this._retainDisposable = null;
                        }
                    }
                }
            };
        };
    }
    var _proto = SuspenseResource.prototype;
    _proto.temporaryRetain = function temporaryRetain(environment) {
        var _this2 = this;
        var _this$_releaseTempora;
        if (environment.isServer()) return {
            dispose: function dispose() {}
        };
        var retention = this._retain(environment);
        var releaseQueryTimeout = null;
        var releaseTemporaryRetain = function releaseTemporaryRetain() {
            clearTimeout(releaseQueryTimeout);
            releaseQueryTimeout = null;
            _this2._releaseTemporaryRetain = null;
            retention.dispose();
        };
        releaseQueryTimeout = setTimeout(releaseTemporaryRetain, $f2ed972e0ca582a1$var$TEMPORARY_RETAIN_DURATION_MS);
        (_this$_releaseTempora = this._releaseTemporaryRetain) === null || _this$_releaseTempora === void 0 || _this$_releaseTempora.call(this);
        this._releaseTemporaryRetain = releaseTemporaryRetain;
        return {
            dispose: function dispose() {
                var _this$_releaseTempora2;
                (_this$_releaseTempora2 = _this2._releaseTemporaryRetain) === null || _this$_releaseTempora2 === void 0 || _this$_releaseTempora2.call(_this2);
            }
        };
    };
    _proto.permanentRetain = function permanentRetain(environment) {
        var disposable = this._retain(environment);
        this.releaseTemporaryRetain();
        return disposable;
    };
    _proto.releaseTemporaryRetain = function releaseTemporaryRetain() {
        var _this$_releaseTempora3;
        (_this$_releaseTempora3 = this._releaseTemporaryRetain) === null || _this$_releaseTempora3 === void 0 || _this$_releaseTempora3.call(this);
        this._releaseTemporaryRetain = null;
    };
    _proto.getRetainCount = function getRetainCount() {
        return this._retainCount;
    };
    return SuspenseResource;
}();
module.exports = $f2ed972e0ca582a1$var$SuspenseResource;

});


parcelRegister("5U6n8", function(module, exports) {
'use strict';

var $6OPey = parcelRequire("6OPey");

var $gwFzn = parcelRequire("gwFzn");
var $44c7201574a70e2a$var$useCallback = $gwFzn.useCallback, $44c7201574a70e2a$var$useEffect = $gwFzn.useEffect;
function $44c7201574a70e2a$var$useFetchTrackingRef() {
    var subscriptionRef = $6OPey(null);
    var isFetchingRef = $6OPey(false);
    var disposeFetch = $44c7201574a70e2a$var$useCallback(function() {
        if (subscriptionRef.current != null) {
            subscriptionRef.current.unsubscribe();
            subscriptionRef.current = null;
        }
        isFetchingRef.current = false;
    }, []);
    var startFetch = $44c7201574a70e2a$var$useCallback(function(subscription) {
        subscriptionRef.current = subscription;
        isFetchingRef.current = true;
    }, []);
    var completeFetch = $44c7201574a70e2a$var$useCallback(function() {
        subscriptionRef.current = null;
        isFetchingRef.current = false;
    }, []);
    $44c7201574a70e2a$var$useEffect(function() {
        return disposeFetch;
    }, [
        disposeFetch
    ]);
    return {
        isFetchingRef: isFetchingRef,
        startFetch: startFetch,
        disposeFetch: disposeFetch,
        completeFetch: completeFetch
    };
}
module.exports = $44c7201574a70e2a$var$useFetchTrackingRef;

});
parcelRegister("6OPey", function(module, exports) {
'use strict';

var $gwFzn = parcelRequire("gwFzn");
var $4f6f2785361d0a40$var$useMemo = $gwFzn.useMemo;
function $4f6f2785361d0a40$var$useUnsafeRef_DEPRECATED(init) {
    return $4f6f2785361d0a40$var$useMemo(function() {
        return {
            current: init
        };
    }, []);
}
module.exports = $4f6f2785361d0a40$var$useUnsafeRef_DEPRECATED;

});


parcelRegister("lO358", function(module, exports) {
'use strict';

var $7dvyf = parcelRequire("7dvyf");
var $fe00a87c4d484dca$var$_interopRequireDefault = $7dvyf.default;

var $fe00a87c4d484dca$var$_objectSpread2 = $fe00a87c4d484dca$var$_interopRequireDefault((parcelRequire("4N8OD")));

var $fe00a87c4d484dca$var$_createForOfIteratorHelper2 = $fe00a87c4d484dca$var$_interopRequireDefault((parcelRequire("bTRzt")));

var $fe00a87c4d484dca$var$_toConsumableArray2 = $fe00a87c4d484dca$var$_interopRequireDefault((parcelRequire("gvI75")));

var $eaErg = parcelRequire("eaErg");
var $fe00a87c4d484dca$var$getQueryResourceForEnvironment = $eaErg.getQueryResourceForEnvironment;

var $cdYu4 = parcelRequire("cdYu4");

var $bQThX = parcelRequire("bQThX");

var $gwFzn = parcelRequire("gwFzn");
var $fe00a87c4d484dca$var$useDebugValue = $gwFzn.useDebugValue, $fe00a87c4d484dca$var$useEffect = $gwFzn.useEffect, $fe00a87c4d484dca$var$useMemo = $gwFzn.useMemo, $fe00a87c4d484dca$var$useRef = $gwFzn.useRef, $fe00a87c4d484dca$var$useState = $gwFzn.useState;

var $lan9D = parcelRequire("lan9D");
var $fe00a87c4d484dca$var$_require3$__internal = $lan9D.__internal, $fe00a87c4d484dca$var$fetchQueryInternal = $fe00a87c4d484dca$var$_require3$__internal.fetchQuery, $fe00a87c4d484dca$var$getPromiseForActiveRequest = $fe00a87c4d484dca$var$_require3$__internal.getPromiseForActiveRequest, $fe00a87c4d484dca$var$RelayFeatureFlags = $lan9D.RelayFeatureFlags, $fe00a87c4d484dca$var$areEqualSelectors = $lan9D.areEqualSelectors, $fe00a87c4d484dca$var$createOperationDescriptor = $lan9D.createOperationDescriptor, $fe00a87c4d484dca$var$getPendingOperationsForFragment = $lan9D.getPendingOperationsForFragment, $fe00a87c4d484dca$var$getSelector = $lan9D.getSelector, $fe00a87c4d484dca$var$getVariablesFromFragment = $lan9D.getVariablesFromFragment, $fe00a87c4d484dca$var$handlePotentialSnapshotErrors = $lan9D.handlePotentialSnapshotErrors, $fe00a87c4d484dca$var$recycleNodesInto = $lan9D.recycleNodesInto;
parcelRequire("hzw7m");
function $fe00a87c4d484dca$var$isMissingData(state) {
    if (state.kind === 'bailout') return false;
    else if (state.kind === 'singular') return state.snapshot.isMissingData;
    else return state.snapshots.some(function(s) {
        return s.isMissingData;
    });
}
function $fe00a87c4d484dca$var$getMissingClientEdges(state) {
    if (state.kind === 'bailout') return null;
    else if (state.kind === 'singular') {
        var _state$snapshot$missi;
        return (_state$snapshot$missi = state.snapshot.missingClientEdges) !== null && _state$snapshot$missi !== void 0 ? _state$snapshot$missi : null;
    } else {
        var edges = null;
        var _iterator = (0, $fe00a87c4d484dca$var$_createForOfIteratorHelper2["default"])(state.snapshots), _step;
        try {
            for(_iterator.s(); !(_step = _iterator.n()).done;){
                var snapshot = _step.value;
                if (snapshot.missingClientEdges) {
                    var _edges;
                    edges = (_edges = edges) !== null && _edges !== void 0 ? _edges : [];
                    var _iterator2 = (0, $fe00a87c4d484dca$var$_createForOfIteratorHelper2["default"])(snapshot.missingClientEdges), _step2;
                    try {
                        for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
                            var edge = _step2.value;
                            edges.push(edge);
                        }
                    } catch (err) {
                        _iterator2.e(err);
                    } finally{
                        _iterator2.f();
                    }
                }
            }
        } catch (err) {
            _iterator.e(err);
        } finally{
            _iterator.f();
        }
        return edges;
    }
}
function $fe00a87c4d484dca$var$getSuspendingLiveResolver(state) {
    if (state.kind === 'bailout') return null;
    else if (state.kind === 'singular') {
        var _state$snapshot$missi2;
        return (_state$snapshot$missi2 = state.snapshot.missingLiveResolverFields) !== null && _state$snapshot$missi2 !== void 0 ? _state$snapshot$missi2 : null;
    } else {
        var missingFields = null;
        var _iterator3 = (0, $fe00a87c4d484dca$var$_createForOfIteratorHelper2["default"])(state.snapshots), _step3;
        try {
            for(_iterator3.s(); !(_step3 = _iterator3.n()).done;){
                var snapshot = _step3.value;
                if (snapshot.missingLiveResolverFields) {
                    var _missingFields;
                    missingFields = (_missingFields = missingFields) !== null && _missingFields !== void 0 ? _missingFields : [];
                    var _iterator4 = (0, $fe00a87c4d484dca$var$_createForOfIteratorHelper2["default"])(snapshot.missingLiveResolverFields), _step4;
                    try {
                        for(_iterator4.s(); !(_step4 = _iterator4.n()).done;){
                            var edge = _step4.value;
                            missingFields.push(edge);
                        }
                    } catch (err) {
                        _iterator4.e(err);
                    } finally{
                        _iterator4.f();
                    }
                }
            }
        } catch (err) {
            _iterator3.e(err);
        } finally{
            _iterator3.f();
        }
        return missingFields;
    }
}
function $fe00a87c4d484dca$var$handlePotentialSnapshotErrorsForState(environment, state) {
    if (state.kind === 'singular') {
        var _state$snapshot$selec, _state$snapshot$selec2;
        $fe00a87c4d484dca$var$handlePotentialSnapshotErrors(environment, state.snapshot.missingRequiredFields, state.snapshot.relayResolverErrors, state.snapshot.errorResponseFields, (_state$snapshot$selec = (_state$snapshot$selec2 = state.snapshot.selector.node.metadata) === null || _state$snapshot$selec2 === void 0 ? void 0 : _state$snapshot$selec2.throwOnFieldError) !== null && _state$snapshot$selec !== void 0 ? _state$snapshot$selec : false);
    } else if (state.kind === 'plural') {
        var _iterator5 = (0, $fe00a87c4d484dca$var$_createForOfIteratorHelper2["default"])(state.snapshots), _step5;
        try {
            for(_iterator5.s(); !(_step5 = _iterator5.n()).done;){
                var _snapshot$selector$no, _snapshot$selector$no2;
                var snapshot = _step5.value;
                $fe00a87c4d484dca$var$handlePotentialSnapshotErrors(environment, snapshot.missingRequiredFields, snapshot.relayResolverErrors, snapshot.errorResponseFields, (_snapshot$selector$no = (_snapshot$selector$no2 = snapshot.selector.node.metadata) === null || _snapshot$selector$no2 === void 0 ? void 0 : _snapshot$selector$no2.throwOnFieldError) !== null && _snapshot$selector$no !== void 0 ? _snapshot$selector$no : false);
            }
        } catch (err) {
            _iterator5.e(err);
        } finally{
            _iterator5.f();
        }
    }
}
function $fe00a87c4d484dca$var$handleMissedUpdates(environment, state) {
    if (state.kind === 'bailout') return null;
    var currentEpoch = environment.getStore().getEpoch();
    if (currentEpoch === state.epoch) return null;
    if (state.kind === 'singular') {
        var currentSnapshot = environment.lookup(state.snapshot.selector);
        var updatedData = $fe00a87c4d484dca$var$recycleNodesInto(state.snapshot.data, currentSnapshot.data);
        var updatedCurrentSnapshot = {
            data: updatedData,
            isMissingData: currentSnapshot.isMissingData,
            missingClientEdges: currentSnapshot.missingClientEdges,
            missingLiveResolverFields: currentSnapshot.missingLiveResolverFields,
            seenRecords: currentSnapshot.seenRecords,
            selector: currentSnapshot.selector,
            missingRequiredFields: currentSnapshot.missingRequiredFields,
            relayResolverErrors: currentSnapshot.relayResolverErrors,
            errorResponseFields: currentSnapshot.errorResponseFields
        };
        return [
            updatedData !== state.snapshot.data,
            {
                kind: 'singular',
                snapshot: updatedCurrentSnapshot,
                epoch: currentEpoch
            }
        ];
    } else {
        var didMissUpdates = false;
        var currentSnapshots = [];
        for(var index = 0; index < state.snapshots.length; index++){
            var snapshot = state.snapshots[index];
            var _currentSnapshot = environment.lookup(snapshot.selector);
            var _updatedData = $fe00a87c4d484dca$var$recycleNodesInto(snapshot.data, _currentSnapshot.data);
            var _updatedCurrentSnapshot = {
                data: _updatedData,
                isMissingData: _currentSnapshot.isMissingData,
                missingClientEdges: _currentSnapshot.missingClientEdges,
                missingLiveResolverFields: _currentSnapshot.missingLiveResolverFields,
                seenRecords: _currentSnapshot.seenRecords,
                selector: _currentSnapshot.selector,
                missingRequiredFields: _currentSnapshot.missingRequiredFields,
                relayResolverErrors: _currentSnapshot.relayResolverErrors,
                errorResponseFields: _currentSnapshot.errorResponseFields
            };
            if (_updatedData !== snapshot.data) didMissUpdates = true;
            currentSnapshots.push(_updatedCurrentSnapshot);
        }
        !(currentSnapshots.length === state.snapshots.length) && $bQThX(false);
        return [
            didMissUpdates,
            {
                kind: 'plural',
                snapshots: currentSnapshots,
                epoch: currentEpoch
            }
        ];
    }
}
function $fe00a87c4d484dca$var$handleMissingClientEdge(environment, parentFragmentNode, parentFragmentRef, missingClientEdgeRequestInfo, queryOptions) {
    var originalVariables = $fe00a87c4d484dca$var$getVariablesFromFragment(parentFragmentNode, parentFragmentRef);
    var variables = (0, $fe00a87c4d484dca$var$_objectSpread2["default"])((0, $fe00a87c4d484dca$var$_objectSpread2["default"])({}, originalVariables), {}, {
        id: missingClientEdgeRequestInfo.clientEdgeDestinationID
    });
    var queryOperationDescriptor = $fe00a87c4d484dca$var$createOperationDescriptor(missingClientEdgeRequestInfo.request, variables, queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.networkCacheConfig);
    var QueryResource = $fe00a87c4d484dca$var$getQueryResourceForEnvironment(environment);
    var queryResult = QueryResource.prepare(queryOperationDescriptor, $fe00a87c4d484dca$var$fetchQueryInternal(environment, queryOperationDescriptor), queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.fetchPolicy);
    return [
        queryResult,
        $fe00a87c4d484dca$var$getPromiseForActiveRequest(environment, queryOperationDescriptor.request)
    ];
}
function $fe00a87c4d484dca$var$subscribeToSnapshot(environment, state, setState, hasPendingStateChanges) {
    if (state.kind === 'bailout') return function() {};
    else if (state.kind === 'singular') {
        var disposable = environment.subscribe(state.snapshot, function(latestSnapshot) {
            setState(function(prevState) {
                if (prevState.kind !== 'singular' || prevState.snapshot.selector !== latestSnapshot.selector) {
                    var updates = $fe00a87c4d484dca$var$handleMissedUpdates(environment, prevState);
                    if (updates != null) {
                        var dataChanged = updates[0], nextState = updates[1];
                        environment.__log({
                            name: 'useFragment.subscription.missedUpdates',
                            hasDataChanges: dataChanged
                        });
                        hasPendingStateChanges.current = dataChanged;
                        return dataChanged ? nextState : prevState;
                    } else return prevState;
                }
                hasPendingStateChanges.current = true;
                return {
                    kind: 'singular',
                    snapshot: latestSnapshot,
                    epoch: environment.getStore().getEpoch()
                };
            });
        });
        return function() {
            disposable.dispose();
        };
    } else {
        var disposables = state.snapshots.map(function(snapshot, index) {
            return environment.subscribe(snapshot, function(latestSnapshot) {
                setState(function(prevState) {
                    var _prevState$snapshots$;
                    if (prevState.kind !== 'plural' || ((_prevState$snapshots$ = prevState.snapshots[index]) === null || _prevState$snapshots$ === void 0 ? void 0 : _prevState$snapshots$.selector) !== latestSnapshot.selector) {
                        var updates = $fe00a87c4d484dca$var$handleMissedUpdates(environment, prevState);
                        if (updates != null) {
                            var dataChanged = updates[0], nextState = updates[1];
                            environment.__log({
                                name: 'useFragment.subscription.missedUpdates',
                                hasDataChanges: dataChanged
                            });
                            hasPendingStateChanges.current = hasPendingStateChanges.current || dataChanged;
                            return dataChanged ? nextState : prevState;
                        } else return prevState;
                    }
                    var updated = (0, $fe00a87c4d484dca$var$_toConsumableArray2["default"])(prevState.snapshots);
                    updated[index] = latestSnapshot;
                    hasPendingStateChanges.current = true;
                    return {
                        kind: 'plural',
                        snapshots: updated,
                        epoch: environment.getStore().getEpoch()
                    };
                });
            });
        });
        return function() {
            var _iterator6 = (0, $fe00a87c4d484dca$var$_createForOfIteratorHelper2["default"])(disposables), _step6;
            try {
                for(_iterator6.s(); !(_step6 = _iterator6.n()).done;){
                    var d = _step6.value;
                    d.dispose();
                }
            } catch (err) {
                _iterator6.e(err);
            } finally{
                _iterator6.f();
            }
        };
    }
}
function $fe00a87c4d484dca$var$getFragmentState(environment, fragmentSelector) {
    if (fragmentSelector == null) return {
        kind: 'bailout'
    };
    else if (fragmentSelector.kind === 'PluralReaderSelector') return {
        kind: 'plural',
        snapshots: fragmentSelector.selectors.map(function(s) {
            return environment.lookup(s);
        }),
        epoch: environment.getStore().getEpoch()
    };
    else return {
        kind: 'singular',
        snapshot: environment.lookup(fragmentSelector),
        epoch: environment.getStore().getEpoch()
    };
}
function $fe00a87c4d484dca$var$useFragmentInternal(fragmentNode, fragmentRef, hookDisplayName, queryOptions) {
    var _fragmentNode$metadat, _fragmentNode$metadat2;
    var fragmentSelector = $fe00a87c4d484dca$var$useMemo(function() {
        return $fe00a87c4d484dca$var$getSelector(fragmentNode, fragmentRef);
    }, [
        fragmentNode,
        fragmentRef
    ]);
    var isPlural = (fragmentNode === null || fragmentNode === void 0 ? void 0 : (_fragmentNode$metadat = fragmentNode.metadata) === null || _fragmentNode$metadat === void 0 ? void 0 : _fragmentNode$metadat.plural) === true;
    if (isPlural) !(fragmentRef == null || Array.isArray(fragmentRef)) && $bQThX(false);
    else !!Array.isArray(fragmentRef) && $bQThX(false);
    !(fragmentRef == null || isPlural && Array.isArray(fragmentRef) && fragmentRef.length === 0 || fragmentSelector != null) && $bQThX(false);
    var environment = $cdYu4();
    var _useState = $fe00a87c4d484dca$var$useState(function() {
        return $fe00a87c4d484dca$var$getFragmentState(environment, fragmentSelector);
    }), _state = _useState[0], setState = _useState[1];
    var state = _state;
    var _useState2 = $fe00a87c4d484dca$var$useState(state), _subscribedState = _useState2[0], setSubscribedState = _useState2[1];
    var subscribedState = _subscribedState;
    var _useState3 = $fe00a87c4d484dca$var$useState(fragmentSelector), previousFragmentSelector = _useState3[0], setPreviousFragmentSelector = _useState3[1];
    var _useState4 = $fe00a87c4d484dca$var$useState(environment), previousEnvironment = _useState4[0], setPreviousEnvironment = _useState4[1];
    if (!$fe00a87c4d484dca$var$areEqualSelectors(fragmentSelector, previousFragmentSelector) || environment !== previousEnvironment) {
        setPreviousFragmentSelector(fragmentSelector);
        setPreviousEnvironment(environment);
        var newState = $fe00a87c4d484dca$var$getFragmentState(environment, fragmentSelector);
        setState(newState);
        setSubscribedState(newState);
        state = newState;
        subscribedState = newState;
    }
    var committedFragmentSelectorRef = $fe00a87c4d484dca$var$useRef(false);
    $fe00a87c4d484dca$var$useEffect(function() {
        committedFragmentSelectorRef.current = fragmentSelector;
    }, [
        fragmentSelector
    ]);
    if (((_fragmentNode$metadat2 = fragmentNode.metadata) === null || _fragmentNode$metadat2 === void 0 ? void 0 : _fragmentNode$metadat2.hasClientEdges) === true) {
        var _useMemo = $fe00a87c4d484dca$var$useMemo(function() {
            var missingClientEdges = $fe00a87c4d484dca$var$getMissingClientEdges(state);
            var clientEdgeQueries;
            var activeRequestPromises = [];
            if (missingClientEdges !== null && missingClientEdges !== void 0 && missingClientEdges.length) {
                clientEdgeQueries = [];
                var _iterator7 = (0, $fe00a87c4d484dca$var$_createForOfIteratorHelper2["default"])(missingClientEdges), _step7;
                try {
                    for(_iterator7.s(); !(_step7 = _iterator7.n()).done;){
                        var edge = _step7.value;
                        var _handleMissingClientE = $fe00a87c4d484dca$var$handleMissingClientEdge(environment, fragmentNode, fragmentRef, edge, queryOptions), queryResult = _handleMissingClientE[0], requestPromise = _handleMissingClientE[1];
                        clientEdgeQueries.push(queryResult);
                        if (requestPromise != null) activeRequestPromises.push(requestPromise);
                    }
                } catch (err) {
                    _iterator7.e(err);
                } finally{
                    _iterator7.f();
                }
            }
            return [
                clientEdgeQueries,
                activeRequestPromises
            ];
        }, [
            state,
            environment,
            fragmentNode,
            fragmentRef,
            queryOptions
        ]), clientEdgeQueries = _useMemo[0], activeRequestPromises = _useMemo[1];
        if (activeRequestPromises.length) throw Promise.all(activeRequestPromises);
        $fe00a87c4d484dca$var$useEffect(function() {
            var QueryResource = $fe00a87c4d484dca$var$getQueryResourceForEnvironment(environment);
            if (clientEdgeQueries !== null && clientEdgeQueries !== void 0 && clientEdgeQueries.length) {
                var disposables = [];
                var _iterator8 = (0, $fe00a87c4d484dca$var$_createForOfIteratorHelper2["default"])(clientEdgeQueries), _step8;
                try {
                    for(_iterator8.s(); !(_step8 = _iterator8.n()).done;){
                        var query = _step8.value;
                        disposables.push(QueryResource.retain(query));
                    }
                } catch (err) {
                    _iterator8.e(err);
                } finally{
                    _iterator8.f();
                }
                return function() {
                    var _iterator9 = (0, $fe00a87c4d484dca$var$_createForOfIteratorHelper2["default"])(disposables), _step9;
                    try {
                        for(_iterator9.s(); !(_step9 = _iterator9.n()).done;){
                            var disposable = _step9.value;
                            disposable.dispose();
                        }
                    } catch (err) {
                        _iterator9.e(err);
                    } finally{
                        _iterator9.f();
                    }
                };
            }
        }, [
            environment,
            clientEdgeQueries
        ]);
    }
    if ($fe00a87c4d484dca$var$isMissingData(state)) {
        var suspendingLiveResolvers = $fe00a87c4d484dca$var$getSuspendingLiveResolver(state);
        if (suspendingLiveResolvers != null && suspendingLiveResolvers.length > 0) throw Promise.all(suspendingLiveResolvers.map(function(_ref) {
            var liveStateID = _ref.liveStateID;
            return environment.getStore().getLiveResolverPromise(liveStateID);
        }));
        if ($fe00a87c4d484dca$var$RelayFeatureFlags.ENABLE_RELAY_OPERATION_TRACKER_SUSPENSE || environment !== previousEnvironment || !committedFragmentSelectorRef.current || !$fe00a87c4d484dca$var$areEqualSelectors(committedFragmentSelectorRef.current, fragmentSelector)) {
            !(fragmentSelector != null) && $bQThX(false);
            var fragmentOwner = fragmentSelector.kind === 'PluralReaderSelector' ? fragmentSelector.selectors[0].owner : fragmentSelector.owner;
            var pendingOperationsResult = $fe00a87c4d484dca$var$getPendingOperationsForFragment(environment, fragmentNode, fragmentOwner);
            if (pendingOperationsResult) throw pendingOperationsResult.promise;
        }
    }
    $fe00a87c4d484dca$var$handlePotentialSnapshotErrorsForState(environment, state);
    var hasPendingStateChanges = $fe00a87c4d484dca$var$useRef(false);
    $fe00a87c4d484dca$var$useEffect(function() {
        var currentState = subscribedState;
        var updates = $fe00a87c4d484dca$var$handleMissedUpdates(environment, subscribedState);
        if (updates !== null) {
            var didMissUpdates = updates[0], updatedState = updates[1];
            if (didMissUpdates) setState(updatedState);
            currentState = updatedState;
        }
        return $fe00a87c4d484dca$var$subscribeToSnapshot(environment, currentState, setState, hasPendingStateChanges);
    }, [
        environment,
        subscribedState
    ]);
    if (hasPendingStateChanges.current) {
        var updates = $fe00a87c4d484dca$var$handleMissedUpdates(environment, state);
        if (updates != null) {
            var hasStateUpdates = updates[0], updatedState = updates[1];
            if (hasStateUpdates) {
                setState(updatedState);
                state = updatedState;
            }
        }
        hasPendingStateChanges.current = false;
    }
    var data;
    if (isPlural) {
        var fragmentRefIsNullish = fragmentRef == null;
        data = $fe00a87c4d484dca$var$useMemo(function() {
            if (state.kind === 'bailout') return fragmentRefIsNullish ? null : [];
            else {
                !(state.kind === 'plural') && $bQThX(false);
                return state.snapshots.map(function(s) {
                    return s.data;
                });
            }
        }, [
            state,
            fragmentRefIsNullish
        ]);
    } else if (state.kind === 'bailout') data = null;
    else {
        !(state.kind === 'singular') && $bQThX(false);
        data = state.snapshot.data;
    }
    if ($fe00a87c4d484dca$var$RelayFeatureFlags.LOG_MISSING_RECORDS_IN_PROD || false) fragmentRef != null && (data === undefined || Array.isArray(data) && data.length > 0 && data.every(function(d) {
        return d === undefined;
    }));
    return data;
}
module.exports = $fe00a87c4d484dca$var$useFragmentInternal;

});


parcelRegister("ax2Om", function(module, exports) {
'use strict';

var $lSJHA = parcelRequire("lSJHA");

var $gwFzn = parcelRequire("gwFzn");

var $lan9D = parcelRequire("lan9D");
var $7aaf2ab8a3798b1c$var$createOperationDescriptor = $lan9D.createOperationDescriptor, $7aaf2ab8a3798b1c$var$getRequest = $lan9D.getRequest;
var $7aaf2ab8a3798b1c$var$useMemo = $gwFzn.useMemo;
function $7aaf2ab8a3798b1c$var$useMemoOperationDescriptor(gqlQuery, variables, cacheConfig) {
    var memoVariables = $lSJHA(variables);
    var memoCacheConfig = $lSJHA(cacheConfig || {});
    return $7aaf2ab8a3798b1c$var$useMemo(function() {
        return $7aaf2ab8a3798b1c$var$createOperationDescriptor($7aaf2ab8a3798b1c$var$getRequest(gqlQuery), memoVariables, memoCacheConfig);
    }, [
        gqlQuery,
        memoVariables,
        memoCacheConfig
    ]);
}
module.exports = $7aaf2ab8a3798b1c$var$useMemoOperationDescriptor;

});
parcelRegister("lSJHA", function(module, exports) {
'use strict';

var $3Nt2B = parcelRequire("3Nt2B");

var $gwFzn = parcelRequire("gwFzn");
var $fee217923dec0dab$var$useState = $gwFzn.useState;
function $fee217923dec0dab$var$useMemoVariables(variables) {
    var _useState = $fee217923dec0dab$var$useState(variables), mirroredVariables = _useState[0], setMirroredVariables = _useState[1];
    if ($3Nt2B(variables, mirroredVariables)) return mirroredVariables;
    else {
        setMirroredVariables(variables);
        return variables;
    }
}
module.exports = $fee217923dec0dab$var$useMemoVariables;

});




parcelRegister("aSHZo", function(module, exports) {
'use strict';

var $7dvyf = parcelRequire("7dvyf");
var $7ec111e31f69bf1a$var$_interopRequireDefault = $7dvyf.default;

var $7ec111e31f69bf1a$var$_createForOfIteratorHelper2 = $7ec111e31f69bf1a$var$_interopRequireDefault((parcelRequire("bTRzt")));

var $itR7S = parcelRequire("itR7S");

var $kgUNJ = parcelRequire("kgUNJ");
var $7ec111e31f69bf1a$var$useTrackLoadQueryInRender = $kgUNJ.useTrackLoadQueryInRender;

var $fYVz6 = parcelRequire("fYVz6");

var $gwFzn = parcelRequire("gwFzn");
var $7ec111e31f69bf1a$var$useCallback = $gwFzn.useCallback, $7ec111e31f69bf1a$var$useEffect = $gwFzn.useEffect, $7ec111e31f69bf1a$var$useRef = $gwFzn.useRef, $7ec111e31f69bf1a$var$useState = $gwFzn.useState;
var $7ec111e31f69bf1a$var$initialNullEntryPointReferenceState = {
    kind: 'NullEntryPointReference'
};
function $7ec111e31f69bf1a$var$useLoadEntryPoint(environmentProvider, entryPoint, options) {
    var _options$TEST_ONLY__i, _options$TEST_ONLY__i2, _options$TEST_ONLY__i3, _options$TEST_ONLY__i4;
    $7ec111e31f69bf1a$var$useTrackLoadQueryInRender();
    var initialEntryPointReferenceInternal = (_options$TEST_ONLY__i = options === null || options === void 0 ? void 0 : (_options$TEST_ONLY__i2 = options.TEST_ONLY__initialEntryPointData) === null || _options$TEST_ONLY__i2 === void 0 ? void 0 : _options$TEST_ONLY__i2.entryPointReference) !== null && _options$TEST_ONLY__i !== void 0 ? _options$TEST_ONLY__i : $7ec111e31f69bf1a$var$initialNullEntryPointReferenceState;
    var initialEntryPointParamsInternal = (_options$TEST_ONLY__i3 = options === null || options === void 0 ? void 0 : (_options$TEST_ONLY__i4 = options.TEST_ONLY__initialEntryPointData) === null || _options$TEST_ONLY__i4 === void 0 ? void 0 : _options$TEST_ONLY__i4.entryPointParams) !== null && _options$TEST_ONLY__i3 !== void 0 ? _options$TEST_ONLY__i3 : null;
    var isMountedRef = $fYVz6();
    var undisposedEntryPointReferencesRef = $7ec111e31f69bf1a$var$useRef(new Set([
        initialEntryPointReferenceInternal
    ]));
    var _useState = $7ec111e31f69bf1a$var$useState(initialEntryPointReferenceInternal), entryPointReference = _useState[0], setEntryPointReference = _useState[1];
    var _useState2 = $7ec111e31f69bf1a$var$useState(initialEntryPointParamsInternal), entryPointParams = _useState2[0], setEntryPointParams = _useState2[1];
    var disposeEntryPoint = $7ec111e31f69bf1a$var$useCallback(function() {
        if (isMountedRef.current) {
            var nullEntryPointReference = {
                kind: 'NullEntryPointReference'
            };
            undisposedEntryPointReferencesRef.current.add(nullEntryPointReference);
            setEntryPointReference(nullEntryPointReference);
        }
    }, [
        setEntryPointReference,
        isMountedRef
    ]);
    var entryPointLoaderCallback = $7ec111e31f69bf1a$var$useCallback(function(params) {
        if (isMountedRef.current) {
            var updatedEntryPointReference = $itR7S(environmentProvider, entryPoint, params);
            undisposedEntryPointReferencesRef.current.add(updatedEntryPointReference);
            setEntryPointReference(updatedEntryPointReference);
            setEntryPointParams(params);
        }
    }, [
        environmentProvider,
        entryPoint,
        setEntryPointReference,
        isMountedRef
    ]);
    var maybeHiddenOrFastRefresh = $7ec111e31f69bf1a$var$useRef(false);
    $7ec111e31f69bf1a$var$useEffect(function() {
        return function() {
            maybeHiddenOrFastRefresh.current = true;
        };
    }, []);
    $7ec111e31f69bf1a$var$useEffect(function() {
        if (maybeHiddenOrFastRefresh.current === true) {
            maybeHiddenOrFastRefresh.current = false;
            if (entryPointReference.kind !== 'NullEntryPointReference' && entryPointParams != null) entryPointLoaderCallback(entryPointParams);
            return;
        }
        var undisposedEntryPointReferences = undisposedEntryPointReferencesRef.current;
        if (isMountedRef.current) {
            var _iterator = (0, $7ec111e31f69bf1a$var$_createForOfIteratorHelper2["default"])(undisposedEntryPointReferences), _step;
            try {
                for(_iterator.s(); !(_step = _iterator.n()).done;){
                    var undisposedEntryPointReference = _step.value;
                    if (undisposedEntryPointReference === entryPointReference) break;
                    undisposedEntryPointReferences["delete"](undisposedEntryPointReference);
                    if (undisposedEntryPointReference.kind !== 'NullEntryPointReference') undisposedEntryPointReference.dispose();
                }
            } catch (err) {
                _iterator.e(err);
            } finally{
                _iterator.f();
            }
        }
    }, [
        entryPointReference,
        entryPointParams,
        entryPointLoaderCallback,
        isMountedRef
    ]);
    $7ec111e31f69bf1a$var$useEffect(function() {
        return function disposeAllRemainingEntryPointReferences() {
            var _iterator2 = (0, $7ec111e31f69bf1a$var$_createForOfIteratorHelper2["default"])(undisposedEntryPointReferencesRef.current), _step2;
            try {
                for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
                    var unhandledStateChange = _step2.value;
                    if (unhandledStateChange.kind !== 'NullEntryPointReference') unhandledStateChange.dispose();
                }
            } catch (err) {
                _iterator2.e(err);
            } finally{
                _iterator2.f();
            }
        };
    }, []);
    return [
        entryPointReference.kind === 'NullEntryPointReference' ? null : entryPointReference,
        entryPointLoaderCallback,
        disposeEntryPoint
    ];
}
module.exports = $7ec111e31f69bf1a$var$useLoadEntryPoint;

});
parcelRegister("fYVz6", function(module, exports) {
'use strict';

var $gwFzn = parcelRequire("gwFzn");
var $ba291cdaac3621e0$var$useEffect = $gwFzn.useEffect, $ba291cdaac3621e0$var$useRef = $gwFzn.useRef;
function $ba291cdaac3621e0$var$useIsMountedRef() {
    var isMountedRef = $ba291cdaac3621e0$var$useRef(true);
    $ba291cdaac3621e0$var$useEffect(function() {
        isMountedRef.current = true;
        return function() {
            isMountedRef.current = false;
        };
    }, []);
    return isMountedRef;
}
module.exports = $ba291cdaac3621e0$var$useIsMountedRef;

});


parcelRegister("6sNrX", function(module, exports) {
'use strict';

var $kgUNJ = parcelRequire("kgUNJ");
var $4b4bb75708a738cf$var$useTrackLoadQueryInRender = $kgUNJ.useTrackLoadQueryInRender;

var $lO358 = parcelRequire("lO358");

var $dXLJe = parcelRequire("dXLJe");

var $gwFzn = parcelRequire("gwFzn");
var $4b4bb75708a738cf$var$useDebugValue = $gwFzn.useDebugValue;

var $lan9D = parcelRequire("lan9D");
var $4b4bb75708a738cf$var$getFragment = $lan9D.getFragment;
function $4b4bb75708a738cf$var$useFragment(fragment, key) {
    $4b4bb75708a738cf$var$useTrackLoadQueryInRender();
    var fragmentNode = $4b4bb75708a738cf$var$getFragment(fragment);
    $dXLJe(fragmentNode, 'first argument of useFragment()');
    var data = $lO358(fragmentNode, key, 'useFragment()');
    return data;
}
module.exports = $4b4bb75708a738cf$var$useFragment;

});
parcelRegister("dXLJe", function(module, exports) {
'use strict';
parcelRequire("6OPey");
parcelRequire("hzw7m");
function $a2a5cef19bb40c11$var$useStaticFragmentNodeWarning(fragmentNode, warningContext) {
    var initialPropRef;
}
module.exports = $a2a5cef19bb40c11$var$useStaticFragmentNodeWarning;

});


parcelRegister("dWvxD", function(module, exports) {
'use strict';

var $7dvyf = parcelRequire("7dvyf");
var $a26928a433d72ab3$var$_interopRequireDefault = $7dvyf.default;

var $a26928a433d72ab3$var$_objectSpread2 = $a26928a433d72ab3$var$_interopRequireDefault((parcelRequire("4N8OD")));

var $fYVz6 = parcelRequire("fYVz6");

var $cdYu4 = parcelRequire("cdYu4");

var $gwFzn = parcelRequire("gwFzn");

var $lan9D = parcelRequire("lan9D");
var $a26928a433d72ab3$var$defaultCommitMutation = $lan9D.commitMutation;
var $a26928a433d72ab3$var$useState = $gwFzn.useState, $a26928a433d72ab3$var$useEffect = $gwFzn.useEffect, $a26928a433d72ab3$var$useRef = $gwFzn.useRef, $a26928a433d72ab3$var$useCallback = $gwFzn.useCallback;
function $a26928a433d72ab3$var$useMutation(mutation) {
    var commitMutationFn = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $a26928a433d72ab3$var$defaultCommitMutation;
    var environment = $cdYu4();
    var isMountedRef = $fYVz6();
    var environmentRef = $a26928a433d72ab3$var$useRef(environment);
    var mutationRef = $a26928a433d72ab3$var$useRef(mutation);
    var inFlightMutationsRef = $a26928a433d72ab3$var$useRef(new Set());
    var _useState = $a26928a433d72ab3$var$useState(false), isMutationInFlight = _useState[0], setMutationInFlight = _useState[1];
    var cleanup = $a26928a433d72ab3$var$useCallback(function(disposable) {
        if (environmentRef.current === environment && mutationRef.current === mutation) {
            inFlightMutationsRef.current["delete"](disposable);
            if (isMountedRef.current) setMutationInFlight(inFlightMutationsRef.current.size > 0);
        }
    }, [
        environment,
        isMountedRef,
        mutation
    ]);
    $a26928a433d72ab3$var$useEffect(function() {
        if (environmentRef.current !== environment || mutationRef.current !== mutation) {
            inFlightMutationsRef.current = new Set();
            if (isMountedRef.current) setMutationInFlight(false);
            environmentRef.current = environment;
            mutationRef.current = mutation;
        }
    }, [
        environment,
        isMountedRef,
        mutation
    ]);
    var commit = $a26928a433d72ab3$var$useCallback(function(config) {
        if (isMountedRef.current) setMutationInFlight(true);
        var disposable = commitMutationFn(environment, (0, $a26928a433d72ab3$var$_objectSpread2["default"])((0, $a26928a433d72ab3$var$_objectSpread2["default"])({}, config), {}, {
            mutation: mutation,
            onCompleted: function onCompleted(response, errors) {
                var _config$onCompleted;
                cleanup(disposable);
                (_config$onCompleted = config.onCompleted) === null || _config$onCompleted === void 0 || _config$onCompleted.call(config, response, errors);
            },
            onError: function onError(error) {
                var _config$onError;
                cleanup(disposable);
                (_config$onError = config.onError) === null || _config$onError === void 0 || _config$onError.call(config, error);
            },
            onUnsubscribe: function onUnsubscribe() {
                var _config$onUnsubscribe;
                cleanup(disposable);
                (_config$onUnsubscribe = config.onUnsubscribe) === null || _config$onUnsubscribe === void 0 || _config$onUnsubscribe.call(config);
            },
            onNext: function onNext() {
                var _config$onNext;
                (_config$onNext = config.onNext) === null || _config$onNext === void 0 || _config$onNext.call(config);
            }
        }));
        inFlightMutationsRef.current.add(disposable);
        return disposable;
    }, [
        cleanup,
        commitMutationFn,
        environment,
        isMountedRef,
        mutation
    ]);
    return [
        commit,
        isMutationInFlight
    ];
}
module.exports = $a26928a433d72ab3$var$useMutation;

});

parcelRegister("ctS2H", function(module, exports) {
'use strict';

var $7dvyf = parcelRequire("7dvyf");
var $91621d3708760018$var$_interopRequireDefault = $7dvyf.default;

var $91621d3708760018$var$_objectSpread2 = $91621d3708760018$var$_interopRequireDefault((parcelRequire("4N8OD")));

var $hQ42O = parcelRequire("hQ42O");

var $jfwgE = parcelRequire("jfwgE");

var $cdYu4 = parcelRequire("cdYu4");

var $dXLJe = parcelRequire("dXLJe");

var $gwFzn = parcelRequire("gwFzn");
var $91621d3708760018$var$useCallback = $gwFzn.useCallback, $91621d3708760018$var$useDebugValue = $gwFzn.useDebugValue, $91621d3708760018$var$useState = $gwFzn.useState;

var $lan9D = parcelRequire("lan9D");
var $91621d3708760018$var$getFragment = $lan9D.getFragment, $91621d3708760018$var$getFragmentIdentifier = $lan9D.getFragmentIdentifier, $91621d3708760018$var$getPaginationMetadata = $lan9D.getPaginationMetadata;
function $91621d3708760018$var$usePaginationFragment(fragmentInput, parentFragmentRef) {
    var fragmentNode = $91621d3708760018$var$getFragment(fragmentInput);
    $dXLJe(fragmentNode, 'first argument of usePaginationFragment()');
    var componentDisplayName = 'usePaginationFragment()';
    var _getPaginationMetadat = $91621d3708760018$var$getPaginationMetadata(fragmentNode, componentDisplayName), connectionPathInFragmentData = _getPaginationMetadat.connectionPathInFragmentData, paginationRequest = _getPaginationMetadat.paginationRequest, paginationMetadata = _getPaginationMetadat.paginationMetadata;
    var _useRefetchableFragme = $jfwgE(fragmentNode, parentFragmentRef, componentDisplayName), fragmentData = _useRefetchableFragme.fragmentData, fragmentRef = _useRefetchableFragme.fragmentRef, refetch = _useRefetchableFragme.refetch;
    var fragmentIdentifier = $91621d3708760018$var$getFragmentIdentifier(fragmentNode, fragmentRef);
    var _useLoadMore = $91621d3708760018$var$useLoadMore({
        componentDisplayName: componentDisplayName,
        connectionPathInFragmentData: connectionPathInFragmentData,
        direction: 'backward',
        fragmentData: fragmentData,
        fragmentIdentifier: fragmentIdentifier,
        fragmentNode: fragmentNode,
        fragmentRef: fragmentRef,
        paginationMetadata: paginationMetadata,
        paginationRequest: paginationRequest
    }), loadPrevious = _useLoadMore[0], hasPrevious = _useLoadMore[1], isLoadingPrevious = _useLoadMore[2], disposeFetchPrevious = _useLoadMore[3];
    var _useLoadMore2 = $91621d3708760018$var$useLoadMore({
        componentDisplayName: componentDisplayName,
        connectionPathInFragmentData: connectionPathInFragmentData,
        direction: 'forward',
        fragmentData: fragmentData,
        fragmentIdentifier: fragmentIdentifier,
        fragmentNode: fragmentNode,
        fragmentRef: fragmentRef,
        paginationMetadata: paginationMetadata,
        paginationRequest: paginationRequest
    }), loadNext = _useLoadMore2[0], hasNext = _useLoadMore2[1], isLoadingNext = _useLoadMore2[2], disposeFetchNext = _useLoadMore2[3];
    var refetchPagination = $91621d3708760018$var$useCallback(function(variables, options) {
        disposeFetchNext();
        disposeFetchPrevious();
        return refetch(variables, (0, $91621d3708760018$var$_objectSpread2["default"])((0, $91621d3708760018$var$_objectSpread2["default"])({}, options), {}, {
            __environment: undefined
        }));
    }, [
        disposeFetchNext,
        disposeFetchPrevious,
        refetch
    ]);
    return {
        data: fragmentData,
        loadNext: loadNext,
        loadPrevious: loadPrevious,
        hasNext: hasNext,
        hasPrevious: hasPrevious,
        isLoadingNext: isLoadingNext,
        isLoadingPrevious: isLoadingPrevious,
        refetch: refetchPagination
    };
}
function $91621d3708760018$var$useLoadMore(args) {
    var environment = $cdYu4();
    var _useState = $91621d3708760018$var$useState(false), isLoadingMore = _useState[0], reallySetIsLoadingMore = _useState[1];
    var setIsLoadingMore = function setIsLoadingMore(value) {
        var _environment$getSched;
        var schedule = (_environment$getSched = environment.getScheduler()) === null || _environment$getSched === void 0 ? void 0 : _environment$getSched.schedule;
        if (schedule) schedule(function() {
            reallySetIsLoadingMore(value);
        });
        else reallySetIsLoadingMore(value);
    };
    var observer = {
        start: function start() {
            return setIsLoadingMore(true);
        },
        complete: function complete() {
            return setIsLoadingMore(false);
        },
        error: function error() {
            return setIsLoadingMore(false);
        }
    };
    var handleReset = function handleReset() {
        return setIsLoadingMore(false);
    };
    var _useLoadMoreFunction = $hQ42O((0, $91621d3708760018$var$_objectSpread2["default"])((0, $91621d3708760018$var$_objectSpread2["default"])({}, args), {}, {
        observer: observer,
        onReset: handleReset
    })), loadMore = _useLoadMoreFunction[0], hasMore = _useLoadMoreFunction[1], disposeFetch = _useLoadMoreFunction[2];
    return [
        loadMore,
        hasMore,
        isLoadingMore,
        disposeFetch
    ];
}
module.exports = $91621d3708760018$var$usePaginationFragment;

});
parcelRegister("hQ42O", function(module, exports) {
'use strict';

var $7dvyf = parcelRequire("7dvyf");
var $cfca6e1c2703d239$var$_interopRequireDefault = $7dvyf.default;

var $cfca6e1c2703d239$var$_objectSpread2 = $cfca6e1c2703d239$var$_interopRequireDefault((parcelRequire("4N8OD")));

var $5U6n8 = parcelRequire("5U6n8");

var $fYVz6 = parcelRequire("fYVz6");

var $d7sis = parcelRequire("d7sis");

var $cdYu4 = parcelRequire("cdYu4");

var $bQThX = parcelRequire("bQThX");

var $gwFzn = parcelRequire("gwFzn");
var $cfca6e1c2703d239$var$useCallback = $gwFzn.useCallback, $cfca6e1c2703d239$var$useEffect = $gwFzn.useEffect, $cfca6e1c2703d239$var$useState = $gwFzn.useState;

var $lan9D = parcelRequire("lan9D");
var $cfca6e1c2703d239$var$fetchQuery = $lan9D.__internal.fetchQuery, $cfca6e1c2703d239$var$ConnectionInterface = $lan9D.ConnectionInterface, $cfca6e1c2703d239$var$createOperationDescriptor = $lan9D.createOperationDescriptor, $cfca6e1c2703d239$var$getPaginationVariables = $lan9D.getPaginationVariables, $cfca6e1c2703d239$var$getRefetchMetadata = $lan9D.getRefetchMetadata, $cfca6e1c2703d239$var$getSelector = $lan9D.getSelector, $cfca6e1c2703d239$var$getValueAtPath = $lan9D.getValueAtPath;
parcelRequire("hzw7m");
function $cfca6e1c2703d239$var$useLoadMoreFunction(args) {
    var direction = args.direction, fragmentNode = args.fragmentNode, fragmentRef = args.fragmentRef, fragmentIdentifier = args.fragmentIdentifier, fragmentData = args.fragmentData, connectionPathInFragmentData = args.connectionPathInFragmentData, paginationRequest = args.paginationRequest, paginationMetadata = args.paginationMetadata, componentDisplayName = args.componentDisplayName, observer = args.observer, onReset = args.onReset;
    var environment = $cdYu4();
    var _useFetchTrackingRef = $5U6n8(), isFetchingRef = _useFetchTrackingRef.isFetchingRef, startFetch = _useFetchTrackingRef.startFetch, disposeFetch = _useFetchTrackingRef.disposeFetch, completeFetch = _useFetchTrackingRef.completeFetch;
    var _getRefetchMetadata = $cfca6e1c2703d239$var$getRefetchMetadata(fragmentNode, componentDisplayName), identifierInfo = _getRefetchMetadata.identifierInfo;
    var identifierValue = (identifierInfo === null || identifierInfo === void 0 ? void 0 : identifierInfo.identifierField) != null && fragmentData != null && typeof fragmentData === 'object' ? fragmentData[identifierInfo.identifierField] : null;
    var isMountedRef = $fYVz6();
    var _useState = $cfca6e1c2703d239$var$useState(environment), mirroredEnvironment = _useState[0], setMirroredEnvironment = _useState[1];
    var _useState2 = $cfca6e1c2703d239$var$useState(fragmentIdentifier), mirroredFragmentIdentifier = _useState2[0], setMirroredFragmentIdentifier = _useState2[1];
    var isParentQueryActive = $d7sis(fragmentNode, fragmentRef);
    var shouldReset = environment !== mirroredEnvironment || fragmentIdentifier !== mirroredFragmentIdentifier;
    if (shouldReset) {
        disposeFetch();
        onReset();
        setMirroredEnvironment(environment);
        setMirroredFragmentIdentifier(fragmentIdentifier);
    }
    var _getConnectionState = $cfca6e1c2703d239$var$getConnectionState(direction, fragmentNode, fragmentData, connectionPathInFragmentData), cursor = _getConnectionState.cursor, hasMore = _getConnectionState.hasMore;
    $cfca6e1c2703d239$var$useEffect(function() {
        return function() {
            disposeFetch();
        };
    }, [
        disposeFetch
    ]);
    var loadMore = $cfca6e1c2703d239$var$useCallback(function(count, options) {
        var onComplete = options === null || options === void 0 ? void 0 : options.onComplete;
        if (isMountedRef.current !== true) return {
            dispose: function dispose() {}
        };
        var fragmentSelector = $cfca6e1c2703d239$var$getSelector(fragmentNode, fragmentRef);
        if (isFetchingRef.current === true || fragmentData == null || isParentQueryActive) {
            fragmentSelector;
            if (onComplete) onComplete(null);
            return {
                dispose: function dispose() {}
            };
        }
        !(fragmentSelector != null && fragmentSelector.kind !== 'PluralReaderSelector') && $bQThX(false);
        var parentVariables = fragmentSelector.owner.variables;
        var fragmentVariables = fragmentSelector.variables;
        var extraVariables = options === null || options === void 0 ? void 0 : options.UNSTABLE_extraVariables;
        var baseVariables = (0, $cfca6e1c2703d239$var$_objectSpread2["default"])((0, $cfca6e1c2703d239$var$_objectSpread2["default"])({}, parentVariables), fragmentVariables);
        var paginationVariables = $cfca6e1c2703d239$var$getPaginationVariables(direction, count, cursor, baseVariables, (0, $cfca6e1c2703d239$var$_objectSpread2["default"])({}, extraVariables), paginationMetadata);
        if (identifierInfo != null) {
            typeof identifierValue;
            paginationVariables[identifierInfo.identifierQueryVariableName] = identifierValue;
        }
        var paginationQuery = $cfca6e1c2703d239$var$createOperationDescriptor(paginationRequest, paginationVariables, {
            force: true
        });
        $cfca6e1c2703d239$var$fetchQuery(environment, paginationQuery).subscribe((0, $cfca6e1c2703d239$var$_objectSpread2["default"])((0, $cfca6e1c2703d239$var$_objectSpread2["default"])({}, observer), {}, {
            start: function start(subscription) {
                startFetch(subscription);
                observer.start && observer.start(subscription);
            },
            complete: function complete() {
                completeFetch();
                observer.complete && observer.complete();
                onComplete && onComplete(null);
            },
            error: function error(_error) {
                completeFetch();
                observer.error && observer.error(_error);
                onComplete && onComplete(_error);
            }
        }));
        return {
            dispose: disposeFetch
        };
    }, [
        environment,
        identifierValue,
        direction,
        cursor,
        startFetch,
        disposeFetch,
        completeFetch,
        isFetchingRef,
        isParentQueryActive,
        fragmentData,
        fragmentNode.name,
        fragmentRef,
        componentDisplayName
    ]);
    return [
        loadMore,
        hasMore,
        disposeFetch
    ];
}
function $cfca6e1c2703d239$var$getConnectionState(direction, fragmentNode, fragmentData, connectionPathInFragmentData) {
    var _pageInfo$END_CURSOR, _pageInfo$START_CURSO;
    var _ConnectionInterface$ = $cfca6e1c2703d239$var$ConnectionInterface.get(), EDGES = _ConnectionInterface$.EDGES, PAGE_INFO = _ConnectionInterface$.PAGE_INFO, HAS_NEXT_PAGE = _ConnectionInterface$.HAS_NEXT_PAGE, HAS_PREV_PAGE = _ConnectionInterface$.HAS_PREV_PAGE, END_CURSOR = _ConnectionInterface$.END_CURSOR, START_CURSOR = _ConnectionInterface$.START_CURSOR;
    var connection = $cfca6e1c2703d239$var$getValueAtPath(fragmentData, connectionPathInFragmentData);
    if (connection == null) return {
        cursor: null,
        hasMore: false
    };
    !(typeof connection === 'object') && $bQThX(false);
    var edges = connection[EDGES];
    var pageInfo = connection[PAGE_INFO];
    if (edges == null || pageInfo == null) return {
        cursor: null,
        hasMore: false
    };
    !Array.isArray(edges) && $bQThX(false);
    !(typeof pageInfo === 'object') && $bQThX(false);
    var cursor = direction === 'forward' ? (_pageInfo$END_CURSOR = pageInfo[END_CURSOR]) !== null && _pageInfo$END_CURSOR !== void 0 ? _pageInfo$END_CURSOR : null : (_pageInfo$START_CURSO = pageInfo[START_CURSOR]) !== null && _pageInfo$START_CURSO !== void 0 ? _pageInfo$START_CURSO : null;
    !(cursor === null || typeof cursor === 'string') && $bQThX(false);
    var hasMore;
    if (direction === 'forward') hasMore = cursor != null && pageInfo[HAS_NEXT_PAGE] === true;
    else hasMore = cursor != null && pageInfo[HAS_PREV_PAGE] === true;
    return {
        cursor: cursor,
        hasMore: hasMore
    };
}
module.exports = $cfca6e1c2703d239$var$useLoadMoreFunction;

});
parcelRegister("d7sis", function(module, exports) {
'use strict';

var $cdYu4 = parcelRequire("cdYu4");

var $bQThX = parcelRequire("bQThX");

var $gwFzn = parcelRequire("gwFzn");

var $lan9D = parcelRequire("lan9D");
var $98d1e0ed6e33e3e2$var$getObservableForActiveRequest = $lan9D.__internal.getObservableForActiveRequest, $98d1e0ed6e33e3e2$var$getSelector = $lan9D.getSelector;
var $98d1e0ed6e33e3e2$var$useEffect = $gwFzn.useEffect, $98d1e0ed6e33e3e2$var$useState = $gwFzn.useState, $98d1e0ed6e33e3e2$var$useMemo = $gwFzn.useMemo;
function $98d1e0ed6e33e3e2$var$useIsOperationNodeActive(fragmentNode, fragmentRef) {
    var environment = $cdYu4();
    var observable = $98d1e0ed6e33e3e2$var$useMemo(function() {
        var selector = $98d1e0ed6e33e3e2$var$getSelector(fragmentNode, fragmentRef);
        if (selector == null) return null;
        !(selector.kind === 'SingularReaderSelector') && $bQThX(false);
        return $98d1e0ed6e33e3e2$var$getObservableForActiveRequest(environment, selector.owner);
    }, [
        environment,
        fragmentNode,
        fragmentRef
    ]);
    var _useState = $98d1e0ed6e33e3e2$var$useState(observable != null), isActive = _useState[0], setIsActive = _useState[1];
    $98d1e0ed6e33e3e2$var$useEffect(function() {
        var subscription;
        setIsActive(observable != null);
        if (observable != null) {
            var onCompleteOrError = function onCompleteOrError() {
                setIsActive(false);
            };
            subscription = observable.subscribe({
                complete: onCompleteOrError,
                error: onCompleteOrError
            });
        }
        return function() {
            if (subscription) subscription.unsubscribe();
        };
    }, [
        observable
    ]);
    return isActive;
}
module.exports = $98d1e0ed6e33e3e2$var$useIsOperationNodeActive;

});


parcelRegister("jfwgE", function(module, exports) {
'use strict';

var $7dvyf = parcelRequire("7dvyf");
var $e03872af09bfb9f0$var$_interopRequireDefault = $7dvyf.default;

var $e03872af09bfb9f0$var$_objectSpread2 = $e03872af09bfb9f0$var$_interopRequireDefault((parcelRequire("4N8OD")));

var $fWBut = parcelRequire("fWBut");

var $eaErg = parcelRequire("eaErg");
var $e03872af09bfb9f0$var$getQueryResourceForEnvironment = $eaErg.getQueryResourceForEnvironment;

var $b8FIi = parcelRequire("b8FIi");

var $lO358 = parcelRequire("lO358");

var $fYVz6 = parcelRequire("fYVz6");

var $h4xdD = parcelRequire("h4xdD");

var $cdYu4 = parcelRequire("cdYu4");

var $bQThX = parcelRequire("bQThX");

var $gwFzn = parcelRequire("gwFzn");
var $e03872af09bfb9f0$var$useCallback = $gwFzn.useCallback, $e03872af09bfb9f0$var$useContext = $gwFzn.useContext, $e03872af09bfb9f0$var$useReducer = $gwFzn.useReducer;

var $lan9D = parcelRequire("lan9D");
var $e03872af09bfb9f0$var$fetchQuery = $lan9D.__internal.fetchQuery, $e03872af09bfb9f0$var$createOperationDescriptor = $lan9D.createOperationDescriptor, $e03872af09bfb9f0$var$getFragmentIdentifier = $lan9D.getFragmentIdentifier, $e03872af09bfb9f0$var$getRefetchMetadata = $lan9D.getRefetchMetadata, $e03872af09bfb9f0$var$getSelector = $lan9D.getSelector, $e03872af09bfb9f0$var$getValueAtPath = $lan9D.getValueAtPath;
parcelRequire("hzw7m");
function $e03872af09bfb9f0$var$reducer(state, action) {
    switch(action.type){
        case 'refetch':
            var _action$refetchEnviro;
            return (0, $e03872af09bfb9f0$var$_objectSpread2["default"])((0, $e03872af09bfb9f0$var$_objectSpread2["default"])({}, state), {}, {
                fetchPolicy: action.fetchPolicy,
                mirroredEnvironment: (_action$refetchEnviro = action.refetchEnvironment) !== null && _action$refetchEnviro !== void 0 ? _action$refetchEnviro : state.mirroredEnvironment,
                onComplete: action.onComplete,
                refetchEnvironment: action.refetchEnvironment,
                refetchQuery: action.refetchQuery,
                renderPolicy: action.renderPolicy
            });
        case 'reset':
            return {
                fetchPolicy: undefined,
                mirroredEnvironment: action.environment,
                mirroredFragmentIdentifier: action.fragmentIdentifier,
                onComplete: undefined,
                refetchQuery: null,
                renderPolicy: undefined
            };
        default:
            action.type;
            throw new Error('useRefetchableFragmentNode: Unexpected action type');
    }
}
function $e03872af09bfb9f0$var$useRefetchableFragmentNode(fragmentNode, parentFragmentRef, componentDisplayName) {
    var parentEnvironment = $cdYu4();
    var _getRefetchMetadata = $e03872af09bfb9f0$var$getRefetchMetadata(fragmentNode, componentDisplayName), refetchableRequest = _getRefetchMetadata.refetchableRequest, fragmentRefPathInResponse = _getRefetchMetadata.fragmentRefPathInResponse, identifierInfo = _getRefetchMetadata.identifierInfo;
    var fragmentIdentifier = $e03872af09bfb9f0$var$getFragmentIdentifier(fragmentNode, parentFragmentRef);
    var _useReducer = $e03872af09bfb9f0$var$useReducer($e03872af09bfb9f0$var$reducer, {
        fetchPolicy: undefined,
        mirroredEnvironment: parentEnvironment,
        mirroredFragmentIdentifier: fragmentIdentifier,
        onComplete: undefined,
        refetchEnvironment: null,
        refetchQuery: null,
        renderPolicy: undefined
    }), refetchState = _useReducer[0], dispatch = _useReducer[1];
    var fetchPolicy = refetchState.fetchPolicy, mirroredEnvironment = refetchState.mirroredEnvironment, mirroredFragmentIdentifier = refetchState.mirroredFragmentIdentifier, onComplete = refetchState.onComplete, refetchEnvironment = refetchState.refetchEnvironment, refetchQuery = refetchState.refetchQuery, renderPolicy = refetchState.renderPolicy;
    var environment = refetchEnvironment !== null && refetchEnvironment !== void 0 ? refetchEnvironment : parentEnvironment;
    var QueryResource = $e03872af09bfb9f0$var$getQueryResourceForEnvironment(environment);
    var profilerContext = $e03872af09bfb9f0$var$useContext($fWBut);
    var shouldReset = environment !== mirroredEnvironment || fragmentIdentifier !== mirroredFragmentIdentifier;
    var _useQueryLoader = $h4xdD(refetchableRequest), queryRef = _useQueryLoader[0], loadQuery = _useQueryLoader[1], disposeQuery = _useQueryLoader[2];
    var fragmentRef = parentFragmentRef;
    if (shouldReset) {
        dispatch({
            type: 'reset',
            environment: environment,
            fragmentIdentifier: fragmentIdentifier
        });
        disposeQuery();
    } else if (refetchQuery != null && queryRef != null) {
        var debugPreviousIDAndTypename;
        var handleQueryCompleted = function handleQueryCompleted(maybeError) {
            onComplete && onComplete(maybeError !== null && maybeError !== void 0 ? maybeError : null);
        };
        var fetchObservable = queryRef.source != null ? queryRef.source : $e03872af09bfb9f0$var$fetchQuery(environment, refetchQuery);
        var queryResult = profilerContext.wrapPrepareQueryResource(function() {
            return QueryResource.prepare(refetchQuery, fetchObservable, fetchPolicy, renderPolicy, {
                error: handleQueryCompleted,
                complete: function complete() {
                    handleQueryCompleted();
                }
            }, queryRef.fetchKey, profilerContext);
        });
        var queryData = $b8FIi(environment, queryResult.fragmentNode, queryResult.fragmentRef, componentDisplayName).data;
        !(queryData != null) && $bQThX(false);
        var refetchedFragmentRef = $e03872af09bfb9f0$var$getValueAtPath(queryData, fragmentRefPathInResponse);
        fragmentRef = refetchedFragmentRef;
    }
    var fragmentData = $lO358(fragmentNode, fragmentRef, componentDisplayName);
    var refetch = $e03872af09bfb9f0$var$useRefetchFunction(componentDisplayName, dispatch, disposeQuery, fragmentData, fragmentIdentifier, fragmentNode, fragmentRefPathInResponse, identifierInfo, loadQuery, parentFragmentRef, refetchableRequest);
    return {
        fragmentData: fragmentData,
        fragmentRef: fragmentRef,
        refetch: refetch
    };
}
function $e03872af09bfb9f0$var$useRefetchFunction(componentDisplayName, dispatch, disposeQuery, fragmentData, fragmentIdentifier, fragmentNode, fragmentRefPathInResponse, identifierInfo, loadQuery, parentFragmentRef, refetchableRequest) {
    var isMountedRef = $fYVz6();
    var identifierValue = (identifierInfo === null || identifierInfo === void 0 ? void 0 : identifierInfo.identifierField) != null && fragmentData != null && typeof fragmentData === 'object' ? fragmentData[identifierInfo.identifierField] : null;
    return $e03872af09bfb9f0$var$useCallback(function(providedRefetchVariables, options) {
        if (isMountedRef.current !== true) return {
            dispose: function dispose() {}
        };
        parentFragmentRef;
        var refetchEnvironment = options === null || options === void 0 ? void 0 : options.__environment;
        var fetchPolicy = options === null || options === void 0 ? void 0 : options.fetchPolicy;
        var renderPolicy = options === null || options === void 0 ? void 0 : options.UNSTABLE_renderPolicy;
        var onComplete = options === null || options === void 0 ? void 0 : options.onComplete;
        var fragmentSelector = $e03872af09bfb9f0$var$getSelector(fragmentNode, parentFragmentRef);
        var parentVariables;
        var fragmentVariables;
        if (fragmentSelector == null) {
            parentVariables = {};
            fragmentVariables = {};
        } else if (fragmentSelector.kind === 'PluralReaderSelector') {
            var _fragmentSelector$sel, _fragmentSelector$sel2, _fragmentSelector$sel3, _fragmentSelector$sel4;
            parentVariables = (_fragmentSelector$sel = (_fragmentSelector$sel2 = fragmentSelector.selectors[0]) === null || _fragmentSelector$sel2 === void 0 ? void 0 : _fragmentSelector$sel2.owner.variables) !== null && _fragmentSelector$sel !== void 0 ? _fragmentSelector$sel : {};
            fragmentVariables = (_fragmentSelector$sel3 = (_fragmentSelector$sel4 = fragmentSelector.selectors[0]) === null || _fragmentSelector$sel4 === void 0 ? void 0 : _fragmentSelector$sel4.variables) !== null && _fragmentSelector$sel3 !== void 0 ? _fragmentSelector$sel3 : {};
        } else {
            parentVariables = fragmentSelector.owner.variables;
            fragmentVariables = fragmentSelector.variables;
        }
        var refetchVariables = (0, $e03872af09bfb9f0$var$_objectSpread2["default"])((0, $e03872af09bfb9f0$var$_objectSpread2["default"])((0, $e03872af09bfb9f0$var$_objectSpread2["default"])({}, parentVariables), fragmentVariables), providedRefetchVariables);
        if (identifierInfo != null && !providedRefetchVariables.hasOwnProperty(identifierInfo.identifierQueryVariableName)) {
            typeof identifierValue;
            refetchVariables[identifierInfo.identifierQueryVariableName] = identifierValue;
        }
        var refetchQuery = $e03872af09bfb9f0$var$createOperationDescriptor(refetchableRequest, refetchVariables, {
            force: true
        });
        loadQuery(refetchQuery.request.variables, {
            fetchPolicy: fetchPolicy,
            __environment: refetchEnvironment,
            __nameForWarning: 'refetch'
        });
        dispatch({
            type: 'refetch',
            fetchPolicy: fetchPolicy,
            onComplete: onComplete,
            refetchEnvironment: refetchEnvironment,
            refetchQuery: refetchQuery,
            renderPolicy: renderPolicy
        });
        return {
            dispose: disposeQuery
        };
    }, [
        fragmentIdentifier,
        dispatch,
        disposeQuery,
        identifierValue,
        loadQuery
    ]);
}
var $e03872af09bfb9f0$var$debugFunctions;
module.exports = $e03872af09bfb9f0$var$useRefetchableFragmentNode;

});
parcelRegister("b8FIi", function(module, exports) {
'use strict';

var $7dvyf = parcelRequire("7dvyf");
var $81c0cc778859b97e$var$_interopRequireDefault = $7dvyf.default;

var $81c0cc778859b97e$var$_objectSpread2 = $81c0cc778859b97e$var$_interopRequireDefault((parcelRequire("4N8OD")));

var $81c0cc778859b97e$var$_createForOfIteratorHelper2 = $81c0cc778859b97e$var$_interopRequireDefault((parcelRequire("bTRzt")));

var $eaErg = parcelRequire("eaErg");
var $81c0cc778859b97e$var$getQueryResourceForEnvironment = $eaErg.getQueryResourceForEnvironment;

var $bQThX = parcelRequire("bQThX");

var $lan9D = parcelRequire("lan9D");
var $81c0cc778859b97e$var$fetchQueryInternal = $lan9D.__internal.fetchQuery, $81c0cc778859b97e$var$RelayFeatureFlags = $lan9D.RelayFeatureFlags, $81c0cc778859b97e$var$createOperationDescriptor = $lan9D.createOperationDescriptor, $81c0cc778859b97e$var$getPendingOperationsForFragment = $lan9D.getPendingOperationsForFragment, $81c0cc778859b97e$var$getSelector = $lan9D.getSelector, $81c0cc778859b97e$var$getVariablesFromFragment = $lan9D.getVariablesFromFragment, $81c0cc778859b97e$var$handlePotentialSnapshotErrors = $lan9D.handlePotentialSnapshotErrors;
parcelRequire("hzw7m");
function $81c0cc778859b97e$var$isMissingData(state) {
    if (state.kind === 'bailout') return false;
    else if (state.kind === 'singular') return state.snapshot.isMissingData;
    else return state.snapshots.some(function(s) {
        return s.isMissingData;
    });
}
function $81c0cc778859b97e$var$getMissingClientEdges(state) {
    if (state.kind === 'bailout') return null;
    else if (state.kind === 'singular') {
        var _state$snapshot$missi;
        return (_state$snapshot$missi = state.snapshot.missingClientEdges) !== null && _state$snapshot$missi !== void 0 ? _state$snapshot$missi : null;
    } else {
        var edges = null;
        var _iterator = (0, $81c0cc778859b97e$var$_createForOfIteratorHelper2["default"])(state.snapshots), _step;
        try {
            for(_iterator.s(); !(_step = _iterator.n()).done;){
                var snapshot = _step.value;
                if (snapshot.missingClientEdges) {
                    var _edges;
                    edges = (_edges = edges) !== null && _edges !== void 0 ? _edges : [];
                    var _iterator2 = (0, $81c0cc778859b97e$var$_createForOfIteratorHelper2["default"])(snapshot.missingClientEdges), _step2;
                    try {
                        for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
                            var edge = _step2.value;
                            edges.push(edge);
                        }
                    } catch (err) {
                        _iterator2.e(err);
                    } finally{
                        _iterator2.f();
                    }
                }
            }
        } catch (err) {
            _iterator.e(err);
        } finally{
            _iterator.f();
        }
        return edges;
    }
}
function $81c0cc778859b97e$var$handlePotentialSnapshotErrorsForState(environment, state) {
    if (state.kind === 'singular') {
        var _state$snapshot$selec, _state$snapshot$selec2;
        $81c0cc778859b97e$var$handlePotentialSnapshotErrors(environment, state.snapshot.missingRequiredFields, state.snapshot.relayResolverErrors, state.snapshot.errorResponseFields, (_state$snapshot$selec = (_state$snapshot$selec2 = state.snapshot.selector.node.metadata) === null || _state$snapshot$selec2 === void 0 ? void 0 : _state$snapshot$selec2.throwOnFieldError) !== null && _state$snapshot$selec !== void 0 ? _state$snapshot$selec : false);
    } else if (state.kind === 'plural') {
        var _iterator3 = (0, $81c0cc778859b97e$var$_createForOfIteratorHelper2["default"])(state.snapshots), _step3;
        try {
            for(_iterator3.s(); !(_step3 = _iterator3.n()).done;){
                var _snapshot$selector$no, _snapshot$selector$no2;
                var snapshot = _step3.value;
                $81c0cc778859b97e$var$handlePotentialSnapshotErrors(environment, snapshot.missingRequiredFields, snapshot.relayResolverErrors, snapshot.errorResponseFields, (_snapshot$selector$no = (_snapshot$selector$no2 = snapshot.selector.node.metadata) === null || _snapshot$selector$no2 === void 0 ? void 0 : _snapshot$selector$no2.throwOnFieldError) !== null && _snapshot$selector$no !== void 0 ? _snapshot$selector$no : false);
            }
        } catch (err) {
            _iterator3.e(err);
        } finally{
            _iterator3.f();
        }
    }
}
function $81c0cc778859b97e$var$handleMissingClientEdge(environment, parentFragmentNode, parentFragmentRef, missingClientEdgeRequestInfo, queryOptions) {
    var originalVariables = $81c0cc778859b97e$var$getVariablesFromFragment(parentFragmentNode, parentFragmentRef);
    var variables = (0, $81c0cc778859b97e$var$_objectSpread2["default"])((0, $81c0cc778859b97e$var$_objectSpread2["default"])({}, originalVariables), {}, {
        id: missingClientEdgeRequestInfo.clientEdgeDestinationID
    });
    var queryOperationDescriptor = $81c0cc778859b97e$var$createOperationDescriptor(missingClientEdgeRequestInfo.request, variables, queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.networkCacheConfig);
    var QueryResource = $81c0cc778859b97e$var$getQueryResourceForEnvironment(environment);
    return QueryResource.prepare(queryOperationDescriptor, $81c0cc778859b97e$var$fetchQueryInternal(environment, queryOperationDescriptor), queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.fetchPolicy);
}
function $81c0cc778859b97e$var$getFragmentState(environment, fragmentSelector) {
    if (fragmentSelector == null) return {
        kind: 'bailout'
    };
    else if (fragmentSelector.kind === 'PluralReaderSelector') {
        if (fragmentSelector.selectors.length === 0) return {
            kind: 'bailout'
        };
        else return {
            kind: 'plural',
            snapshots: fragmentSelector.selectors.map(function(s) {
                return environment.lookup(s);
            }),
            epoch: environment.getStore().getEpoch()
        };
    } else return {
        kind: 'singular',
        snapshot: environment.lookup(fragmentSelector),
        epoch: environment.getStore().getEpoch()
    };
}
function $81c0cc778859b97e$var$readFragmentInternal(environment, fragmentNode, fragmentRef, hookDisplayName, queryOptions, fragmentKey) {
    var _fragmentNode$metadat, _fragmentNode$metadat2;
    var fragmentSelector = $81c0cc778859b97e$var$getSelector(fragmentNode, fragmentRef);
    var isPlural = (fragmentNode === null || fragmentNode === void 0 ? void 0 : (_fragmentNode$metadat = fragmentNode.metadata) === null || _fragmentNode$metadat === void 0 ? void 0 : _fragmentNode$metadat.plural) === true;
    if (isPlural) !(fragmentRef == null || Array.isArray(fragmentRef)) && $bQThX(false);
    else !!Array.isArray(fragmentRef) && $bQThX(false);
    !(fragmentRef == null || isPlural && Array.isArray(fragmentRef) && fragmentRef.length === 0 || fragmentSelector != null) && $bQThX(false);
    var state = $81c0cc778859b97e$var$getFragmentState(environment, fragmentSelector);
    var clientEdgeQueries = null;
    if (((_fragmentNode$metadat2 = fragmentNode.metadata) === null || _fragmentNode$metadat2 === void 0 ? void 0 : _fragmentNode$metadat2.hasClientEdges) === true) {
        var missingClientEdges = $81c0cc778859b97e$var$getMissingClientEdges(state);
        if (missingClientEdges !== null && missingClientEdges !== void 0 && missingClientEdges.length) {
            clientEdgeQueries = [];
            var _iterator4 = (0, $81c0cc778859b97e$var$_createForOfIteratorHelper2["default"])(missingClientEdges), _step4;
            try {
                for(_iterator4.s(); !(_step4 = _iterator4.n()).done;){
                    var edge = _step4.value;
                    clientEdgeQueries.push($81c0cc778859b97e$var$handleMissingClientEdge(environment, fragmentNode, fragmentRef, edge, queryOptions));
                }
            } catch (err) {
                _iterator4.e(err);
            } finally{
                _iterator4.f();
            }
        }
    }
    if ($81c0cc778859b97e$var$isMissingData(state)) {
        !(fragmentSelector != null) && $bQThX(false);
        var fragmentOwner = fragmentSelector.kind === 'PluralReaderSelector' ? fragmentSelector.selectors[0].owner : fragmentSelector.owner;
        var pendingOperationsResult = $81c0cc778859b97e$var$getPendingOperationsForFragment(environment, fragmentNode, fragmentOwner);
        if (pendingOperationsResult) throw pendingOperationsResult.promise;
        $81c0cc778859b97e$var$handlePotentialSnapshotErrorsForState(environment, state);
    }
    var data;
    if (state.kind === 'bailout') data = isPlural ? [] : null;
    else if (state.kind === 'singular') data = state.snapshot.data;
    else data = state.snapshots.map(function(s) {
        return s.data;
    });
    if ($81c0cc778859b97e$var$RelayFeatureFlags.LOG_MISSING_RECORDS_IN_PROD || false) fragmentRef != null && (data === undefined || Array.isArray(data) && data.length > 0 && data.every(function(d) {
        return d === undefined;
    }));
    return {
        data: data,
        clientEdgeQueries: clientEdgeQueries
    };
}
module.exports = $81c0cc778859b97e$var$readFragmentInternal;

});

parcelRegister("h4xdD", function(module, exports) {
'use strict';

var $7dvyf = parcelRequire("7dvyf");
var $c6dc93f5cb748f46$var$_interopRequireDefault = $7dvyf.default;

var $c6dc93f5cb748f46$var$_createForOfIteratorHelper2 = $c6dc93f5cb748f46$var$_interopRequireDefault((parcelRequire("bTRzt")));

var $kgUNJ = parcelRequire("kgUNJ");
var $c6dc93f5cb748f46$var$loadQuery = $kgUNJ.loadQuery, $c6dc93f5cb748f46$var$useTrackLoadQueryInRender = $kgUNJ.useTrackLoadQueryInRender;

var $fYVz6 = parcelRequire("fYVz6");

var $cdYu4 = parcelRequire("cdYu4");

var $gwFzn = parcelRequire("gwFzn");
var $c6dc93f5cb748f46$var$useCallback = $gwFzn.useCallback, $c6dc93f5cb748f46$var$useEffect = $gwFzn.useEffect, $c6dc93f5cb748f46$var$useRef = $gwFzn.useRef, $c6dc93f5cb748f46$var$useState = $gwFzn.useState;

var $lan9D = parcelRequire("lan9D");
var $c6dc93f5cb748f46$var$getRequest = $lan9D.getRequest;
var $c6dc93f5cb748f46$var$initialNullQueryReferenceState = {
    kind: 'NullQueryReference'
};
function $c6dc93f5cb748f46$var$requestIsLiveQuery(preloadableRequest) {
    if (preloadableRequest.kind === 'PreloadableConcreteRequest') return preloadableRequest.params.metadata.live !== undefined;
    var request = $c6dc93f5cb748f46$var$getRequest(preloadableRequest);
    return request.params.metadata.live !== undefined;
}
function $c6dc93f5cb748f46$var$useQueryLoader(preloadableRequest, initialQueryReference) {
    var initialQueryReferenceInternal = initialQueryReference !== null && initialQueryReference !== void 0 ? initialQueryReference : $c6dc93f5cb748f46$var$initialNullQueryReferenceState;
    var environment = $cdYu4();
    $c6dc93f5cb748f46$var$useTrackLoadQueryInRender();
    var isMountedRef = $fYVz6();
    var undisposedQueryReferencesRef = $c6dc93f5cb748f46$var$useRef(new Set([
        initialQueryReferenceInternal
    ]));
    var _useState = $c6dc93f5cb748f46$var$useState(function() {
        return initialQueryReferenceInternal;
    }), queryReference = _useState[0], setQueryReference = _useState[1];
    var _useState2 = $c6dc93f5cb748f46$var$useState(function() {
        return initialQueryReferenceInternal;
    }), previousInitialQueryReference = _useState2[0], setPreviousInitialQueryReference = _useState2[1];
    if (initialQueryReferenceInternal !== previousInitialQueryReference) {
        undisposedQueryReferencesRef.current.add(initialQueryReferenceInternal);
        setPreviousInitialQueryReference(initialQueryReferenceInternal);
        setQueryReference(initialQueryReferenceInternal);
    }
    var disposeQuery = $c6dc93f5cb748f46$var$useCallback(function() {
        if (isMountedRef.current) {
            undisposedQueryReferencesRef.current.add($c6dc93f5cb748f46$var$initialNullQueryReferenceState);
            setQueryReference($c6dc93f5cb748f46$var$initialNullQueryReferenceState);
        }
    }, [
        isMountedRef
    ]);
    var queryLoaderCallback = $c6dc93f5cb748f46$var$useCallback(function(variables, options) {
        var mergedOptions = options != null && options.hasOwnProperty('__environment') ? {
            fetchPolicy: options.fetchPolicy,
            networkCacheConfig: options.networkCacheConfig,
            __nameForWarning: options.__nameForWarning
        } : options;
        if (isMountedRef.current) {
            var _options$__environmen;
            var updatedQueryReference = $c6dc93f5cb748f46$var$loadQuery((_options$__environmen = options === null || options === void 0 ? void 0 : options.__environment) !== null && _options$__environmen !== void 0 ? _options$__environmen : environment, preloadableRequest, variables, mergedOptions);
            undisposedQueryReferencesRef.current.add(updatedQueryReference);
            setQueryReference(updatedQueryReference);
        }
    }, [
        environment,
        preloadableRequest,
        setQueryReference,
        isMountedRef
    ]);
    var maybeHiddenOrFastRefresh = $c6dc93f5cb748f46$var$useRef(false);
    $c6dc93f5cb748f46$var$useEffect(function() {
        return function() {
            maybeHiddenOrFastRefresh.current = true;
        };
    }, []);
    $c6dc93f5cb748f46$var$useEffect(function() {
        if (maybeHiddenOrFastRefresh.current === true) {
            maybeHiddenOrFastRefresh.current = false;
            if (queryReference.kind !== 'NullQueryReference') queryLoaderCallback(queryReference.variables, {
                fetchPolicy: queryReference.fetchPolicy,
                networkCacheConfig: queryReference.networkCacheConfig
            });
            return;
        }
        var undisposedQueryReferences = undisposedQueryReferencesRef.current;
        if (isMountedRef.current) {
            var _iterator = (0, $c6dc93f5cb748f46$var$_createForOfIteratorHelper2["default"])(undisposedQueryReferences), _step;
            try {
                for(_iterator.s(); !(_step = _iterator.n()).done;){
                    var undisposedQueryReference = _step.value;
                    if (undisposedQueryReference === queryReference) break;
                    undisposedQueryReferences["delete"](undisposedQueryReference);
                    if (undisposedQueryReference.kind !== 'NullQueryReference') {
                        if ($c6dc93f5cb748f46$var$requestIsLiveQuery(preloadableRequest)) undisposedQueryReference.dispose && undisposedQueryReference.dispose();
                        else undisposedQueryReference.releaseQuery && undisposedQueryReference.releaseQuery();
                    }
                }
            } catch (err) {
                _iterator.e(err);
            } finally{
                _iterator.f();
            }
        }
    }, [
        queryReference,
        isMountedRef,
        queryLoaderCallback,
        preloadableRequest
    ]);
    $c6dc93f5cb748f46$var$useEffect(function() {
        return function disposeAllRemainingQueryReferences() {
            var _iterator2 = (0, $c6dc93f5cb748f46$var$_createForOfIteratorHelper2["default"])(undisposedQueryReferencesRef.current), _step2;
            try {
                for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
                    var undisposedQueryReference = _step2.value;
                    if (undisposedQueryReference.kind !== 'NullQueryReference') {
                        if ($c6dc93f5cb748f46$var$requestIsLiveQuery(preloadableRequest)) undisposedQueryReference.dispose && undisposedQueryReference.dispose();
                        else undisposedQueryReference.releaseQuery && undisposedQueryReference.releaseQuery();
                    }
                }
            } catch (err) {
                _iterator2.e(err);
            } finally{
                _iterator2.f();
            }
        };
    }, [
        preloadableRequest
    ]);
    return [
        queryReference.kind === 'NullQueryReference' ? null : queryReference,
        queryLoaderCallback,
        disposeQuery
    ];
}
module.exports = $c6dc93f5cb748f46$var$useQueryLoader;

});



parcelRegister("8mdVS", function(module, exports) {
'use strict';

var $kgUNJ = parcelRequire("kgUNJ");
var $615b2f7e5e177e2b$var$useTrackLoadQueryInRender = $kgUNJ.useTrackLoadQueryInRender;

var $2VcGn = parcelRequire("2VcGn");

var $ax2Om = parcelRequire("ax2Om");

var $cdYu4 = parcelRequire("cdYu4");

var $bQThX = parcelRequire("bQThX");

var $gwFzn = parcelRequire("gwFzn");
var $615b2f7e5e177e2b$var$useDebugValue = $gwFzn.useDebugValue;

var $lan9D = parcelRequire("lan9D");
var $615b2f7e5e177e2b$var$_require3$__internal = $lan9D.__internal, $615b2f7e5e177e2b$var$fetchQueryDeduped = $615b2f7e5e177e2b$var$_require3$__internal.fetchQueryDeduped, $615b2f7e5e177e2b$var$fetchQuery = $615b2f7e5e177e2b$var$_require3$__internal.fetchQuery;
parcelRequire("hzw7m");
function $615b2f7e5e177e2b$var$usePreloadedQuery(gqlQuery, preloadedQuery, options) {
    $615b2f7e5e177e2b$var$useTrackLoadQueryInRender();
    var environment = $cdYu4();
    var fetchKey = preloadedQuery.fetchKey, fetchPolicy = preloadedQuery.fetchPolicy, source = preloadedQuery.source, variables = preloadedQuery.variables, networkCacheConfig = preloadedQuery.networkCacheConfig;
    var operation = $ax2Om(gqlQuery, variables, networkCacheConfig);
    var useLazyLoadQueryNodeParams;
    if (preloadedQuery.kind === 'PreloadedQuery_DEPRECATED') {
        !(operation.request.node.params.name === preloadedQuery.name) && $bQThX(false);
        useLazyLoadQueryNodeParams = {
            componentDisplayName: 'usePreloadedQuery()',
            fetchKey: fetchKey,
            fetchObservable: $615b2f7e5e177e2b$var$fetchQueryDeduped(environment, operation.request.identifier, function() {
                if (environment === preloadedQuery.environment && source != null) return environment.executeWithSource({
                    operation: operation,
                    source: source
                });
                else return environment.execute({
                    operation: operation
                });
            }),
            fetchPolicy: fetchPolicy,
            query: operation,
            renderPolicy: options === null || options === void 0 ? void 0 : options.UNSTABLE_renderPolicy
        };
    } else {
        var fallbackFetchObservable = $615b2f7e5e177e2b$var$fetchQuery(environment, operation);
        var fetchObservable;
        if (source != null && environment === preloadedQuery.environment) fetchObservable = source.ifEmpty(fallbackFetchObservable);
        else if (environment !== preloadedQuery.environment) fetchObservable = fallbackFetchObservable;
        else fetchObservable = fallbackFetchObservable;
        useLazyLoadQueryNodeParams = {
            componentDisplayName: 'usePreloadedQuery()',
            fetchObservable: fetchObservable,
            fetchKey: fetchKey,
            fetchPolicy: fetchPolicy,
            query: operation,
            renderPolicy: options === null || options === void 0 ? void 0 : options.UNSTABLE_renderPolicy
        };
    }
    var data = $2VcGn(useLazyLoadQueryNodeParams);
    return data;
}
module.exports = $615b2f7e5e177e2b$var$usePreloadedQuery;

});

parcelRegister("1Q1T2", function(module, exports) {
'use strict';

var $jfwgE = parcelRequire("jfwgE");

var $dXLJe = parcelRequire("dXLJe");

var $gwFzn = parcelRequire("gwFzn");
var $156c1c7516204a4e$var$useDebugValue = $gwFzn.useDebugValue;

var $lan9D = parcelRequire("lan9D");
var $156c1c7516204a4e$var$getFragment = $lan9D.getFragment;
function $156c1c7516204a4e$var$useRefetchableFragment(fragmentInput, fragmentRef) {
    var fragmentNode = $156c1c7516204a4e$var$getFragment(fragmentInput);
    $dXLJe(fragmentNode, 'first argument of useRefetchableFragment()');
    var _useRefetchableFragme = $jfwgE(fragmentNode, fragmentRef, 'useRefetchableFragment()'), fragmentData = _useRefetchableFragme.fragmentData, refetch = _useRefetchableFragme.refetch;
    return [
        fragmentData,
        refetch
    ];
}
module.exports = $156c1c7516204a4e$var$useRefetchableFragment;

});

parcelRegister("fXECE", function(module, exports) {
'use strict';

var $cdYu4 = parcelRequire("cdYu4");

var $gwFzn = parcelRequire("gwFzn");
var $b9ebe07d0cf955bb$var$useEffect = $gwFzn.useEffect, $b9ebe07d0cf955bb$var$useRef = $gwFzn.useRef;
function $b9ebe07d0cf955bb$var$useSubscribeToInvalidationState(dataIDs, callback) {
    var environment = $cdYu4();
    var disposableRef = $b9ebe07d0cf955bb$var$useRef(null);
    var stableDataIDs = Array.from(dataIDs).sort().join('');
    $b9ebe07d0cf955bb$var$useEffect(function() {
        var store = environment.getStore();
        var invalidationState = store.lookupInvalidationState(dataIDs);
        var disposable = store.subscribeToInvalidationState(invalidationState, callback);
        disposableRef.current = disposable;
        return function() {
            return disposable.dispose();
        };
    }, [
        stableDataIDs,
        callback,
        environment
    ]);
    return {
        dispose: function dispose() {
            if (disposableRef.current != null) disposableRef.current.dispose();
        }
    };
}
module.exports = $b9ebe07d0cf955bb$var$useSubscribeToInvalidationState;

});

parcelRegister("hdLtK", function(module, exports) {
'use strict';

var $cdYu4 = parcelRequire("cdYu4");

var $gwFzn = parcelRequire("gwFzn");
var $c8987ae1712edcb4$var$useEffect = $gwFzn.useEffect;

var $lan9D = parcelRequire("lan9D");
var $c8987ae1712edcb4$var$requestSubscription = $lan9D.requestSubscription;
function $c8987ae1712edcb4$var$useSubscription(config, requestSubscriptionFn) {
    var actualRequestSubscription = requestSubscriptionFn !== null && requestSubscriptionFn !== void 0 ? requestSubscriptionFn : $c8987ae1712edcb4$var$requestSubscription;
    var environment = $cdYu4();
    $c8987ae1712edcb4$var$useEffect(function() {
        var _actualRequestSubscri = actualRequestSubscription(environment, config), dispose = _actualRequestSubscri.dispose;
        return dispose;
    }, [
        environment,
        config,
        actualRequestSubscription
    ]);
}
module.exports = $c8987ae1712edcb4$var$useSubscription;

});



parcelRegister("3tMMZ", function(module, exports) {

$parcel$export(module.exports, "getDefaultRelayEnvironmentConfig", () => $887e63c8434f65c2$export$6c790f07f4ef6a59);

var $lan9D = parcelRequire("lan9D");

var $8aLmh = parcelRequire("8aLmh");

var $f2OFx = parcelRequire("f2OFx");

var $7z5rG = parcelRequire("7z5rG");

var $iTyoD = parcelRequire("iTyoD");

var $1b0Xp = parcelRequire("1b0Xp");
const $887e63c8434f65c2$var$createStore = (source, options)=>{
    (0, $lan9D.RelayFeatureFlags).ENABLE_RELAY_RESOLVERS = true;
    return new (0, (/*@__PURE__*/$parcel$interopDefault($8aLmh)))(source, options);
};
const $887e63c8434f65c2$export$6c790f07f4ef6a59 = ({ log: log, requiredFieldLogger: requiredFieldLogger, network: network })=>({
        configName: 'Atlassian Graphql Gateway',
        network: network || (0, $iTyoD.network),
        store: $887e63c8434f65c2$var$createStore(new (0, $lan9D.RecordSource)(), {
            log: log ?? undefined,
            getDataID: (0, $f2OFx.default)
        }),
        log: log,
        requiredFieldLogger: // Renamed https://github.com/facebook/relay/commit/914794c4ddba6f7c8d2469ecdc5aa42eb112a6bb
        // @ts-expect-error Object literal may only specify known properties, and 'relayFieldLogger' does not exist in type 'EnvironmentConfig'
        requiredFieldLogger,
        relayFieldLogger: requiredFieldLogger,
        getDataID: (0, $f2OFx.default),
        scheduler: (0, $1b0Xp.default),
        missingFieldHandlers: (0, $7z5rG.default)
    });

});
parcelRegister("8aLmh", function(module, exports) {
'use strict';

var $7dvyf = parcelRequire("7dvyf");
var $5f33fe4387abf05f$var$_interopRequireDefault = $7dvyf.default;

var $5f33fe4387abf05f$var$_createForOfIteratorHelper2 = $5f33fe4387abf05f$var$_interopRequireDefault((parcelRequire("bTRzt")));

var $5f33fe4387abf05f$var$_defineProperty2 = $5f33fe4387abf05f$var$_interopRequireDefault((parcelRequire("dW6Ee")));

var $bd1WG = parcelRequire("bd1WG");
var $5f33fe4387abf05f$var$INTERNAL_ACTOR_IDENTIFIER_DO_NOT_USE = $bd1WG.INTERNAL_ACTOR_IDENTIFIER_DO_NOT_USE, $5f33fe4387abf05f$var$assertInternalActorIdentifier = $bd1WG.assertInternalActorIdentifier;
parcelRequire("8YAvI");

var $8yHCQ = parcelRequire("8yHCQ");

var $5wm2f = parcelRequire("5wm2f");

var $eGOdg = parcelRequire("eGOdg");

var $c4ZG3 = parcelRequire("c4ZG3");

var $hprpJ = parcelRequire("hprpJ");

var $2Nqi8 = parcelRequire("2Nqi8");

var $b7ANd = parcelRequire("b7ANd");

var $7sSWY = parcelRequire("7sSWY");

var $a6k4O = parcelRequire("a6k4O");

var $a6k4O = parcelRequire("a6k4O");
var $5f33fe4387abf05f$var$ROOT_ID = $a6k4O.ROOT_ID, $5f33fe4387abf05f$var$ROOT_TYPE = $a6k4O.ROOT_TYPE;

var $9AoCU = parcelRequire("9AoCU");
var $5f33fe4387abf05f$var$LiveResolverCache = $9AoCU.LiveResolverCache, $5f33fe4387abf05f$var$RELAY_RESOLVER_LIVE_STATE_SUBSCRIPTION_KEY = $9AoCU.RELAY_RESOLVER_LIVE_STATE_SUBSCRIPTION_KEY, $5f33fe4387abf05f$var$getUpdatedDataIDs = $9AoCU.getUpdatedDataIDs;

var $bQThX = parcelRequire("bQThX");
var $5f33fe4387abf05f$var$DEFAULT_RELEASE_BUFFER_SIZE = 10;
var $5f33fe4387abf05f$var$LiveResolverStore = /*#__PURE__*/ function() {
    function LiveResolverStore(source, options) {
        var _this = this;
        var _options$gcReleaseBuf, _options$gcScheduler, _options$getDataID, _options$log, _options$operationLoa, _options$treatMissing, _options$shouldProces;
        (0, $5f33fe4387abf05f$var$_defineProperty2["default"])(this, "_gcStep", function() {
            if (_this._gcRun) {
                if (_this._gcRun.next().done) _this._gcRun = null;
                else _this._gcScheduler(_this._gcStep);
            }
        });
        var storeIDs, ii, record;
        this._currentWriteEpoch = 0;
        this._gcHoldCounter = 0;
        this._gcReleaseBufferSize = (_options$gcReleaseBuf = options === null || options === void 0 ? void 0 : options.gcReleaseBufferSize) !== null && _options$gcReleaseBuf !== void 0 ? _options$gcReleaseBuf : $5f33fe4387abf05f$var$DEFAULT_RELEASE_BUFFER_SIZE;
        this._gcRun = null;
        this._gcScheduler = (_options$gcScheduler = options === null || options === void 0 ? void 0 : options.gcScheduler) !== null && _options$gcScheduler !== void 0 ? _options$gcScheduler : $8yHCQ;
        this._getDataID = (_options$getDataID = options === null || options === void 0 ? void 0 : options.getDataID) !== null && _options$getDataID !== void 0 ? _options$getDataID : $eGOdg;
        this._globalInvalidationEpoch = null;
        this._invalidationSubscriptions = new Set();
        this._invalidatedRecordIDs = new Set();
        this.__log = (_options$log = options === null || options === void 0 ? void 0 : options.log) !== null && _options$log !== void 0 ? _options$log : null;
        this._queryCacheExpirationTime = options === null || options === void 0 ? void 0 : options.queryCacheExpirationTime;
        this._operationLoader = (_options$operationLoa = options === null || options === void 0 ? void 0 : options.operationLoader) !== null && _options$operationLoa !== void 0 ? _options$operationLoa : null;
        this._optimisticSource = null;
        this._recordSource = source;
        this._releaseBuffer = [];
        this._roots = new Map();
        this._shouldScheduleGC = false;
        this._resolverCache = new $5f33fe4387abf05f$var$LiveResolverCache(function() {
            return _this._getMutableRecordSource();
        }, this);
        this._storeSubscriptions = new $7sSWY(options === null || options === void 0 ? void 0 : options.log, this._resolverCache);
        this._updatedRecordIDs = new Set();
        this._treatMissingFieldsAsNull = (_options$treatMissing = options === null || options === void 0 ? void 0 : options.treatMissingFieldsAsNull) !== null && _options$treatMissing !== void 0 ? _options$treatMissing : false;
        this._actorIdentifier = options === null || options === void 0 ? void 0 : options.actorIdentifier;
        this._shouldProcessClientComponents = (_options$shouldProces = options === null || options === void 0 ? void 0 : options.shouldProcessClientComponents) !== null && _options$shouldProces !== void 0 ? _options$shouldProces : false;
        $5f33fe4387abf05f$var$initializeRecordSource(this._recordSource);
    }
    var _proto = LiveResolverStore.prototype;
    _proto.getSource = function getSource() {
        var _this$_optimisticSour;
        return (_this$_optimisticSour = this._optimisticSource) !== null && _this$_optimisticSour !== void 0 ? _this$_optimisticSour : this._recordSource;
    };
    _proto._getMutableRecordSource = function _getMutableRecordSource() {
        var _this$_optimisticSour2;
        return (_this$_optimisticSour2 = this._optimisticSource) !== null && _this$_optimisticSour2 !== void 0 ? _this$_optimisticSour2 : this._recordSource;
    };
    _proto.getLiveResolverPromise = function getLiveResolverPromise(recordID) {
        return this._resolverCache.getLiveResolverPromise(recordID);
    };
    _proto.batchLiveStateUpdates = function batchLiveStateUpdates(callback) {
        if (this.__log != null) this.__log({
            name: 'liveresolver.batch.start'
        });
        try {
            this._resolverCache.batchLiveStateUpdates(callback);
        } finally{
            if (this.__log != null) this.__log({
                name: 'liveresolver.batch.end'
            });
        }
    };
    _proto.check = function check(operation, options) {
        var _options$handlers, _options$getSourceFor, _options$getTargetFor, _options$defaultActor;
        var selector = operation.root;
        var source = this._getMutableRecordSource();
        var globalInvalidationEpoch = this._globalInvalidationEpoch;
        var rootEntry = this._roots.get(operation.request.identifier);
        var operationLastWrittenAt = rootEntry != null ? rootEntry.epoch : null;
        if (globalInvalidationEpoch != null) {
            if (operationLastWrittenAt == null || operationLastWrittenAt <= globalInvalidationEpoch) return {
                status: 'stale'
            };
        }
        var handlers = (_options$handlers = options === null || options === void 0 ? void 0 : options.handlers) !== null && _options$handlers !== void 0 ? _options$handlers : [];
        var getSourceForActor = (_options$getSourceFor = options === null || options === void 0 ? void 0 : options.getSourceForActor) !== null && _options$getSourceFor !== void 0 ? _options$getSourceFor : function(actorIdentifier) {
            $5f33fe4387abf05f$var$assertInternalActorIdentifier(actorIdentifier);
            return source;
        };
        var getTargetForActor = (_options$getTargetFor = options === null || options === void 0 ? void 0 : options.getTargetForActor) !== null && _options$getTargetFor !== void 0 ? _options$getTargetFor : function(actorIdentifier) {
            $5f33fe4387abf05f$var$assertInternalActorIdentifier(actorIdentifier);
            return source;
        };
        var operationAvailability = $5wm2f.check(getSourceForActor, getTargetForActor, (_options$defaultActor = options === null || options === void 0 ? void 0 : options.defaultActorIdentifier) !== null && _options$defaultActor !== void 0 ? _options$defaultActor : $5f33fe4387abf05f$var$INTERNAL_ACTOR_IDENTIFIER_DO_NOT_USE, selector, handlers, this._operationLoader, this._getDataID, this._shouldProcessClientComponents);
        return $5f33fe4387abf05f$var$getAvailabilityStatus(operationAvailability, operationLastWrittenAt, rootEntry === null || rootEntry === void 0 ? void 0 : rootEntry.fetchTime, this._queryCacheExpirationTime);
    };
    _proto.retain = function retain(operation) {
        var _this2 = this;
        var id = operation.request.identifier;
        var disposed = false;
        var dispose = function dispose() {
            if (disposed) return;
            disposed = true;
            var rootEntry = _this2._roots.get(id);
            if (rootEntry == null) return;
            rootEntry.refCount--;
            if (rootEntry.refCount === 0) {
                var _queryCacheExpirationTime = _this2._queryCacheExpirationTime;
                var rootEntryIsStale = rootEntry.fetchTime != null && _queryCacheExpirationTime != null && rootEntry.fetchTime <= Date.now() - _queryCacheExpirationTime;
                if (rootEntryIsStale) {
                    _this2._roots["delete"](id);
                    _this2.scheduleGC();
                } else {
                    _this2._releaseBuffer.push(id);
                    if (_this2._releaseBuffer.length > _this2._gcReleaseBufferSize) {
                        var _id = _this2._releaseBuffer.shift();
                        _this2._roots["delete"](_id);
                        _this2.scheduleGC();
                    }
                }
            }
        };
        var rootEntry = this._roots.get(id);
        if (rootEntry != null) {
            if (rootEntry.refCount === 0) this._releaseBuffer = this._releaseBuffer.filter(function(_id) {
                return _id !== id;
            });
            rootEntry.refCount += 1;
        } else this._roots.set(id, {
            operation: operation,
            refCount: 1,
            epoch: null,
            fetchTime: null
        });
        return {
            dispose: dispose
        };
    };
    _proto.lookup = function lookup(selector) {
        var source = this.getSource();
        var snapshot = $2Nqi8.read(source, selector, this._resolverCache);
        return snapshot;
    };
    _proto.notify = function notify(sourceOperation, invalidateStore) {
        var _this3 = this;
        var log = this.__log;
        if (log != null) log({
            name: 'store.notify.start',
            sourceOperation: sourceOperation
        });
        this._currentWriteEpoch++;
        if (invalidateStore === true) this._globalInvalidationEpoch = this._currentWriteEpoch;
        this._resolverCache.invalidateDataIDs(this._updatedRecordIDs);
        var source = this.getSource();
        var updatedOwners = [];
        this._storeSubscriptions.updateSubscriptions(source, this._updatedRecordIDs, updatedOwners, sourceOperation);
        this._invalidationSubscriptions.forEach(function(subscription) {
            _this3._updateInvalidationSubscription(subscription, invalidateStore === true);
        });
        if (log != null) log({
            name: 'store.notify.complete',
            sourceOperation: sourceOperation,
            updatedRecordIDs: this._updatedRecordIDs,
            invalidatedRecordIDs: this._invalidatedRecordIDs
        });
        this._updatedRecordIDs.clear();
        this._invalidatedRecordIDs.clear();
        if (sourceOperation != null) {
            var id = sourceOperation.request.identifier;
            var rootEntry = this._roots.get(id);
            if (rootEntry != null) {
                rootEntry.epoch = this._currentWriteEpoch;
                rootEntry.fetchTime = Date.now();
            } else if (sourceOperation.request.node.params.operationKind === 'query' && this._gcReleaseBufferSize > 0 && this._releaseBuffer.length < this._gcReleaseBufferSize) {
                var temporaryRootEntry = {
                    operation: sourceOperation,
                    refCount: 0,
                    epoch: this._currentWriteEpoch,
                    fetchTime: Date.now()
                };
                this._releaseBuffer.push(id);
                this._roots.set(id, temporaryRootEntry);
            }
        }
        return updatedOwners;
    };
    _proto.publish = function publish(source, idsMarkedForInvalidation) {
        var target = this._getMutableRecordSource();
        $5f33fe4387abf05f$var$updateTargetFromSource(target, source, this._currentWriteEpoch + 1, idsMarkedForInvalidation, this._updatedRecordIDs, this._invalidatedRecordIDs);
        var log = this.__log;
        if (log != null) log({
            name: 'store.publish',
            source: source,
            optimistic: target === this._optimisticSource
        });
    };
    _proto.subscribe = function subscribe(snapshot, callback) {
        return this._storeSubscriptions.subscribe(snapshot, callback);
    };
    _proto.holdGC = function holdGC() {
        var _this4 = this;
        if (this._gcRun) {
            this._gcRun = null;
            this._shouldScheduleGC = true;
        }
        this._gcHoldCounter++;
        var dispose = function dispose() {
            if (_this4._gcHoldCounter > 0) {
                _this4._gcHoldCounter--;
                if (_this4._gcHoldCounter === 0 && _this4._shouldScheduleGC) {
                    _this4.scheduleGC();
                    _this4._shouldScheduleGC = false;
                }
            }
        };
        return {
            dispose: dispose
        };
    };
    _proto.toJSON = function toJSON() {
        return 'LiveResolverStore()';
    };
    _proto.getEpoch = function getEpoch() {
        return this._currentWriteEpoch;
    };
    _proto.__getUpdatedRecordIDs = function __getUpdatedRecordIDs() {
        return this._updatedRecordIDs;
    };
    _proto.lookupInvalidationState = function lookupInvalidationState(dataIDs) {
        var _this5 = this;
        var invalidations = new Map();
        dataIDs.forEach(function(dataID) {
            var _RelayModernRecord$ge;
            var record = _this5.getSource().get(dataID);
            invalidations.set(dataID, (_RelayModernRecord$ge = $c4ZG3.getInvalidationEpoch(record)) !== null && _RelayModernRecord$ge !== void 0 ? _RelayModernRecord$ge : null);
        });
        invalidations.set('global', this._globalInvalidationEpoch);
        var invalidationState = {
            dataIDs: dataIDs,
            invalidations: invalidations
        };
        return invalidationState;
    };
    _proto.checkInvalidationState = function checkInvalidationState(prevInvalidationState) {
        var latestInvalidationState = this.lookupInvalidationState(prevInvalidationState.dataIDs);
        var currentInvalidations = latestInvalidationState.invalidations;
        var prevInvalidations = prevInvalidationState.invalidations;
        if (currentInvalidations.get('global') !== prevInvalidations.get('global')) return true;
        var _iterator = (0, $5f33fe4387abf05f$var$_createForOfIteratorHelper2["default"])(prevInvalidationState.dataIDs), _step;
        try {
            for(_iterator.s(); !(_step = _iterator.n()).done;){
                var dataID = _step.value;
                if (currentInvalidations.get(dataID) !== prevInvalidations.get(dataID)) return true;
            }
        } catch (err) {
            _iterator.e(err);
        } finally{
            _iterator.f();
        }
        return false;
    };
    _proto.subscribeToInvalidationState = function subscribeToInvalidationState(invalidationState, callback) {
        var _this6 = this;
        var subscription = {
            callback: callback,
            invalidationState: invalidationState
        };
        var dispose = function dispose() {
            _this6._invalidationSubscriptions["delete"](subscription);
        };
        this._invalidationSubscriptions.add(subscription);
        return {
            dispose: dispose
        };
    };
    _proto._updateInvalidationSubscription = function _updateInvalidationSubscription(subscription, invalidatedStore) {
        var _this7 = this;
        var callback = subscription.callback, invalidationState = subscription.invalidationState;
        var dataIDs = invalidationState.dataIDs;
        var isSubscribedToInvalidatedIDs = invalidatedStore || dataIDs.some(function(dataID) {
            return _this7._invalidatedRecordIDs.has(dataID);
        });
        if (!isSubscribedToInvalidatedIDs) return;
        callback();
    };
    _proto.snapshot = function snapshot() {
        !(this._optimisticSource == null) && $bQThX(false);
        var log = this.__log;
        if (log != null) log({
            name: 'store.snapshot'
        });
        this._storeSubscriptions.snapshotSubscriptions(this.getSource());
        if (this._gcRun) {
            this._gcRun = null;
            this._shouldScheduleGC = true;
        }
        this._optimisticSource = $hprpJ.create(this.getSource());
    };
    _proto.restore = function restore() {
        var optimisticSource = this._optimisticSource;
        !optimisticSource && $bQThX(false);
        var log = this.__log;
        if (log != null) log({
            name: 'store.restore'
        });
        var optimisticIDs = $hprpJ.getOptimisticRecordIDs(optimisticSource);
        this._resolverCache.unsubscribeFromLiveResolverRecords(optimisticIDs);
        this._optimisticSource = null;
        if (this._shouldScheduleGC) this.scheduleGC();
        this._storeSubscriptions.restoreSubscriptions();
        this._resolverCache.invalidateResolverRecords(optimisticIDs);
    };
    _proto.scheduleGC = function scheduleGC() {
        if (this._gcHoldCounter > 0) {
            this._shouldScheduleGC = true;
            return;
        }
        if (this._gcRun) return;
        this._gcRun = this._collect();
        this._gcScheduler(this._gcStep);
    };
    _proto.__gc = function __gc() {
        if (this._optimisticSource != null) return;
        var gcRun = this._collect();
        while(!gcRun.next().done);
    };
    _proto._collect = function* _collect() {
        top: while(true){
            var startEpoch = this._currentWriteEpoch;
            var references = new Set();
            var _iterator2 = (0, $5f33fe4387abf05f$var$_createForOfIteratorHelper2["default"])(this._roots.values()), _step2;
            try {
                for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
                    var operation = _step2.value.operation;
                    var selector = operation.root;
                    $b7ANd.mark(this._recordSource, selector, references, this._operationLoader, this._shouldProcessClientComponents);
                    yield;
                    if (startEpoch !== this._currentWriteEpoch) continue top;
                }
            } catch (err) {
                _iterator2.e(err);
            } finally{
                _iterator2.f();
            }
            var log = this.__log;
            if (log != null) log({
                name: 'store.gc',
                references: references
            });
            if (references.size === 0) this._recordSource.clear();
            else {
                var storeIDs = this._recordSource.getRecordIDs();
                for(var ii = 0; ii < storeIDs.length; ii++){
                    var dataID = storeIDs[ii];
                    if (!references.has(dataID)) {
                        var record = this._recordSource.get(dataID);
                        if (record != null) {
                            var maybeResolverSubscription = $c4ZG3.getValue(record, $5f33fe4387abf05f$var$RELAY_RESOLVER_LIVE_STATE_SUBSCRIPTION_KEY);
                            if (maybeResolverSubscription != null) maybeResolverSubscription();
                        }
                        this._recordSource.remove(dataID);
                    }
                }
            }
            return;
        }
    };
    _proto.__getNormalizationOptions = function __getNormalizationOptions(path) {
        return {
            path: path,
            getDataID: this._getDataID,
            treatMissingFieldsAsNull: this._treatMissingFieldsAsNull,
            shouldProcessClientComponents: this._shouldProcessClientComponents,
            actorIdentifier: this._actorIdentifier
        };
    };
    _proto.__notifyUpdatedSubscribers = function __notifyUpdatedSubscribers(updatedRecords) {
        var nextUpdatedRecordIDs = $5f33fe4387abf05f$var$getUpdatedDataIDs(updatedRecords);
        var prevUpdatedRecordIDs = this._updatedRecordIDs;
        this._updatedRecordIDs = nextUpdatedRecordIDs;
        this.notify();
        this._updatedRecordIDs = prevUpdatedRecordIDs;
    };
    return LiveResolverStore;
}();
function $5f33fe4387abf05f$var$initializeRecordSource(target) {
    if (!target.has($5f33fe4387abf05f$var$ROOT_ID)) {
        var rootRecord = $c4ZG3.create($5f33fe4387abf05f$var$ROOT_ID, $5f33fe4387abf05f$var$ROOT_TYPE);
        target.set($5f33fe4387abf05f$var$ROOT_ID, rootRecord);
    }
}
function $5f33fe4387abf05f$var$updateTargetFromSource(target, source, currentWriteEpoch, idsMarkedForInvalidation, updatedRecordIDs, invalidatedRecordIDs) {
    if (idsMarkedForInvalidation) idsMarkedForInvalidation.forEach(function(dataID) {
        var targetRecord = target.get(dataID);
        var sourceRecord = source.get(dataID);
        if (sourceRecord === null) return;
        var nextRecord;
        if (targetRecord != null) nextRecord = $c4ZG3.clone(targetRecord);
        else nextRecord = sourceRecord != null ? $c4ZG3.clone(sourceRecord) : null;
        if (!nextRecord) return;
        $c4ZG3.setValue(nextRecord, $a6k4O.INVALIDATED_AT_KEY, currentWriteEpoch);
        invalidatedRecordIDs.add(dataID);
        target.set(dataID, nextRecord);
    });
    var dataIDs = source.getRecordIDs();
    for(var ii = 0; ii < dataIDs.length; ii++){
        var dataID = dataIDs[ii];
        var sourceRecord = source.get(dataID);
        var targetRecord = target.get(dataID);
        if (sourceRecord && targetRecord) {
            var nextRecord = $c4ZG3.update(targetRecord, sourceRecord);
            if (nextRecord !== targetRecord) {
                updatedRecordIDs.add(dataID);
                target.set(dataID, nextRecord);
            }
        } else if (sourceRecord === null) {
            target["delete"](dataID);
            if (targetRecord !== null) updatedRecordIDs.add(dataID);
        } else if (sourceRecord) {
            target.set(dataID, sourceRecord);
            updatedRecordIDs.add(dataID);
        }
    }
}
function $5f33fe4387abf05f$var$getAvailabilityStatus(operationAvailability, operationLastWrittenAt, operationFetchTime, queryCacheExpirationTime) {
    var mostRecentlyInvalidatedAt = operationAvailability.mostRecentlyInvalidatedAt, status = operationAvailability.status;
    if (typeof mostRecentlyInvalidatedAt === 'number') {
        if (operationLastWrittenAt == null || mostRecentlyInvalidatedAt > operationLastWrittenAt) return {
            status: 'stale'
        };
    }
    if (status === 'missing') return {
        status: 'missing'
    };
    if (operationFetchTime != null && queryCacheExpirationTime != null) {
        var isStale = operationFetchTime <= Date.now() - queryCacheExpirationTime;
        if (isStale) return {
            status: 'stale'
        };
    }
    return {
        status: 'available',
        fetchTime: operationFetchTime !== null && operationFetchTime !== void 0 ? operationFetchTime : null
    };
}
module.exports = $5f33fe4387abf05f$var$LiveResolverStore;

});
parcelRegister("9AoCU", function(module, exports) {
'use strict';

var $7dvyf = parcelRequire("7dvyf");
var $6faa942e11b73f2c$var$_interopRequireDefault = $7dvyf.default;

var $6faa942e11b73f2c$var$_createForOfIteratorHelper2 = $6faa942e11b73f2c$var$_interopRequireDefault((parcelRequire("bTRzt")));

var $hrF5e = parcelRequire("hrF5e");

var $9lZfN = parcelRequire("9lZfN");
var $6faa942e11b73f2c$var$RELAY_LIVE_RESOLVER = $9lZfN.RELAY_LIVE_RESOLVER;

var $9DZlA = parcelRequire("9DZlA");

var $bAYfv = parcelRequire("bAYfv");

var $70q7x = parcelRequire("70q7x");
var $6faa942e11b73f2c$var$generateClientID = $70q7x.generateClientID, $6faa942e11b73f2c$var$generateClientObjectClientID = $70q7x.generateClientObjectClientID;

var $c4ZG3 = parcelRequire("c4ZG3");

var $3o9ph = parcelRequire("3o9ph");
var $6faa942e11b73f2c$var$createNormalizationSelector = $3o9ph.createNormalizationSelector;

var $fWVgk = parcelRequire("fWVgk");

var $80YOC = parcelRequire("80YOC");
var $6faa942e11b73f2c$var$normalize = $80YOC.normalize;

var $a6k4O = parcelRequire("a6k4O");
var $6faa942e11b73f2c$var$RELAY_RESOLVER_ERROR_KEY = $a6k4O.RELAY_RESOLVER_ERROR_KEY, $6faa942e11b73f2c$var$RELAY_RESOLVER_INVALIDATION_KEY = $a6k4O.RELAY_RESOLVER_INVALIDATION_KEY, $6faa942e11b73f2c$var$RELAY_RESOLVER_OUTPUT_TYPE_RECORD_IDS = $a6k4O.RELAY_RESOLVER_OUTPUT_TYPE_RECORD_IDS, $6faa942e11b73f2c$var$RELAY_RESOLVER_SNAPSHOT_KEY = $a6k4O.RELAY_RESOLVER_SNAPSHOT_KEY, $6faa942e11b73f2c$var$RELAY_RESOLVER_VALUE_KEY = $a6k4O.RELAY_RESOLVER_VALUE_KEY, $6faa942e11b73f2c$var$getStorageKey = $a6k4O.getStorageKey;

var $2EioI = parcelRequire("2EioI");

var $32h0Y = parcelRequire("32h0Y");

var $gXI8O = parcelRequire("gXI8O");
var $6faa942e11b73f2c$var$isSuspenseSentinel = $gXI8O.isSuspenseSentinel;

var $bQThX = parcelRequire("bQThX");
parcelRequire("hzw7m");
var $6faa942e11b73f2c$var$RELAY_RESOLVER_LIVE_STATE_SUBSCRIPTION_KEY = '__resolverLiveStateSubscription';
var $6faa942e11b73f2c$var$RELAY_RESOLVER_LIVE_STATE_VALUE = '__resolverLiveStateValue';
var $6faa942e11b73f2c$var$RELAY_RESOLVER_LIVE_STATE_DIRTY = '__resolverLiveStateDirty';
var $6faa942e11b73f2c$var$RELAY_RESOLVER_RECORD_TYPENAME = '__RELAY_RESOLVER__';
var $6faa942e11b73f2c$var$MODEL_PROPERTY_NAME = '__relay_model_instance';
function $6faa942e11b73f2c$var$addDependencyEdge(edges, from, to) {
    var set = edges.get(from);
    if (!set) {
        set = new Set();
        edges.set(from, set);
    }
    set.add(to);
}
var $6faa942e11b73f2c$var$LiveResolverCache = /*#__PURE__*/ function() {
    function LiveResolverCache(getRecordSource, store) {
        this._resolverIDToRecordIDs = new Map();
        this._recordIDToResolverIDs = new Map();
        this._getRecordSource = getRecordSource;
        this._store = store;
        this._handlingBatch = false;
        this._liveResolverBatchRecordSource = null;
    }
    var _proto = LiveResolverCache.prototype;
    _proto.readFromCacheOrEvaluate = function readFromCacheOrEvaluate(recordID, field, variables, evaluate, getDataForResolverFragment) {
        var recordSource = this._getRecordSource();
        var record = $6faa942e11b73f2c$var$expectRecord(recordSource, recordID);
        var storageKey = $6faa942e11b73f2c$var$getStorageKey(field, variables);
        var linkedID = $c4ZG3.getLinkedRecordID(record, storageKey);
        var linkedRecord = linkedID == null ? null : recordSource.get(linkedID);
        var updatedDataIDs;
        if (linkedRecord == null || this._isInvalid(linkedRecord, getDataForResolverFragment)) {
            var _linkedID;
            if (linkedRecord != null) $6faa942e11b73f2c$var$maybeUnsubscribeFromLiveState(linkedRecord);
            linkedID = (_linkedID = linkedID) !== null && _linkedID !== void 0 ? _linkedID : $6faa942e11b73f2c$var$generateClientID(recordID, storageKey);
            linkedRecord = $c4ZG3.create(linkedID, $6faa942e11b73f2c$var$RELAY_RESOLVER_RECORD_TYPENAME);
            var evaluationResult = evaluate();
            $c4ZG3.setValue(linkedRecord, $6faa942e11b73f2c$var$RELAY_RESOLVER_SNAPSHOT_KEY, evaluationResult.snapshot);
            $c4ZG3.setValue(linkedRecord, $6faa942e11b73f2c$var$RELAY_RESOLVER_ERROR_KEY, evaluationResult.error);
            if (field.kind === $6faa942e11b73f2c$var$RELAY_LIVE_RESOLVER) {
                if (evaluationResult.resolverResult != null) {
                    !(evaluationResult.error == null) && $bQThX(false);
                    var liveState = evaluationResult.resolverResult;
                    updatedDataIDs = this._setLiveStateValue(linkedRecord, linkedID, liveState, field, variables);
                } else var _evaluationResult$sna;
            } else updatedDataIDs = this._setResolverValue(linkedRecord, evaluationResult.resolverResult, field, variables);
            recordSource.set(linkedID, linkedRecord);
            var currentRecord = $6faa942e11b73f2c$var$expectRecord(recordSource, recordID);
            var nextRecord = $c4ZG3.clone(currentRecord);
            $c4ZG3.setLinkedRecordID(nextRecord, storageKey, linkedID);
            recordSource.set(recordID, nextRecord);
            if (field.fragment != null) {
                var _evaluationResult$sna2;
                var fragmentStorageKey = $6faa942e11b73f2c$var$getStorageKey(field.fragment, variables);
                var resolverID = $6faa942e11b73f2c$var$generateClientID(recordID, fragmentStorageKey);
                $6faa942e11b73f2c$var$addDependencyEdge(this._resolverIDToRecordIDs, resolverID, linkedID);
                $6faa942e11b73f2c$var$addDependencyEdge(this._recordIDToResolverIDs, recordID, resolverID);
                var seenRecordIds = (_evaluationResult$sna2 = evaluationResult.snapshot) === null || _evaluationResult$sna2 === void 0 ? void 0 : _evaluationResult$sna2.seenRecords;
                if (seenRecordIds != null) {
                    var _iterator = (0, $6faa942e11b73f2c$var$_createForOfIteratorHelper2["default"])(seenRecordIds), _step;
                    try {
                        for(_iterator.s(); !(_step = _iterator.n()).done;){
                            var seenRecordID = _step.value;
                            $6faa942e11b73f2c$var$addDependencyEdge(this._recordIDToResolverIDs, seenRecordID, resolverID);
                        }
                    } catch (err) {
                        _iterator.e(err);
                    } finally{
                        _iterator.f();
                    }
                }
            }
        } else if (field.kind === $6faa942e11b73f2c$var$RELAY_LIVE_RESOLVER && $c4ZG3.getValue(linkedRecord, $6faa942e11b73f2c$var$RELAY_RESOLVER_LIVE_STATE_DIRTY)) {
            var _linkedID2;
            linkedID = (_linkedID2 = linkedID) !== null && _linkedID2 !== void 0 ? _linkedID2 : $6faa942e11b73f2c$var$generateClientID(recordID, storageKey);
            linkedRecord = $c4ZG3.clone(linkedRecord);
            var _liveState = $c4ZG3.getValue(linkedRecord, $6faa942e11b73f2c$var$RELAY_RESOLVER_LIVE_STATE_VALUE);
            if (!$32h0Y(_liveState)) $bQThX(false);
            updatedDataIDs = this._setLiveResolverValue(linkedRecord, _liveState, field, variables);
            $c4ZG3.setValue(linkedRecord, $6faa942e11b73f2c$var$RELAY_RESOLVER_LIVE_STATE_DIRTY, false);
            recordSource.set(linkedID, linkedRecord);
        }
        var answer = this._getResolverValue(linkedRecord);
        var snapshot = $c4ZG3.getValue(linkedRecord, $6faa942e11b73f2c$var$RELAY_RESOLVER_SNAPSHOT_KEY);
        var error = $c4ZG3.getValue(linkedRecord, $6faa942e11b73f2c$var$RELAY_RESOLVER_ERROR_KEY);
        var suspenseID = null;
        if ($6faa942e11b73f2c$var$isSuspenseSentinel(answer)) {
            var _linkedID3;
            suspenseID = (_linkedID3 = linkedID) !== null && _linkedID3 !== void 0 ? _linkedID3 : $6faa942e11b73f2c$var$generateClientID(recordID, storageKey);
        }
        return [
            answer,
            linkedID,
            error,
            snapshot,
            suspenseID,
            updatedDataIDs
        ];
    };
    _proto.getLiveResolverPromise = function getLiveResolverPromise(liveStateID) {
        var recordSource = this._getRecordSource();
        var liveStateRecord = recordSource.get(liveStateID);
        !(liveStateRecord != null) && $bQThX(false);
        var liveState = $c4ZG3.getValue(liveStateRecord, $6faa942e11b73f2c$var$RELAY_RESOLVER_LIVE_STATE_VALUE);
        return new Promise(function(resolve) {
            var unsubscribe = liveState.subscribe(function() {
                unsubscribe();
                resolve();
            });
        });
    };
    _proto._setLiveStateValue = function _setLiveStateValue(linkedRecord, linkedID, liveState, field, variables) {
        var handler = this._makeLiveStateHandler(linkedID);
        var unsubscribe = liveState.subscribe(handler);
        $c4ZG3.setValue(linkedRecord, $6faa942e11b73f2c$var$RELAY_RESOLVER_LIVE_STATE_VALUE, liveState);
        var updatedDataIDs = this._setLiveResolverValue(linkedRecord, liveState, field, variables);
        $c4ZG3.setValue(linkedRecord, $6faa942e11b73f2c$var$RELAY_RESOLVER_LIVE_STATE_DIRTY, false);
        $c4ZG3.setValue(linkedRecord, $6faa942e11b73f2c$var$RELAY_RESOLVER_LIVE_STATE_SUBSCRIPTION_KEY, unsubscribe);
        return updatedDataIDs;
    };
    _proto._makeLiveStateHandler = function _makeLiveStateHandler(linkedID) {
        var _this = this;
        return function() {
            var currentSource = _this._getRecordSource();
            var currentRecord = currentSource.get(linkedID);
            if (!currentRecord) return;
            if (!$c4ZG3.hasValue(currentRecord, $6faa942e11b73f2c$var$RELAY_RESOLVER_LIVE_STATE_VALUE)) return;
            var nextRecord = $c4ZG3.clone(currentRecord);
            $c4ZG3.setValue(nextRecord, $6faa942e11b73f2c$var$RELAY_RESOLVER_LIVE_STATE_DIRTY, true);
            _this._setLiveResolverUpdate(linkedID, nextRecord);
        };
    };
    _proto._setLiveResolverUpdate = function _setLiveResolverUpdate(linkedId, record) {
        if (this._handlingBatch) {
            if (this._liveResolverBatchRecordSource == null) this._liveResolverBatchRecordSource = $fWVgk.create();
            this._liveResolverBatchRecordSource.set(linkedId, record);
        } else {
            var nextSource = $fWVgk.create();
            nextSource.set(linkedId, record);
            this._store.publish(nextSource);
            this._store.notify();
        }
    };
    _proto.batchLiveStateUpdates = function batchLiveStateUpdates(callback) {
        !!this._handlingBatch && $bQThX(false);
        this._handlingBatch = true;
        try {
            callback();
        } finally{
            if (this._liveResolverBatchRecordSource != null) {
                this._store.publish(this._liveResolverBatchRecordSource);
                this._store.notify();
            }
            this._liveResolverBatchRecordSource = null;
            this._handlingBatch = false;
        }
    };
    _proto._setLiveResolverValue = function _setLiveResolverValue(resolverRecord, liveValue, field, variables) {
        var value = null;
        var resolverError = null;
        try {
            value = liveValue.read();
        } catch (e) {
            resolverError = e;
        }
        $c4ZG3.setValue(resolverRecord, $6faa942e11b73f2c$var$RELAY_RESOLVER_ERROR_KEY, resolverError);
        return this._setResolverValue(resolverRecord, value, field, variables);
    };
    _proto._setResolverValue = function _setResolverValue(resolverRecord, value, field, variables) {
        var normalizationInfo = field.normalizationInfo;
        var updatedDataIDs = null;
        if (value != null && normalizationInfo != null && !$6faa942e11b73f2c$var$isSuspenseSentinel(value)) {
            var resolverValue;
            var prevOutputTypeRecordIDs = $2EioI(resolverRecord);
            var nextOutputTypeRecordIDs = new Set();
            var currentSource = this._getRecordSource();
            if (normalizationInfo.plural) {
                !Array.isArray(value) && $bQThX(false);
                resolverValue = [];
                var nextSource = $fWVgk.create();
                for(var ii = 0; ii < value.length; ii++){
                    var currentValue = value[ii];
                    if (currentValue == null) continue;
                    !(typeof currentValue === 'object') && $bQThX(false);
                    var typename = $6faa942e11b73f2c$var$getConcreteTypename(normalizationInfo, currentValue);
                    var outputTypeDataID = $6faa942e11b73f2c$var$generateClientObjectClientID(typename, $c4ZG3.getDataID(resolverRecord), ii);
                    var source = this._normalizeOutputTypeValue(outputTypeDataID, currentValue, variables, normalizationInfo, [
                        field.path,
                        String(ii)
                    ], typename);
                    var _iterator2 = (0, $6faa942e11b73f2c$var$_createForOfIteratorHelper2["default"])(source.getRecordIDs()), _step2;
                    try {
                        for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
                            var recordID = _step2.value;
                            nextSource.set(recordID, $6faa942e11b73f2c$var$expectRecord(source, recordID));
                            nextOutputTypeRecordIDs.add(recordID);
                        }
                    } catch (err) {
                        _iterator2.e(err);
                    } finally{
                        _iterator2.f();
                    }
                    resolverValue.push(outputTypeDataID);
                }
                updatedDataIDs = $6faa942e11b73f2c$var$updateCurrentSource(currentSource, nextSource, prevOutputTypeRecordIDs);
            } else {
                !(typeof value === 'object') && $bQThX(false);
                var _typename = $6faa942e11b73f2c$var$getConcreteTypename(normalizationInfo, value);
                var _outputTypeDataID = $6faa942e11b73f2c$var$generateClientObjectClientID(_typename, $c4ZG3.getDataID(resolverRecord));
                var _nextSource = this._normalizeOutputTypeValue(_outputTypeDataID, value, variables, normalizationInfo, [
                    field.path
                ], _typename);
                var _iterator3 = (0, $6faa942e11b73f2c$var$_createForOfIteratorHelper2["default"])(_nextSource.getRecordIDs()), _step3;
                try {
                    for(_iterator3.s(); !(_step3 = _iterator3.n()).done;){
                        var _recordID = _step3.value;
                        nextOutputTypeRecordIDs.add(_recordID);
                    }
                } catch (err) {
                    _iterator3.e(err);
                } finally{
                    _iterator3.f();
                }
                resolverValue = _outputTypeDataID;
                updatedDataIDs = $6faa942e11b73f2c$var$updateCurrentSource(currentSource, _nextSource, prevOutputTypeRecordIDs);
            }
            $c4ZG3.setValue(resolverRecord, $6faa942e11b73f2c$var$RELAY_RESOLVER_OUTPUT_TYPE_RECORD_IDS, nextOutputTypeRecordIDs);
            $bAYfv(resolverValue);
            $c4ZG3.setValue(resolverRecord, $6faa942e11b73f2c$var$RELAY_RESOLVER_VALUE_KEY, resolverValue);
        } else {
            $bAYfv(value);
            $c4ZG3.setValue(resolverRecord, $6faa942e11b73f2c$var$RELAY_RESOLVER_VALUE_KEY, value);
        }
        return updatedDataIDs;
    };
    _proto.notifyUpdatedSubscribers = function notifyUpdatedSubscribers(updatedDataIDs) {
        this._store.__notifyUpdatedSubscribers(updatedDataIDs);
    };
    _proto._getResolverValue = function _getResolverValue(resolverRecord) {
        return $c4ZG3.getValue(resolverRecord, $6faa942e11b73f2c$var$RELAY_RESOLVER_VALUE_KEY);
    };
    _proto.invalidateDataIDs = function invalidateDataIDs(updatedDataIDs) {
        var recordSource = this._getRecordSource();
        var visited = new Set();
        var recordsToVisit = Array.from(updatedDataIDs);
        while(recordsToVisit.length){
            var recordID = recordsToVisit.pop();
            updatedDataIDs.add(recordID);
            var fragmentSet = this._recordIDToResolverIDs.get(recordID);
            if (fragmentSet == null) continue;
            var _iterator4 = (0, $6faa942e11b73f2c$var$_createForOfIteratorHelper2["default"])(fragmentSet), _step4;
            try {
                for(_iterator4.s(); !(_step4 = _iterator4.n()).done;){
                    var fragment = _step4.value;
                    if (!visited.has(fragment)) {
                        var recordSet = this._resolverIDToRecordIDs.get(fragment);
                        if (recordSet == null) continue;
                        var _iterator5 = (0, $6faa942e11b73f2c$var$_createForOfIteratorHelper2["default"])(recordSet), _step5;
                        try {
                            for(_iterator5.s(); !(_step5 = _iterator5.n()).done;){
                                var anotherRecordID = _step5.value;
                                $6faa942e11b73f2c$var$markInvalidatedResolverRecord(anotherRecordID, recordSource);
                                if (!visited.has(anotherRecordID)) recordsToVisit.push(anotherRecordID);
                            }
                        } catch (err) {
                            _iterator5.e(err);
                        } finally{
                            _iterator5.f();
                        }
                    }
                }
            } catch (err) {
                _iterator4.e(err);
            } finally{
                _iterator4.f();
            }
        }
    };
    _proto._isInvalid = function _isInvalid(record, getDataForResolverFragment) {
        if (!$c4ZG3.getValue(record, $6faa942e11b73f2c$var$RELAY_RESOLVER_INVALIDATION_KEY)) return false;
        var snapshot = $c4ZG3.getValue(record, $6faa942e11b73f2c$var$RELAY_RESOLVER_SNAPSHOT_KEY);
        var originalInputs = snapshot === null || snapshot === void 0 ? void 0 : snapshot.data;
        var readerSelector = snapshot === null || snapshot === void 0 ? void 0 : snapshot.selector;
        if (originalInputs == null || readerSelector == null) return true;
        var _getDataForResolverFr = getDataForResolverFragment(readerSelector), latestValues = _getDataForResolverFr.data;
        var recycled = $hrF5e(originalInputs, latestValues);
        if (recycled !== originalInputs) return true;
        if ($9DZlA.MARK_RESOLVER_VALUES_AS_CLEAN_AFTER_FRAGMENT_REREAD) {
            var nextRecord = $c4ZG3.clone(record);
            $c4ZG3.setValue(nextRecord, $6faa942e11b73f2c$var$RELAY_RESOLVER_INVALIDATION_KEY, false);
            var recordSource = this._getRecordSource();
            recordSource.set($c4ZG3.getDataID(record), nextRecord);
        }
        return false;
    };
    _proto._normalizeOutputTypeValue = function _normalizeOutputTypeValue(outputTypeDataID, value, variables, normalizationInfo, fieldPath, typename) {
        var source = $fWVgk.create();
        switch(normalizationInfo.kind){
            case 'OutputType':
                var record = $c4ZG3.create(outputTypeDataID, typename);
                source.set(outputTypeDataID, record);
                var selector = $6faa942e11b73f2c$var$createNormalizationSelector(normalizationInfo.normalizationNode, outputTypeDataID, variables);
                var normalizationOptions = this._store.__getNormalizationOptions(fieldPath);
                return $6faa942e11b73f2c$var$normalize(source, selector, value, normalizationOptions).source;
            case 'WeakModel':
                var _record = $c4ZG3.create(outputTypeDataID, typename);
                $c4ZG3.setValue(_record, $6faa942e11b73f2c$var$MODEL_PROPERTY_NAME, value);
                source.set(outputTypeDataID, _record);
                return source;
            default:
                normalizationInfo.kind;
                $bQThX(false);
        }
    };
    _proto.ensureClientRecord = function ensureClientRecord(id, typeName) {
        var key = $6faa942e11b73f2c$var$generateClientObjectClientID(typeName, id);
        var recordSource = this._getRecordSource();
        if (!recordSource.has(key)) {
            var newRecord = $c4ZG3.create(key, typeName);
            $c4ZG3.setValue(newRecord, 'id', id);
            recordSource.set(key, newRecord);
        }
        return key;
    };
    _proto.unsubscribeFromLiveResolverRecords = function unsubscribeFromLiveResolverRecords(invalidatedDataIDs) {
        return $6faa942e11b73f2c$var$unsubscribeFromLiveResolverRecordsImpl(this._getRecordSource(), invalidatedDataIDs);
    };
    _proto.invalidateResolverRecords = function invalidateResolverRecords(invalidatedDataIDs) {
        if (invalidatedDataIDs.size === 0) return;
        var _iterator6 = (0, $6faa942e11b73f2c$var$_createForOfIteratorHelper2["default"])(invalidatedDataIDs), _step6;
        try {
            for(_iterator6.s(); !(_step6 = _iterator6.n()).done;){
                var dataID = _step6.value;
                var record = this._getRecordSource().get(dataID);
                if (record != null && $6faa942e11b73f2c$var$isResolverRecord(record)) this._getRecordSource()["delete"](dataID);
            }
        } catch (err) {
            _iterator6.e(err);
        } finally{
            _iterator6.f();
        }
    };
    return LiveResolverCache;
}();
function $6faa942e11b73f2c$var$updateCurrentSource(currentSource, nextSource, prevOutputTypeRecordIDs) {
    var updatedDataIDs = new Set();
    if (prevOutputTypeRecordIDs != null) {
        var _iterator7 = (0, $6faa942e11b73f2c$var$_createForOfIteratorHelper2["default"])(prevOutputTypeRecordIDs), _step7;
        try {
            for(_iterator7.s(); !(_step7 = _iterator7.n()).done;){
                var recordID = _step7.value;
                if (!nextSource.has(recordID)) {
                    updatedDataIDs.add(recordID);
                    currentSource.remove(recordID);
                }
            }
        } catch (err) {
            _iterator7.e(err);
        } finally{
            _iterator7.f();
        }
    }
    var _iterator8 = (0, $6faa942e11b73f2c$var$_createForOfIteratorHelper2["default"])(nextSource.getRecordIDs()), _step8;
    try {
        for(_iterator8.s(); !(_step8 = _iterator8.n()).done;){
            var _recordID2 = _step8.value;
            var nextRecord = $6faa942e11b73f2c$var$expectRecord(nextSource, _recordID2);
            if (currentSource.has(_recordID2)) {
                var currentRecord = $6faa942e11b73f2c$var$expectRecord(currentSource, _recordID2);
                var updatedRecord = $c4ZG3.update(currentRecord, nextRecord);
                if (updatedRecord !== currentRecord) {
                    updatedDataIDs.add(_recordID2);
                    currentSource.set(_recordID2, updatedRecord);
                    $6faa942e11b73f2c$var$markInvalidatedLinkedResolverRecords(currentRecord, currentSource);
                }
            } else currentSource.set(_recordID2, nextRecord);
        }
    } catch (err) {
        _iterator8.e(err);
    } finally{
        _iterator8.f();
    }
    return updatedDataIDs;
}
function $6faa942e11b73f2c$var$getAllLinkedRecordIds(record) {
    var linkedRecordIDs = new Set();
    $c4ZG3.getFields(record).forEach(function(field) {
        if ($c4ZG3.hasLinkedRecordID(record, field)) {
            var linkedRecordID = $c4ZG3.getLinkedRecordID(record, field);
            if (linkedRecordID != null) linkedRecordIDs.add(linkedRecordID);
        } else if ($c4ZG3.hasLinkedRecordIDs(record, field)) {
            var _RelayModernRecord$ge;
            (_RelayModernRecord$ge = $c4ZG3.getLinkedRecordIDs(record, field)) === null || _RelayModernRecord$ge === void 0 || _RelayModernRecord$ge.forEach(function(linkedRecordID) {
                if (linkedRecordID != null) linkedRecordIDs.add(linkedRecordID);
            });
        }
    });
    return linkedRecordIDs;
}
function $6faa942e11b73f2c$var$markInvalidatedResolverRecord(dataID, recordSource) {
    var record = recordSource.get(dataID);
    if (!record) return;
    var nextRecord = $c4ZG3.clone(record);
    $c4ZG3.setValue(nextRecord, $6faa942e11b73f2c$var$RELAY_RESOLVER_INVALIDATION_KEY, true);
    recordSource.set(dataID, nextRecord);
}
function $6faa942e11b73f2c$var$markInvalidatedLinkedResolverRecords(record, recordSource) {
    var currentLinkedDataIDs = $6faa942e11b73f2c$var$getAllLinkedRecordIds(record);
    var _iterator9 = (0, $6faa942e11b73f2c$var$_createForOfIteratorHelper2["default"])(currentLinkedDataIDs), _step9;
    try {
        for(_iterator9.s(); !(_step9 = _iterator9.n()).done;){
            var recordID = _step9.value;
            var _record2 = recordSource.get(recordID);
            if (_record2 != null && $6faa942e11b73f2c$var$isResolverRecord(_record2)) $6faa942e11b73f2c$var$markInvalidatedResolverRecord(recordID, recordSource);
        }
    } catch (err) {
        _iterator9.e(err);
    } finally{
        _iterator9.f();
    }
}
function $6faa942e11b73f2c$var$unsubscribeFromLiveResolverRecordsImpl(recordSource, invalidatedDataIDs) {
    if (invalidatedDataIDs.size === 0) return;
    var _iterator10 = (0, $6faa942e11b73f2c$var$_createForOfIteratorHelper2["default"])(invalidatedDataIDs), _step10;
    try {
        for(_iterator10.s(); !(_step10 = _iterator10.n()).done;){
            var dataID = _step10.value;
            var record = recordSource.get(dataID);
            if (record != null && $6faa942e11b73f2c$var$isResolverRecord(record)) $6faa942e11b73f2c$var$maybeUnsubscribeFromLiveState(record);
        }
    } catch (err) {
        _iterator10.e(err);
    } finally{
        _iterator10.f();
    }
}
function $6faa942e11b73f2c$var$isResolverRecord(record) {
    return $c4ZG3.getType(record) === $6faa942e11b73f2c$var$RELAY_RESOLVER_RECORD_TYPENAME;
}
function $6faa942e11b73f2c$var$maybeUnsubscribeFromLiveState(linkedRecord) {
    var previousUnsubscribe = $c4ZG3.getValue(linkedRecord, $6faa942e11b73f2c$var$RELAY_RESOLVER_LIVE_STATE_SUBSCRIPTION_KEY);
    if (previousUnsubscribe != null) previousUnsubscribe();
}
function $6faa942e11b73f2c$var$expectRecord(source, recordID) {
    var record = source.get(recordID);
    !(record != null) && $bQThX(false);
    return record;
}
function $6faa942e11b73f2c$var$getUpdatedDataIDs(updatedRecords) {
    return updatedRecords;
}
function $6faa942e11b73f2c$var$getConcreteTypename(normalizationInfo, currentValue) {
    var _normalizationInfo$co;
    var typename = (_normalizationInfo$co = normalizationInfo.concreteType) !== null && _normalizationInfo$co !== void 0 ? _normalizationInfo$co : currentValue.__typename;
    !(typename != null) && $bQThX(false);
    return typename;
}
module.exports = {
    LiveResolverCache: $6faa942e11b73f2c$var$LiveResolverCache,
    getUpdatedDataIDs: $6faa942e11b73f2c$var$getUpdatedDataIDs,
    RELAY_RESOLVER_LIVE_STATE_SUBSCRIPTION_KEY: $6faa942e11b73f2c$var$RELAY_RESOLVER_LIVE_STATE_SUBSCRIPTION_KEY
};

});
parcelRegister("32h0Y", function(module, exports) {
'use strict';
function $235ec1ca667ff2fa$var$isLiveStateValue(v) {
    return v != null && typeof v === 'object' && typeof v.read === 'function' && typeof v.subscribe === 'function';
}
module.exports = $235ec1ca667ff2fa$var$isLiveStateValue;

});



parcelRegister("f2OFx", function(module, exports) {

$parcel$export(module.exports, "default", () => $c1b075e40986c7a5$export$2e2bcd8739ae039);

var $dh538 = parcelRequire("dh538");

var $94DPb = parcelRequire("94DPb");
const $c1b075e40986c7a5$var$idTypeMap = new Map();
function $c1b075e40986c7a5$export$2e2bcd8739ae039(fieldValue, typeName) {
    const { id: id } = fieldValue;
    if (id == null) return undefined;
    if ((0, $dh538.fg)('platform_log_relay_duplicate_identifiers')) {
        const idString = String(id);
        if ($c1b075e40986c7a5$var$idTypeMap.has(idString)) {
            const entry = $c1b075e40986c7a5$var$idTypeMap.get(idString);
            if (entry) {
                const { typeName: existingTypeName, hasLoggedConflict: hasLoggedConflict } = entry;
                if (existingTypeName !== typeName && !hasLoggedConflict) {
                    (0, $94DPb.safeWarnWithoutCustomerData)('relaydataid.generator', `RelayDataID: conflicting type names for the same ID: ${idString} with type names: ${existingTypeName} and ${typeName}.`, {
                        id: idString,
                        types: `${existingTypeName}, ${typeName}`
                    });
                    entry.hasLoggedConflict = true;
                }
            }
        } else $c1b075e40986c7a5$var$idTypeMap.set(idString, {
            typeName: typeName,
            hasLoggedConflict: false
        });
    }
    return `${String(id)}:::::${typeName}`;
}

});
parcelRegister("94DPb", function(module, exports) {

$parcel$export(module.exports, "safeWarnWithoutCustomerData", () => $89103c584b545818$export$b8c037155fd57aaf);
const $89103c584b545818$var$defaultOptions = {
    credentials: 'same-origin',
    headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json, text/javascript, */*'
    }
};
const $89103c584b545818$var$isProduction = ()=>true;
const $89103c584b545818$var$MAX_REQUESTS_PER_INTERVAL = 5;
const $89103c584b545818$var$INTERVAL_MS = 1000;
let $89103c584b545818$var$requestQueue = [];
let $89103c584b545818$var$isProcessingQueue = false;
const $89103c584b545818$var$processQueue = ()=>{
    if ($89103c584b545818$var$isProcessingQueue) return;
    $89103c584b545818$var$isProcessingQueue = true;
    const processNextBatch = ()=>{
        if ($89103c584b545818$var$requestQueue.length === 0) {
            $89103c584b545818$var$isProcessingQueue = false;
            return;
        }
        const batch = $89103c584b545818$var$requestQueue.splice(0, $89103c584b545818$var$MAX_REQUESTS_PER_INTERVAL);
        batch.forEach(({ body: body, endpoint: endpoint })=>{
            fetch(endpoint, {
                ...$89103c584b545818$var$defaultOptions,
                method: 'POST',
                body: body
            });
        });
        setTimeout(processNextBatch, $89103c584b545818$var$INTERVAL_MS);
    };
    processNextBatch();
};
const $89103c584b545818$var$sendToServerBatched = (body, endpoint)=>{
    $89103c584b545818$var$requestQueue.push({
        body: body,
        endpoint: endpoint
    });
    // Start processing the logging queue if not already started
    $89103c584b545818$var$processQueue();
};
const $89103c584b545818$var$sendToConsole = (body, endpoint, level, message, eventType, event)=>{
    // eslint-disable-next-line no-console
    console[level]('%c%s %c(POST %s)\n%cMessage\n%c%s\n\n%cEvent body\n%c%s\n\n%cException object and Stack trace (expand to jump to source)\n', 'font-size: 14px; font-weight: bold;', level.toUpperCase(), 'font-size: 10px; font-family: monospace;', endpoint, 'font-family: sans-serif; font-weight: bold; font-size: 12px', 'font-family: sans-serif; font-weight: initial;', message, 'font-family: sans-serif; font-weight: bold;', 'font-family: monospace; font-weight: initial;', body, 'font-family: sans-serif; font-size: 12px; font-weight: bold;', event);
    const currentWindow = window;
    if (!$89103c584b545818$var$isProduction() && currentWindow.Cypress) {
        if (!currentWindow.cypressSafeErrorsLog) currentWindow.cypressSafeErrorsLog = [];
        currentWindow.cypressSafeErrorsLog.push({
            body: body,
            endpoint: endpoint,
            level: level,
            message: message
        });
    }
    if (eventType !== 'object') {
        const errorMessage = `Invalid log API usage: expected event of type 'object', but was ${eventType}`;
        // eslint-disable-next-line no-console
        console.error(errorMessage);
    }
    if (typeof body !== 'string') {
        const errorMessage = `Invalid log API usage: expected event of type 'string', but was ${eventType}; message will be replaced by: ${String(message)}`;
        // eslint-disable-next-line no-console
        console.error(errorMessage);
    }
    return Promise.resolve();
};
const $89103c584b545818$var$transformData = (location, message, event)=>{
    return {
        sentFrom: location,
        message: String(message),
        event: event,
        buildKey: window?.BUILD_KEY,
        logTime: new Date().toISOString()
    };
};
const $89103c584b545818$var$sendData = (level, location, message, event = {})=>{
    const data = $89103c584b545818$var$transformData(location, message, event);
    const body = JSON.stringify(data);
    const endpoint = `/rest/internal/2/log/safe/${level}`;
    if ($89103c584b545818$var$isProduction()) return $89103c584b545818$var$sendToServerBatched(body, endpoint);
    return $89103c584b545818$var$sendToConsole(body, endpoint, level, message, typeof event, event);
};
const $89103c584b545818$export$b8c037155fd57aaf = (location, message, event)=>{
    $89103c584b545818$var$sendData('warn', location, message, event);
};

});


parcelRegister("7z5rG", function(module, exports) {

$parcel$export(module.exports, "default", () => $a69540a1adc2255f$export$2e2bcd8739ae039);

var $pCS7V = parcelRequire("pCS7V");

var $f2OFx = parcelRequire("f2OFx");
const $a69540a1adc2255f$var$isCustomFilter = (filterId)=>/^\d+$/.test(filterId);
const $a69540a1adc2255f$var$isSystemFilter = (filterId)=>/^-\d+$/.test(filterId);
const $a69540a1adc2255f$export$77232ec02db7a24a = {
    handle: (field, record, argValues)=>{
        // https://relay.dev/docs/guided-tour/reusing-cached-data/filling-in-missing-data/
        // This lets relay know that a query of
        // JiraQuery.filter(id: ID!)
        // can return:
        //   - a JiraCustomFilter object
        //   - a JiraSystemFilter object
        // determined by the type encoded within the id field (which is an ARI type).
        // By providing the id that relay would refer to those objects by, it is able to check it's
        // store to see if they are already fetched, and avoid refetching them if it is unnecessary
        if (record != null && record.getType() === 'JiraQuery' && field.name === 'filter' && argValues.id != null) {
            const { id: id } = argValues;
            const filterId = (0, $pCS7V.JiraFilterAri).parse(id).filterId;
            if ($a69540a1adc2255f$var$isCustomFilter(filterId)) return (0, $f2OFx.default)({
                id: id
            }, 'JiraCustomFilter');
            if ($a69540a1adc2255f$var$isSystemFilter(filterId)) return (0, $f2OFx.default)({
                id: id
            }, 'JiraSystemFilter');
            return undefined;
        }
        return undefined;
    },
    kind: 'linked'
};
const $a69540a1adc2255f$var$MissingFieldHandlers = [
    $a69540a1adc2255f$export$77232ec02db7a24a
];
var $a69540a1adc2255f$export$2e2bcd8739ae039 = $a69540a1adc2255f$var$MissingFieldHandlers;

});
parcelRegister("pCS7V", function(module, exports) {

$parcel$export(module.exports, "JiraFilterAri", () => $04d07d1619a9fed4$export$3cfb6cc809e835bd);

var $dK1NM = parcelRequire("dK1NM");

var $fY4NL = parcelRequire("fY4NL");

var $3w0K2 = parcelRequire("3w0K2");
// src/jira/filter/manifest.ts
var $04d07d1619a9fed4$var$jiraFilterAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^[a-zA-Z0-9_\\-.]{1,255}$"),
    // eslint-disable-line no-useless-escape
    resourceOwner: (0, $dK1NM.JiraFilterAriResourceOwner),
    resourceType: (0, $dK1NM.JiraFilterAriResourceType),
    resourceIdSlug: "activation/{activationId}/{filterId}",
    resourceIdSegmentFormats: {
        activationId: /[a-zA-Z0-9\-]+/,
        // eslint-disable-line no-useless-escape
        filterId: /[!a-zA-Z0-9\-_.~@:{}=]+(\/[!a-zA-Z0-9\-_.~@:{}=]+)*/
    }
};
// src/jira/filter/index.ts
var $04d07d1619a9fed4$export$3cfb6cc809e835bd = class _JiraFilterAri extends (0, $fY4NL.RegisteredAri) {
    get siteId() {
        return this._siteId;
    }
    get activationId() {
        return this._activationId;
    }
    get filterId() {
        return this._filterId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $04d07d1619a9fed4$var$jiraFilterAriStaticOpts.qualifier,
            platformQualifier: $04d07d1619a9fed4$var$jiraFilterAriStaticOpts.platformQualifier,
            cloudId: opts.siteId,
            resourceOwner: $04d07d1619a9fed4$var$jiraFilterAriStaticOpts.resourceOwner,
            resourceType: $04d07d1619a9fed4$var$jiraFilterAriStaticOpts.resourceType,
            resourceId: `activation/${opts.activationId}/${opts.filterId}`,
            resourceIdSegmentValues: {
                activationId: opts.activationId,
                filterId: opts.filterId
            }
        }, ariOpts = (0, $3w0K2.AriParser).fromOpts(derivedOpts, $04d07d1619a9fed4$var$jiraFilterAriStaticOpts);
        return new _JiraFilterAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $3w0K2.AriParser).fromString(maybeAri, $04d07d1619a9fed4$var$jiraFilterAriStaticOpts);
        return new _JiraFilterAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId,
            activationId: this.activationId,
            filterId: this.filterId
        };
    }
    constructor(opts){
        super(opts);
        this._siteId = opts.cloudId || "", this._activationId = opts.resourceIdSegmentValues.activationId, this._filterId = opts.resourceIdSegmentValues.filterId;
    }
};

});
parcelRegister("dK1NM", function(module, exports) {

$parcel$export(module.exports, "JiraFilterAriResourceOwner", () => $a010f812d7ed679f$export$e6199848f52f1119);
$parcel$export(module.exports, "JiraFilterAriResourceType", () => $a010f812d7ed679f$export$3c64de4ae038e3ae);
// src/jira/filter/types.ts
var $a010f812d7ed679f$export$e6199848f52f1119 = "jira", $a010f812d7ed679f$export$3c64de4ae038e3ae = "filter";

});



parcelRegister("iTyoD", function(module, exports) {

$parcel$export(module.exports, "network", () => $185542a16deb61ee$export$21fcfd9d5c6ebbd4);

var $lan9D = parcelRequire("lan9D");

var $2gQQV = parcelRequire("2gQQV");

var $jynRP = parcelRequire("jynRP");
function $185542a16deb61ee$var$fetchQuery(request, variables, cacheConfig) {
    const endpoint = (0, $2gQQV.getAggEndpoint)(request, cacheConfig);
    const body = (0, $2gQQV.getRequestBody)(request, variables);
    return fetch(endpoint, {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
            // Add authentication and other headers here
            'content-type': 'application/json',
            'X-ExperimentalApi': (0, $jynRP.RelayExperimentalApis).join(',')
        },
        body: body
    }).then((response)=>{
        return response.json();
    });
}
const $185542a16deb61ee$export$21fcfd9d5c6ebbd4 = (0, $lan9D.Network).create($185542a16deb61ee$var$fetchQuery);

});
parcelRegister("2gQQV", function(module, exports) {

$parcel$export(module.exports, "getAggEndpoint", () => $00d790897fd8fcbc$export$fd126d8de571b77d);
$parcel$export(module.exports, "getRequestBody", () => $00d790897fd8fcbc$export$55bce18df99af758);

var $3mTvL = parcelRequire("3mTvL");
const $00d790897fd8fcbc$var$branchSlug = typeof $3mTvL !== 'undefined' && $3mTvL.env ? undefined : undefined;
const $00d790897fd8fcbc$var$aggPathname = `/gateway/api/graphql${$00d790897fd8fcbc$var$branchSlug ? `/${$00d790897fd8fcbc$var$branchSlug}/graphql` : ''}`;
const $00d790897fd8fcbc$export$fd126d8de571b77d = (request, cacheConfig = {})=>{
    let endpoint = $00d790897fd8fcbc$var$aggPathname;
    if (cacheConfig.metadata?.META_SLOW_ENDPOINT) endpoint = `${endpoint}/slow`;
    if (request.id != null) endpoint = `${endpoint}/pq/${request.id}`;
    return `${endpoint}?operation=${request.name}`;
};
const $00d790897fd8fcbc$export$55bce18df99af758 = (request, variables)=>{
    const requestBody = {
        operationName: request.name,
        variables: variables
    };
    return JSON.stringify(requestBody);
};

});

parcelRegister("jynRP", function(module, exports) {

$parcel$export(module.exports, "RelayExperimentalApis", () => $b7af7e3cbaf72c79$export$ebe3a775ce3053a5);
// Please add your Experimental API name below
// You do not need to wait for approval to add to this list
const $b7af7e3cbaf72c79$export$ebe3a775ce3053a5 = [
    'ariGraph',
    'boardCardMove',
    'deleteCard',
    'JiraJqlBuilder',
    'SoftwareCardTypeTransitions',
    'jira-releases-v0',
    'JiraDevOps',
    'JiraDevOpsProviders',
    'createCustomFilter',
    'updateCustomFilter',
    'deleteCustomFilter',
    'customFilters',
    'PermissionScheme',
    'JiraIssue',
    'projectStyle',
    'startSprintPrototype',
    'AddIssuesToFixVersion',
    'JiraVersionResult',
    'JiraIssueConnectionJql',
    'JiraFieldOptionSearching',
    'JiraIssueFieldMutations',
    'JiraIssueDevInfoDetails',
    'JiraIssueDevSummaryCache',
    'JiraVersionWarningConfig',
    'JiraReleaseNotesConfiguration',
    'JiraUpdateReleaseNotesConfiguration',
    'ReleaseNotes',
    'ReleaseNotesOptions',
    'DeploymentsFeaturePrecondition',
    'UpdateVersionWarningConfig',
    'UpdateVersionName',
    'UpdateVersionDescription',
    'UpdateVersionStartDate',
    'UpdateVersionReleaseDate',
    'VersionsForProject',
    'RelatedWork',
    'SuggestedRelatedWorkCategories',
    'setIssueMediaVisibility',
    'toggleBoardFeature',
    'DevOpsProvider',
    'DevOpsSummarisedDeployments',
    'JiraProject',
    'DevOpsSummarisedEntities',
    'RoadmapsMutation',
    'RoadmapsQuery',
    'JiraApplicationProperties',
    'JiraIssueSearch',
    'JiraFilter',
    'featureGroups',
    'setBoardEstimationType',
    'devOps',
    'softwareBoards',
    'name',
    'AddRelatedWorkToVersion',
    'RemoveRelatedWorkFromVersion',
    'admins',
    'canAdministerBoard',
    'jql',
    'globalCardCreateAdditionalFields',
    'GlobalTimeTrackingSettings',
    'ReleaseNotesOptions',
    'search-experience',
    'MoveOrRemoveIssuesToFixVersion',
    'compass-beta',
    'JiraIssueSearchStatus',
    'Townsquare',
    'JiraNavigationItems',
    'JiraVersionsForProjects',
    'columnConfigs'
];

});


parcelRegister("1b0Xp", function(module, exports) {

$parcel$export(module.exports, "default", () => $2912bf4fa2770fd6$export$2e2bcd8739ae039);

var $gwFzn = parcelRequire("gwFzn");

var $4FhhO = parcelRequire("4FhhO");
var // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
$2912bf4fa2770fd6$export$2e2bcd8739ae039 = {
    cancel: ()=>{},
    schedule: (fn)=>{
        // react 16.x
        if (// `unstable_batchedUpdates` is defined in all currently supported versions
        // but could be removed in the future.
        // This check is defensive and not currently necessary.
        typeof (0, (/*@__PURE__*/$parcel$interopDefault($4FhhO))).unstable_batchedUpdates === 'function' && // The version export was only introduced in `react-dom@16.13.0`
        // but we need to support `react-dom@^16.8.0`
        // so we need to handle when the version is `undefined`
        (typeof (0, $4FhhO.version) === 'undefined' || (0, $4FhhO.version).startsWith('16'))) (0, (/*@__PURE__*/$parcel$interopDefault($4FhhO))).unstable_batchedUpdates(()=>{
            fn();
        });
        else if (typeof (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).startTransition === 'function') // @ts-ignore-error React.startTransition does not exist in react-16
        (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).startTransition(()=>{
            fn();
        });
        else fn();
        return '';
    }
};

});




//# sourceMappingURL=EditionAwareness.6fdbf364.js.map
